webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routes = __webpack_require__(31);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _ravenJs = __webpack_require__(433);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _vue3 = __webpack_require__(429);
	
	var _vue4 = _interopRequireDefault(_vue3);
	
	var _index = __webpack_require__(222);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(224);
	
	var _index4 = _interopRequireDefault(_index3);
	
	__webpack_require__(228);
	
	__webpack_require__(229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.jQuery = window.$ = __webpack_require__(7);
	window.Bootstrap = __webpack_require__(297);
	window.Select2 = __webpack_require__(436);
	window.Skycons = __webpack_require__(219);
	window.Moment = __webpack_require__(1);
	window._ = __webpack_require__(76);
	
	window.CANV_GAUGE_FONTS_PATH = '/static/fonts';
	
	__webpack_require__(422);
	__webpack_require__(50);
	__webpack_require__(398);
	__webpack_require__(399);
	__webpack_require__(428);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(215);
	__webpack_require__(220);
	__webpack_require__(221);
	__webpack_require__(218);
	__webpack_require__(213);
	__webpack_require__(214);
	__webpack_require__(212);
	__webpack_require__(216);
	__webpack_require__(217);
	
	if (true) {
		_ravenJs2.default.config('https://d7c7c6cc128a4b6fb0a0990924090d0b@bugs.codium.com.au/23').addPlugin(_vue4.default, _vue2.default).install();
	}
	
	var App = _vue2.default.extend(__webpack_require__(486));
	
	(0, _index2.default)(_vue2.default);
	(0, _index4.default)(_vue2.default);
	
	_routes2.default.start(App, 'app');
	
	exports.default = _routes2.default.app;

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loading = exports.loading = function loading(_ref) {
	  var app = _ref.app;
	  return app.loading;
	};
	var eventLoading = exports.eventLoading = function eventLoading(_ref2) {
	  var app = _ref2.app;
	  return app.eventLoading;
	};
	var title = exports.title = function title(_ref3) {
	  var app = _ref3.app;
	  return app.title;
	};
	
	var authorized = exports.authorized = function authorized(_ref4) {
	  var user = _ref4.user;
	  return user.authorized;
	};
	
	var fermenter = exports.fermenter = function fermenter(_ref5) {
	  var fermenters = _ref5.fermenters;
	  return fermenters.active;
	};
	var fermenters = exports.fermenters = function fermenters(_ref6) {
	  var fermenters = _ref6.fermenters;
	  return fermenters.all;
	};
	
	var tankGroup = exports.tankGroup = function tankGroup(_ref7) {
	  var tankGroups = _ref7.tankGroups;
	  return tankGroups.active;
	};
	var tankGroups = exports.tankGroups = function tankGroups(_ref8) {
	  var tankGroups = _ref8.tankGroups;
	  return tankGroups.all;
	};
	
	var site = exports.site = function site(_ref9) {
	  var sites = _ref9.sites;
	  return sites.active;
	};
	var sites = exports.sites = function sites(_ref10) {
	  var sites = _ref10.sites;
	  return sites.all;
	};
	
	var whatNow = exports.whatNow = function whatNow(_ref11) {
	  var settings = _ref11.settings;
	  return settings.whatNow;
	};
	var varietals = exports.varietals = function varietals(_ref12) {
	  var settings = _ref12.settings;
	  return settings.varietals;
	};
	var regions = exports.regions = function regions(_ref13) {
	  var settings = _ref13.settings;
	  return settings.regions;
	};
	var yeastTypes = exports.yeastTypes = function yeastTypes(_ref14) {
	  var settings = _ref14.settings;
	  return settings.yeastTypes;
	};
	var countries = exports.countries = function countries(_ref15) {
	  var settings = _ref15.settings;
	  return settings.countries;
	};
	
	var simulatorSetup = exports.simulatorSetup = function simulatorSetup(_ref16) {
	  var simulatorSetup = _ref16.simulatorSetup;
	  return simulatorSetup.active;
	};
	
	var profile = exports.profile = function profile(_ref17) {
	  var profiles = _ref17.profiles;
	  return profiles.active;
	};
	var profiles = exports.profiles = function profiles(_ref18) {
	  var profiles = _ref18.profiles;
	  return profiles.all;
	};
	
	var ferment = exports.ferment = function ferment(_ref19) {
	  var ferments = _ref19.ferments;
	  return ferments.active;
	};
	var ferments = exports.ferments = function ferments(_ref20) {
	  var ferments = _ref20.ferments;
	  return ferments.all;
	};
	var graphBase64 = exports.graphBase64 = function graphBase64(_ref21) {
	  var ferments = _ref21.ferments;
	  return ferments.graphBase64;
	};
	
	var simulatorRunning = exports.simulatorRunning = function simulatorRunning(_ref22) {
	  var simulator = _ref22.simulator;
	  return simulator.running;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.User = exports.App = exports.Ferments = exports.Profiles = exports.Sites = exports.SimulatorSetup = exports.Settings = exports.TankGroups = exports.Fermenters = undefined;
	
	var _fermenters = __webpack_require__(231);
	
	var Fermenters = _interopRequireWildcard(_fermenters);
	
	var _tankGroups = __webpack_require__(237);
	
	var TankGroups = _interopRequireWildcard(_tankGroups);
	
	var _settings = __webpack_require__(234);
	
	var Settings = _interopRequireWildcard(_settings);
	
	var _simulatorSetup = __webpack_require__(235);
	
	var SimulatorSetup = _interopRequireWildcard(_simulatorSetup);
	
	var _sites = __webpack_require__(236);
	
	var Sites = _interopRequireWildcard(_sites);
	
	var _profiles = __webpack_require__(233);
	
	var Profiles = _interopRequireWildcard(_profiles);
	
	var _ferments = __webpack_require__(232);
	
	var Ferments = _interopRequireWildcard(_ferments);
	
	var _app = __webpack_require__(230);
	
	var App = _interopRequireWildcard(_app);
	
	var _user = __webpack_require__(238);
	
	var User = _interopRequireWildcard(_user);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.Fermenters = Fermenters;
	exports.TankGroups = TankGroups;
	exports.Settings = Settings;
	exports.SimulatorSetup = SimulatorSetup;
	exports.Sites = Sites;
	exports.Profiles = Profiles;
	exports.Ferments = Ferments;
	exports.App = App;
	exports.User = User;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_LOADING = exports.SET_LOADING = 'SET_LOADING';
	var SET_EVENT_LOADING = exports.SET_EVENT_LOADING = 'SET_EVENT_LOADING';
	var SET_TITLE = exports.SET_TITLE = 'SET_TITLE';
	var INIT_PUSHER = exports.INIT_PUSHER = 'INIT_PUSHER';
	
	var SET_AUTHORIZED = exports.SET_AUTHORIZED = 'SET_AUTHORIZED';
	
	var SET_FERMENTERS = exports.SET_FERMENTERS = 'SET_FERMENTERS';
	var SET_ACTIVE_FERMENTER = exports.SET_ACTIVE_FERMENTER = 'SET_ACTIVE_FERMENTER';
	var ADD_FERMENTER = exports.ADD_FERMENTER = 'ADD_FERMENTER';
	
	var SET_ACTIVE_FERMENT = exports.SET_ACTIVE_FERMENT = 'SET_ACTIVE_FERMENT';
	var ADD_FERMENT = exports.ADD_FERMENT = 'ADD_FERMENT';
	var SET_FERMENTS = exports.SET_FERMENTS = 'SET_FERMENTS';
	var SET_GRAPH_BASE64 = exports.SET_GRAPH_BASE64 = 'SET_GRAPH_BASE64';
	
	var SET_ACTIVE_TANK_GROUP = exports.SET_ACTIVE_TANK_GROUP = 'SET_ACTIVE_TANK_GROUP';
	var SET_TANK_GROUPS = exports.SET_TANK_GROUPS = 'SET_TANK_GROUPS';
	var ADD_TANK_GROUP = exports.ADD_TANK_GROUP = 'ADD_TANK_GROUP';
	var SET_TANK_GROUP_NAME = exports.SET_TANK_GROUP_NAME = 'SET_TANK_GROUP_NAME';
	var DESTROY_TANK_GROUP = exports.DESTROY_TANK_GROUP = 'DESTROY_TANK_GROUP';
	
	var SET_SITE = exports.SET_SITE = 'SET_SITE';
	var SET_SITES = exports.SET_SITES = 'SET_SITES';
	
	var SET_WHAT_NOW = exports.SET_WHAT_NOW = 'SET_WHAT_NOW';
	var SET_YEAST_TYPES = exports.SET_YEAST_TYPES = 'SET_YEAST_TYPES';
	var ADD_YEAST_TYPE = exports.ADD_YEAST_TYPE = 'ADD_YEAST_TYPE';
	var DESTROY_YEAST_TYPE = exports.DESTROY_YEAST_TYPE = 'DESTROY_YEAST_TYPE';
	var UPDATE_YEAST_TYPE = exports.UPDATE_YEAST_TYPE = 'UPDATE_YEAST_TYPE';
	var SET_REGIONS = exports.SET_REGIONS = 'SET_REGIONS';
	var ADD_REGION = exports.ADD_REGION = 'ADD_REGION';
	var DESTROY_REGION = exports.DESTROY_REGION = 'DESTROY_REGION';
	var UPDATE_REGION = exports.UPDATE_REGION = 'UPDATE_REGION';
	var SET_VARIETALS = exports.SET_VARIETALS = 'SET_VARIETALS';
	var ADD_VARIETAL = exports.ADD_VARIETAL = 'ADD_VARIETAL';
	var DESTROY_VARIETAL = exports.DESTROY_VARIETAL = 'DESTROY_VARIETAL';
	var UPDATE_VARIETAL = exports.UPDATE_VARIETAL = 'UPDATE_VARIETAL';
	var SET_COUNTRIES = exports.SET_COUNTRIES = 'SET_COUNTRIES';
	
	var SET_SIMULATOR_SETUP = exports.SET_SIMULATOR_SETUP = 'SET_SIMULATOR_SETUP';
	
	var SET_PROFILES = exports.SET_PROFILES = 'SET_PROFILES';
	var SET_ACTIVE_PROFILE = exports.SET_ACTIVE_PROFILE = 'SET_ACTIVE_PROFILE';
	var ADD_PROFILE = exports.ADD_PROFILE = 'ADD_PROFILE';
	
	var SET_SIMULATOR_RUNNING = exports.SET_SIMULATOR_RUNNING = 'SET_SIMULATOR_RUNNING';

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _toastr = __webpack_require__(438);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		notify: function notify(type, message) {
			var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
			    _ref$timeout = _ref.timeout,
			    timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
			    _ref$callback = _ref.callback,
			    callback = _ref$callback === undefined ? null : _ref$callback,
			    _ref$title = _ref.title,
			    title = _ref$title === undefined ? '' : _ref$title;
	
			_toastr2.default.options = {
				newestOnTop: false,
				progressBar: true,
				positionClass: 'toast-top-right',
				showDuration: 300,
				hideDuration: 500,
				timeOut: timeout,
				extendedTimeOut: 1000,
				showEasing: 'swing',
				hideEasing: 'linear',
				showMethod: 'fadeIn',
				hideMethod: 'fadeOut'
			};
	
			var toast = _toastr2.default[type](message, title);
	
			if (callback) callback(toast);
	
			return toast;
		},
		success: function success(message) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			return this.notify('success', message, options);
		},
		error: function error(message) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			return this.notify('error', message, options);
		},
		warning: function warning(message) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			return this.notify('warning', message, options);
		},
		info: function info(message) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			return this.notify('info', message, options);
		},
		clear: function clear() {
			var toast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
			_toastr2.default.clear(toast);
		}
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _sweetalert = __webpack_require__(437);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		changes: function changes() {
			return (0, _sweetalert2.default)({
				title: 'You have unsaved changes.',
				text: 'Are you sure you want to perform this action?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				customClass: 'animated bounceIn',
				animation: false,
				confirmButtonText: 'Yes, continue!'
			});
		},
		success: function success(_ref) {
			var _ref$title = _ref.title,
			    title = _ref$title === undefined ? 'Success!' : _ref$title,
			    _ref$text = _ref.text,
			    text = _ref$text === undefined ? '' : _ref$text,
			    _ref$timer = _ref.timer,
			    timer = _ref$timer === undefined ? 2500 : _ref$timer;
	
			return (0, _sweetalert2.default)({
				title: title,
				text: text,
				type: 'success',
				customClass: 'animated bounceIn',
				animation: false,
				showConfirmButton: false,
				timer: timer
			});
		},
		confirm: function confirm(options) {
			return (0, _sweetalert2.default)($.extend({
				title: 'Are you sure?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				customClass: 'animated bounceIn',
				animation: false,
				confirmButtonText: 'Yes, I am sure.'
			}, options));
		},
		custom: function custom(options) {
			return (0, _sweetalert2.default)($.extend({
				customClass: 'animated bounceIn',
				animation: false
			}, options));
		},
		delete: function _delete() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			return (0, _sweetalert2.default)($.extend({
				title: 'Warning!',
				text: 'Are you sure you want to perform this delete?',
				type: 'error',
				customClass: 'animated bounceIn',
				animation: false,
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Yes, continue!'
			}, options));
		},
		error: function error(_ref2) {
			var _ref2$title = _ref2.title,
			    title = _ref2$title === undefined ? 'Uh oh!' : _ref2$title,
			    text = _ref2.text,
			    _ref2$options = _ref2.options,
			    options = _ref2$options === undefined ? {} : _ref2$options;
	
			return (0, _sweetalert2.default)($.extend({
				title: title,
				text: text,
				type: 'error',
				customClass: 'animated bounceIn',
				animation: false,
				confirmButtonColor: '#d33',
				confirmButtonText: 'Okay.'
			}, options));
		}
	};

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(524);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _config = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.options.root = _config.config.API_PATH;
	
	var Http = function () {
		function Http() {
			(0, _classCallCheck3.default)(this, Http);
	
			this.request = {
				before: null,
				query: {},
				headers: {},
				entity: {},
				includes: []
			};
		}
	
		(0, _createClass3.default)(Http, [{
			key: 'buildPath',
			value: function buildPath(path) {
				var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				if (path.charAt(0) == '/') {
					path = path.substr(1);
				}
	
				if (token) {
					var joiner = '?';
	
					if (path.match(/(\?.*?\=)/g)) {
						joiner = '&';
					}
	
					path = '' + path + joiner + 'token=' + sessionStorage.getItem('token');
				}
	
				return _vue2.default.http.options.root + '/' + path;
			}
		}, {
			key: 'before',
			value: function before(_before) {
				this.request.before = _before;
	
				return this;
			}
		}, {
			key: 'include',
			value: function include(includes) {
				this.request.includes = includes;
	
				return this;
			}
		}, {
			key: 'query',
			value: function query(_query) {
				this.request.query = _query;
	
				return this;
			}
		}, {
			key: 'headers',
			value: function headers(_headers) {
				this.request.headers = _headers;
	
				return this;
			}
		}, {
			key: 'entity',
			value: function entity(_entity) {
				this.request.entity = _entity;
	
				return this;
			}
		}, {
			key: 'get',
			value: function get(path) {
				var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				var cb = arguments[2];
	
				return this.execute('get', path, query, {}, {}, cb);
			}
		}, {
			key: 'post',
			value: function post(path) {
				var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				return this.execute('post', path, {}, entity);
			}
		}, {
			key: 'put',
			value: function put(path) {
				var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				return this.execute('put', path, {}, entity);
			}
		}, {
			key: 'destroy',
			value: function destroy(path) {
				return this.execute('delete', path);
			}
		}, {
			key: 'execute',
			value: function execute(method, path) {
				var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
				var entity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
				var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
				var cb = arguments[5];
	
				if (this.request.headers) {
					headers = $.extend(this.request.headers, headers);
	
					this.request.headers = {};
				}
	
				if (this.request.entity) {
					entity = $.extend(this.request.entity, entity);
	
					this.request.entity = {};
				}
	
				if (this.request.query) {
					query = $.extend(this.request.query, query);
	
					this.request.query = {};
				}
	
				if (this.request.includes.length) {
					query = $.extend(query, { include: this.request.includes.join(',') });
	
					this.request.includes = [];
				}
	
				var before = this.request.before;
	
				this.request.before = null;
	
				return _vue2.default.http({
					method: method,
					url: path,
					body: entity,
					params: query,
					headers: headers,
					before: before
				});
			}
		}]);
		return Http;
	}();
	
	;
	
	exports.default = new Http();

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var environment = exports.environment = function environment(env) {
	  return ("production") === env;
	};
	
	var isProduction = exports.isProduction = environment('production');
	var isStaging = exports.isStaging = environment('staging');
	
	function makeConfig(apiPath, wineCloudPath, pusherKey) {
	  return {
	    API_PATH: apiPath,
	    WC_PATH: wineCloudPath,
	    PUSHER_KEY: pusherKey
	  };
	}
	
	var allConfigs = {
	  production: makeConfig('https://api.fermentsimulator.com.au', 'https://thewinecloud.com.au', 'e3f3c0ef7b852baa7401'),
	  staging: makeConfig('http://api.awri.codium.com.au', 'http://winecloud.projectstatus.in', '8027d5f83a3e5eaea4fc'),
	  default: makeConfig('http://api.fermentsimulator.com.au', 'http://thewinecloud.com.au', 'e46a2030bdc6ee061be4')
	};
	
	var config = exports.config = isProduction ? allConfigs['production'] : isStaging ? allConfigs['staging'] : allConfigs['default'];

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _store = __webpack_require__(21);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		baumeToBrix: function baumeToBrix(sugar) {
			if (!sugar) return sugar;
	
			if (_store2.default.state.simulatorSetup.active.sugar_units) {
				return parseFloat(sugar);
			}
	
			return (parseFloat(sugar) - 0.0181) / 0.5532;
		},
		brixToBaume: function brixToBaume(sugar) {
			if (!sugar) return sugar;
	
			if (_store2.default.state.simulatorSetup.active.sugar_units) {
				return parseFloat(sugar);
			}
	
			return parseFloat(sugar) * 0.5532 + 0.0181;
		},
		celsiusToFahrenheit: function celsiusToFahrenheit(temperature) {
			if (!temperature) return temperature;
	
			if (_store2.default.state.simulatorSetup.active.temp_units) {
				return parseFloat(temperature);
			}
	
			return parseFloat(temperature) * 1.8 + 32;
		},
		fahrenheitToCelsius: function fahrenheitToCelsius(temperature) {
			if (!temperature) return temperature;
	
			if (_store2.default.state.simulatorSetup.active.temp_units) {
				return parseFloat(temperature);
			}
	
			return (parseFloat(temperature) - 32) * (5 / 9);
		},
		sugarUnit: function sugarUnit() {
			return _store2.default.state.simulatorSetup.active.sugar_units ? 'Be&deg;' : '&deg;Bx';
		},
		secondarySugarUnit: function secondarySugarUnit() {
			return _store2.default.state.simulatorSetup.active.secondary_sugar_units == 'sg' ? 'SG' : 'RS (g/L)';
		},
		temperatureUnit: function temperatureUnit() {
			return _store2.default.state.simulatorSetup.active.temp_units ? '&deg;C' : '&deg;F';
		}
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(526);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _app = __webpack_require__(239);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _fermenters = __webpack_require__(240);
	
	var _fermenters2 = _interopRequireDefault(_fermenters);
	
	var _tankGroups = __webpack_require__(247);
	
	var _tankGroups2 = _interopRequireDefault(_tankGroups);
	
	var _sites = __webpack_require__(246);
	
	var _sites2 = _interopRequireDefault(_sites);
	
	var _settings = __webpack_require__(243);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _simulatorSetup = __webpack_require__(244);
	
	var _simulatorSetup2 = _interopRequireDefault(_simulatorSetup);
	
	var _profiles = __webpack_require__(242);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _ferments = __webpack_require__(241);
	
	var _ferments2 = _interopRequireDefault(_ferments);
	
	var _simulator = __webpack_require__(245);
	
	var _simulator2 = _interopRequireDefault(_simulator);
	
	var _user = __webpack_require__(248);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
		modules: {
			app: _app2.default,
			fermenters: _fermenters2.default,
			tankGroups: _tankGroups2.default,
			sites: _sites2.default,
			settings: _settings2.default,
			simulatorSetup: _simulatorSetup2.default,
			profiles: _profiles2.default,
			ferments: _ferments2.default,
			simulator: _simulator2.default,
			user: _user2.default
		}
	});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		failedValidation: function failedValidation(errors) {
			if (errors.has(this.name)) {
				this.errorMessage = errors.first(this.name);
				this.hasError = true;
			} else {
				this.errorMessage = null;
				this.hasError = false;
			}
		},
		passedValidation: function passedValidation() {
			this.errorMessage = null;
			this.hasError = false;
		},
		resetValidation: function resetValidation() {
			this.errorMessage = null;
			this.hasError = false;
		}
	};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		vmodel: {
			default: ''
		},
		name: {
			type: String,
			required: true,
			default: ''
		},
		label: {
			type: String
		},
		inline: {
			type: Boolean,
			default: false
		},
		class: {
			type: String,
			default: 'col-sm-8 col-md-9'
		},
		spinner: {
			type: Boolean,
			default: false
		},
		postfix: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		select2: {
			type: Boolean,
			default: false
		},
		tags: {
			type: Boolean,
			default: false
		},
		textarea: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: 4
		},
		type: {
			type: String,
			default: 'text'
		},
		placeholder: {
			type: String,
			default: ''
		},
		datepicker: {
			type: Boolean,
			default: false
		},
		dateFormat: {
			type: String,
			default: "DD/MM/YYYY hh:mm A"
		},
		on: {
			type: String,
			default: 'Yes'
		},
		off: {
			type: String,
			default: 'No'
		},
		onValue: {
			type: Number,
			default: 1
		},
		offValue: {
			type: Number,
			default: 0
		},
		onStyle: {
			type: String,
			default: 'danger'
		},
		offStyle: {
			type: String,
			default: 'default'
		},
		prependIcon: {
			type: String
		},
		prependText: {
			type: String
		},
		appendText: {
			type: String
		},
		appendIcon: {
			type: String
		},
		icon: {
			type: String,
			default: ''
		}
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(22);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(525);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _template = __webpack_require__(523);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index = __webpack_require__(502);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(504);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(515);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(520);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(498);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _index11 = __webpack_require__(506);
	
	var _index12 = _interopRequireDefault(_index11);
	
	var _index13 = __webpack_require__(522);
	
	var _index14 = _interopRequireDefault(_index13);
	
	var _index15 = __webpack_require__(513);
	
	var _index16 = _interopRequireDefault(_index15);
	
	var _index17 = __webpack_require__(511);
	
	var _index18 = _interopRequireDefault(_index17);
	
	var _authorize = __webpack_require__(494);
	
	var _authorize2 = _interopRequireDefault(_authorize);
	
	var _login = __webpack_require__(495);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _logout = __webpack_require__(496);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _register = __webpack_require__(497);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _store = __webpack_require__(21);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _actions = __webpack_require__(3);
	
	var _config = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var Router = new _vueRouter2.default({
		hashbang: false,
		history: true
	});
	
	Router.map({
		'/': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index2.default,
					name: 'dashboard'
				},
				'/tank-group/:tankGroupId': {
					component: _index2.default,
					name: 'dashboard.tank-group'
				},
				'bulk-entry': {
					component: _index2.default,
					name: 'dashboard.bulk-entry'
				}
			}
		},
		'/fermenters': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index4.default,
					name: 'fermenters.index'
				}
			}
		},
		'/settings': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index6.default,
					name: 'settings.index'
				}
			}
		},
		'/simulator-setup': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index8.default,
					name: 'simulators.index'
				}
			}
		},
		'/contact': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index10.default,
					name: 'contact.index'
				}
			}
		},
		'/ferments': {
			component: _template2.default,
			subRoutes: {
				'/:fermenterId/:fermentId': {
					component: _index12.default,
					name: 'ferments.index'
				},
				'/:fermenterId/:fermentId/what-if': {
					component: _index12.default,
					name: 'ferments.what-if'
				},
				'/:fermenterId/:fermentId/what-now': {
					component: _index12.default,
					name: 'ferments.what-now'
				}
			}
		},
		'/profiles': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index16.default,
					name: 'profiles.index'
				}
			}
		},
		'/site-selection': {
			hideNavigation: true,
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index14.default,
					name: 'site-selection.index'
				}
			}
		},
		'/history': {
			component: _template2.default,
			subRoutes: {
				'/': {
					component: _index18.default,
					name: 'history.index'
				}
			}
		},
		'/oauth': {
			component: _template2.default,
			hideNavigation: true,
			subRoutes: {
				'/authorize': {
					component: _authorize2.default,
					name: 'oauth.authorize'
				}
			}
		},
		'/login': {
			component: _template2.default,
			hideNavigation: false,
			subRoutes: {
				'/': {
					component: _login2.default,
					name: 'login'
				}
			}
		},
		'/logout': {
			component: _template2.default,
			hideNavigation: true,
			subRoutes: {
				'/': {
					component: _logout2.default,
					name: 'logout'
				}
			}
		},
		'/register': {
			component: _template2.default,
			hideNavigation: false,
			subRoutes: {
				'/': {
					component: _register2.default,
					name: 'register'
				}
			}
		}
	});
	
	Router.alias({
		'/ferments/:fermenterId': '/ferments/:fermenterId/0'
	});
	
	Router.beforeEach(function (_ref) {
		var to = _ref.to,
		    next = _ref.next,
		    redirect = _ref.redirect;
	
		$(window).off('resize');
	
		if (to.name != 'ferments.index') {
			localStorage.setItem('scrolledState', (0, _stringify2.default)({ top: 0, left: 0 }));
		}
	
		var authCallback = function authCallback() {
			if (!isAuthorized && to.name !== 'login' && to.name !== 'register') {
				redirect({ name: 'login' });
			}
	
			if ($.isEmptyObject(_store2.default.state.sites.active) && to.name !== 'site-selection.index' && to.name !== 'oauth.authorize' && to.name !== 'login' && to.name !== 'register') {
				var site = JSON.parse(localStorage.getItem('site'));
	
				if (!$.isEmptyObject(site)) {
					_store2.default.dispatch(types.SET_SITE, site);
				} else {
					redirect({ name: 'site-selection.index' });
				}
			}
	
			next();
		};
	
		var token = sessionStorage.getItem('token');
	
		var isAuthorized = _store2.default.state.user.authorized && token;
		if (!isAuthorized && !_store2.default.state.user.authorized && token && to.name !== 'login' && to.name !== 'register') {
			_actions.User.authorize(_store2.default, token).then(function (response) {
				isAuthorized = true;
				authCallback();
			}, function (response) {
				redirect({ name: 'login' });
			});
		} else {
			authCallback();
		}
	});
	
	exports.default = Router;

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		newBlankDay: function newBlankDay() {
			var day = this.getNextDay();
	
			return {
				id: null,
				day: day,
				baume: '',
				temp: '',
				comments: '',
				action: {
					data: {
						aeration: false,
						pump_over: false,
						dap: '',
						juice: '',
						reinoculate: '',
						water: '',
						agitator: '0'
					}
				},
				analysis: {
					data: {
						cell_count: '',
						fs02: '',
						gf: '',
						ntu: '',
						ph: '',
						ta: '',
						ts02: '',
						alcohol: '',
						malic_acid: ''
					}
				}
			};
		}
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		isBlankRow: function isBlankRow(row) {
			if (row && !row.baume && !row.temp && !row.comments && this.isEmptyAction(row) && this.isEmptyAnalysis(row)) {
				return true;
			}
	
			return false;
		},
		isEmptyAction: function isEmptyAction(row) {
			if ($.isEmptyObject(row.action)) {
				return true;
			}
	
			if (row.action.data) {
				var data = row.action.data;
	
				if (data.aeration || data.pump_over || data.dap || data.juice || data.reinoculate || data.water || parseFloat(data.agitator) > 0) {
					return false;
				}
			}
	
			return true;
		},
		isEmptyAnalysis: function isEmptyAnalysis(row) {
			if ($.isEmptyObject(row.analysis)) {
				return true;
			}
	
			if (row.analysis.data) {
				var data = row.analysis.data;
	
				if (data.cell_count || data.fs02 || data.gf || data.ntu || data.ph || data.ta || data.ts02 || data.alcohol || data.malic_acid || this.simulatorSetup.secondary_sugar_units == 'sg' && data.rs || this.simulatorSetup.secondary_sugar_units == 'rs' && data.sg) {
					return false;
				}
			}
	
			return true;
		}
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		editCell: function editCell(event, index, column, dailyData) {
			var _this = this;
	
			if (this.editingDisabled || dailyData.locked) return;
	
			var parent = $(event.target).is('td') ? $(event.target) : $(event.target).parent('td');
	
			this.editing = {
				status: true,
				index: index,
				column: column
			};
	
			_vue2.default.nextTick(function () {
				parent.find('input').focus();
	
				$(document).on('click.leaveCell', function (documentEvent) {
					if ($(documentEvent.target).is(parent.find('input'))) return;
	
					$(document).off('click.leaveCell');
	
					if (!_this.isEditingAction) {
						_this.editing.status = false;
						_this.editing.index = null;
					}
				});
			});
		},
		tabToNextCell: function tabToNextCell(event, index, next, previous, data) {
			var _this2 = this;
	
			event.preventDefault();
	
			var row = $(event.target).closest('tr'),
			    nextRow = row;
	
			if (event.shiftKey) {
				if (previous == 'comments') {
					nextRow = nextRow.prev('tr');
	
					index--;
				}
			} else {
				if (next == 'baume' || !this.allowBaume && next == 'temp') {
					nextRow = nextRow.next('tr');
	
					index++;
				}
			}
	
			if (data.locked) {
				return;
			}
	
			if (nextRow.length == 0) {
				this.handleTabToBlankRow(event, index, previous, next);
			} else {
				this.editing = {
					status: true,
					index: index,
					column: event.shiftKey ? previous : next
				};
			}
	
			_vue2.default.nextTick(function () {
				if (nextRow.length == 0) {
					nextRow = _this2.findNextRow(row);
				}
	
				nextRow = nextRow.find('td.' + _this2.editing.column);
	
				nextRow.find('input').focus();
			});
		}
	};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.caluculateMeasuringFreq = caluculateMeasuringFreq;
	function caluculateMeasuringFreq(freq) {
	  return parseFloat((1.0 / freq).toFixed(2));
	}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		fermentNotEnoughData: function fermentNotEnoughData(ferment) {
			if (!ferment.dailyData.data || !ferment.duration) {
				return true;
			}
	
			var baumeCount = 0;
	
			for (var i = 0; i < ferment.dailyData.data.length; ++i) {
				if (ferment.dailyData.data[i].baume) {
					baumeCount++;
				}
			}
	
			if (baumeCount < 4) {
				return true;
			}
	
			if (!ferment.volume) {
				return true;
			}
	
			return false;
		}
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toConsole = toConsole;
	
	var _config = __webpack_require__(12);
	
	function toConsole(msg) {
	  !_config.isProduction && console.log(msg);
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindEvents = bindEvents;
	exports.clearEventLoading = clearEventLoading;
	exports.startEvent = startEvent;
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _config = __webpack_require__(12);
	
	var _store = __webpack_require__(21);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileEvents = {
	  'dashboard-summary-csv-created': 'Dashboard data',
	  'history-file-created': 'History slsx file'
	};
	
	function bindEvents(channel) {
	  var _loop = function _loop(eventName) {
	    channel.bind(eventName, function (url) {
	      dumpDownloadLink(fileEvents[eventName], url);
	    });
	  };
	
	  for (var eventName in fileEvents) {
	    _loop(eventName);
	  }
	}
	
	function dumpDownloadLink(file, url) {
	  clearEventLoading();
	
	  _notify2.default.success(file + ' generated, click <a href="' + _config.config.API_PATH + '/' + url + '" target="_blank"><b>here</b></a> to download', { timeout: 0 });
	}
	
	function clearEventLoading() {
	  $('#toast-container').remove();
	  _store2.default.dispatch(types.SET_EVENT_LOADING, false);
	}
	
	function startEvent(type) {
	  _store2.default.dispatch(types.SET_EVENT_LOADING, true);
	  _notify2.default.success(type + ' data generating...', { timeout: 0 });
	}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.validate = undefined;
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _routes = __webpack_require__(31);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ValidatorJS = __webpack_require__(445);
	
	var Validator = function () {
		function Validator(data, rules) {
			var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
			(0, _classCallCheck3.default)(this, Validator);
	
			this.validator = new ValidatorJS(data, rules, messages);
		}
	
		(0, _createClass3.default)(Validator, [{
			key: 'passes',
			value: function passes(callback) {
				var _this = this;
	
				this.validator.passes(function () {
					_routes2.default.app.$broadcast('passedValidation');
	
					callback();
				});
	
				this.validator.fails(function () {
					_routes2.default.app.$broadcast('failedValidation', _this.validator.errors);
				});
			}
		}]);
		return Validator;
	}();
	
	exports.default = Validator;
	var validate = exports.validate = function validate(data, rules) {
		var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		return new Validator(data, rules, messages);
	};

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(250)
	__vue_template__ = __webpack_require__(447)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(400)
	__vue_script__ = __webpack_require__(251)
	__vue_template__ = __webpack_require__(448)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	+function (a) {
	  "use strict";
	  function b(b) {
	    return this.each(function () {
	      var d = a(this),
	          e = d.data("bs.toggle"),
	          f = "object" == (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) && b;e || d.data("bs.toggle", e = new c(this, f)), "string" == typeof b && e[b] && e[b]();
	    });
	  }var c = function c(b, _c) {
	    this.$element = a(b), this.options = a.extend({}, this.defaults(), _c), this.render();
	  };c.VERSION = "2.2.0", c.DEFAULTS = { on: "On", off: "Off", onstyle: "primary", offstyle: "default", size: "normal", style: "", width: null, height: null }, c.prototype.defaults = function () {
	    return { on: this.$element.attr("data-on") || c.DEFAULTS.on, off: this.$element.attr("data-off") || c.DEFAULTS.off, onstyle: this.$element.attr("data-onstyle") || c.DEFAULTS.onstyle, offstyle: this.$element.attr("data-offstyle") || c.DEFAULTS.offstyle, size: this.$element.attr("data-size") || c.DEFAULTS.size, style: this.$element.attr("data-style") || c.DEFAULTS.style, width: this.$element.attr("data-width") || c.DEFAULTS.width, height: this.$element.attr("data-height") || c.DEFAULTS.height };
	  }, c.prototype.render = function () {
	    this._onstyle = "btn-" + this.options.onstyle, this._offstyle = "btn-" + this.options.offstyle;var b = "large" === this.options.size ? "btn-lg" : "small" === this.options.size ? "btn-sm" : "mini" === this.options.size ? "btn-xs" : "",
	        c = a('<label class="btn">').html(this.options.on).addClass(this._onstyle + " " + b),
	        d = a('<label class="btn">').html(this.options.off).addClass(this._offstyle + " " + b + " active"),
	        e = a('<span class="toggle-handle btn btn-default">').addClass(b),
	        f = a('<div class="toggle-group">').append(c, d, e),
	        g = a('<div class="toggle btn" data-toggle="toggle">').addClass(this.$element.prop("checked") ? this._onstyle : this._offstyle + " off").addClass(b).addClass(this.options.style);this.$element.wrap(g), a.extend(this, { $toggle: this.$element.parent(), $toggleOn: c, $toggleOff: d, $toggleGroup: f }), this.$toggle.append(f);var h = this.options.width || Math.max(c.outerWidth(), d.outerWidth()) + e.outerWidth() / 2,
	        i = this.options.height || Math.max(c.outerHeight(), d.outerHeight());c.addClass("toggle-on"), d.addClass("toggle-off"), this.$toggle.css({ width: h, height: i }), this.options.height && (c.css("line-height", c.height() + "px"), d.css("line-height", d.height() + "px")), this.update(!0), this.trigger(!0);
	  }, c.prototype.toggle = function () {
	    this.$element.prop("checked") ? this.off() : this.on();
	  }, c.prototype.on = function (a) {
	    return this.$element.prop("disabled") ? !1 : (this.$toggle.removeClass(this._offstyle + " off").addClass(this._onstyle), this.$element.prop("checked", !0), void (a || this.trigger()));
	  }, c.prototype.off = function (a) {
	    return this.$element.prop("disabled") ? !1 : (this.$toggle.removeClass(this._onstyle).addClass(this._offstyle + " off"), this.$element.prop("checked", !1), void (a || this.trigger()));
	  }, c.prototype.enable = function () {
	    this.$toggle.removeAttr("disabled"), this.$element.prop("disabled", !1);
	  }, c.prototype.disable = function () {
	    this.$toggle.attr("disabled", "disabled"), this.$element.prop("disabled", !0);
	  }, c.prototype.update = function (a) {
	    this.$element.prop("disabled") ? this.disable() : this.enable(), this.$element.prop("checked") ? this.on(a) : this.off(a);
	  }, c.prototype.trigger = function (b) {
	    this.$element.off("change.bs.toggle"), b || this.$element.change(), this.$element.on("change.bs.toggle", a.proxy(function () {
	      this.update();
	    }, this));
	  }, c.prototype.destroy = function () {
	    this.$element.off("change.bs.toggle"), this.$toggleGroup.remove(), this.$element.removeData("bs.toggle"), this.$element.unwrap();
	  };var d = a.fn.bootstrapToggle;a.fn.bootstrapToggle = b, a.fn.bootstrapToggle.Constructor = c, a.fn.toggle.noConflict = function () {
	    return a.fn.bootstrapToggle = d, this;
	  }, a(function () {
	    a("input[type=checkbox][data-toggle^=toggle]").bootstrapToggle();
	  }), a(document).on("click.bs.toggle", "div[data-toggle^=toggle]", function (b) {
	    var c = a(this).find("input[type=checkbox]");c.bootstrapToggle("toggle"), b.preventDefault();
	  });
	}(jQuery);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(require('jquery'));
	  } else {
	    factory(jQuery);
	  }
	})(function ($) {
	  var slice = Array.prototype.slice;
	  var splice = Array.prototype.splice;
	
	  var defaults = {
	    topSpacing: 0,
	    bottomSpacing: 0,
	    className: 'is-sticky',
	    wrapperClassName: 'sticky-wrapper',
	    center: false,
	    getWidthFrom: '',
	    widthFromWrapper: true,
	    responsiveWidth: false,
	    zIndex: 'auto'
	  },
	      $window = $(window),
	      $document = $(document),
	      sticked = [],
	      windowHeight = $window.height(),
	      scroller = function scroller() {
	    var scrollTop = $window.scrollTop(),
	        documentHeight = $document.height(),
	        dwh = documentHeight - windowHeight,
	        extra = scrollTop > dwh ? dwh - scrollTop : 0;
	
	    for (var i = 0, l = sticked.length; i < l; i++) {
	      var s = sticked[i],
	          elementTop = s.stickyWrapper.offset().top,
	          etse = elementTop - s.topSpacing - extra;
	
	      s.stickyWrapper.css('height', s.stickyElement.outerHeight());
	
	      if (scrollTop <= etse) {
	        if (s.currentTop !== null) {
	          s.stickyElement.css({
	            'width': '',
	            'position': '',
	            'top': '',
	            'z-index': ''
	          });
	          s.stickyElement.parent().removeClass(s.className);
	          s.stickyElement.trigger('sticky-end', [s]);
	          s.currentTop = null;
	        }
	      } else {
	        var newTop = documentHeight - s.stickyElement.outerHeight() - s.topSpacing - s.bottomSpacing - scrollTop - extra;
	        if (newTop < 0) {
	          newTop = newTop + s.topSpacing;
	        } else {
	          newTop = s.topSpacing;
	        }
	        if (s.currentTop !== newTop) {
	          var newWidth;
	          if (s.getWidthFrom) {
	            newWidth = $(s.getWidthFrom).width() || null;
	          } else if (s.widthFromWrapper) {
	            newWidth = s.stickyWrapper.width();
	          }
	          if (newWidth == null) {
	            newWidth = s.stickyElement.width();
	          }
	          s.stickyElement.css('width', newWidth).css('position', 'fixed').css('top', newTop).css('z-index', s.zIndex);
	
	          s.stickyElement.parent().addClass(s.className);
	
	          if (s.currentTop === null) {
	            s.stickyElement.trigger('sticky-start', [s]);
	          } else {
	            s.stickyElement.trigger('sticky-update', [s]);
	          }
	
	          if (s.currentTop === s.topSpacing && s.currentTop > newTop || s.currentTop === null && newTop < s.topSpacing) {
	            s.stickyElement.trigger('sticky-bottom-reached', [s]);
	          } else if (s.currentTop !== null && newTop === s.topSpacing && s.currentTop < newTop) {
	            s.stickyElement.trigger('sticky-bottom-unreached', [s]);
	          }
	
	          s.currentTop = newTop;
	        }
	
	        var stickyWrapperContainer = s.stickyWrapper.parent();
	        var unstick = s.stickyElement.offset().top + s.stickyElement.outerHeight() >= stickyWrapperContainer.offset().top + stickyWrapperContainer.outerHeight() && s.stickyElement.offset().top <= s.topSpacing;
	
	        if (unstick) {
	          s.stickyElement.css('position', 'absolute').css('top', '').css('bottom', 0).css('z-index', '');
	        } else {
	          s.stickyElement.css('position', 'fixed').css('top', newTop).css('bottom', '').css('z-index', s.zIndex);
	        }
	      }
	    }
	  },
	      resizer = function resizer() {
	    windowHeight = $window.height();
	
	    for (var i = 0, l = sticked.length; i < l; i++) {
	      var s = sticked[i];
	      var newWidth = null;
	      if (s.getWidthFrom) {
	        if (s.responsiveWidth) {
	          newWidth = $(s.getWidthFrom).width();
	        }
	      } else if (s.widthFromWrapper) {
	        newWidth = s.stickyWrapper.width();
	      }
	      if (newWidth != null) {
	        s.stickyElement.css('width', newWidth);
	      }
	    }
	  },
	      methods = {
	    init: function init(options) {
	      var o = $.extend({}, defaults, options);
	      return this.each(function () {
	        var stickyElement = $(this);
	
	        var stickyId = stickyElement.attr('id');
	        var wrapperId = stickyId ? stickyId + '-' + defaults.wrapperClassName : defaults.wrapperClassName;
	        var wrapper = $('<div></div>').attr('id', wrapperId).addClass(o.wrapperClassName);
	
	        stickyElement.wrapAll(function () {
	          if ($(this).parent("#" + wrapperId).length == 0) {
	            return wrapper;
	          }
	        });
	
	        var stickyWrapper = stickyElement.parent();
	
	        if (o.center) {
	          stickyWrapper.css({ width: stickyElement.outerWidth(), marginLeft: "auto", marginRight: "auto" });
	        }
	
	        if (stickyElement.css("float") === "right") {
	          stickyElement.css({ "float": "none" }).parent().css({ "float": "right" });
	        }
	
	        o.stickyElement = stickyElement;
	        o.stickyWrapper = stickyWrapper;
	        o.currentTop = null;
	
	        sticked.push(o);
	
	        methods.setWrapperHeight(this);
	        methods.setupChangeListeners(this);
	      });
	    },
	
	    setWrapperHeight: function setWrapperHeight(stickyElement) {
	      var element = $(stickyElement);
	      var stickyWrapper = element.parent();
	      if (stickyWrapper) {
	        stickyWrapper.css('height', element.outerHeight());
	      }
	    },
	
	    setupChangeListeners: function setupChangeListeners(stickyElement) {
	      if (window.MutationObserver) {
	        var mutationObserver = new window.MutationObserver(function (mutations) {
	          if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
	            methods.setWrapperHeight(stickyElement);
	          }
	        });
	        mutationObserver.observe(stickyElement, { subtree: true, childList: true });
	      } else {
	        stickyElement.addEventListener('DOMNodeInserted', function () {
	          methods.setWrapperHeight(stickyElement);
	        }, false);
	        stickyElement.addEventListener('DOMNodeRemoved', function () {
	          methods.setWrapperHeight(stickyElement);
	        }, false);
	      }
	    },
	    update: scroller,
	    unstick: function unstick(options) {
	      return this.each(function () {
	        var that = this;
	        var unstickyElement = $(that);
	
	        var removeIdx = -1;
	        var i = sticked.length;
	        while (i-- > 0) {
	          if (sticked[i].stickyElement.get(0) === that) {
	            splice.call(sticked, i, 1);
	            removeIdx = i;
	          }
	        }
	        if (removeIdx !== -1) {
	          unstickyElement.unwrap();
	          unstickyElement.css({
	            'width': '',
	            'position': '',
	            'top': '',
	            'float': '',
	            'z-index': ''
	          });
	        }
	      });
	    }
	  };
	
	  if (window.addEventListener) {
	    window.addEventListener('scroll', scroller, false);
	    window.addEventListener('resize', resizer, false);
	  } else if (window.attachEvent) {
	    window.attachEvent('onscroll', scroller);
	    window.attachEvent('onresize', resizer);
	  }
	
	  $.fn.sticky = function (method) {
	    if (methods[method]) {
	      return methods[method].apply(this, slice.call(arguments, 1));
	    } else if ((typeof method === 'undefined' ? 'undefined' : (0, _typeof3.default)(method)) === 'object' || !method) {
	      return methods.init.apply(this, arguments);
	    } else {
	      $.error('Method ' + method + ' does not exist on jQuery.sticky');
	    }
	  };
	
	  $.fn.unstick = function (method) {
	    if (methods[method]) {
	      return methods[method].apply(this, slice.call(arguments, 1));
	    } else if ((typeof method === 'undefined' ? 'undefined' : (0, _typeof3.default)(method)) === 'object' || !method) {
	      return methods.unstick.apply(this, arguments);
	    } else {
	      $.error('Method ' + method + ' does not exist on jQuery.sticky');
	    }
	  };
	  $(function () {
	    setTimeout(scroller, 0);
	  });
	});

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($, window, document, undefined) {
		'use strict';
	
		var pluginName = "loader",
		    defaults = {
			progress: 0,
			frontSpeed: 0.021,
			frontColor: 'green',
			frontOpacity: 0.5,
			backSpeed: 0.025,
			backColor: 'green',
			backOpacity: 0.2
		},
		    requestAnimationFrame = function () {
			var vendors = ['ms', 'moz', 'webkit', 'o'],
			    raf = null,
			    lastTime = 0;
	
			for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
				raf = window[vendors[x] + 'RequestAnimationFrame'];
			}
	
			if (!raf) {
				raf = function raf(callback, element) {
					var currTime = new Date().getTime(),
					    timeToCall = Math.max(0, 16 - (currTime - lastTime)),
					    id = window.setTimeout(function () {
						callback(currTime + timeToCall);
					}, timeToCall);
	
					lastTime = currTime + timeToCall;
	
					return id;
				};
			}
	
			return raf;
		}(),
		    cancelAnimationFrame = function () {
			var vendors = ['ms', 'moz', 'webkit', 'o'],
			    caf = null;
	
			for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
				caf = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
			}
	
			if (!caf) {
				caf = function caf(id) {
					clearTimeout(id);
				};
			}
	
			return caf;
		}();
	
		function Oscillator(variation, max, speed, horizon) {
			this.variation = variation || 0.1;
			this.max = max || 5;
			this.speed = speed || 0.02;
			this.horizon = horizon || 0;
	
			this._pt = 0;
			this._max = this._getMax();
		}
	
		$.extend(Oscillator.prototype, {
			getAmp: function getAmp() {
				this._pt += this.speed;
	
				if (this._pt >= 2.0) {
					this._pt = 0;
					this._max = this._getMax();
				}
	
				return this._max * Math.sin(this._pt * Math.PI) + this.horizon;
			},
	
			_getMax: function _getMax() {
				return Math.random() * this.max * this.variation + this.max * (1 - this.variation);
			}
	
		});
	
		function Plugin(element, options) {
			this.element = element;
			this.$el = $(element);
			this.options = $.extend({}, defaults, options);
			this._defaults = defaults;
			this._name = pluginName;
	
			this._width = this.$el.width();
			this._height = this.$el.height();
	
			this.init();
		}
	
		Plugin.prototype = {
	
			init: function init() {
				var canvas = $('<canvas></canvas>'),
				    counter = $('<div></div>', {
					'class': 'counter'
				}),
				    STEPS = 20;
	
				canvas[0].width = this._width;
				canvas[0].height = this._height;
	
				this._ctx = canvas[0].getContext('2d');
				this._counter = counter;
	
				this.$el.append(canvas);
				this.$el.append(counter);
	
				this._frontOscillator = new Oscillator();
				this._backOscillator = new Oscillator();
	
				this._frontOscillator.speed = this.options.frontSpeed;
				this._frontOscillator.horizon = this.options.progress;
				this._backOscillator.speed = this.options.backSpeed;
				this._backOscillator.horizon = this.options.progress;
	
				this._frontOscillatorPts = new Array(STEPS);
				this._backOscillatorPts = new Array(STEPS);
	
				this._fillOscillatorPts(this._frontOscillatorPts, this._frontOscillator);
				this._fillOscillatorPts(this._backOscillatorPts, this._backOscillator);
	
				this._step = Math.ceil(this._width / (STEPS - 1));
	
				this._writeProgress(this.options.progress);
				this.animate();
			},
	
			_fillOscillatorPts: function _fillOscillatorPts(pts, oscillator) {
				for (var i = 0, l = pts.length; i < l; i++) {
					pts[i] = oscillator.getAmp();
				}
			},
	
			_shiftPts: function _shiftPts(pts) {
				for (var i = 0, l = pts.length - 1; i < l; i++) {
					pts[i] = pts[i + 1];
				}
			},
	
			_draw: function _draw(pts) {
				this._ctx.beginPath();
	
				for (var i = 0, l = pts.length; i < l; i++) {
					this._ctx.lineTo(i * this._step, this._height - pts[i]);
				}
	
				this._ctx.lineTo(this._width, this._height);
				this._ctx.lineTo(0, this._height);
				this._ctx.lineTo(0, this._height - pts[0]);
	
				this._ctx.fill();
			},
	
			_writeProgress: function _writeProgress(progress) {
				this._counter.text(progress + '%');
			},
	
			animate: function animate() {
				this._shiftPts(this._frontOscillatorPts);
				this._shiftPts(this._backOscillatorPts);
	
				this._frontOscillatorPts[this._frontOscillatorPts.length - 1] = this._frontOscillator.getAmp();
				this._backOscillatorPts[this._backOscillatorPts.length - 1] = this._backOscillator.getAmp();
	
				this._ctx.clearRect(0, 0, this._width, this._height);
	
				this._ctx.globalAlpha = this.options.backOpacity;
				this._ctx.fillStyle = this.options.backColor;
				this._draw(this._backOscillatorPts);
				this._ctx.globalAlpha = this.options.frontOpacity;
				this._ctx.fillStyle = this.options.frontColor;
				this._draw(this._frontOscillatorPts);
	
				this._animateFrame = requestAnimationFrame($.proxy(this.animate, this));
			},
	
			setProgress: function setProgress(progress) {
				if (progress < 0) {
					progress = 0;
				} else if (progress > 100) {
					progress = 100;
				}
	
				this._frontOscillator.horizon = progress;
				this._backOscillator.horizon = progress;
	
				this._writeProgress(progress);
			},
	
			destroy: function destroy() {
				cancelAnimationFrame(this._animateFrame);
			}
		};
	
		$.fn[pluginName] = function (options) {
			var args = Array.prototype.slice.call(arguments, 0);
	
			return this.each(function () {
				var plugin = $.data(this, "plugin_" + pluginName),
				    method = null;
	
				if (!plugin) {
					$.data(this, "plugin_" + pluginName, new Plugin(this, options));
				} else if ($.type(args[0]) === 'string' && args[0].charAt(0) !== '_') {
					method = plugin[args[0]];
	
					if (method) {
						method.apply(plugin, args.slice(1));
					}
				}
			});
		};
	})(jQuery, window, document);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	(function (factory) {
	    "use strict";
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(425)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        factory(window.jQuery);
	    }
	})(function ($) {
	    "use strict";
	
	    function isOverAxis(x, reference, size) {
	        return x > reference && x < reference + size;
	    }
	
	    $.widget("mjs.nestedSortable", $.extend({}, $.ui.sortable.prototype, {
	
	        options: {
	            disableParentChange: false,
	            doNotClear: false,
	            expandOnHover: 700,
	            isAllowed: function isAllowed() {
	                return true;
	            },
	            isTree: false,
	            listType: "ol",
	            maxLevels: 0,
	            protectRoot: false,
	            rootID: null,
	            rtl: false,
	            startCollapsed: false,
	            tabSize: 20,
	
	            branchClass: "mjs-nestedSortable-branch",
	            collapsedClass: "mjs-nestedSortable-collapsed",
	            disableNestingClass: "mjs-nestedSortable-no-nesting",
	            errorClass: "mjs-nestedSortable-error",
	            expandedClass: "mjs-nestedSortable-expanded",
	            hoveringClass: "mjs-nestedSortable-hovering",
	            leafClass: "mjs-nestedSortable-leaf",
	            disabledClass: "mjs-nestedSortable-disabled"
	        },
	
	        _create: function _create() {
	            var self = this,
	                err;
	
	            this.element.data("ui-sortable", this.element.data("mjs-nestedSortable"));
	
	            if (!this.element.is(this.options.listType)) {
	                err = "nestedSortable: " + "Please check that the listType option is set to your actual list type";
	
	                throw new Error(err);
	            }
	
	            if (this.options.isTree && this.options.expandOnHover) {
	                this.options.tolerance = "intersect";
	            }
	
	            $.ui.sortable.prototype._create.apply(this, arguments);
	
	            if (this.options.isTree) {
	                $(this.items).each(function () {
	                    var $li = this.item,
	                        hasCollapsedClass = $li.hasClass(self.options.collapsedClass),
	                        hasExpandedClass = $li.hasClass(self.options.expandedClass);
	
	                    if ($li.children(self.options.listType).length) {
	                        $li.addClass(self.options.branchClass);
	
	
	                        if (!hasCollapsedClass && !hasExpandedClass) {
	                            if (self.options.startCollapsed) {
	                                $li.addClass(self.options.collapsedClass);
	                            } else {
	                                $li.addClass(self.options.expandedClass);
	                            }
	                        }
	                    } else {
	                        $li.addClass(self.options.leafClass);
	                    }
	                });
	            }
	        },
	
	        _destroy: function _destroy() {
	            this.element.removeData("mjs-nestedSortable").removeData("ui-sortable");
	            return $.ui.sortable.prototype._destroy.apply(this, arguments);
	        },
	
	        _mouseDrag: function _mouseDrag(event) {
	            var i,
	                item,
	                itemElement,
	                intersection,
	                self = this,
	                o = this.options,
	                scrolled = false,
	                $document = $(document),
	                previousTopOffset,
	                parentItem,
	                level,
	                childLevels,
	                itemAfter,
	                itemBefore,
	                newList,
	                method,
	                a,
	                previousItem,
	                nextItem,
	                helperIsNotSibling;
	
	            this.position = this._generatePosition(event);
	            this.positionAbs = this._convertPositionTo("absolute");
	
	            if (!this.lastPositionAbs) {
	                this.lastPositionAbs = this.positionAbs;
	            }
	
	            if (this.options.scroll) {
	                if (this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {
	
	                    if (this.overflowOffset.top + this.scrollParent[0].offsetHeight - event.pageY < o.scrollSensitivity) {
	                        scrolled = this.scrollParent.scrollTop() + o.scrollSpeed;
	                        this.scrollParent.scrollTop(scrolled);
	                    } else if (event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
	                        scrolled = this.scrollParent.scrollTop() - o.scrollSpeed;
	                        this.scrollParent.scrollTop(scrolled);
	                    }
	
	                    if (this.overflowOffset.left + this.scrollParent[0].offsetWidth - event.pageX < o.scrollSensitivity) {
	                        scrolled = this.scrollParent.scrollLeft() + o.scrollSpeed;
	                        this.scrollParent.scrollLeft(scrolled);
	                    } else if (event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
	                        scrolled = this.scrollParent.scrollLeft() - o.scrollSpeed;
	                        this.scrollParent.scrollLeft(scrolled);
	                    }
	                } else {
	
	                    if (event.pageY - $document.scrollTop() < o.scrollSensitivity) {
	                        scrolled = $document.scrollTop() - o.scrollSpeed;
	                        $document.scrollTop(scrolled);
	                    } else if ($(window).height() - (event.pageY - $document.scrollTop()) < o.scrollSensitivity) {
	                        scrolled = $document.scrollTop() + o.scrollSpeed;
	                        $document.scrollTop(scrolled);
	                    }
	
	                    if (event.pageX - $document.scrollLeft() < o.scrollSensitivity) {
	                        scrolled = $document.scrollLeft() - o.scrollSpeed;
	                        $document.scrollLeft(scrolled);
	                    } else if ($(window).width() - (event.pageX - $document.scrollLeft()) < o.scrollSensitivity) {
	                        scrolled = $document.scrollLeft() + o.scrollSpeed;
	                        $document.scrollLeft(scrolled);
	                    }
	                }
	
	                if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
	                    $.ui.ddmanager.prepareOffsets(this, event);
	                }
	            }
	
	            this.positionAbs = this._convertPositionTo("absolute");
	
	            previousTopOffset = this.placeholder.offset().top;
	
	            if (!this.options.axis || this.options.axis !== "y") {
	                this.helper[0].style.left = this.position.left + "px";
	            }
	            if (!this.options.axis || this.options.axis !== "x") {
	                this.helper[0].style.top = this.position.top + "px";
	            }
	
	            this.hovering = this.hovering ? this.hovering : null;
	            this.mouseentered = this.mouseentered ? this.mouseentered : false;
	
	            (function () {
	                var _parentItem = this.placeholder.parent().parent();
	                if (_parentItem && _parentItem.closest(".ui-sortable").length) {
	                    parentItem = _parentItem;
	                }
	            }).call(this);
	
	            level = this._getLevel(this.placeholder);
	            childLevels = this._getChildLevels(this.helper);
	            newList = document.createElement(o.listType);
	
	            for (i = this.items.length - 1; i >= 0; i--) {
	                item = this.items[i];
	                itemElement = item.item[0];
	                intersection = this._intersectsWithPointer(item);
	                if (!intersection) {
	                    continue;
	                }
	
	                if (item.instance !== this.currentContainer) {
	                    continue;
	                }
	
	                if (itemElement.className.indexOf(o.disabledClass) !== -1) {
	                    if (intersection === 2) {
	                        itemAfter = this.items[i + 1];
	                        if (itemAfter && itemAfter.item.hasClass(o.disabledClass)) {
	                            continue;
	                        }
	                    } else if (intersection === 1) {
	                        itemBefore = this.items[i - 1];
	                        if (itemBefore && itemBefore.item.hasClass(o.disabledClass)) {
	                            continue;
	                        }
	                    }
	                }
	
	                method = intersection === 1 ? "next" : "prev";
	
	                if (itemElement !== this.currentItem[0] && this.placeholder[method]()[0] !== itemElement && !$.contains(this.placeholder[0], itemElement) && (this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)) {
	                    if (!this.mouseentered) {
	                        $(itemElement).mouseenter();
	                        this.mouseentered = true;
	                    }
	
	                    if (o.isTree && $(itemElement).hasClass(o.collapsedClass) && o.expandOnHover) {
	                        if (!this.hovering) {
	                            $(itemElement).addClass(o.hoveringClass);
	                            this.hovering = window.setTimeout(function () {
	                                $(itemElement).removeClass(o.collapsedClass).addClass(o.expandedClass);
	
	                                self.refreshPositions();
	                                self._trigger("expand", event, self._uiHash());
	                            }, o.expandOnHover);
	                        }
	                    }
	
	                    this.direction = intersection === 1 ? "down" : "up";
	
	                    if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
	                        $(itemElement).mouseleave();
	                        this.mouseentered = false;
	                        $(itemElement).removeClass(o.hoveringClass);
	                        if (this.hovering) {
	                            window.clearTimeout(this.hovering);
	                        }
	                        this.hovering = null;
	
	                        if (o.protectRoot && !(this.currentItem[0].parentNode === this.element[0] && itemElement.parentNode !== this.element[0])) {
	                            if (this.currentItem[0].parentNode !== this.element[0] && itemElement.parentNode === this.element[0]) {
	
	                                if (!$(itemElement).children(o.listType).length) {
	                                    itemElement.appendChild(newList);
	                                    if (o.isTree) {
	                                        $(itemElement).removeClass(o.leafClass).addClass(o.branchClass + " " + o.expandedClass);
	                                    }
	                                }
	
	                                if (this.direction === "down") {
	                                    a = $(itemElement).prev().children(o.listType);
	                                } else {
	                                    a = $(itemElement).children(o.listType);
	                                }
	
	                                if (a[0] !== undefined) {
	                                    this._rearrange(event, null, a);
	                                }
	                            } else {
	                                this._rearrange(event, item);
	                            }
	                        } else if (!o.protectRoot) {
	                            this._rearrange(event, item);
	                        }
	                    } else {
	                        break;
	                    }
	
	                    this._clearEmpty(itemElement);
	
	                    this._trigger("change", event, this._uiHash());
	                    break;
	                }
	            }
	
	            (function () {
	                var _previousItem = this.placeholder.prev();
	                if (_previousItem.length) {
	                    previousItem = _previousItem;
	                } else {
	                    previousItem = null;
	                }
	            }).call(this);
	
	            if (previousItem != null) {
	                while (previousItem[0].nodeName.toLowerCase() !== "li" || previousItem[0].className.indexOf(o.disabledClass) !== -1 || previousItem[0] === this.currentItem[0] || previousItem[0] === this.helper[0]) {
	                    if (previousItem[0].previousSibling) {
	                        previousItem = $(previousItem[0].previousSibling);
	                    } else {
	                        previousItem = null;
	                        break;
	                    }
	                }
	            }
	
	            (function () {
	                var _nextItem = this.placeholder.next();
	                if (_nextItem.length) {
	                    nextItem = _nextItem;
	                } else {
	                    nextItem = null;
	                }
	            }).call(this);
	
	            if (nextItem != null) {
	                while (nextItem[0].nodeName.toLowerCase() !== "li" || nextItem[0].className.indexOf(o.disabledClass) !== -1 || nextItem[0] === this.currentItem[0] || nextItem[0] === this.helper[0]) {
	                    if (nextItem[0].nextSibling) {
	                        nextItem = $(nextItem[0].nextSibling);
	                    } else {
	                        nextItem = null;
	                        break;
	                    }
	                }
	            }
	
	            this.beyondMaxLevels = 0;
	
	            if (parentItem != null && nextItem == null && !(o.protectRoot && parentItem[0].parentNode == this.element[0]) && (o.rtl && this.positionAbs.left + this.helper.outerWidth() > parentItem.offset().left + parentItem.outerWidth() || !o.rtl && this.positionAbs.left < parentItem.offset().left)) {
	
	                parentItem.after(this.placeholder[0]);
	                helperIsNotSibling = !parentItem.children(o.listItem).children("li:visible:not(.ui-sortable-helper)").length;
	                if (o.isTree && helperIsNotSibling) {
	                    parentItem.removeClass(this.options.branchClass + " " + this.options.expandedClass).addClass(this.options.leafClass);
	                }
	                if (typeof parentItem !== 'undefined') this._clearEmpty(parentItem[0]);
	                this._trigger("change", event, this._uiHash());
	            } else if (previousItem != null && !previousItem.hasClass(o.disableNestingClass) && (previousItem.children(o.listType).length && previousItem.children(o.listType).is(":visible") || !previousItem.children(o.listType).length) && !(o.protectRoot && this.currentItem[0].parentNode === this.element[0]) && (o.rtl && this.positionAbs.left + this.helper.outerWidth() < previousItem.offset().left + previousItem.outerWidth() - o.tabSize || !o.rtl && this.positionAbs.left > previousItem.offset().left + o.tabSize)) {
	
	                this._isAllowed(previousItem, level, level + childLevels + 1);
	
	                if (!previousItem.children(o.listType).length) {
	                    previousItem[0].appendChild(newList);
	                    if (o.isTree) {
	                        previousItem.removeClass(o.leafClass).addClass(o.branchClass + " " + o.expandedClass);
	                    }
	                }
	
	                if (previousTopOffset && previousTopOffset <= previousItem.offset().top) {
	                    previousItem.children(o.listType).prepend(this.placeholder);
	                } else {
	                    previousItem.children(o.listType)[0].appendChild(this.placeholder[0]);
	                }
	                if (typeof parentItem !== 'undefined') this._clearEmpty(parentItem[0]);
	                this._trigger("change", event, this._uiHash());
	            } else {
	                this._isAllowed(parentItem, level, level + childLevels);
	            }
	
	            this._contactContainers(event);
	
	            if ($.ui.ddmanager) {
	                $.ui.ddmanager.drag(this, event);
	            }
	
	            this._trigger("sort", event, this._uiHash());
	
	            this.lastPositionAbs = this.positionAbs;
	            return false;
	        },
	
	        _mouseStop: function _mouseStop(event) {
	            if (this.beyondMaxLevels) {
	
	                this.placeholder.removeClass(this.options.errorClass);
	
	                if (this.domPosition.prev) {
	                    $(this.domPosition.prev).after(this.placeholder);
	                } else {
	                    $(this.domPosition.parent).prepend(this.placeholder);
	                }
	
	                this._trigger("revert", event, this._uiHash());
	            }
	
	            $("." + this.options.hoveringClass).mouseleave().removeClass(this.options.hoveringClass);
	
	            this.mouseentered = false;
	            if (this.hovering) {
	                window.clearTimeout(this.hovering);
	            }
	            this.hovering = null;
	
	            this._relocate_event = event;
	            this._pid_current = $(this.domPosition.parent).parent().attr("id");
	            this._sort_current = this.domPosition.prev ? $(this.domPosition.prev).next().index() : 0;
	            $.ui.sortable.prototype._mouseStop.apply(this, arguments);
	        },
	
	        _intersectsWithSides: function _intersectsWithSides(item) {
	
	            var half = this.options.isTree ? .8 : .5,
	                isOverBottomHalf = isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + item.height * half, item.height),
	                isOverTopHalf = isOverAxis(this.positionAbs.top + this.offset.click.top, item.top - item.height * half, item.height),
	                isOverRightHalf = isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + item.width / 2, item.width),
	                verticalDirection = this._getDragVerticalDirection(),
	                horizontalDirection = this._getDragHorizontalDirection();
	
	            if (this.floating && horizontalDirection) {
	                return horizontalDirection === "right" && isOverRightHalf || horizontalDirection === "left" && !isOverRightHalf;
	            } else {
	                return verticalDirection && (verticalDirection === "down" && isOverBottomHalf || verticalDirection === "up" && isOverTopHalf);
	            }
	        },
	
	        _contactContainers: function _contactContainers() {
	
	            if (this.options.protectRoot && this.currentItem[0].parentNode === this.element[0]) {
	                return;
	            }
	
	            $.ui.sortable.prototype._contactContainers.apply(this, arguments);
	        },
	
	        _clear: function _clear() {
	            var i, item;
	
	            $.ui.sortable.prototype._clear.apply(this, arguments);
	
	            if (!(this._pid_current === this._uiHash().item.parent().parent().attr("id") && this._sort_current === this._uiHash().item.index())) {
	                this._trigger("relocate", this._relocate_event, this._uiHash());
	            }
	
	            for (i = this.items.length - 1; i >= 0; i--) {
	                item = this.items[i].item[0];
	                this._clearEmpty(item);
	            }
	        },
	
	        serialize: function serialize(options) {
	
	            var o = $.extend({}, this.options, options),
	                items = this._getItemsAsjQuery(o && o.connected),
	                str = [];
	
	            $(items).each(function () {
	                var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || /(.+)[-=_](.+)/),
	                    pid = ($(o.item || this).parent(o.listType).parent(o.items).attr(o.attribute || "id") || "").match(o.expression || /(.+)[-=_](.+)/);
	
	                if (res) {
	                    str.push((o.key || res[1]) + "[" + (o.key && o.expression ? res[1] : res[2]) + "]" + "=" + (pid ? o.key && o.expression ? pid[1] : pid[2] : o.rootID));
	                }
	            });
	
	            if (!str.length && o.key) {
	                str.push(o.key + "=");
	            }
	
	            return str.join("&");
	        },
	
	        toHierarchy: function toHierarchy(options) {
	
	            var o = $.extend({}, this.options, options),
	                ret = [];
	
	            $(this.element).children(o.items).each(function () {
	                var level = _recursiveItems(this);
	                ret.push(level);
	            });
	
	            return ret;
	
	            function _recursiveItems(item) {
	                var id = ($(item).attr(o.attribute || "id") || "").match(o.expression || /(.+)[-=_](.+)/),
	                    currentItem;
	
	                var data = $(item).data();
	                if (data.nestedSortableItem) {
	                    delete data.nestedSortableItem;
	                }
	
	                if (id) {
	                    currentItem = {
	                        "id": id[2]
	                    };
	
	                    currentItem = $.extend({}, currentItem, data);
	
	                    if ($(item).children(o.listType).children(o.items).length > 0) {
	                        currentItem.children = [];
	                        $(item).children(o.listType).children(o.items).each(function () {
	                            var level = _recursiveItems(this);
	                            currentItem.children.push(level);
	                        });
	                    }
	                    return currentItem;
	                }
	            }
	        },
	
	        toArray: function toArray(options) {
	
	            var o = $.extend({}, this.options, options),
	                sDepth = o.startDepthCount || 0,
	                ret = [],
	                left = 1;
	
	            if (!o.excludeRoot) {
	                ret.push({
	                    "item_id": o.rootID,
	                    "parent_id": null,
	                    "depth": sDepth,
	                    "left": left,
	                    "right": ($(o.items, this.element).length + 1) * 2
	                });
	                left++;
	            }
	
	            $(this.element).children(o.items).each(function () {
	                left = _recursiveArray(this, sDepth, left);
	            });
	
	            ret = ret.sort(function (a, b) {
	                return a.left - b.left;
	            });
	
	            return ret;
	
	            function _recursiveArray(item, depth, _left) {
	
	                var right = _left + 1,
	                    id,
	                    pid,
	                    parentItem;
	
	                if ($(item).children(o.listType).children(o.items).length > 0) {
	                    depth++;
	                    $(item).children(o.listType).children(o.items).each(function () {
	                        right = _recursiveArray($(this), depth, right);
	                    });
	                    depth--;
	                }
	
	                id = $(item).attr(o.attribute || "id").match(o.expression || /(.+)[-=_](.+)/);
	
	                if (depth === sDepth) {
	                    pid = o.rootID;
	                } else {
	                    parentItem = $(item).parent(o.listType).parent(o.items).attr(o.attribute || "id").match(o.expression || /(.+)[-=_](.+)/);
	                    pid = parentItem[2];
	                }
	
	                if (id) {
	                    var data = $(item).children('div').data();
	                    var itemObj = $.extend(data, {
	                        "id": id[2],
	                        "parent_id": pid,
	                        "depth": depth,
	                        "left": _left,
	                        "right": right
	                    });
	                    ret.push(itemObj);
	                }
	
	                _left = right + 1;
	                return _left;
	            }
	        },
	
	        _clearEmpty: function _clearEmpty(item) {
	            function replaceClass(elem, search, replace, swap) {
	                if (swap) {
	                    search = [replace, replace = search][0];
	                }
	
	                $(elem).removeClass(search).addClass(replace);
	            }
	
	            var o = this.options,
	                childrenList = $(item).children(o.listType),
	                hasChildren = childrenList.has('li').length;
	
	            var doNotClear = o.doNotClear || hasChildren || o.protectRoot && $(item)[0] === this.element[0];
	
	            if (o.isTree) {
	                replaceClass(item, o.branchClass, o.leafClass, doNotClear);
	            }
	
	            if (!doNotClear) {
	                childrenList.parent().removeClass(o.expandedClass);
	                childrenList.remove();
	            }
	        },
	
	        _getLevel: function _getLevel(item) {
	
	            var level = 1,
	                list;
	
	            if (this.options.listType) {
	                list = item.closest(this.options.listType);
	                while (list && list.length > 0 && !list.is(".ui-sortable")) {
	                    level++;
	                    list = list.parent().closest(this.options.listType);
	                }
	            }
	
	            return level;
	        },
	
	        _getChildLevels: function _getChildLevels(parent, depth) {
	            var self = this,
	                o = this.options,
	                result = 0;
	            depth = depth || 0;
	
	            $(parent).children(o.listType).children(o.items).each(function (index, child) {
	                result = Math.max(self._getChildLevels(child, depth + 1), result);
	            });
	
	            return depth ? result + 1 : result;
	        },
	
	        _isAllowed: function _isAllowed(parentItem, level, levels) {
	            var o = this.options,
	                maxLevels = this.placeholder.closest(".ui-sortable").nestedSortable("option", "maxLevels"),
	                oldParent = this.currentItem.parent().parent(),
	                disabledByParentchange = o.disableParentChange && (typeof parentItem !== 'undefined' && !oldParent.is(parentItem) || typeof parentItem === 'undefined' && oldParent.is("li"));
	
	            if (disabledByParentchange || !o.isAllowed(this.placeholder, parentItem, this.currentItem)) {
	                this.placeholder.addClass(o.errorClass);
	                if (maxLevels < levels && maxLevels !== 0) {
	                    this.beyondMaxLevels = levels - maxLevels;
	                } else {
	                    this.beyondMaxLevels = 1;
	                }
	            } else {
	                if (maxLevels < levels && maxLevels !== 0) {
	                    this.placeholder.addClass(o.errorClass);
	                    this.beyondMaxLevels = levels - maxLevels;
	                } else {
	                    this.placeholder.removeClass(o.errorClass);
	                    this.beyondMaxLevels = 0;
	                }
	            }
	        }
	
	    }));
	
	    $.mjs.nestedSortable.prototype.options = $.extend({}, $.ui.sortable.prototype.options, $.mjs.nestedSortable.prototype.options);
	});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(36);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(22);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*!
	* Velocity.js: Accelerated JavaScript animation.
	* @version 0.0.0
	* @requires jQuery.js
	* @docs julian.com/research/velocity
	* @license Copyright 2014 Julian Shapiro. MIT License: http://en.wikipedia.org/wiki/MIT_License
	*/
	!function (e, t, a, r) {
	  function o(e) {
	    for (var t = -1, a = e ? e.length : 0, r = []; ++t < a;) {
	      var o = e[t];o && r.push(o);
	    }return r;
	  }function i(e) {
	    return "[object Function]" === Object.prototype.toString.call(e);
	  }function l(t) {
	    if (t) for (var a = new Date().getTime(), o = 0, i = e.velocity.State.calls.length; i > o; o++) {
	      if (e.velocity.State.calls[o]) {
	        var s = e.velocity.State.calls[o],
	            g = s[0],
	            d = s[2],
	            f = s[3];f || (f = e.velocity.State.calls[o][3] = a - 16);for (var y = Math.min((a - f) / d.duration, 1), m = 0, h = g.length; h > m; m++) {
	          var v = g[m],
	              x = v.element;if (e.data(x, u)) {
	            var P = !1;d.display && "none" !== d.display && (p.setPropertyValue(x, "display", d.display), e.velocity.State.calls[o][2].display = !1);for (var b in v) {
	              if ("element" !== b) {
	                var V = v[b],
	                    S = V.currentValue,
	                    k;if (k = 1 === y ? V.endValue : V.startValue + (V.endValue - V.startValue) * e.easing[V.easing](y), V.currentValue = k, p.Hooks.registered[b]) {
	                  var w = p.Hooks.getRoot(b),
	                      C = e.data(x, u).rootPropertyValueCache[w];C && (V.rootPropertyValue = C);
	                }var T = p.setPropertyValue(x, b, V.currentValue + ("auto" === k ? "" : V.unitType), V.rootPropertyValue);p.Hooks.registered[b] && (e.data(x, u).rootPropertyValueCache[w] = p.Normalizations.registered[w] ? p.Normalizations.registered[w]("extract", null, T[1]) : T[1]), "transform" === T[0] && (P = !0);
	              }
	            }d.mobileHA && (e.data(x, u).transformCache.translate3d === r ? (e.data(x, u).transformCache.translate3d = "(0, 0, 0)", P = !0) : 1 === y && (delete e.data(x, u).transformCache.translate3d, P = !0)), P && p.flushTransformCache(x);
	          }
	        }1 === y && n(o);
	      }
	    }e.velocity.State.isTicking && c(l);
	  }function n(t) {
	    for (var a = e.velocity.State.calls[t][0], o = e.velocity.State.calls[t][1], i = e.velocity.State.calls[t][2], l = !1, n = 0, s = a.length; s > n; n++) {
	      var c = a[n].element;"none" === i.display && i.loop === !1 && p.setPropertyValue(c, "display", i.display), e.queue(c)[1] !== r && /\$\.velocity\.queueEntryFlag/i.test(e.queue(c)[1]) || e.data(c, u) && (e.data(c, u).isAnimating = !1, e.data(c, u).rootPropertyValueCache = {}), e.dequeue(c);
	    }e.velocity.State.calls[t] = !1;for (var g = 0, d = e.velocity.State.calls.length; d > g; g++) {
	      if (e.velocity.State.calls[g] !== !1) {
	        l = !0;break;
	      }
	    }l === !1 && (e.velocity.State.isTicking = !1, delete e.velocity.State.calls, e.velocity.State.calls = []), i.complete && i.complete.call(o);
	  }var s = function () {
	    if (a.documentMode) return a.documentMode;for (var e = 7; e > 4; e--) {
	      var t = a.createElement("div");if (t.innerHTML = "<!--[if IE " + e + "]><span></span><![endif]-->", t.getElementsByTagName("span").length) return t = null, e;
	    }return r;
	  }(),
	      c = t.requestAnimationFrame || function () {
	    var e = 0;return t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function (t) {
	      var a = new Date().getTime(),
	          r;return r = Math.max(0, 16 - (a - e)), e = a + r, setTimeout(function () {
	        t(a + r);
	      }, r);
	    };
	  }();if (7 >= s) return void (e.fn.velocity = e.fn.animate);if (e.velocity !== r || e.fn.velocity !== r) return void console.log("Velocity is already loaded or its namespace is occupied.");!function () {
	    var t = {};e.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (e, a) {
	      t[a] = function (t) {
	        return Math.pow(t, e + 2);
	      };
	    }), e.extend(t, { Sine: function Sine(e) {
	        return 1 - Math.cos(e * Math.PI / 2);
	      }, Circ: function Circ(e) {
	        return 1 - Math.sqrt(1 - e * e);
	      }, Elastic: function Elastic(e) {
	        return 0 === e || 1 === e ? e : -Math.pow(2, 8 * (e - 1)) * Math.sin((80 * (e - 1) - 7.5) * Math.PI / 15);
	      }, Back: function Back(e) {
	        return e * e * (3 * e - 2);
	      }, Bounce: function Bounce(e) {
	        for (var t, a = 4; e < ((t = Math.pow(2, --a)) - 1) / 11;) {}return 1 / Math.pow(4, 3 - a) - 7.5625 * Math.pow((3 * t - 2) / 22 - e, 2);
	      } }), e.each(t, function (t, a) {
	      e.easing["easeIn" + t] = a, e.easing["easeOut" + t] = function (e) {
	        return 1 - a(1 - e);
	      }, e.easing["easeInOut" + t] = function (e) {
	        return .5 > e ? a(2 * e) / 2 : 1 - a(-2 * e + 2) / 2;
	      };
	    }), e.easing.spring = function (e) {
	      return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e);
	    };
	  }();var u = "velocity";e.velocity = { State: { isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), prefixElement: a.createElement("div"), prefixMatches: {}, scrollAnchor: null, scrollProperty: null, isTicking: !1, calls: [] }, Classes: { extracted: {}, extract: function extract() {} }, CSS: {}, Sequence: {}, animate: function animate() {}, debug: !1 }, t.pageYOffset !== r ? (e.velocity.State.scrollAnchor = t, e.velocity.State.scrollProperty = "pageYOffset") : (e.velocity.State.scrollAnchor = a.documentElement || a.body.parentNode || a.body, e.velocity.State.scrollProperty = "scrollTop"), e.velocity.Classes.extract = function () {
	    for (var t = a.styleSheets, r = {}, o = 0, i = t.length; i > o; o++) {
	      var l = t[o],
	          n;try {
	        if (!l.cssText && !l.cssRules) continue;n = l.cssText ? l.cssText.replace(/[\r\n]/g, "").match(/[^}]+\{[^{]+\}/g) : l.cssRules;for (var s = 0, c = n.length; c > s; s++) {
	          var u;if (l.cssText) u = n[s];else {
	            if (!n[s].cssText) continue;u = n[s].cssText;
	          }var p = u.match(/\.animate_([A-z0-9_-]+)(?:(\s+)?{)/);if (p) {
	            var g = p[1],
	                d = u.toLowerCase().match(/\{([\S\s]*)\}/)[1].match(/[A-z-][^;]+/g);r[g] || (r[g] = {});for (var f = 0, y = d.length; y > f; f++) {
	              var m = d[f].match(/([^:]+):\s*(.+)/);r[g][m[1]] = m[2];
	            }
	          }
	        }
	      } catch (h) {}
	    }return e.velocity.Classes.extracted = r, e.velocity.debug && console.log("Classes: " + (0, _stringify2.default)(e.velocity.Classes.extracted)), r;
	  };var p = e.velocity.CSS = { RegEx: { valueUnwrap: /^[A-z]+\((.*)\)$/i, wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/, valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi }, Hooks: { templates: { color: ["Red Green Blue Alpha", "255 255 255 1"], backgroundColor: ["Red Green Blue Alpha", "255 255 255 1"], borderColor: ["Red Green Blue Alpha", "255 255 255 1"], outlineColor: ["Red Green Blue Alpha", "255 255 255 1"], textShadow: ["Color X Y Blur", "black 0px 0px 0px"], boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"], clip: ["Top Right Bottom Left", "0px 0px 0px 0px"], backgroundPosition: ["X Y", "0% 0%"], transformOrigin: ["X Y Z", "50% 50% 0%"], perspectiveOrigin: ["X Y", "50% 50%"] }, registered: {}, register: function register() {
	        var e, t, a;if (s) for (e in p.Hooks.templates) {
	          t = p.Hooks.templates[e], a = t[0].split(" ");var r = t[1].match(p.RegEx.valueSplit);"Color" === a[0] && (a.push(a.shift()), r.push(r.shift()), p.Hooks.templates[e] = [a.join(" "), r.join(" ")]);
	        }for (e in p.Hooks.templates) {
	          t = p.Hooks.templates[e], a = t[0].split(" ");for (var o in a) {
	            var i = e + a[o],
	                l = o;p.Hooks.registered[i] = [e, l];
	          }
	        }
	      }, getRoot: function getRoot(e) {
	        var t = p.Hooks.registered[e];return t ? t[0] : e;
	      }, cleanRootPropertyValue: function cleanRootPropertyValue(e, t) {
	        return p.RegEx.valueUnwrap.test(t) && (t = t.match(p.Hooks.RegEx.valueUnwrap)[1]), p.Values.isCSSNullValue(t) && (t = p.Hooks.templates[e][1]), t;
	      }, extractValue: function extractValue(e, t) {
	        var a = p.Hooks.registered[e];if (a) {
	          var r = a[0],
	              o = a[1];return t = p.Hooks.cleanRootPropertyValue(r, t), t.toString().match(p.RegEx.valueSplit)[o];
	        }return t;
	      }, injectValue: function injectValue(e, t, a) {
	        var r = p.Hooks.registered[e];if (r) {
	          var o = r[0],
	              i = r[1],
	              l,
	              n;return a = p.Hooks.cleanRootPropertyValue(o, a), l = a.toString().match(p.RegEx.valueSplit), l[i] = t, n = l.join(" ");
	        }return a;
	      } }, Normalizations: { registered: { clip: function clip(e, t, a) {
	          switch (e) {case "name":
	              return "clip";case "extract":
	              var r;return p.RegEx.wrappedValueAlreadyExtracted.test(a) ? r = a : (r = a.toString().match(p.RegEx.valueUnwrap), r && (r = r[1].replace(/,(\s+)?/g, " "))), r;case "inject":
	              return "rect(" + a + ")";}
	        }, opacity: function opacity(e, t, a) {
	          if (8 >= s) switch (e) {case "name":
	              return "filter";case "extract":
	              var r = a.toString().match(/alpha\(opacity=(.*)\)/i);return a = r ? r[1] / 100 : 1;case "inject":
	              return t.style.zoom = 1, "alpha(opacity=" + parseInt(100 * a) + ")";} else switch (e) {case "name":
	              return "opacity";case "extract":
	              return a;case "inject":
	              return a;}
	        } }, register: function register() {
	        function t(e) {
	          var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
	              a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
	              r;return e = e.replace(t, function (e, t, a, r) {
	            return t + t + a + a + r + r;
	          }), r = a.exec(e), r ? "rgb(" + (parseInt(r[1], 16) + " " + parseInt(r[2], 16) + " " + parseInt(r[3], 16)) + ")" : "rgb(0 0 0)";
	        }var a = ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"];9 >= s || (a = a.concat(["translateZ", "scaleZ", "rotateX", "rotateY"]));for (var o = 0, i = a.length; i > o; o++) {
	          !function () {
	            var t = a[o];p.Normalizations.registered[t] = function (a, o, i) {
	              switch (a) {case "name":
	                  return "transform";case "extract":
	                  return e.data(o, u).transformCache[t] === r ? /^scale/i.test(t) ? 1 : 0 : e.data(o, u).transformCache[t].replace(/[()]/g, "");case "inject":
	                  var l = !1;switch (t.substr(0, t.length - 1)) {case "translate":
	                      l = !/(%|px|em|rem|\d)$/i.test(i);break;case "scale":
	                      l = !/(\d)$/i.test(i);break;case "skew":
	                      l = !/(deg|\d)$/i.test(i);break;case "rotate":
	                      l = !/(deg|\d)$/i.test(i);}return l || (e.data(o, u).transformCache[t] = "(" + i + ")"), e.data(o, u).transformCache[t];}
	            };
	          }();
	        }for (var l = ["color", "backgroundColor", "borderColor", "outlineColor"], o = 0, n = l.length; n > o; o++) {
	          !function () {
	            var e = l[o];p.Normalizations.registered[e] = function (a, o, i) {
	              switch (a) {case "name":
	                  return e;case "extract":
	                  var l;if (p.RegEx.wrappedValueAlreadyExtracted.test(i)) l = i;else {
	                    var n,
	                        c = { aqua: "rgb(0, 255, 255);", black: "rgb(0, 0, 0)", blue: "rgb(0, 0, 255)", fuchsia: "rgb(255, 0, 255)", gray: "rgb(128, 128, 128)", green: "rgb(0, 128, 0)", lime: "rgb(0, 255, 0)", maroon: "rgb(128, 0, 0)", navy: "rgb(0, 0, 128)", olive: "rgb(128, 128, 0)", purple: "rgb(128, 0, 128)", red: "rgb(255, 0, 0)", silver: "rgb(192, 192, 192)", teal: "rgb(0, 128, 128)", white: "rgb(255, 255, 255)", yellow: "rgb(255, 255, 0)" };/^[A-z]+$/i.test(i) ? n = c[i] !== r ? c[i] : c.black : /^#([A-f\d]{3}){1,2}$/i.test(i) ? n = t(i) : /^rgba?\(/i.test(i) || (n = c.black), l = (n || i).toString().match(p.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
	                  }return 8 >= s || 3 !== l.split(" ").length || (l += " 1"), l;case "inject":
	                  return 8 >= s ? 4 === i.split(" ").length && (i = i.split(/\s+/).slice(0, 3).join(" ")) : 3 === i.split(" ").length && (i += " 1"), (8 >= s ? "rgb" : "rgba") + "(" + i.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";}
	            };
	          }();
	        }
	      } }, Names: { camelCase: function camelCase(e) {
	        return e.replace(/-(\w)/g, function (e, t) {
	          return t.toUpperCase();
	        });
	      }, prefixCheck: function prefixCheck(t) {
	        if (e.velocity.State.prefixMatches[t]) return [e.velocity.State.prefixMatches[t], !0];for (var a = ["", "Webkit", "Moz", "ms", "O"], r = 0, o = a.length; o > r; r++) {
	          var i;if (i = 0 === r ? t : a[r] + t.replace(/^\w/, function (e) {
	            return e.toUpperCase();
	          }), "string" == typeof e.velocity.State.prefixElement.style[i]) return e.velocity.State.prefixMatches[t] = i, [i, !0];
	        }return [t, !1];
	      } }, Values: { isCSSNullValue: function isCSSNullValue(e) {
	        return 0 == e || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e);
	      }, getUnitType: function getUnitType(e) {
	        return (/^(rotate|skew)/i.test(e) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|opacity|alpha|fillOpacity|flexGrow|flexHeight|zIndex|fontWeight)$)|color/i.test(e) ? "" : "px"
	        );
	      } }, getPropertyValue: function getPropertyValue(a, o, i, l) {
	      function n(a, o) {
	        if (!l) {
	          if ("height" === o && "border-box" !== p.getPropertyValue(a, "boxSizing").toLowerCase()) return a.offsetHeight - (parseFloat(p.getPropertyValue(a, "borderTopWidth")) || 0) - (parseFloat(p.getPropertyValue(a, "borderBottomWidth")) || 0) - (parseFloat(p.getPropertyValue(a, "paddingTop")) || 0) - (parseFloat(p.getPropertyValue(a, "paddingBottom")) || 0);if ("width" === o && "border-box" !== p.getPropertyValue(a, "boxSizing").toLowerCase()) return a.offsetWidth - (parseFloat(p.getPropertyValue(a, "borderLeftWidth")) || 0) - (parseFloat(p.getPropertyValue(a, "borderRightWidth")) || 0) - (parseFloat(p.getPropertyValue(a, "paddingLeft")) || 0) - (parseFloat(p.getPropertyValue(a, "paddingRight")) || 0);
	        }var i = 0;if (8 >= s) i = e.css(a, o);else {
	          var c;c = e.data(a, u) === r ? t.getComputedStyle(a, null) : e.data(a, u).computedStyle ? e.data(a, u).computedStyle : e.data(a, u).computedStyle = t.getComputedStyle(a, null), s && "borderColor" === o && (o = "borderTopColor"), i = 9 === s && "filter" === o ? c.getPropertyValue(o) : c[o], "" === i && (i = a.style[o]);
	        }if ("auto" === i && /^(top|right|bottom|left)$/i.test(o)) {
	          var g = n(a, "position");("fixed" === g || "absolute" === g && /top|left/i.test(o)) && (i = e(a).position()[o] + "px");
	        }return i;
	      }var c;if (p.Hooks.registered[o]) {
	        var g = o,
	            d = p.Hooks.getRoot(g);i === r && (i = p.getPropertyValue(a, p.Names.prefixCheck(d)[0])), p.Normalizations.registered[d] && (i = p.Normalizations.registered[d]("extract", a, i)), c = p.Hooks.extractValue(g, i);
	      } else if (p.Normalizations.registered[o]) {
	        var f, y;f = p.Normalizations.registered[o]("name", a), "transform" !== f && (y = n(a, p.Names.prefixCheck(f)[0]), p.Values.isCSSNullValue(y) && p.Hooks.templates[o] && (y = p.Hooks.templates[o][1])), c = p.Normalizations.registered[o]("extract", a, y);
	      }return (/^[\d-]/.test(c) || (c = n(a, p.Names.prefixCheck(o)[0])), p.Values.isCSSNullValue(c) && (c = 0), e.velocity.debug >= 2 && console.log("Get " + o + ": " + c), c
	      );
	    }, setPropertyValue: function setPropertyValue(a, r, o, i) {
	      var l = r;if ("scroll" === r) t.scrollTo(null, o);else if (p.Normalizations.registered[r] && "transform" === p.Normalizations.registered[r]("name", a)) p.Normalizations.registered[r]("inject", a, o), l = "transform", o = e.data(a, u).transformCache[r];else {
	        if (p.Hooks.registered[r]) {
	          var n = r,
	              c = p.Hooks.getRoot(r);i = i || p.getPropertyValue(a, c), o = p.Hooks.injectValue(n, o, i), r = c;
	        }if (p.Normalizations.registered[r] && (o = p.Normalizations.registered[r]("inject", a, o), r = p.Normalizations.registered[r]("name", a)), l = p.Names.prefixCheck(r)[0], 8 >= s) try {
	          a.style[l] = o;
	        } catch (g) {
	          console.log("Error setting [" + l + "] to [" + o + "]");
	        } else a.style[l] = o;e.velocity.debug >= 2 && console.log("Set " + r + " (" + l + "): " + o);
	      }return [l, o];
	    }, flushTransformCache: function flushTransformCache(t) {
	      var a = "",
	          r,
	          o;for (r in e.data(t, u).transformCache) {
	        o = e.data(t, u).transformCache[r], 9 === s && "rotateZ" === r && (r = "rotate"), a += r + o + " ";
	      }p.setPropertyValue(t, "transform", a);
	    } };p.Hooks.register(), p.Normalizations.register(), e.fn.velocity = e.velocity.animate = function () {
	    function t() {
	      var t = this,
	          n = e.extend({}, e.fn.velocity.defaults, g),
	          d = {};if ("stop" === y) return e.queue(t, "string" == typeof g ? g : "", []), !0;switch (e.data(t, u) === r && e.data(t, u, { isAnimating: !1, computedStyle: null, tweensContainer: null, rootPropertyValueCache: {}, transformCache: {} }), n.duration.toString().toLowerCase()) {case "fast":
	          n.duration = 200;break;case "normal":
	          n.duration = 400;break;case "slow":
	          n.duration = 600;break;default:
	          n.duration = parseFloat(n.duration) || parseFloat(e.fn.velocity.defaults.duration) || 400;}e.easing[n.easing] || (n.easing = e.easing[e.fn.velocity.defaults.easing] ? e.fn.velocity.defaults.easing : "swing"), /^\d/.test(n.delay) && e.queue(t, n.queue, function (t) {
	        e.velocity.queueEntryFlag = !0, setTimeout(t, parseFloat(n.delay));
	      }), n.display && (n.display = n.display.toLowerCase()), n.mobileHA = n.mobileHA && e.velocity.State.isMobile, e.queue(t, n.queue, function (f) {
	        function m(a) {
	          var o = r,
	              l = r,
	              s = r;return "[object Array]" === Object.prototype.toString.call(a) ? (o = a[0], /^[\d-]/.test(a[1]) || i(a[1]) ? s = a[1] : "string" == typeof a[1] && (e.easing[a[1]] !== r && (l = a[1]), a[2] && (s = a[2]))) : o = a, l = l || n.easing, i(o) && (o = o.call(t, x, v)), i(s) && (s = s.call(t, x, v)), [o || 0, l, s];
	        }function h(e, t) {
	          var a, r;return r = (t || 0).toString().toLowerCase().replace(/[%A-z]+$/, function (e) {
	            return a = e, "";
	          }), a || (a = p.Values.getUnitType(e)), [r, a];
	        }function V() {
	          var r = { parent: t.parentNode, position: p.getPropertyValue(t, "position"), fontSize: p.getPropertyValue(t, "fontSize") },
	              o = r.position === P.lastPosition && r.parent === P.lastParent,
	              i = r.fontSize === P.lastFontSize;P.lastParent = r.parent, P.lastPosition = r.position, P.lastFontSize = r.fontSize, null === P.remToPxRatio && (P.remToPxRatio = parseFloat(p.getPropertyValue(a.body, "fontSize")) || 16);var l = { overflowX: null, overflowY: null, boxSizing: null, width: null, minWidth: null, maxWidth: null, height: null, minHeight: null, maxHeight: null, paddingLeft: null },
	              n = {},
	              s = 10;n.remToPxRatio = P.remToPxRatio, l.overflowX = p.getPropertyValue(t, "overflowX"), l.overflowY = p.getPropertyValue(t, "overflowY"), l.boxSizing = p.getPropertyValue(t, "boxSizing"), l.width = p.getPropertyValue(t, "width", null, !0), l.minWidth = p.getPropertyValue(t, "minWidth"), l.maxWidth = p.getPropertyValue(t, "maxWidth") || "none", l.height = p.getPropertyValue(t, "height", null, !0), l.minHeight = p.getPropertyValue(t, "minHeight"), l.maxHeight = p.getPropertyValue(t, "maxHeight") || "none", l.paddingLeft = p.getPropertyValue(t, "paddingLeft"), o ? (n.percentToPxRatioWidth = P.lastPercentToPxWidth, n.percentToPxRatioHeight = P.lastPercentToPxHeight) : (p.setPropertyValue(t, "overflowX", "hidden"), p.setPropertyValue(t, "overflowY", "hidden"), p.setPropertyValue(t, "boxSizing", "content-box"), p.setPropertyValue(t, "width", s + "%"), p.setPropertyValue(t, "minWidth", s + "%"), p.setPropertyValue(t, "maxWidth", s + "%"), p.setPropertyValue(t, "height", s + "%"), p.setPropertyValue(t, "minHeight", s + "%"), p.setPropertyValue(t, "maxHeight", s + "%")), i ? n.emToPxRatio = P.lastEmToPx : p.setPropertyValue(t, "paddingLeft", s + "em"), o || (n.percentToPxRatioWidth = P.lastPercentToPxWidth = (parseFloat(p.getPropertyValue(t, "width", null, !0)) || 0) / s, n.percentToPxRatioHeight = P.lastPercentToPxHeight = (parseFloat(p.getPropertyValue(t, "height", null, !0)) || 0) / s), i || (n.emToPxRatio = P.lastEmToPx = (parseFloat(p.getPropertyValue(t, "paddingLeft")) || 0) / s);for (var c in l) {
	            p.setPropertyValue(t, c, l[c]);
	          }return e.velocity.debug >= 1 && console.log("Unit ratios: " + (0, _stringify2.default)(n), t), n;
	        }if (e.velocity.queueEntryFlag = !0, "scroll" === y) {
	          var S = e.velocity.State.scrollAnchor[e.velocity.State.scrollProperty],
	              k = parseFloat(n.offset) || 0;d = { scroll: { rootPropertyValue: !1, startValue: S, currentValue: S, endValue: e(t).offset().top + k, unitType: "", easing: n.easing }, element: t };
	        } else if ("reverse" === y) {
	          if (!e.data(t, u).tweensContainer) return void e.dequeue(t, n.queue);"none" === e.data(t, u).opts.display && (e.data(t, u).opts.display = "block"), e.data(t, u).opts.loop = !1, n = e.extend({}, e.data(t, u).opts, g);var w = e.extend(!0, {}, e.data(t, u).tweensContainer);for (var C in w) {
	            if ("element" !== C) {
	              var T = w[C].startValue;w[C].startValue = w[C].currentValue = w[C].endValue, w[C].endValue = T, g && (w[C].easing = n.easing);
	            }
	          }d = w;
	        } else if ("start" === y) {
	          var w;e.data(t, u).tweensContainer && e.data(t, u).isAnimating === !0 && (w = e.data(t, u).tweensContainer);for (var H in c) {
	            H = p.Names.camelCase(H);var R = m(c[H]),
	                z = R[0],
	                N = R[1],
	                A = R[2],
	                E = p.Hooks.getRoot(H),
	                q = !1;if (p.Names.prefixCheck(E)[1] !== !1 || p.Normalizations.registered[E] !== r) {
	              n.display && "none" !== n.display && /opacity|filter/.test(H) && !A && 0 !== z && (A = 0), n._cacheValues && w && w[H] ? (A = w[H].endValue + w[H].unitType, q = e.data(t, u).rootPropertyValueCache[E]) : p.Hooks.registered[H] ? A === r ? (q = p.getPropertyValue(t, E), A = p.getPropertyValue(t, H, q)) : q = p.Hooks.templates[E][1] : A === r && (A = p.getPropertyValue(t, H));var F, M, j, W;F = h(H, A), A = F[0], j = F[1], F = h(H, z), z = F[0].replace(/^([+-\/*])=/, function (e, t) {
	                return W = t, "";
	              }), M = F[1], A = parseFloat(A) || 0, z = parseFloat(z) || 0;var $;if ("%" === M && (/^(fontSize|lineHeight)$/.test(H) ? (z /= 100, M = "em") : /^scale/.test(H) ? (z /= 100, M = "") : /(Red|Green|Blue)$/i.test(H) && (z = z / 100 * 255, M = "")), /[\/*]/.test(W)) M = j;else if (j !== M && 0 !== A) if (0 === z) M = j;else {
	                $ = $ || V();var O = /margin|padding|left|right|width|text|word|letter/i.test(H) || /X$/.test(H) ? "x" : "y";switch (j) {case "%":
	                    A *= "x" === O ? $.percentToPxRatioWidth : $.percentToPxRatioHeight;break;case "em":
	                    A *= $.emToPxRatio;break;case "rem":
	                    A *= $.remToPxRatio;break;case "px":}switch (M) {case "%":
	                    A *= 1 / ("x" === O ? $.percentToPxRatioWidth : $.percentToPxRatioHeight);break;case "em":
	                    A *= 1 / $.emToPxRatio;break;case "rem":
	                    A *= 1 / $.remToPxRatio;break;case "px":}
	              }switch (W) {case "+":
	                  z = A + z;break;case "-":
	                  z = A - z;break;case "*":
	                  z = A * z;break;case "/":
	                  z = A / z;}d[H] = { rootPropertyValue: q, startValue: A, currentValue: A, endValue: z, unitType: M, easing: N }, e.velocity.debug && console.log("tweensContainer (" + H + "): " + (0, _stringify2.default)(d[H]), t);
	            } else e.velocity.debug && console.log("Skipping [" + E + "] due to a lack of browser support.");
	          }d.element = t;
	        }d.element && (b.push(d), e.data(t, u).tweensContainer = d, e.data(t, u).opts = n, e.data(t, u).isAnimating = !0, x === v - 1 ? (e.velocity.State.calls.length > 1e4 && (e.velocity.State.calls = o(e.velocity.State.calls)), e.velocity.State.calls.push([b, s, n]), e.velocity.State.isTicking === !1 && (e.velocity.State.isTicking = !0, l())) : x++), "" !== n.queue && "fx" !== n.queue && setTimeout(f, n.duration + n.delay);
	      }), (n.queue === !1 || ("" === n.queue || "fx" === n.queue) && "inprogress" !== e.queue(t)[0]) && e.dequeue(t);
	    }var n, s, c, g, d, f;this.jquery ? (n = !0, s = this, c = arguments[0], g = arguments[1]) : (n = !1, s = arguments[0], c = arguments[1], g = arguments[2]);var y;switch (c) {case "scroll":
	        y = "scroll";break;case "reverse":
	        y = "reverse";break;case "stop":
	        y = "stop";break;default:
	        if (e.isPlainObject(c) && !e.isEmptyObject(c)) y = "start";else {
	          if ("string" == typeof c && e.velocity.Sequence[c]) return e.velocity.Sequence[c].call(s, g);if ("string" != typeof c || !e.velocity.Classes.extracted[c]) return e.velocity.debug && console.log("First argument was not a property map, a CSS class reference, or a known action. Aborting."), s;c = e.velocity.Classes.extracted[c], y = "start";
	        }}if ("stop" !== y && "object" != (typeof g === "undefined" ? "undefined" : (0, _typeof3.default)(g))) {
	      var m = n ? 1 : 2;g = {};for (var h = m; h < arguments.length; h++) {
	        /^\d/.test(arguments[h]) ? g.duration = parseFloat(arguments[h]) : "string" == typeof arguments[h] ? g.easing = arguments[h].replace(/^\s+|\s+$/g, "") : i(arguments[h]) && (g.complete = arguments[h]);
	      }
	    }var v = s.length || 1,
	        x = 0,
	        P = { lastParent: null, lastPosition: null, lastFontSize: null, lastPercentToPxWidth: null, lastPercentToPxHeight: null, lastEmToPx: null, remToPxRatio: null },
	        b = [];if (g && !i(g.complete) && (g.complete = null), n) s.each(t);else if (s.nodeType) t.call(s);else if (s[0] && s[0].nodeType) for (var V in s) {
	      t.call(s[V]);
	    }var S = e.extend({}, e.fn.velocity.defaults, g);if (S.loop = parseInt(S.loop), S.loop) for (var k = 0; k < 2 * S.loop - 1; k++) {
	      n ? s.velocity("reverse", { delay: S.delay }) : e.velocity.animate(s, "reverse", { delay: S.delay });
	    }return s;
	  };
	}(jQuery, window, document), jQuery.fn.velocity.defaults = { queue: "", duration: 400, easing: "swing", complete: null, display: null, loop: !1, delay: !1, mobileHA: !0, _cacheValues: !0 };

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	  var NumberProgressBar = function NumberProgressBar(element, options) {
	    var settings = $.extend({
	      duration: 10000,
	      style: 'basic',
	      min: 0,
	      max: 100,
	      current: 0,
	      shownQuery: '.number-pb-shown',
	      numQuery: '.number-pb-num'
	    }, options || {});
	
	    this.duration = settings.duration;
	    if (settings.style == 'percentage') {
	      this.style = 'percentage';
	      this.min = 0;
	      this.max = 100;
	    } else if (settings.style == 'step') {
	      this.style = 'step';
	      this.min = 0;
	      this.max = settings.max > this.min ? settings.max : 100;
	    } else {
	      this.style = 'basic';
	      if (settings.min < settings.max) {
	        this.min = settings.min;
	        this.max = settings.max;
	      } else {
	        this.min = 0;
	        this.max = 100;
	      }
	    }
	    this.current = settings.current >= this.min && settings.current <= this.max ? settings.current : this.min;
	    this.interval = this.max - this.min;
	    this.last = this.min;
	    this.$element = $(element);
	    this.$shownBar = this.$element.find(settings.shownQuery);
	    this.$num = this.$element.find(settings.numQuery);
	
	    this.reach(this.current);
	  };
	
	  NumberProgressBar.prototype.calDestination = function (dest) {
	    return dest < this.min ? this.min : dest > this.max ? this.max : dest;
	  };
	
	  NumberProgressBar.prototype.calDuration = function () {
	    return this.duration * Math.abs(this.current - this.last) / this.interval;
	  };
	
	  NumberProgressBar.prototype.shuffle = function (callback) {
	    var dest = Math.round(Math.random() * this.interval) + this.min;
	    this.reach(dest, null, callback);
	  };
	
	  NumberProgressBar.prototype.calPercentage = function () {
	    return (this.current - this.min) / this.interval * 100;
	  };
	
	  NumberProgressBar.prototype.numStyle = function (num) {
	    var n = Math.ceil(num);
	    var s = "";
	    switch (this.style) {
	      case 'percentage':
	        s = n + '%';break;
	      case 'step':
	        s = n + '/' + this.max;break;
	      default:
	        s = n;
	    }
	    return s;
	  };
	
	  NumberProgressBar.prototype.reach = function (dest, duration, callback) {
	    this.current = this.calDestination(dest);
	    this.moveShown(duration);
	    this.moveNum(duration, callback);
	    this.last = this.current;
	  };
	
	  NumberProgressBar.prototype.moveShown = function (duration) {
	    this.$shownBar.velocity({
	      width: this.calPercentage() + '%'
	    }, {
	      duration: duration || this.calDuration()
	    });
	  };
	
	  NumberProgressBar.prototype.moveNum = function (duration, callback) {
	    var self = this;
	    var duration = duration || this.calDuration();
	
	    this.$num.velocity({
	      left: this.calPercentage() + '%'
	    }, {
	      duration: duration,
	      complete: callback
	    });
	
	    $({ num: this.last }).animate({
	      num: this.current
	    }, {
	      queue: true,
	      duration: duration,
	      step: function step() {
	        self.$num.text(self.numStyle(this.num));
	      },
	      complete: function complete() {
	        self.$num.text(self.numStyle(self.current));
	      }
	    });
	  };
	
	  $.fn.NumberProgressBar = function (options) {
	    return this.each(function () {
	      var element = $(this);
	      if (element.data('number-pb')) return;
	      element.data('number-pb', new NumberProgressBar(this, options));
	    });
	  };
	
	  $.fn.reach = function (dest, options) {
	    var settings = $.extend({
	      duration: null,
	      complete: null
	    }, options || {});
	    return this.each(function () {
	      var element = $(this);
	      var progressbar = element.data('number-pb');
	      if (!progressbar) return;
	      if (typeof dest === "undefined") {
	        progressbar.shuffle(settings.complete);
	      } else {
	        progressbar.reach(dest, settings.duration, settings.complete);
	      }
	    });
	  };
	})(jQuery);

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	  $.fn.extend({
	    accordionze: function accordionze(options) {
	
	      var defaults = {
	        accordionze: 'true',
	        speed: 300,
	        closedSign: '[+]',
	        openedSign: '[-]'
	      };
	
	      var opts = $.extend(defaults, options);
	
	      var $this = $(this);
	
	      $this.find("li").each(function () {
	        if ($(this).find("ul").size() != 0) {
	          $(this).find("a:first").append("<h4>" + opts.closedSign + "</h4>");
	
	          if ($(this).find("a:first").attr('href') == "#") {
	            $(this).find("a:first").click(function () {
	              return false;
	            });
	          }
	        }
	      });
	
	      $this.find("li.active").each(function () {
	        $(this).parents("ul").slideDown(opts.speed);
	        $(this).parents("ul").parent("li").find("h4:first").html(opts.openedSign);
	      });
	
	      $this.find("li a").click(function () {
	        if ($(this).parent().find("ul").size() != 0) {
	          if (opts.accordionze) {
	            if (!$(this).parent().find("ul").is(':visible')) {
	              var parents = $(this).parent().parents("ul"),
	                  visible = $this.find("ul:visible");
	              visible.each(function (visibleIndex) {
	                var close = true;
	                parents.each(function (parentIndex) {
	                  if (parents[parentIndex] == visible[visibleIndex]) {
	                    close = false;
	                    return false;
	                  }
	                });
	                if (close) {
	                  if ($(this).parent().find("ul") != visible[visibleIndex]) {
	                    $(visible[visibleIndex]).slideUp(opts.speed, function () {
	                      $(this).parent("li").find("h4:first").html(opts.closedSign);
	                    });
	                  }
	                }
	              });
	            }
	          }
	          if ($(this).parent().find("ul:first").is(":visible")) {
	            $(this).parent().find("ul:first").slideUp(opts.speed, function () {
	              $(this).parent("li").find("h4:first").delay(opts.speed).html(opts.closedSign);
	            });
	          } else {
	            $(this).parent().find("ul:first").slideDown(opts.speed, function () {
	              $(this).parent("li").find("h4:first").delay(opts.speed).html(opts.openedSign);
	            });
	          }
	        }
	      });
	    }
	  });
	})(jQuery);

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	'use strict';
	
	(function (global) {
	    "use strict";
	
	    var requestInterval, cancelInterval;
	
	    (function () {
	        var raf = global.requestAnimationFrame || global.webkitRequestAnimationFrame || global.mozRequestAnimationFrame || global.oRequestAnimationFrame || global.msRequestAnimationFrame,
	            caf = global.cancelAnimationFrame || global.webkitCancelAnimationFrame || global.mozCancelAnimationFrame || global.oCancelAnimationFrame || global.msCancelAnimationFrame;
	
	        if (raf && caf) {
	            requestInterval = function requestInterval(fn, delay) {
	                var handle = { value: null };
	
	                function loop() {
	                    handle.value = raf(loop);
	                    fn();
	                }
	
	                loop();
	                return handle;
	            };
	
	            cancelInterval = function cancelInterval(handle) {
	                caf(handle.value);
	            };
	        } else {
	            requestInterval = setInterval;
	            cancelInterval = clearInterval;
	        }
	    })();
	
	    var KEYFRAME = 500,
	        STROKE = 0.08,
	        TWO_PI = 2.0 * Math.PI,
	        TWO_OVER_SQRT_2 = 2.0 / Math.sqrt(2);
	
	    function circle(ctx, x, y, r) {
	        ctx.beginPath();
	        ctx.arc(x, y, r, 0, TWO_PI, false);
	        ctx.fill();
	    }
	
	    function line(ctx, ax, ay, bx, by) {
	        ctx.beginPath();
	        ctx.moveTo(ax, ay);
	        ctx.lineTo(bx, by);
	        ctx.stroke();
	    }
	
	    function puff(ctx, t, cx, cy, rx, ry, rmin, rmax) {
	        var c = Math.cos(t * TWO_PI),
	            s = Math.sin(t * TWO_PI);
	
	        rmax -= rmin;
	
	        circle(ctx, cx - s * rx, cy + c * ry + rmax * 0.5, rmin + (1 - c * 0.5) * rmax);
	    }
	
	    function puffs(ctx, t, cx, cy, rx, ry, rmin, rmax) {
	        var i;
	
	        for (i = 5; i--;) {
	            puff(ctx, t + i / 5, cx, cy, rx, ry, rmin, rmax);
	        }
	    }
	
	    function cloud(ctx, t, cx, cy, cw, s, color) {
	        t /= 30000;
	
	        var a = cw * 0.21,
	            b = cw * 0.12,
	            c = cw * 0.24,
	            d = cw * 0.28;
	
	        ctx.fillStyle = color;
	        puffs(ctx, t, cx, cy, a, b, c, d);
	
	        ctx.globalCompositeOperation = 'destination-out';
	        puffs(ctx, t, cx, cy, a, b, c - s, d - s);
	        ctx.globalCompositeOperation = 'source-over';
	    }
	
	    function sun(ctx, t, cx, cy, cw, s, color) {
	        t /= 120000;
	
	        var a = cw * 0.25 - s * 0.5,
	            b = cw * 0.32 + s * 0.5,
	            c = cw * 0.50 - s * 0.5,
	            i,
	            p,
	            cos,
	            sin;
	
	        ctx.strokeStyle = color;
	        ctx.lineWidth = s;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        ctx.beginPath();
	        ctx.arc(cx, cy, a, 0, TWO_PI, false);
	        ctx.stroke();
	
	        for (i = 8; i--;) {
	            p = (t + i / 8) * TWO_PI;
	            cos = Math.cos(p);
	            sin = Math.sin(p);
	            line(ctx, cx + cos * b, cy + sin * b, cx + cos * c, cy + sin * c);
	        }
	    }
	
	    function moon(ctx, t, cx, cy, cw, s, color) {
	        t /= 15000;
	
	        var a = cw * 0.29 - s * 0.5,
	            b = cw * 0.05,
	            c = Math.cos(t * TWO_PI),
	            p = c * TWO_PI / -16;
	
	        ctx.strokeStyle = color;
	        ctx.lineWidth = s;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        cx += c * b;
	
	        ctx.beginPath();
	        ctx.arc(cx, cy, a, p + TWO_PI / 8, p + TWO_PI * 7 / 8, false);
	        ctx.arc(cx + Math.cos(p) * a * TWO_OVER_SQRT_2, cy + Math.sin(p) * a * TWO_OVER_SQRT_2, a, p + TWO_PI * 5 / 8, p + TWO_PI * 3 / 8, true);
	        ctx.closePath();
	        ctx.stroke();
	    }
	
	    function rain(ctx, t, cx, cy, cw, s, color) {
	        t /= 1350;
	
	        var a = cw * 0.16,
	            b = TWO_PI * 11 / 12,
	            c = TWO_PI * 7 / 12,
	            i,
	            p,
	            x,
	            y;
	
	        ctx.fillStyle = color;
	
	        for (i = 4; i--;) {
	            p = (t + i / 4) % 1;
	            x = cx + (i - 1.5) / 1.5 * (i === 1 || i === 2 ? -1 : 1) * a;
	            y = cy + p * p * cw;
	            ctx.beginPath();
	            ctx.moveTo(x, y - s * 1.5);
	            ctx.arc(x, y, s * 0.75, b, c, false);
	            ctx.fill();
	        }
	    }
	
	    function sleet(ctx, t, cx, cy, cw, s, color) {
	        t /= 750;
	
	        var a = cw * 0.1875,
	            b = TWO_PI * 11 / 12,
	            c = TWO_PI * 7 / 12,
	            i,
	            p,
	            x,
	            y;
	
	        ctx.strokeStyle = color;
	        ctx.lineWidth = s * 0.5;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        for (i = 4; i--;) {
	            p = (t + i / 4) % 1;
	            x = Math.floor(cx + (i - 1.5) / 1.5 * (i === 1 || i === 2 ? -1 : 1) * a) + 0.5;
	            y = cy + p * cw;
	            line(ctx, x, y - s * 1.5, x, y + s * 1.5);
	        }
	    }
	
	    function snow(ctx, t, cx, cy, cw, s, color) {
	        t /= 3000;
	
	        var a = cw * 0.16,
	            b = s * 0.75,
	            u = t * TWO_PI * 0.7,
	            ux = Math.cos(u) * b,
	            uy = Math.sin(u) * b,
	            v = u + TWO_PI / 3,
	            vx = Math.cos(v) * b,
	            vy = Math.sin(v) * b,
	            w = u + TWO_PI * 2 / 3,
	            wx = Math.cos(w) * b,
	            wy = Math.sin(w) * b,
	            i,
	            p,
	            x,
	            y;
	
	        ctx.strokeStyle = color;
	        ctx.lineWidth = s * 0.5;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        for (i = 4; i--;) {
	            p = (t + i / 4) % 1;
	            x = cx + Math.sin((p + i / 4) * TWO_PI) * a;
	            y = cy + p * cw;
	
	            line(ctx, x - ux, y - uy, x + ux, y + uy);
	            line(ctx, x - vx, y - vy, x + vx, y + vy);
	            line(ctx, x - wx, y - wy, x + wx, y + wy);
	        }
	    }
	
	    function fogbank(ctx, t, cx, cy, cw, s, color) {
	        t /= 30000;
	
	        var a = cw * 0.21,
	            b = cw * 0.06,
	            c = cw * 0.21,
	            d = cw * 0.28;
	
	        ctx.fillStyle = color;
	        puffs(ctx, t, cx, cy, a, b, c, d);
	
	        ctx.globalCompositeOperation = 'destination-out';
	        puffs(ctx, t, cx, cy, a, b, c - s, d - s);
	        ctx.globalCompositeOperation = 'source-over';
	    }
	
	    var WIND_PATHS = [[-0.7500, -0.1800, -0.7219, -0.1527, -0.6971, -0.1225, -0.6739, -0.0910, -0.6516, -0.0588, -0.6298, -0.0262, -0.6083, 0.0065, -0.5868, 0.0396, -0.5643, 0.0731, -0.5372, 0.1041, -0.5033, 0.1259, -0.4662, 0.1406, -0.4275, 0.1493, -0.3881, 0.1530, -0.3487, 0.1526, -0.3095, 0.1488, -0.2708, 0.1421, -0.2319, 0.1342, -0.1943, 0.1217, -0.1600, 0.1025, -0.1290, 0.0785, -0.1012, 0.0509, -0.0764, 0.0206, -0.0547, -0.0120, -0.0378, -0.0472, -0.0324, -0.0857, -0.0389, -0.1241, -0.0546, -0.1599, -0.0814, -0.1876, -0.1193, -0.1964, -0.1582, -0.1935, -0.1931, -0.1769, -0.2157, -0.1453, -0.2290, -0.1085, -0.2327, -0.0697, -0.2240, -0.0317, -0.2064, 0.0033, -0.1853, 0.0362, -0.1613, 0.0672, -0.1350, 0.0961, -0.1051, 0.1213, -0.0706, 0.1397, -0.0332, 0.1512, 0.0053, 0.1580, 0.0442, 0.1624, 0.0833, 0.1636, 0.1224, 0.1615, 0.1613, 0.1565, 0.1999, 0.1500, 0.2378, 0.1402, 0.2749, 0.1279, 0.3118, 0.1147, 0.3487, 0.1015, 0.3858, 0.0892, 0.4236, 0.0787, 0.4621, 0.0715, 0.5012, 0.0702, 0.5398, 0.0766, 0.5768, 0.0890, 0.6123, 0.1055, 0.6466, 0.1244, 0.6805, 0.1440, 0.7147, 0.1630, 0.7500, 0.1800], [-0.7500, 0.0000, -0.7033, 0.0195, -0.6569, 0.0399, -0.6104, 0.0600, -0.5634, 0.0789, -0.5155, 0.0954, -0.4667, 0.1089, -0.4174, 0.1206, -0.3676, 0.1299, -0.3174, 0.1365, -0.2669, 0.1398, -0.2162, 0.1391, -0.1658, 0.1347, -0.1157, 0.1271, -0.0661, 0.1169, -0.0170, 0.1046, 0.0316, 0.0903, 0.0791, 0.0728, 0.1259, 0.0534, 0.1723, 0.0331, 0.2188, 0.0129, 0.2656, -0.0064, 0.3122, -0.0263, 0.3586, -0.0466, 0.4052, -0.0665, 0.4525, -0.0847, 0.5007, -0.1002, 0.5497, -0.1130, 0.5991, -0.1240, 0.6491, -0.1325, 0.6994, -0.1380, 0.7500, -0.1400]],
	        WIND_OFFSETS = [{ start: 0.36, end: 0.11 }, { start: 0.56, end: 0.16 }];
	
	    function leaf(ctx, t, x, y, cw, s, color) {
	        var a = cw / 8,
	            b = a / 3,
	            c = 2 * b,
	            d = t % 1 * TWO_PI,
	            e = Math.cos(d),
	            f = Math.sin(d);
	
	        ctx.fillStyle = color;
	        ctx.strokeStyle = color;
	        ctx.lineWidth = s;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        ctx.beginPath();
	        ctx.arc(x, y, a, d, d + Math.PI, false);
	        ctx.arc(x - b * e, y - b * f, c, d + Math.PI, d, false);
	        ctx.arc(x + c * e, y + c * f, b, d + Math.PI, d, true);
	        ctx.globalCompositeOperation = 'destination-out';
	        ctx.fill();
	        ctx.globalCompositeOperation = 'source-over';
	        ctx.stroke();
	    }
	
	    function swoosh(ctx, t, cx, cy, cw, s, index, total, color) {
	        t /= 2500;
	
	        var path = WIND_PATHS[index],
	            a = (t + index - WIND_OFFSETS[index].start) % total,
	            c = (t + index - WIND_OFFSETS[index].end) % total,
	            e = (t + index) % total,
	            b,
	            d,
	            f,
	            i;
	
	        ctx.strokeStyle = color;
	        ctx.lineWidth = s;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        if (a < 1) {
	            ctx.beginPath();
	
	            a *= path.length / 2 - 1;
	            b = Math.floor(a);
	            a -= b;
	            b *= 2;
	            b += 2;
	
	            ctx.moveTo(cx + (path[b - 2] * (1 - a) + path[b] * a) * cw, cy + (path[b - 1] * (1 - a) + path[b + 1] * a) * cw);
	
	            if (c < 1) {
	                c *= path.length / 2 - 1;
	                d = Math.floor(c);
	                c -= d;
	                d *= 2;
	                d += 2;
	
	                for (i = b; i !== d; i += 2) {
	                    ctx.lineTo(cx + path[i] * cw, cy + path[i + 1] * cw);
	                }ctx.lineTo(cx + (path[d - 2] * (1 - c) + path[d] * c) * cw, cy + (path[d - 1] * (1 - c) + path[d + 1] * c) * cw);
	            } else for (i = b; i !== path.length; i += 2) {
	                ctx.lineTo(cx + path[i] * cw, cy + path[i + 1] * cw);
	            }ctx.stroke();
	        } else if (c < 1) {
	            ctx.beginPath();
	
	            c *= path.length / 2 - 1;
	            d = Math.floor(c);
	            c -= d;
	            d *= 2;
	            d += 2;
	
	            ctx.moveTo(cx + path[0] * cw, cy + path[1] * cw);
	
	            for (i = 2; i !== d; i += 2) {
	                ctx.lineTo(cx + path[i] * cw, cy + path[i + 1] * cw);
	            }ctx.lineTo(cx + (path[d - 2] * (1 - c) + path[d] * c) * cw, cy + (path[d - 1] * (1 - c) + path[d + 1] * c) * cw);
	
	            ctx.stroke();
	        }
	
	        if (e < 1) {
	            e *= path.length / 2 - 1;
	            f = Math.floor(e);
	            e -= f;
	            f *= 2;
	            f += 2;
	
	            leaf(ctx, t, cx + (path[f - 2] * (1 - e) + path[f] * e) * cw, cy + (path[f - 1] * (1 - e) + path[f + 1] * e) * cw, cw, s, color);
	        }
	    }
	
	    var Skycons = function Skycons(opts) {
	        this.list = [];
	        this.interval = null;
	        STROKE = opts && opts.stroke ? opts.stroke : 0.06;
	
	        this.color = new Array();
	        this.color["default"] = opts && opts.color ? opts.color : "black";
	        this.color["sun"] = opts && opts.sunColor ? opts.sunColor : this.color["default"];
	        this.color["moon"] = opts && opts.moonColor ? opts.moonColor : this.color["default"];
	        this.color["cloud"] = opts && opts.cloudColor ? opts.cloudColor : this.color["default"];
	        this.color["rain"] = opts && opts.rainColor ? opts.rainColor : this.color["default"];
	        this.color["snow"] = opts && opts.snowColor ? opts.snowColor : this.color["default"];
	        this.color["wind"] = opts && opts.windColor ? opts.windColor : this.color["default"];
	        this.color["fog"] = opts && opts.fogColor ? opts.fogColor : this.color["default"];
	
	        this.resizeClear = !!(opts && opts.resizeClear);
	    };
	
	    Skycons.CLEAR_DAY = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        sun(ctx, t, w * 0.5, h * 0.5, s, s * STROKE, color["sun"]);
	    };
	
	    Skycons.CLEAR_NIGHT = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        moon(ctx, t, w * 0.5, h * 0.5, s, s * STROKE, color["moon"]);
	    };
	
	    Skycons.PARTLY_CLOUDY_DAY = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        sun(ctx, t, w * 0.625, h * 0.375, s * 0.75, s * STROKE, color["sun"]);
	        cloud(ctx, t, w * 0.375, h * 0.625, s * 0.75, s * STROKE, color["cloud"]);
	    };
	
	    Skycons.PARTLY_CLOUDY_NIGHT = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        moon(ctx, t, w * 0.667, h * 0.375, s * 0.75, s * STROKE, color["moon"]);
	        cloud(ctx, t, w * 0.375, h * 0.625, s * 0.75, s * STROKE, color["cloud"]);
	    };
	
	    Skycons.CLOUDY = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        cloud(ctx, t, w * 0.5, h * 0.5, s, s * STROKE, color["cloud"]);
	    };
	
	    Skycons.RAIN = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        rain(ctx, t, w * 0.5, h * 0.37, s * 0.9, s * STROKE, color["rain"]);
	        cloud(ctx, t, w * 0.5, h * 0.37, s * 0.9, s * STROKE, color["cloud"]);
	    };
	
	    Skycons.SLEET = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        sleet(ctx, t, w * 0.5, h * 0.37, s * 0.9, s * STROKE, color["rain"]);
	        cloud(ctx, t, w * 0.5, h * 0.37, s * 0.9, s * STROKE, color["cloud"]);
	    };
	
	    Skycons.SNOW = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        snow(ctx, t, w * 0.5, h * 0.37, s * 0.9, s * STROKE, color["snow"]);
	        cloud(ctx, t, w * 0.5, h * 0.37, s * 0.9, s * STROKE, color["cloud"]);
	    };
	
	    Skycons.WIND = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h);
	
	        swoosh(ctx, t, w * 0.5, h * 0.5, s, s * STROKE, 0, 2, color["wind"]);
	        swoosh(ctx, t, w * 0.5, h * 0.5, s, s * STROKE, 1, 2, color["wind"]);
	    };
	
	    Skycons.FOG = function (ctx, t, color) {
	        var w = ctx.canvas.width,
	            h = ctx.canvas.height,
	            s = Math.min(w, h),
	            k = s * STROKE;
	
	        fogbank(ctx, t, w * 0.5, h * 0.32, s * 0.75, k, color["cloud"]);
	
	        t /= 5000;
	
	        var a = Math.cos(t * TWO_PI) * s * 0.02,
	            b = Math.cos((t + 0.25) * TWO_PI) * s * 0.02,
	            c = Math.cos((t + 0.50) * TWO_PI) * s * 0.02,
	            d = Math.cos((t + 0.75) * TWO_PI) * s * 0.02,
	            n = h * 0.936,
	            e = Math.floor(n - k * 0.5) + 0.5,
	            f = Math.floor(n - k * 2.5) + 0.5;
	
	        ctx.strokeStyle = color["fog"];
	        ctx.lineWidth = k;
	        ctx.lineCap = "round";
	        ctx.lineJoin = "round";
	
	        line(ctx, a + w * 0.2 + k * 0.5, e, b + w * 0.8 - k * 0.5, e);
	        line(ctx, c + w * 0.2 + k * 0.5, f, d + w * 0.8 - k * 0.5, f);
	    };
	
	    Skycons.prototype = {
	        add: function add(el, draw) {
	            var obj;
	
	            if (typeof el === "string") el = document.getElementById(el);
	
	            if (el === null) return;
	
	            if (typeof draw === "string") {
	                draw = draw.toUpperCase().replace(/-/g, "_");
	                draw = Skycons.hasOwnProperty(draw) ? Skycons[draw] : null;
	            }
	
	            if (typeof draw !== "function") return;
	
	            obj = {
	                element: el,
	                context: el.getContext("2d"),
	                drawing: draw
	            };
	
	            this.list.push(obj);
	            this.draw(obj, KEYFRAME);
	        },
	        set: function set(el, draw) {
	            var i;
	
	            if (typeof el === "string") el = document.getElementById(el);
	
	            for (i = this.list.length; i--;) {
	                if (this.list[i].element === el) {
	                    this.list[i].drawing = draw;
	                    this.draw(this.list[i], KEYFRAME);
	                    return;
	                }
	            }this.add(el, draw);
	        },
	        remove: function remove(el) {
	            var i;
	
	            if (typeof el === "string") el = document.getElementById(el);
	
	            for (i = this.list.length; i--;) {
	                if (this.list[i].element === el) {
	                    this.list.splice(i, 1);
	                    return;
	                }
	            }
	        },
	        draw: function draw(obj, time) {
	            var canvas = obj.context.canvas;
	
	            if (this.resizeClear) canvas.width = canvas.width;else obj.context.clearRect(0, 0, canvas.width, canvas.height);
	
	            obj.drawing(obj.context, time, this.color);
	        },
	        play: function play() {
	            var self = this;
	
	            this.pause();
	            this.interval = requestInterval(function () {
	                var now = Date.now(),
	                    i;
	
	                for (i = self.list.length; i--;) {
	                    self.draw(self.list[i], now);
	                }
	            }, 1000 / 60);
	        },
	        pause: function pause() {
	            var i;
	
	            if (this.interval) {
	                cancelInterval(this.interval);
	                this.interval = null;
	            }
	        }
	    };
	
	    global.Skycons = Skycons;
	})(window);

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	
	  jQuery.fn.extend({
	    slimScroll: function slimScroll(options) {
	
	      var defaults = {
	        width: 'auto',
	
	        height: '250px',
	
	        size: '7px',
	
	        color: '#000',
	
	        position: 'right',
	
	        distance: '1px',
	
	        start: 'top',
	
	        opacity: .4,
	
	        alwaysVisible: false,
	
	        disableFadeOut: false,
	
	        railVisible: false,
	
	        railColor: '#333',
	
	        railOpacity: .2,
	
	        railDraggable: true,
	
	        railClass: 'slimScrollRail',
	
	        barClass: 'slimScrollBar',
	
	        wrapperClass: 'slimScrollDiv',
	
	        allowPageScroll: false,
	
	        wheelStep: 20,
	
	        touchScrollStep: 200,
	
	        borderRadius: '7px',
	
	        railBorderRadius: '7px'
	      };
	
	      var o = $.extend(defaults, options);
	
	      this.each(function () {
	
	        var isOverPanel,
	            isOverBar,
	            isDragg,
	            queueHide,
	            touchDif,
	            barHeight,
	            percentScroll,
	            lastScroll,
	            divS = '<div></div>',
	            minBarHeight = 30,
	            releaseScroll = false;
	
	        var me = $(this);
	
	        if (me.parent().hasClass(o.wrapperClass)) {
	          var offset = me.scrollTop();
	
	          bar = me.parent().find('.' + o.barClass);
	          rail = me.parent().find('.' + o.railClass);
	
	          getBarHeight();
	
	          if ($.isPlainObject(options)) {
	            if ('height' in options && options.height == 'auto') {
	              me.parent().css('height', 'auto');
	              me.css('height', 'auto');
	              var height = me.parent().parent().height();
	              me.parent().css('height', height);
	              me.css('height', height);
	            }
	
	            if ('scrollTo' in options) {
	              offset = parseInt(o.scrollTo);
	            } else if ('scrollBy' in options) {
	              offset += parseInt(o.scrollBy);
	            } else if ('destroy' in options) {
	              bar.remove();
	              rail.remove();
	              me.unwrap();
	              return;
	            }
	
	            scrollContent(offset, false, true);
	          }
	
	          return;
	        }
	
	        o.height = o.height == 'auto' ? me.parent().height() : o.height;
	
	        var wrapper = $(divS).addClass(o.wrapperClass).css({
	          position: 'relative',
	          overflow: 'hidden',
	          width: o.width,
	          height: o.height
	        });
	
	        me.css({
	          overflow: 'hidden',
	          width: o.width,
	          height: o.height
	        });
	
	        var rail = $(divS).addClass(o.railClass).css({
	          width: o.size,
	          height: '100%',
	          position: 'absolute',
	          top: 0,
	          display: o.alwaysVisible && o.railVisible ? 'block' : 'none',
	          'border-radius': o.railBorderRadius,
	          background: o.railColor,
	          opacity: o.railOpacity,
	          zIndex: 90
	        });
	
	        var bar = $(divS).addClass(o.barClass).css({
	          background: o.color,
	          width: o.size,
	          position: 'absolute',
	          top: 0,
	          opacity: o.opacity,
	          display: o.alwaysVisible ? 'block' : 'none',
	          'border-radius': o.borderRadius,
	          BorderRadius: o.borderRadius,
	          MozBorderRadius: o.borderRadius,
	          WebkitBorderRadius: o.borderRadius,
	          zIndex: 99
	        });
	
	        var posCss = o.position == 'right' ? { right: o.distance } : { left: o.distance };
	        rail.css(posCss);
	        bar.css(posCss);
	
	        me.wrap(wrapper);
	
	        me.parent().append(bar);
	        me.parent().append(rail);
	
	        if (o.railDraggable) {
	          bar.bind("mousedown", function (e) {
	            var $doc = $(document);
	            isDragg = true;
	            t = parseFloat(bar.css('top'));
	            pageY = e.pageY;
	
	            $doc.bind("mousemove.slimscroll", function (e) {
	              currTop = t + e.pageY - pageY;
	              bar.css('top', currTop);
	              scrollContent(0, bar.position().top, false);
	            });
	
	            $doc.bind("mouseup.slimscroll", function (e) {
	              isDragg = false;hideBar();
	              $doc.unbind('.slimscroll');
	            });
	            return false;
	          }).bind("selectstart.slimscroll", function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            return false;
	          });
	        }
	
	        rail.hover(function () {
	          showBar();
	        }, function () {
	          hideBar();
	        });
	
	        bar.hover(function () {
	          isOverBar = true;
	        }, function () {
	          isOverBar = false;
	        });
	
	        me.hover(function () {
	          isOverPanel = true;
	          showBar();
	          hideBar();
	        }, function () {
	          isOverPanel = false;
	          hideBar();
	        });
	
	        me.bind('touchstart', function (e, b) {
	          if (e.originalEvent.touches.length) {
	            touchDif = e.originalEvent.touches[0].pageY;
	          }
	        });
	
	        me.bind('touchmove', function (e) {
	          if (!releaseScroll) {
	            e.originalEvent.preventDefault();
	          }
	          if (e.originalEvent.touches.length) {
	            var diff = (touchDif - e.originalEvent.touches[0].pageY) / o.touchScrollStep;
	
	            scrollContent(diff, true);
	            touchDif = e.originalEvent.touches[0].pageY;
	          }
	        });
	
	        getBarHeight();
	
	        if (o.start === 'bottom') {
	          bar.css({ top: me.outerHeight() - bar.outerHeight() });
	          scrollContent(0, true);
	        } else if (o.start !== 'top') {
	          scrollContent($(o.start).position().top, null, true);
	
	          if (!o.alwaysVisible) {
	            bar.hide();
	          }
	        }
	
	        attachWheel();
	
	        function _onWheel(e) {
	          if (!isOverPanel) {
	            return;
	          }
	
	          var e = e || window.event;
	
	          var delta = 0;
	          if (e.wheelDelta) {
	            delta = -e.wheelDelta / 120;
	          }
	          if (e.detail) {
	            delta = e.detail / 3;
	          }
	
	          var target = e.target || e.srcTarget || e.srcElement;
	          if ($(target).closest('.' + o.wrapperClass).is(me.parent())) {
	            scrollContent(delta, true);
	          }
	
	          if (e.preventDefault && !releaseScroll) {
	            e.preventDefault();
	          }
	          if (!releaseScroll) {
	            e.returnValue = false;
	          }
	        }
	
	        function scrollContent(y, isWheel, isJump) {
	          releaseScroll = false;
	          var delta = y;
	          var maxTop = me.outerHeight() - bar.outerHeight();
	
	          if (isWheel) {
	            delta = parseInt(bar.css('top')) + y * parseInt(o.wheelStep) / 100 * bar.outerHeight();
	
	            delta = Math.min(Math.max(delta, 0), maxTop);
	
	            delta = y > 0 ? Math.ceil(delta) : Math.floor(delta);
	
	            bar.css({ top: delta + 'px' });
	          }
	
	          percentScroll = parseInt(bar.css('top')) / (me.outerHeight() - bar.outerHeight());
	          delta = percentScroll * (me[0].scrollHeight - me.outerHeight());
	
	          if (isJump) {
	            delta = y;
	            var offsetTop = delta / me[0].scrollHeight * me.outerHeight();
	            offsetTop = Math.min(Math.max(offsetTop, 0), maxTop);
	            bar.css({ top: offsetTop + 'px' });
	          }
	
	          me.scrollTop(delta);
	
	          me.trigger('slimscrolling', ~~delta);
	
	          showBar();
	
	          hideBar();
	        }
	
	        function attachWheel() {
	          if (window.addEventListener) {
	            this.addEventListener('DOMMouseScroll', _onWheel, false);
	            this.addEventListener('mousewheel', _onWheel, false);
	            this.addEventListener('MozMousePixelScroll', _onWheel, false);
	          } else {
	            document.attachEvent("onmousewheel", _onWheel);
	          }
	        }
	
	        function getBarHeight() {
	          barHeight = Math.max(me.outerHeight() / me[0].scrollHeight * me.outerHeight(), minBarHeight);
	          bar.css({ height: barHeight + 'px' });
	
	          var display = barHeight == me.outerHeight() ? 'none' : 'block';
	          bar.css({ display: display });
	        }
	
	        function showBar() {
	          getBarHeight();
	          clearTimeout(queueHide);
	
	          if (percentScroll == ~~percentScroll) {
	            releaseScroll = o.allowPageScroll;
	
	            if (lastScroll != percentScroll) {
	              var msg = ~~percentScroll == 0 ? 'top' : 'bottom';
	              me.trigger('slimscroll', msg);
	            }
	          } else {
	            releaseScroll = false;
	          }
	          lastScroll = percentScroll;
	
	          if (barHeight >= me.outerHeight()) {
	            releaseScroll = true;
	            return;
	          }
	          bar.stop(true, true).fadeIn('fast');
	          if (o.railVisible) {
	            rail.stop(true, true).fadeIn('fast');
	          }
	        }
	
	        function hideBar() {
	          if (!o.alwaysVisible) {
	            queueHide = setTimeout(function () {
	              if (!(o.disableFadeOut && isOverPanel) && !isOverBar && !isDragg) {
	                bar.fadeOut('slow');
	                rail.fadeOut('slow');
	              }
	            }, 1000);
	          }
	        }
	      });
	
	      return this;
	    }
	  });
	
	  jQuery.fn.extend({
	    slimscroll: jQuery.fn.slimScroll
	  });
	})(jQuery);

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	"use strict";
	
	(function (d, f, g, b) {
	  var e = "tooltipster",
	      c = { animation: "fade", arrow: true, arrowColor: "", content: "", delay: 200, fixedWidth: 0, maxWidth: 0, functionBefore: function functionBefore(m, n) {
	      n();
	    }, functionReady: function functionReady(m, n) {}, functionAfter: function functionAfter(m) {}, icon: "(?)", iconDesktop: false, iconTouch: false, iconTheme: ".tooltipster-icon", interactive: false, interactiveTolerance: 350, offsetX: 0, offsetY: 0, onlyOne: true, position: "top", speed: 350, timer: 0, theme: ".tooltipster-default", touchDevices: true, trigger: "hover", updateAnimation: true };function j(n, m) {
	    this.element = n;this.options = d.extend({}, c, m);this._defaults = c;this._name = e;this.init();
	  }function k() {
	    return !!("ontouchstart" in f);
	  }function a() {
	    var m = g.body || g.documentElement;var o = m.style;var q = "transition";if (typeof o[q] == "string") {
	      return true;
	    }v = ["Moz", "Webkit", "Khtml", "O", "ms"], q = q.charAt(0).toUpperCase() + q.substr(1);for (var n = 0; n < v.length; n++) {
	      if (typeof o[v[n] + q] == "string") {
	        return true;
	      }
	    }return false;
	  }var l = true;if (!a()) {
	    l = false;
	  }var h = k();d(f).on("mousemove.tooltipster", function () {
	    h = false;d(f).off("mousemove.tooltipster");
	  });j.prototype = { init: function init() {
	      var s = d(this.element);var o = this;var r = true;if (o.options.touchDevices == false && h) {
	        r = false;
	      }if (g.all && !g.querySelector) {
	        r = false;
	      }if (r == true) {
	        if (this.options.iconDesktop == true && !h || this.options.iconTouch == true && h) {
	          var n = s.attr("title");s.removeAttr("title");var q = o.options.iconTheme;var p = d('<span class="' + q.replace(".", "") + '" title="' + n + '">' + this.options.icon + "</span>");p.insertAfter(s);s.data("tooltipsterIcon", p);s = p;
	        }var m = d.trim(o.options.content).length > 0 ? o.options.content : s.attr("title");s.data("tooltipsterContent", m);s.removeAttr("title");if (this.options.touchDevices == true && h && (this.options.trigger == "click" || this.options.trigger == "hover")) {
	          s.bind("touchstart", function (u, t) {
	            o.showTooltip();
	          });
	        } else {
	          if (this.options.trigger == "hover") {
	            s.on("mouseenter.tooltipster", function () {
	              o.showTooltip();
	            });if (this.options.interactive == true) {
	              s.on("mouseleave.tooltipster", function () {
	                var u = s.data("tooltipster");var w = false;if (u !== b && u !== "") {
	                  u.mouseenter(function () {
	                    w = true;
	                  });u.mouseleave(function () {
	                    w = false;
	                  });var t = setTimeout(function () {
	                    if (w == true) {
	                      u.mouseleave(function () {
	                        o.hideTooltip();
	                      });
	                    } else {
	                      o.hideTooltip();
	                    }
	                  }, o.options.interactiveTolerance);
	                } else {
	                  o.hideTooltip();
	                }
	              });
	            } else {
	              s.on("mouseleave.tooltipster", function () {
	                o.hideTooltip();
	              });
	            }
	          }if (this.options.trigger == "click") {
	            s.on("click.tooltipster", function () {
	              if (s.data("tooltipster") == "" || s.data("tooltipster") == b) {
	                o.showTooltip();
	              } else {
	                o.hideTooltip();
	              }
	            });
	          }
	        }
	      }
	    }, showTooltip: function showTooltip(n) {
	      var o = d(this.element);var m = this;if (o.data("tooltipsterIcon") !== b) {
	        o = o.data("tooltipsterIcon");
	      }if (!o.hasClass("tooltipster-disable")) {
	        if (d(".tooltipster-base").not(".tooltipster-dying").length > 0 && m.options.onlyOne == true) {
	          d(".tooltipster-base").not(".tooltipster-dying").not(o.data("tooltipster")).each(function () {
	            d(this).addClass("tooltipster-kill");var p = d(this).data("origin");p.data("plugin_tooltipster").hideTooltip();
	          });
	        }o.clearQueue().delay(m.options.delay).queue(function () {
	          m.options.functionBefore(o, function () {
	            if (o.data("tooltipster") !== b && o.data("tooltipster") !== "") {
	              var y = o.data("tooltipster");if (!y.hasClass("tooltipster-kill")) {
	                var u = "tooltipster-" + m.options.animation;y.removeClass("tooltipster-dying");if (l == true) {
	                  y.clearQueue().addClass(u + "-show");
	                }if (m.options.timer > 0) {
	                  var r = y.data("tooltipsterTimer");clearTimeout(r);r = setTimeout(function () {
	                    y.data("tooltipsterTimer", b);m.hideTooltip();
	                  }, m.options.timer);y.data("tooltipsterTimer", r);
	                }if (m.options.touchDevices == true && h) {
	                  d("body").bind("touchstart", function (D) {
	                    if (m.options.interactive == true) {
	                      var F = d(D.target);var E = true;F.parents().each(function () {
	                        if (d(this).hasClass("tooltipster-base")) {
	                          E = false;
	                        }
	                      });if (E == true) {
	                        m.hideTooltip();d("body").unbind("touchstart");
	                      }
	                    } else {
	                      m.hideTooltip();d("body").unbind("touchstart");
	                    }
	                  });
	                }
	              }
	            } else {
	              d("body").css("overflow-x", "hidden");var z = o.data("tooltipsterContent");var x = m.options.theme;var A = x.replace(".", "");var u = "tooltipster-" + m.options.animation;var t = "-webkit-transition-duration: " + m.options.speed + "ms; -webkit-animation-duration: " + m.options.speed + "ms; -moz-transition-duration: " + m.options.speed + "ms; -moz-animation-duration: " + m.options.speed + "ms; -o-transition-duration: " + m.options.speed + "ms; -o-animation-duration: " + m.options.speed + "ms; -ms-transition-duration: " + m.options.speed + "ms; -ms-animation-duration: " + m.options.speed + "ms; transition-duration: " + m.options.speed + "ms; animation-duration: " + m.options.speed + "ms;";var p = m.options.fixedWidth > 0 ? "width:" + m.options.fixedWidth + "px;" : "";var B = m.options.maxWidth > 0 ? "max-width:" + m.options.maxWidth + "px;" : "";var w = m.options.interactive == true ? "pointer-events: auto;" : "";var y = d('<div class="tooltipster-base ' + A + " " + u + '" style="' + p + " " + B + " " + w + " " + t + '"></div>');var s = d('<div class="tooltipster-content"></div>');s.html(z);y.append(s);y.appendTo("body");o.data("tooltipster", y);y.data("origin", o);m.positionTooltip();m.options.functionReady(o, y);if (l == true) {
	                y.addClass(u + "-show");
	              } else {
	                y.css("display", "none").removeClass(u).fadeIn(m.options.speed);
	              }var C = z;var q = setInterval(function () {
	                var D = o.data("tooltipsterContent");if (d("body").find(o).length == 0) {
	                  y.addClass("tooltipster-dying");m.hideTooltip();
	                } else {
	                  if (C !== D && D !== "") {
	                    C = D;y.find(".tooltipster-content").html(D);if (m.options.updateAnimation == true) {
	                      if (a()) {
	                        y.css({ width: "", "-webkit-transition": "all " + m.options.speed + "ms, width 0ms, height 0ms, left 0ms, top 0ms", "-moz-transition": "all " + m.options.speed + "ms, width 0ms, height 0ms, left 0ms, top 0ms", "-o-transition": "all " + m.options.speed + "ms, width 0ms, height 0ms, left 0ms, top 0ms", "-ms-transition": "all " + m.options.speed + "ms, width 0ms, height 0ms, left 0ms, top 0ms", transition: "all " + m.options.speed + "ms, width 0ms, height 0ms, left 0ms, top 0ms" }).addClass("tooltipster-content-changing");setTimeout(function () {
	                          y.removeClass("tooltipster-content-changing");setTimeout(function () {
	                            y.css({ "-webkit-transition": m.options.speed + "ms", "-moz-transition": m.options.speed + "ms", "-o-transition": m.options.speed + "ms", "-ms-transition": m.options.speed + "ms", transition: m.options.speed + "ms" });
	                          }, m.options.speed);
	                        }, m.options.speed);
	                      } else {
	                        y.fadeTo(m.options.speed, 0.5, function () {
	                          y.fadeTo(m.options.speed, 1);
	                        });
	                      }
	                    }m.positionTooltip();
	                  }
	                }if (d("body").find(y).length == 0 || d("body").find(o).length == 0) {
	                  clearInterval(q);
	                }
	              }, 200);if (m.options.timer > 0) {
	                var r = setTimeout(function () {
	                  y.data("tooltipsterTimer", b);m.hideTooltip();
	                }, m.options.timer + m.options.speed);y.data("tooltipsterTimer", r);
	              }if (m.options.touchDevices == true && h) {
	                d("body").bind("touchstart", function (D) {
	                  if (m.options.interactive == true) {
	                    var F = d(D.target);var E = true;F.parents().each(function () {
	                      if (d(this).hasClass("tooltipster-base")) {
	                        E = false;
	                      }
	                    });if (E == true) {
	                      m.hideTooltip();d("body").unbind("touchstart");
	                    }
	                  } else {
	                    m.hideTooltip();d("body").unbind("touchstart");
	                  }
	                });
	              }y.mouseleave(function () {
	                m.hideTooltip();
	              });
	            }
	          });o.dequeue();
	        });
	      }
	    }, hideTooltip: function hideTooltip(n) {
	      var q = d(this.element);var m = this;if (q.data("tooltipsterIcon") !== b) {
	        q = q.data("tooltipsterIcon");
	      }var p = q.data("tooltipster");if (p == b) {
	        p = d(".tooltipster-dying");
	      }q.clearQueue();if (p !== b && p !== "") {
	        var r = p.data("tooltipsterTimer");if (r !== b) {
	          clearTimeout(r);
	        }var o = "tooltipster-" + m.options.animation;if (l == true) {
	          p.clearQueue().removeClass(o + "-show").addClass("tooltipster-dying").delay(m.options.speed).queue(function () {
	            p.remove();q.data("tooltipster", "");d("body").css("verflow-x", "");m.options.functionAfter(q);
	          });
	        } else {
	          p.clearQueue().addClass("tooltipster-dying").fadeOut(m.options.speed, function () {
	            p.remove();q.data("tooltipster", "");d("body").css("verflow-x", "");m.options.functionAfter(q);
	          });
	        }
	      }
	    }, positionTooltip: function positionTooltip(P) {
	      var B = d(this.element);var ac = this;if (B.data("tooltipsterIcon") !== b) {
	        B = B.data("tooltipsterIcon");
	      }if (B.data("tooltipster") !== b && B.data("tooltipster") !== "") {
	        var x = function x() {
	          var ao = d(f).scrollLeft();if (t - ao < 0) {
	            var an = t - ao;t = ao;ai.data("arrow-reposition", an);
	          }if (t + am - ao > aj) {
	            var an = t - (aj + ao - am);t = aj + ao - am;ai.data("arrow-reposition", an);
	          }
	        };
	
	        var u = function u(ao, an) {
	          if (aa - d(f).scrollTop() - N - Y - 12 < 0 && an.indexOf("top") > -1) {
	            ac.options.position = ao;z = an;
	          }if (aa + ah + N + 12 + Y > d(f).scrollTop() + d(f).height() && an.indexOf("bottom") > -1) {
	            ac.options.position = ao;z = an;W = aa - N - Y - 12;
	          }
	        };
	
	        var ai = B.data("tooltipster");ai.css("width", "");var aj = d(f).width();var C = B.outerWidth(false);var ah = B.outerHeight(false);var am = ai.outerWidth(false);var n = ai.innerWidth() + 1;var N = ai.outerHeight(false);var ab = B.offset();var aa = ab.top;var w = ab.left;var z = b;if (B.is("area")) {
	          var U = B.attr("shape");var ag = B.parent().attr("name");var Q = d('img[usemap="#' + ag + '"]');var o = Q.offset().left;var M = Q.offset().top;var X = B.attr("coords") !== b ? B.attr("coords").split(",") : b;if (U == "circle") {
	            var O = parseInt(X[0]);var s = parseInt(X[1]);var E = parseInt(X[2]);ah = E * 2;C = E * 2;aa = M + s - E;w = o + O - E;
	          } else {
	            if (U == "rect") {
	              var O = parseInt(X[0]);var s = parseInt(X[1]);var r = parseInt(X[2]);var K = parseInt(X[3]);ah = K - s;C = r - O;aa = M + s;w = o + O;
	            } else {
	              if (U == "poly") {
	                var y = [];var af = [];var I = 0,
	                    H = 0,
	                    ae = 0,
	                    ad = 0;var ak = "even";for (i = 0; i < X.length; i++) {
	                  var G = parseInt(X[i]);if (ak == "even") {
	                    if (G > ae) {
	                      ae = G;if (i == 0) {
	                        I = ae;
	                      }
	                    }if (G < I) {
	                      I = G;
	                    }ak = "odd";
	                  } else {
	                    if (G > ad) {
	                      ad = G;if (i == 1) {
	                        H = ad;
	                      }
	                    }if (G < H) {
	                      H = G;
	                    }ak = "even";
	                  }
	                }ah = ad - H;C = ae - I;aa = M + H;w = o + I;
	              } else {
	                ah = Q.outerHeight(false);C = Q.outerWidth(false);aa = M;w = o;
	              }
	            }
	          }
	        }if (ac.options.fixedWidth == 0) {
	          ai.css({ width: n + "px", "padding-left": "0px", "padding-right": "0px" });
	        }var t = 0,
	            W = 0;var Y = parseInt(ac.options.offsetY);var Z = parseInt(ac.options.offsetX);var q = "";if (ac.options.position == "top") {
	          var R = w + am - (w + C);t = w + Z - R / 2;W = aa - N - Y - 12;x();u("bottom", "top");
	        }if (ac.options.position == "top-left") {
	          t = w + Z;W = aa - N - Y - 12;x();u("bottom-left", "top-left");
	        }if (ac.options.position == "top-right") {
	          t = w + C + Z - am;W = aa - N - Y - 12;x();u("bottom-right", "top-right");
	        }if (ac.options.position == "bottom") {
	          var R = w + am - (w + C);t = w - R / 2 + Z;W = aa + ah + Y + 12;x();u("top", "bottom");
	        }if (ac.options.position == "bottom-left") {
	          t = w + Z;W = aa + ah + Y + 12;x();u("top-left", "bottom-left");
	        }if (ac.options.position == "bottom-right") {
	          t = w + C + Z - am;W = aa + ah + Y + 12;x();u("top-right", "bottom-right");
	        }if (ac.options.position == "left") {
	          t = w - Z - am - 12;myLeftMirror = w + Z + C + 12;var L = aa + N - (aa + B.outerHeight(false));W = aa - L / 2 - Y;if (t < 0 && myLeftMirror + am > aj) {
	            var p = parseFloat(ai.css("border-width")) * 2;var m = am + t - p;ai.css("width", m + "px");N = ai.outerHeight(false);t = w - Z - m - 12 - p;L = aa + N - (aa + B.outerHeight(false));W = aa - L / 2 - Y;
	          } else {
	            if (t < 0) {
	              t = w + Z + C + 12;ai.data("arrow-reposition", "left");
	            }
	          }
	        }if (ac.options.position == "right") {
	          t = w + Z + C + 12;myLeftMirror = w - Z - am - 12;var L = aa + N - (aa + B.outerHeight(false));W = aa - L / 2 - Y;if (t + am > aj && myLeftMirror < 0) {
	            var p = parseFloat(ai.css("border-width")) * 2;var m = aj - t - p;ai.css("width", m + "px");N = ai.outerHeight(false);L = aa + N - (aa + B.outerHeight(false));W = aa - L / 2 - Y;
	          } else {
	            if (t + am > aj) {
	              t = w - Z - am - 12;ai.data("arrow-reposition", "right");
	            }
	          }
	        }if (ac.options.arrow == true) {
	          var J = "tooltipster-arrow-" + ac.options.position;if (ac.options.arrowColor.length < 1) {
	            var S = ai.css("background-color");
	          } else {
	            var S = ac.options.arrowColor;
	          }var al = ai.data("arrow-reposition");if (!al) {
	            al = "";
	          } else {
	            if (al == "left") {
	              J = "tooltipster-arrow-right";al = "";
	            } else {
	              if (al == "right") {
	                J = "tooltipster-arrow-left";al = "";
	              } else {
	                al = "left:" + al + "px;";
	              }
	            }
	          }if (ac.options.position == "top" || ac.options.position == "top-left" || ac.options.position == "top-right") {
	            var V = parseFloat(ai.css("border-bottom-width"));var A = ai.css("border-bottom-color");
	          } else {
	            if (ac.options.position == "bottom" || ac.options.position == "bottom-left" || ac.options.position == "bottom-right") {
	              var V = parseFloat(ai.css("border-top-width"));var A = ai.css("border-top-color");
	            } else {
	              if (ac.options.position == "left") {
	                var V = parseFloat(ai.css("border-right-width"));var A = ai.css("border-right-color");
	              } else {
	                if (ac.options.position == "right") {
	                  var V = parseFloat(ai.css("border-left-width"));var A = ai.css("border-left-color");
	                } else {
	                  var V = parseFloat(ai.css("border-bottom-width"));var A = ai.css("border-bottom-color");
	                }
	              }
	            }
	          }if (V > 1) {
	            V++;
	          }var F = "";if (V !== 0) {
	            var D = "";var T = "border-color: " + A + ";";if (J.indexOf("bottom") !== -1) {
	              D = "margin-top: -" + V + "px;";
	            } else {
	              if (J.indexOf("top") !== -1) {
	                D = "margin-bottom: -" + V + "px;";
	              } else {
	                if (J.indexOf("left") !== -1) {
	                  D = "margin-right: -" + V + "px;";
	                } else {
	                  if (J.indexOf("right") !== -1) {
	                    D = "margin-left: -" + V + "px;";
	                  }
	                }
	              }
	            }F = '<span class="tooltipster-arrow-border" style="' + D + " " + T + ';"></span>';
	          }ai.find(".tooltipster-arrow").remove();q = '<div class="' + J + ' tooltipster-arrow" style="' + al + '">' + F + '<span style="border-color:' + S + ';"></span></div>';ai.append(q);
	        }ai.css({ top: W + "px", left: t + "px" });if (z !== b) {
	          ac.options.position = z;
	        }
	      }
	    } };d.fn[e] = function (n) {
	    if (typeof n === "string") {
	      var p = this;var m = arguments[1];if (p.data("plugin_tooltipster") == b) {
	        var o = p.find("*");p = d();o.each(function () {
	          if (d(this).data("plugin_tooltipster") !== b) {
	            p.push(d(this));
	          }
	        });
	      }p.each(function () {
	        switch (n.toLowerCase()) {case "show":
	            d(this).data("plugin_tooltipster").showTooltip();break;case "hide":
	            d(this).data("plugin_tooltipster").hideTooltip();break;case "disable":
	            d(this).addClass("tooltipster-disable");break;case "enable":
	            d(this).removeClass("tooltipster-disable");break;case "destroy":
	            d(this).data("plugin_tooltipster").hideTooltip();d(this).data("plugin_tooltipster", "").attr("title", p.data("tooltipsterContent")).data("tooltipsterContent", "").data("plugin_tooltipster", "").off("mouseenter.tooltipster mouseleave.tooltipster click.tooltipster");break;case "update":
	            if (d(this).data("tooltipsterIcon") == b) {
	              d(this).data("tooltipsterContent", m);
	            } else {
	              var q = d(this).data("tooltipsterIcon");q.data("tooltipsterContent", m);
	            }break;case "reposition":
	            d(this).data("plugin_tooltipster").positionTooltip();break;}
	      });return this;
	    }return this.each(function () {
	      if (!d.data(this, "plugin_" + e)) {
	        d.data(this, "plugin_" + e, new j(this, n));
	      }var q = d(this).data("plugin_tooltipster").options;if (q.iconDesktop == true && !h || q.iconTouch == true && h) {
	        var r = d(this).data("plugin_tooltipster");d(this).next().data("plugin_tooltipster", r);
	      }
	    });
	  };if (h) {
	    f.addEventListener("orientationchange", function () {
	      if (d(".tooltipster-base").length > 0) {
	        d(".tooltipster-base").each(function () {
	          var m = d(this).data("origin");m.data("plugin_tooltipster").hideTooltip();
	        });
	      }
	    }, false);
	  }d(f).on("resize.tooltipster", function () {
	    var m = d(".tooltipster-base").data("origin");if (m !== null && m !== b) {
	      m.tooltipster("reposition");
	    }
	  });
	})(jQuery, window, document);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerVueComponents;
	
	var _inputText = __webpack_require__(492);
	
	var _inputText2 = _interopRequireDefault(_inputText);
	
	var _inputSelect = __webpack_require__(491);
	
	var _inputSelect2 = _interopRequireDefault(_inputSelect);
	
	var _inputToggle = __webpack_require__(493);
	
	var _inputToggle2 = _interopRequireDefault(_inputToggle);
	
	var _inputDate = __webpack_require__(490);
	
	var _inputDate2 = _interopRequireDefault(_inputDate);
	
	var _quote = __webpack_require__(489);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerVueComponents(Vue) {
		Vue.component('input-text', _inputText2.default);
		Vue.component('input-select', _inputSelect2.default);
		Vue.component('input-toggle', _inputToggle2.default);
		Vue.component('input-date', _inputDate2.default);
		Vue.component('quote', _quote2.default);
	}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(7);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		twoWay: true,
		params: ['dateFormat'],
	
		bind: function bind() {
			var self = this;
			(0, _jquery2.default)(this.el).daterangepicker({
				"locale": {
					"format": self.params.dateFormat
				},
				"singleDatePicker": true,
				"timePicker": true,
				"timePickerIncrement": 30
			});
		},
		update: function update(value) {
			(0, _jquery2.default)(this.el).data('daterangepicker').setStartDate(value);
			(0, _jquery2.default)(this.el).data('daterangepicker').setEndDate(value);
		},
		unbind: function unbind() {}
	};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = registerVueDirectives;
	
	var _select = __webpack_require__(226);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _toggle = __webpack_require__(227);
	
	var _toggle2 = _interopRequireDefault(_toggle);
	
	var _daterangepicker = __webpack_require__(223);
	
	var _daterangepicker2 = _interopRequireDefault(_daterangepicker);
	
	var _radio = __webpack_require__(225);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerVueDirectives(Vue) {
		Vue.directive('select', _select2.default);
		Vue.directive('toggle', _toggle2.default);
		Vue.directive('datepicker', _daterangepicker2.default);
		Vue.directive('radio', _radio2.default);
	}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		twoWay: true,
	
		params: ['defaultValue'],
	
		bind: function bind() {
			var _this = this;
	
			$(this.el).find('.btn').each(function (index, element) {
				$(element).on('click', function (event) {
					if ($(event.target).hasClass('disabled')) {
						return false;
					}
	
					var value = $(event.target).is('input') ? $(event.target).get(0).value : $(event.target).find('input').get(0).value;
	
					_this.set(value);
				});
			});
		},
		update: function update(value) {
			if (value) {
				this.set(value);
	
				$(this.el).find('.btn').each(function (index, element) {
					$(element).removeClass('active');
	
					if ($(element).find('input').get(0).value === value) {
						$(element).addClass('active');
					}
				});
			} else {
				var input = $(this.el).find('.active').get(0);
	
				if (input) {
					this.set(input.value);
				} else {
					this.set(this.params.defaultValue || 0);
				}
			}
		}
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(7);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		twoWay: true,
		params: ['tags', 'placeholder'],
	
		bind: function bind() {
			var self = this;
	
			(0, _jquery2.default)(this.el).select2({
				tags: this.params.tags,
				placeholder: this.params.placeholder,
				allowClear: false
			}).on('change', function () {
				self.set(this.value);
			});
		},
		update: function update(value) {
			(0, _jquery2.default)(this.el).val(value).trigger('change');
		},
		unbind: function unbind() {
			(0, _jquery2.default)(this.el).off().select2('destroy');
		}
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(7);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		twoWay: true,
		params: ['on', 'off', 'onStyle', 'offStyle'],
	
		bind: function bind() {
			var _this = this;
	
			(0, _jquery2.default)(this.el).bootstrapToggle({
				on: this.params.on,
				off: this.params.off,
				onstyle: this.params.onStyle,
				offstyle: this.params.offStyle
			}).on('change', function (event) {
				_this.set((0, _jquery2.default)(event.target).prop('checked'));
			});
		},
		update: function update(newValue, oldValue) {
			if (newValue == 1 || newValue == true) {
				(0, _jquery2.default)(this.el).bootstrapToggle('on');
			} else {
				(0, _jquery2.default)(this.el).bootstrapToggle('off');
			}
		}
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  var token = sessionStorage.getItem('token');
	
	  if (token) {
	    request.headers.set('Authorization', 'Bearer ' + token);
	  }
	
	  next(function (response) {
	    if (response.headers.has('Authorization')) {
	      sessionStorage.setItem('token', response.headers.get('Authorization').substr('Bearer '.length));
	    }
	  });
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(12);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sessionHasExpired = false;
	
	_vue2.default.http.interceptors.push(function (request, next) {
		next(function (response) {
			if (response.status === 401 && !sessionHasExpired && store.state.user.authorized) {
				sessionHasExpired = true;
	
				_notify2.default.error('Your session has expired, please login again.');
	
				setTimeout(function () {
					sessionStorage.removeItem('token');
					undefined.$store.dispatch(types.SET_AUTHORIZED, false);
					undefined.$router.go({ name: 'dashboard' });
				}, 2000);
			}
		});
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.title = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var title = exports.title = function title(_ref, _title) {
		var dispatch = _ref.dispatch;
	
		dispatch(types.SET_TITLE, _title);
	};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.destroy = exports.store = exports.favourite = exports.update = exports.clear = exports.edit = exports.get = exports.exportHistory = exports.exportDashboardData = exports.reset = exports.all = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _pusher = __webpack_require__(58);
	
	var _logger = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var all = exports.all = function all(_ref, site) {
		var dispatch = _ref.dispatch;
		var include = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		return _http2.default.include(include).get('sites/' + site + '/fermenters').then(function (response) {
			dispatch(types.SET_FERMENTERS, response.body.data);
		});
	};
	
	var reset = exports.reset = function reset(_ref2) {
		var dispatch = _ref2.dispatch;
	
		dispatch(types.SET_FERMENTERS, []);
	};
	
	function pusherError(response) {
		(0, _logger.toConsole)(response);
		(0, _pusher.clearEventLoading)();
		_notify2.default.error('Failed to generate file, please try again later');
	}
	
	var exportDashboardData = exports.exportDashboardData = function exportDashboardData(_ref3, site) {
		var dispatch = _ref3.dispatch;
		var include = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		(0, _pusher.startEvent)('Dashboard');
		return _http2.default.include(include).get('sites/' + site + '/fermenters-export').then(function () {}, pusherError);
	};
	
	var exportHistory = exports.exportHistory = function exportHistory(_ref4) {
		var dispatch = _ref4.dispatch;
		var ferments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
		(0, _pusher.startEvent)('History');
		return _http2.default.get('ferments/export-history?ferments=' + ferments).then(function () {}, pusherError);
	};
	
	var get = exports.get = function get(_ref5, id, site) {
		var dispatch = _ref5.dispatch;
		var include = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
		return _http2.default.include(include).get('sites/' + site + '/fermenters/' + id).then(function (response) {
			dispatch(types.SET_ACTIVE_FERMENTER, response.body.data);
		});
	};
	
	var edit = exports.edit = function edit(_ref6, fermenter) {
		var dispatch = _ref6.dispatch;
	
		dispatch(types.SET_ACTIVE_FERMENTER, fermenter);
	};
	
	var clear = exports.clear = function clear(_ref7) {
		var dispatch = _ref7.dispatch;
	
		dispatch(types.SET_ACTIVE_FERMENTER, {});
	};
	
	var update = exports.update = function update(_ref8, site, fermenter) {
		var dispatch = _ref8.dispatch;
	
		return _http2.default.put('sites/' + site + '/fermenters/' + fermenter.id, fermenter);
	};
	
	var favourite = exports.favourite = function favourite(_ref9, fermenter, site) {
		var dispatch = _ref9.dispatch;
	
		return _http2.default.post('sites/' + site + '/fermenters/' + fermenter + '/favourite');
	};
	
	var store = exports.store = function store(_ref10, site, fermenter) {
		var dispatch = _ref10.dispatch;
	
		return _http2.default.post('sites/' + site + '/fermenters', fermenter).then(function (response) {
			dispatch(types.ADD_FERMENTER, response.body.data);
			dispatch(types.SET_ACTIVE_FERMENTER, response.body.data);
		});
	};
	
	var destroy = exports.destroy = function destroy(_ref11, id, site) {
		var dispatch = _ref11.dispatch;
	
		return _http2.default.destroy('sites/' + site + '/fermenters/' + id);
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.move = exports.destroy = exports.archive = exports.temporarySimulation = exports.simulation = exports.store = exports.update = exports.get = exports.all = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var simulatingRequest = null;
	
	var all = exports.all = function all(_ref, site) {
		var dispatch = _ref.dispatch;
		var includes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
		var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		return _http2.default.include(includes).query(query).get('sites/' + site + '/ferments').then(function (response) {
			dispatch(types.SET_FERMENTS, response.body.data);
		});
	};
	
	var get = exports.get = function get(_ref2, site, fermenter, ferment) {
		var dispatch = _ref2.dispatch;
		var includes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
		return _http2.default.include(includes).get('sites/' + site + '/fermenters/' + fermenter + '/ferments/' + ferment).then(function (response) {
			dispatch(types.SET_ACTIVE_FERMENT, response.body.data);
	
			return response;
		});
	};
	
	var update = exports.update = function update(_ref3, site, fermenter, ferment) {
		var dispatch = _ref3.dispatch;
	
		return _http2.default.before(function (request) {
			if (simulatingRequest) {
				simulatingRequest.abort();
			}
		}).put('sites/' + site + '/fermenters/' + fermenter + '/ferments/' + ferment.id, ferment);
	};
	
	var store = exports.store = function store(_ref4, site, fermenter, ferment) {
		var dispatch = _ref4.dispatch;
	
		return _http2.default.post('sites/' + site + '/fermenters/' + fermenter + '/ferments', ferment).then(function (response) {
			return response;
		});
	};
	
	var simulation = exports.simulation = function simulation(_ref5, site, ferment) {
		var dispatch = _ref5.dispatch;
		var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
		return _http2.default.query({ fresh: force ? 'yes' : 'no' }).before(function (request) {
			if (simulatingRequest) {
				simulatingRequest.abort();
			}
	
			simulatingRequest = request;
		}).get('sites/' + site + '/ferments/' + ferment + '/simulate');
	};
	
	var temporarySimulation = exports.temporarySimulation = function temporarySimulation(_ref6, site, ferment, data) {
		var dispatch = _ref6.dispatch;
	
		return _http2.default.before(function (request) {
			if (simulatingRequest) {
				simulatingRequest.abort();
			}
	
			simulatingRequest = request;
		}).post('sites/' + site + '/ferments/' + ferment + '/simulate', data);
	};
	
	var archive = exports.archive = function archive(_ref7, site, fermenter, ferment) {
		var dispatch = _ref7.dispatch;
	
		return _http2.default.post('sites/' + site + '/fermenters/' + fermenter + '/ferments/' + ferment + '/archive');
	};
	
	var destroy = exports.destroy = function destroy(_ref8, site, fermenter, ferment) {
		var dispatch = _ref8.dispatch;
	
		return _http2.default.destroy('sites/' + site + '/fermenters/' + fermenter + '/ferments/' + ferment);
	};
	
	var move = exports.move = function move(_ref9, site, fermenter, ferment, payload) {
		var dispatch = _ref9.dispatch;
	
		return _http2.default.post('sites/' + site + '/fermenters/' + fermenter + '/ferments/' + ferment + '/move', payload);
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.reposition = exports.edit = exports.clear = exports.destroy = exports.update = exports.store = exports.all = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _getters = __webpack_require__(2);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var all = exports.all = function all(_ref, site) {
		var dispatch = _ref.dispatch;
		var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		return _http2.default.include(['dailyData.action', 'dailyData.analysis']).query(query).get('sites/' + site + '/profiles').then(function (response) {
			dispatch(types.SET_PROFILES, response.body.data || []);
		});
	};
	
	var store = exports.store = function store(_ref2, site, profile) {
		var dispatch = _ref2.dispatch;
	
		return _http2.default.include(['dailyData.action', 'dailyData.analysis']).post('sites/' + site + '/profiles', profile).then(function (response) {
			dispatch(types.ADD_PROFILE, response.body.data);
			dispatch(types.SET_ACTIVE_PROFILE, response.body.data);
	
			return response;
		});
	};
	
	var update = exports.update = function update(_ref3, site, profile) {
		var dispatch = _ref3.dispatch;
	
		return _http2.default.include(['dailyData.action', 'dailyData.analysis']).put('sites/' + site + '/profiles/' + profile.id, profile).then(function (response) {
			return response;
		});
	};
	
	var destroy = exports.destroy = function destroy(_ref4, site, profile) {
		var dispatch = _ref4.dispatch;
	
		return _http2.default.destroy('sites/' + site + '/profiles/' + profile);
	};
	
	var clear = exports.clear = function clear(_ref5) {
		var dispatch = _ref5.dispatch;
	
		dispatch(types.SET_ACTIVE_PROFILE, {
			id: null,
			name: '',
			profile: 0,
			duration: 0,
			type: 1,
			dailyData: {
				data: []
			}
		});
	};
	
	var edit = exports.edit = function edit(_ref6, profile) {
		var dispatch = _ref6.dispatch;
	
		dispatch(types.SET_ACTIVE_PROFILE, profile);
	};
	
	var reposition = exports.reposition = function reposition(_ref7, site, hierarchy) {
		var dispatch = _ref7.dispatch;
	
		return _http2.default.post('sites/' + site + '/profiles/reposition', { hierarchy: hierarchy }).then(function (response) {
			dispatch(types.SET_PROFILES, response.body.data);
	
			return response;
		});
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.allCountries = exports.editVarietal = exports.destroyVarietal = exports.storeVarietal = exports.allVarietals = exports.editRegion = exports.destroyRegion = exports.storeRegion = exports.allRegions = exports.editYeastType = exports.destroyYeastType = exports.storeYeastType = exports.allYeastTypes = exports.updateWhatNow = exports.allWhatNow = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var allWhatNow = exports.allWhatNow = function allWhatNow(_ref) {
		var dispatch = _ref.dispatch;
	
		return _http2.default.get('what-now').then(function (response) {
			var whatNow = {};
	
			for (var i = 0; i < response.body.data.length; ++i) {
				whatNow[response.body.data[i].name] = response.body.data[i].value;
			}
	
			dispatch(types.SET_WHAT_NOW, whatNow);
		});
	};
	
	var updateWhatNow = exports.updateWhatNow = function updateWhatNow(_ref2, name, value) {
		var dispatch = _ref2.dispatch;
	
		return _http2.default.put('what-now/' + name, { name: name, value: value });
	};
	
	var allYeastTypes = exports.allYeastTypes = function allYeastTypes(_ref3) {
		var dispatch = _ref3.dispatch;
	
		return _http2.default.get('yeast-types').then(function (response) {
			dispatch(types.SET_YEAST_TYPES, response.body.data || []);
		});
	};
	
	var storeYeastType = exports.storeYeastType = function storeYeastType(_ref4, name) {
		var dispatch = _ref4.dispatch;
	
		return _http2.default.post('yeast-types', { name: name }).then(function (response) {
			dispatch(types.ADD_YEAST_TYPE, response.body.data);
		});
	};
	
	var destroyYeastType = exports.destroyYeastType = function destroyYeastType(_ref5, id) {
		var dispatch = _ref5.dispatch;
	
		return _http2.default.destroy('yeast-types/' + id).then(function (response) {
			dispatch(types.DESTROY_YEAST_TYPE, id);
		});
	};
	
	var editYeastType = exports.editYeastType = function editYeastType(_ref6, id, name) {
		var dispatch = _ref6.dispatch;
	
		return _http2.default.put('yeast-types/' + id, { name: name }).then(function (response) {
			dispatch(types.UPDATE_YEAST_TYPE, id, response.body.data);
	
			return response;
		});
	};
	
	var allRegions = exports.allRegions = function allRegions(_ref7) {
		var dispatch = _ref7.dispatch;
		var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { country_id: null };
	
		return _http2.default.get('regions', country).then(function (response) {
			dispatch(types.SET_REGIONS, response.body.data || []);
		});
	};
	
	var storeRegion = exports.storeRegion = function storeRegion(_ref8, name) {
		var dispatch = _ref8.dispatch;
		var country_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
		return _http2.default.post('regions', { name: name, country_id: country_id }).then(function (response) {
			dispatch(types.ADD_REGION, response.body.data);
		});
	};
	
	var destroyRegion = exports.destroyRegion = function destroyRegion(_ref9, id) {
		var dispatch = _ref9.dispatch;
	
		return _http2.default.destroy('regions/' + id).then(function (response) {
			dispatch(types.DESTROY_REGION, id);
		});
	};
	
	var editRegion = exports.editRegion = function editRegion(_ref10, id, name) {
		var dispatch = _ref10.dispatch;
	
		return _http2.default.put('regions/' + id, { name: name }).then(function (response) {
			dispatch(types.UPDATE_REGION, id, response.body.data);
	
			return response;
		});
	};
	
	var allVarietals = exports.allVarietals = function allVarietals(_ref11) {
		var dispatch = _ref11.dispatch;
	
		return _http2.default.get('varietals').then(function (response) {
			dispatch(types.SET_VARIETALS, response.body.data || []);
		});
	};
	
	var storeVarietal = exports.storeVarietal = function storeVarietal(_ref12, name) {
		var dispatch = _ref12.dispatch;
	
		return _http2.default.post('varietals', { name: name }).then(function (response) {
			dispatch(types.ADD_VARIETAL, response.body.data);
		});
	};
	
	var destroyVarietal = exports.destroyVarietal = function destroyVarietal(_ref13, id) {
		var dispatch = _ref13.dispatch;
	
		return _http2.default.destroy('varietals/' + id).then(function (response) {
			dispatch(types.DESTROY_VARIETAL, id);
		});
	};
	
	var editVarietal = exports.editVarietal = function editVarietal(_ref14, id, name) {
		var dispatch = _ref14.dispatch;
	
		return _http2.default.put('varietals/' + id, { name: name }).then(function (response) {
			dispatch(types.UPDATE_VARIETAL, id, response.body.data);
	
			return response;
		});
	};
	
	var allCountries = exports.allCountries = function allCountries(_ref15) {
		var dispatch = _ref15.dispatch;
	
		return _http2.default.get('countries').then(function (response) {
			dispatch(types.SET_COUNTRIES, response.body || []);
		});
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.update = exports.get = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var get = exports.get = function get(_ref, site) {
		var dispatch = _ref.dispatch;
		var include = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		return _http2.default.get('sites/' + site + '/simulators').then(function (response) {
			dispatch(types.SET_SIMULATOR_SETUP, response.body.data);
		});
	};
	
	var update = exports.update = function update(_ref2, site, simulator, data) {
		var dispatch = _ref2.dispatch;
	
		return _http2.default.put('sites/' + site + '/simulators/' + simulator, { data: data });
	};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.select = exports.all = undefined;
	
	var _stringify = __webpack_require__(22);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var all = exports.all = function all(_ref) {
		var dispatch = _ref.dispatch;
	
		return _http2.default.get('sites').then(function (response) {
			dispatch(types.SET_SITES, response.body.data);
		});
	};
	
	var select = exports.select = function select(_ref2, site) {
		var dispatch = _ref2.dispatch;
	
		dispatch(types.SET_SITE, site);
	
		localStorage.setItem('site', (0, _stringify2.default)(site));
	};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.reposition = exports.destroy = exports.clear = exports.edit = exports.update = exports.store = exports.all = undefined;
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var all = exports.all = function all(_ref, site) {
		var dispatch = _ref.dispatch;
		var include = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		return _http2.default.include(include).get('sites/' + site + '/tank-groups').then(function (response) {
			dispatch(types.SET_TANK_GROUPS, response.body.data);
	
			return response;
		});
	};
	
	var store = exports.store = function store(_ref2, site, name) {
		var dispatch = _ref2.dispatch;
	
		return _http2.default.post('sites/' + site + '/tank-groups', { name: name }).then(function (response) {
			dispatch(types.ADD_TANK_GROUP, response.body.data);
			dispatch(types.SET_ACTIVE_TANK_GROUP, response.body.data);
	
			return response;
		});
	};
	
	var update = exports.update = function update(_ref3, site, tankGroup) {
		var dispatch = _ref3.dispatch;
	
		return _http2.default.put('sites/' + site + '/tank-groups/' + tankGroup.id, { name: tankGroup.name }).then(function (response) {
			dispatch(types.SET_TANK_GROUP_NAME, tankGroup.id, response.body.data.name);
	
			return response;
		});
	};
	
	var edit = exports.edit = function edit(_ref4, tankGroup) {
		var dispatch = _ref4.dispatch;
	
		dispatch(types.SET_ACTIVE_TANK_GROUP, tankGroup);
	};
	
	var clear = exports.clear = function clear(_ref5) {
		var dispatch = _ref5.dispatch;
	
		dispatch(types.SET_ACTIVE_TANK_GROUP, {});
	};
	
	var destroy = exports.destroy = function destroy(_ref6, site, id) {
		var dispatch = _ref6.dispatch;
	
		return _http2.default.destroy('sites/' + site + '/tank-groups/' + id).then(function (response) {
			dispatch(types.DESTROY_TANK_GROUP, id);
		});
	};
	
	var reposition = exports.reposition = function reposition(_ref7, site, hierarchy) {
		var dispatch = _ref7.dispatch;
		var include = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
		return _http2.default.include(include).post('sites/' + site + '/tank-groups/reposition', { hierarchy: hierarchy }).then(function (response) {
			dispatch(types.SET_TANK_GROUPS, response.body.data);
	
			return response;
		});
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.register = exports.store = exports.authenticateLocally = exports.authenticateWithWinecloud = exports.authorize = undefined;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var authorize = exports.authorize = function authorize(_ref, token) {
		var dispatch = _ref.dispatch;
	
		return _http2.default.headers(token ? { Authorization: 'Bearer ' + token } : {}).get('user').then(function (response) {
			dispatch(types.SET_AUTHORIZED, response.body.data);
	
			return response;
		});
	};
	
	var authenticateWithWinecloud = exports.authenticateWithWinecloud = function authenticateWithWinecloud(_ref2, username, password) {
		var dispatch = _ref2.dispatch;
	
		return _http2.default.post('auth/winecloud', { username: username, password: password });
	};
	
	var authenticateLocally = exports.authenticateLocally = function authenticateLocally(_ref3, username, password) {
		var dispatch = _ref3.dispatch;
	
		return _http2.default.post('auth/local', { username: username, password: password });
	};
	
	var store = exports.store = function store(_ref4, username, password, guid) {
		var dispatch = _ref4.dispatch;
	
		return _http2.default.post('users', { username: username, password: password, guid: guid });
	};
	
	var register = exports.register = function register(_ref5, name, email, username, password, siteName) {
		var dispatch = _ref5.dispatch;
	
		return _http2.default.post('auth/register', { name: name, email: email, username: username, password: password, siteName: siteName });
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _pusherJs = __webpack_require__(427);
	
	var _pusherJs2 = _interopRequireDefault(_pusherJs);
	
	var _config = __webpack_require__(12);
	
	var _pusher = __webpack_require__(58);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  loading: false,
	  eventLoading: false,
	  title: null,
	  pusher: null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_LOADING, function (state, loading) {
	  state.loading = loading;
	}), (0, _defineProperty3.default)(_mutations, types.SET_EVENT_LOADING, function (state, loading) {
	  state.eventLoading = loading;
	}), (0, _defineProperty3.default)(_mutations, types.SET_TITLE, function (state, title) {
	  state.title = title;
	}), (0, _defineProperty3.default)(_mutations, types.INIT_PUSHER, function (state, id) {
	  _pusherJs2.default.logToConsole = !_config.isProduction;
	
	  state.pusher = new _pusherJs2.default(_config.config.PUSHER_KEY, {
	    cluster: 'ap1',
	    encrypted: true
	  });
	
	  (0, _pusher.bindEvents)(state.pusher.subscribe('user-' + id));
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		all: [],
		active: {
			id: null
		}
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_FERMENTERS, function (state, fermenters) {
		state.all = fermenters;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_FERMENTER, function (state, fermenter) {
		state.active = fermenter;
	}), (0, _defineProperty3.default)(_mutations, types.ADD_FERMENTER, function (state, fermenter) {
		state.all.push(fermenter);
	}), (0, _defineProperty3.default)(_mutations, types.DESTROY_FERMENTER, function (state, id) {
		for (var i = 0; i < state.all.length; i++) {
			if (state.all[i].id == id) {
				state.all.splice(i, 1);
				break;
			}
		}
	}), _mutations);
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		all: [],
		active: {
			id: null,
			winemaker_id: null,
			wine_name: '',
			duration: null,
			type: false,
			style: true,
			start_date: (0, _moment2.default)().format('DD/MM/YYYY hh:mm A'),
			juiceAnalysis: {
				data: {}
			},
			dailyData: {
				data: []
			}
		},
		graphBase64: null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_FERMENTS, function (state, ferments) {
		state.all = ferments;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_FERMENT, function (state, ferment) {
		state.active = ferment;
	}), (0, _defineProperty3.default)(_mutations, types.SET_GRAPH_BASE64, function (state, base64) {
		state.graphBase64 = base64;
	}), _mutations);
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		all: [],
		active: {
			id: null,
			name: '',
			profile: 0,
			duration: 0,
			type: 1,
			dailyData: {
				data: []
			}
		}
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_PROFILES, function (state, profiles) {
		state.all = profiles;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_PROFILE, function (state, profile) {
		state.active = profile;
	}), (0, _defineProperty3.default)(_mutations, types.ADD_PROFILE, function (state, profile) {
		state.all.push(profile);
	}), _mutations);
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		whatNow: {},
		yeastTypes: [],
		regions: [],
		varietals: [],
		countries: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_WHAT_NOW, function (state, whatNow) {
		state.whatNow = whatNow;
	}), (0, _defineProperty3.default)(_mutations, types.SET_YEAST_TYPES, function (state, yeastTypes) {
		state.yeastTypes = yeastTypes;
	}), (0, _defineProperty3.default)(_mutations, types.ADD_YEAST_TYPE, function (state, yeastType) {
		state.yeastTypes.push(yeastType);
	}), (0, _defineProperty3.default)(_mutations, types.DESTROY_YEAST_TYPE, function (state, id) {
		for (var i = 0; i < state.yeastTypes.length; i++) {
			if (state.yeastTypes[i].id == id) {
				state.yeastTypes.splice(i, 1);
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_YEAST_TYPE, function (state, id, yeastType) {
		for (var i = 0; i < state.yeastTypes.length; i++) {
			if (state.yeastTypes[i].id == id) {
				state.yeastTypes[i].name = yeastType.name;
	
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.SET_REGIONS, function (state, regions) {
		state.regions = regions;
	}), (0, _defineProperty3.default)(_mutations, types.ADD_REGION, function (state, region) {
		state.regions.push(region);
	}), (0, _defineProperty3.default)(_mutations, types.DESTROY_REGION, function (state, id) {
		for (var i = 0; i < state.regions.length; i++) {
			if (state.regions[i].id == id) {
				state.regions.splice(i, 1);
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_REGION, function (state, id, region) {
		for (var i = 0; i < state.regions.length; i++) {
			if (state.regions[i].id == id) {
				state.regions[i].name = region.name;
	
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.SET_VARIETALS, function (state, varietals) {
		state.varietals = varietals;
	}), (0, _defineProperty3.default)(_mutations, types.ADD_VARIETAL, function (state, varietal) {
		state.varietals.push(varietal);
	}), (0, _defineProperty3.default)(_mutations, types.DESTROY_VARIETAL, function (state, id) {
		for (var i = 0; i < state.varietals.length; i++) {
			if (state.varietals[i].id == id) {
				state.varietals.splice(i, 1);
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_VARIETAL, function (state, id, varietal) {
		for (var i = 0; i < state.varietals.length; i++) {
			if (state.varietals[i].id == id) {
				state.varietals[i].name = varietal.name;
	
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.SET_COUNTRIES, function (state, countries) {
		state.countries = countries;
	}), _mutations);
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		active: {}
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.SET_SIMULATOR_SETUP, function (state, simulatorSetup) {
		state.active = simulatorSetup;
	});
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		running: false
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.SET_SIMULATOR_RUNNING, function (state, running) {
		state.running = running;
	});
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		active: {},
		all: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_SITE, function (state, site) {
		state.active = site;
	}), (0, _defineProperty3.default)(_mutations, types.SET_SITES, function (state, sites) {
		state.all = sites;
	}), _mutations);
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		active: {},
		all: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_TANK_GROUP, function (state, tankGroup) {
		state.active = tankGroup;
	}), (0, _defineProperty3.default)(_mutations, types.SET_TANK_GROUPS, function (state, tankGroups) {
		state.all = tankGroups;
	}), (0, _defineProperty3.default)(_mutations, types.ADD_TANK_GROUP, function (state, tankGroup) {
		state.all.push(tankGroup);
	}), (0, _defineProperty3.default)(_mutations, types.DESTROY_TANK_GROUP, function (state, id) {
		for (var i = 0; i < state.all.length; ++i) {
			if (state.all[i].id == id) {
				state.all.splice(i, 1);
	
				break;
			}
		}
	}), (0, _defineProperty3.default)(_mutations, types.SET_TANK_GROUP_NAME, function (state, id, name) {
		for (var i = 0; i < state.all.length; ++i) {
			if (state.all[i].id == id) {
				state.all[i].name = name;
	
				break;
			}
		}
	}), _mutations);
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		authorized: false
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.SET_AUTHORIZED, function (state, authorized) {
		state.authorized = authorized;
	});
	
	exports.default = {
		state: state,
		mutations: mutations
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _store = __webpack_require__(21);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(4);
	
	var _getters = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		store: _store2.default,
	
		vuex: {
			getters: {
				user: _getters.authorized
			}
		},
	
		data: function data() {
			return {};
		},
		ready: function ready() {
			this.$watch('user', function (user, oldUser) {
				if (user && !oldUser) {
					_store2.default.dispatch(_mutationTypes.INIT_PUSHER, user.id);
				}
			});
		},
	
	
		events: {
			loading: function loading() {
				_store2.default.dispatch(_mutationTypes.SET_LOADING, true);
			},
			loaded: function loaded() {
				_store2.default.dispatch(_mutationTypes.SET_LOADING, false);
			}
		}
	};

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      message: "\n        <small style='margin-bottom: 10px; display: block'>\n          1 = Light. Lees prevented from settling\n        </small>\n        <small style='margin-bottom: 10px; display: block'>\n          2 = Moderate. Some vertical mixing\n        </small>\n        <small>\n          3 = Strong. Good mixing between top and bottom of tank\n        </small>\n      "
	    };
	  }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getters = __webpack_require__(2);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _units = __webpack_require__(20);
	
	var _units2 = _interopRequireDefault(_units);
	
	var _tabbing = __webpack_require__(54);
	
	var _tabbing2 = _interopRequireDefault(_tabbing);
	
	var _rowHelpers = __webpack_require__(53);
	
	var _rowHelpers2 = _interopRequireDefault(_rowHelpers);
	
	var _dayHelpers = __webpack_require__(52);
	
	var _dayHelpers2 = _interopRequireDefault(_dayHelpers);
	
	var _agitatorDefinition = __webpack_require__(209);
	
	var _agitatorDefinition2 = _interopRequireDefault(_agitatorDefinition);
	
	var _ferment = __webpack_require__(55);
	
	var _lodash = __webpack_require__(76);
	
	var _moveFerment = __webpack_require__(488);
	
	var _moveFerment2 = _interopRequireDefault(_moveFerment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			AgitatorDefinition: _agitatorDefinition2.default,
			MoveFerment: _moveFerment2.default
		},
	
		vuex: {
			getters: {
				simulatorSetup: _getters.simulatorSetup
			}
		},
	
		computed: {
			editingIndexBeforeExistingMoveEvent: function editingIndexBeforeExistingMoveEvent() {
				if (!this.editing.status || !this.ferment || !this.ferment.previousFermenters) {
					return false;
				}
	
				var moveRegex = new RegExp('Transferred from', 'ig');
	
				for (var i = this.editing.index; i < this.dailyData.data.length; i++) {
					if (this.dailyData.data[i].comments && moveRegex.test(this.dailyData.data[i].comments)) {
						return true;
					}
				}
	
				return false;
			},
			isBlendedFerment: function isBlendedFerment() {
				return this.ferment && this.ferment.blendComponents && this.ferment.blendComponents.data.length > 0;
			}
		},
	
		props: {
			editingDisabled: {
				type: Boolean,
				required: false,
				default: false
			},
			dailyData: {
				required: true
			},
			allowBaume: {
				required: false,
				default: true
			},
			fermentType: {},
			measuringFreq: {
				required: false,
				default: null
			},
			measuringFreqInteger: {
				required: true
			},
			archived: {},
			daysAsDates: {
				type: Boolean,
				required: false,
				default: false
			},
			startDate: {
				type: String,
				required: false
			},
			ferment: {
				required: false,
				default: null
			}
		},
	
		data: function data() {
			return {
				units: _units2.default,
				editing: {
					status: false,
					index: null,
					column: null
				},
				isEditingAction: false,
				isMovingFerment: false,
				freq: 0,
				missingDay: false
			};
		},
		ready: function ready() {
			var _this = this;
	
			this.formatDailyData();
	
			$(window).on('hidden.bs.modal', function () {
				_this.editing.index = null;
				_this.editing.status = false;
				_this.isEditingAction = false;
	
				$('#agitator-group').find('.active').removeClass('active');
			});
	
			$(window).on('show.bs.modal', function () {
				if (_this.editingDisabled) {
					$('.modal-content input').prop('disabled', true);
					$('.modal-content label').addClass('disabled');
	
					$('.modal-content label.disabled').on('click.disabled', function (event) {
						event.preventDefault();
	
						return false;
					});
				} else {
					$('.modal-content input').prop('disabled', false);
					$('.modal-content label').removeClass('disabled');
	
					$('.modal-content label').off('click.disabled');
				}
			});
		},
	
	
		watch: {
			dailyData: {
				handler: function handler() {
					this.formatDailyData();
				},
	
				deep: true
			},
	
			missingDay: function missingDay(newVal, oldVal) {
				if (newVal === false && oldVal === true) {
					this.dailyData.data.pop();
				}
			}
		},
	
		events: {
			isBlankRow: function isBlankRow(row, callback) {
				if (this.isBlankRow(row)) {
					callback();
				}
			},
			clearDailyData: function clearDailyData() {
				this.dailyData.data = [];
			}
		},
	
		methods: (0, _extends3.default)({}, _tabbing2.default, _rowHelpers2.default, _dayHelpers2.default, {
			formatDailyData: function formatDailyData() {
				var _this2 = this;
	
				this.fixBlankDailyData();
				this.missingDay = false;
	
				var lastRow = this.dailyData.data[this.dailyData.data.length - 1];
	
				if (!this.isBlankRow(lastRow)) {
					this.dailyData.data.push(this.newBlankDay());
				}
	
				if (this.dailyData.data.length >= 3) {
					var currentDataFrequency = Math.round(1 / (this.dailyData.data[1].day - this.dailyData.data[0].day));
	
					if (currentDataFrequency != this.measuringFreqInteger) {
						for (var i = 0; i < this.dailyData.data.length - 1; i++) {
							this.dailyData.data[i].day = this.getDayFromIndex(i);
						}
	
						_vue2.default.nextTick(function () {
							_this2.dailyData.data = (0, _lodash.concat)([], _this2.dailyData.data);
							_this2.$dispatch('forceUpdateData');
						});
					}
				}
	
				for (var _i = 0; _i < this.dailyData.data.length - 1; _i++) {
					var dayData = this.dailyData.data[_i];
	
					if (isNaN(dayData.baume)) {
						dayData.baume = null;
					}
	
					if (isNaN(dayData.temp)) {
						dayData.temp = null;
					}
	
					var day = this.getDayFromIndex(_i);
					if (dayData.day != day) {
						this.missingDay = true;
					}
				}
			},
			addMissingRow: function addMissingRow() {
				for (var i = 0; i < this.dailyData.data.length - 1; i++) {
					var day = this.getDayFromIndex(i);
					if (this.dailyData.data[i].day != day) {
						var missingRow = (0, _lodash.merge)(this.newBlankDay(), { day: day });
						this.dailyData.data.splice(i, 0, missingRow);
						break;
					}
				}
			},
			getDayFromIndex: function getDayFromIndex(index) {
				return parseFloat((index / this.measuringFreqInteger).toFixed(2));
			},
			isCurrentDay: function isCurrentDay(day) {
				return (0, _moment2.default)().isSame((0, _moment2.default)(this.startDate, 'DD/MM/YYYY hh:mm A').add(day * 24, 'hours'), 'day');
			},
			isFutureDay: function isFutureDay(day) {
				return (0, _moment2.default)().isBefore((0, _moment2.default)(this.startDate, 'DD/MM/YYYY hh:mm A').add(day * 24, 'hours'), 'day');
			},
			dayToDate: function dayToDate(day) {
				if (!this.daysAsDates || !this.startDate || !this.simulatorSetup.date_day_display) {
					return day;
				}
	
				var format = 'DD/MM/YYYY';
	
				if (this.dayIncrement() == 0.5) {
					format = 'DD/MM/YYYY A';
				}
	
				return (0, _moment2.default)(this.startDate, 'DD/MM/YYYY hh:mm A').add(day * 24, 'hours').format(format);
			},
			removeBlankRow: function removeBlankRow() {
				var _this3 = this;
	
				this.editing = {
					status: false,
					index: null,
					column: null
				};
	
				var lastNonBlankRow = (0, _lodash.findLastIndex)(this.dailyData.data, function (row) {
					return !_this3.isBlankRow(row);
				});
				_vue2.default.nextTick(function () {
					_this3.dailyData.data = (0, _lodash.slice)(_this3.dailyData.data, 0, lastNonBlankRow + 1);
				});
			},
			canRemoveBlankRow: function canRemoveBlankRow() {
				var _this4 = this;
	
				if (this.dailyData.data && this.dailyData.data.length > 1) {
					var lastNonBlankRow = (0, _lodash.findLastIndex)(this.dailyData.data, function (row) {
						return !_this4.isBlankRow(row);
					});
	
					return lastNonBlankRow < this.dailyData.data.length - 2;
				}
	
				return false;
			},
			dayIncrement: function dayIncrement() {
				if (this.measuringFreq) {
					return parseFloat(this.measuringFreq);
				}
	
				var frequencyVariable = this.fermentType ? 'red_sampling_freq' : 'white_sampling_freq';
	
				return (0, _ferment.caluculateMeasuringFreq)(this.simulatorSetup[frequencyVariable]);
			},
			getNextDay: function getNextDay() {
				var dataLen = this.dailyData.data.length;
	
				if (dataLen === 0) {
					return 0;
				}
	
				var nextDay = parseFloat(parseFloat(dataLen / this.measuringFreqInteger).toFixed(2));
	
				return dataLen % this.measuringFreqInteger === 0 ? Math.round(nextDay) : nextDay;
			},
			handleTabToBlankRow: function handleTabToBlankRow(event, index, previous, next) {
				this.dailyData.data.push(this.newBlankDay());
	
				this.editing = {
					status: true,
					index: index,
					column: event.shiftKey ? previous : next
				};
			},
			findNextRow: function findNextRow(row) {
				return row.next('tr');
			},
			fixBlankDailyData: function fixBlankDailyData() {
				if (this.dailyData.data.length == 0) {
					this.editing = {
						status: false,
						index: null,
						column: null
					};
	
					this.dailyData.data = [this.newBlankDay()];
				}
			},
			openActionModal: function openActionModal(index, data) {
				if (data.locked && !this.archived) return;
	
				this.editing.status = true;
				this.editing.index = index;
				this.editing.column = null;
				this.isEditingAction = true;
	
				_vue2.default.nextTick(function () {
					$('#actions_analysis').modal();
				});
			},
			openMoveModal: function openMoveModal() {
				var _this5 = this;
	
				this.isMovingFerment = true;
	
				var editing = (0, _lodash.clone)(this.editing);
	
				$('#actions_analysis').one('hidden.bs.modal', function () {
					$('#move_ferment').one('show.bs.modal', function () {
						_this5.$nextTick(function () {
							_this5.editing = (0, _lodash.clone)(editing);
						});
					}).modal('show');
				}).modal('hide');
			}
		})
	};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getters = __webpack_require__(2);
	
	var _canvasGauges = __webpack_require__(312);
	
	var _units = __webpack_require__(20);
	
	var _units2 = _interopRequireDefault(_units);
	
	var _fermenters = __webpack_require__(56);
	
	var _fermenters2 = _interopRequireDefault(_fermenters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: ['fermenter'],
	
		vuex: {
			getters: {
				simulatorSetup: _getters.simulatorSetup
			}
		},
	
		data: function data() {
			return {
				gauge: null,
				gaugeData: {
					baume_initial: null,
					baume_current: null,
					temp_current: null,
					progress: 0,
					predicted_duration: 0
				},
				ferment: {},
				units: _units2.default
			};
		},
	
	
		computed: {
			fermentIsBlended: function fermentIsBlended() {
				return this.ferment && this.ferment.blendComponents && this.ferment.blendComponents.data.length > 0;
			}
		},
	
		ready: function ready() {
			var _this = this;
	
			if (this.fermenter.currentFerment) {
				this.ferment = this.fermenter.currentFerment.data;
				this.gaugeData = this.ferment.gauge.data;
			}
	
			if (this.gaugeData.baume_initial && this.gaugeData.baume_current && this.ferment.blendComponents.data.length === 0) {
				this.gaugeData.progress = Math.round((this.gaugeData.baume_initial - this.gaugeData.baume_current) / this.gaugeData.baume_initial * 100);
	
				if (this.gaugeData.progress > 100) {
					this.gaugeData.progress = 100;
				}
			}
	
			var gaugeNumbers = {
				min: -4,
				max: 4,
				ticks: [8, 7, 6, 5, 4, 3, 2, 1, 0],
				minorTicks: 5,
				highlights: [{ from: -4, to: -2, color: '#5791d0' }, { from: -2, to: 0, color: '#70bd75' }, { from: 0, to: 2, color: '#70bd75' }, { from: 2, to: 4, color: '#bc4841' }],
				needle: 0
			};
	
			if (this.gaugeData.predicted_duration && this.ferment && !this.fermentNotEnoughData(this.ferment) && this.ferment.blendComponents.data.length === 0) {
				var predictedDuration = parseFloat(this.gaugeData.predicted_duration),
				    desiredDuration = parseFloat(this.ferment.duration),
				    difference = 2 * Math.round(Math.abs(Math.ceil(predictedDuration) - Math.ceil(desiredDuration)) / 2),
				    stuckFerment = false;
	
				if (difference <= 0) {
					difference = 4;
				} else if (difference < 4) {
					difference *= 2;
				}
	
				gaugeNumbers.min = desiredDuration - difference;
				gaugeNumbers.max = desiredDuration + difference;
				gaugeNumbers.ticks = [];
	
				if (gaugeNumbers.max - gaugeNumbers.min > 20) {
					gaugeNumbers.min = desiredDuration - 10;
					gaugeNumbers.max = desiredDuration + 10;
	
					stuckFerment = true;
	
					if (Math.abs(predictedDuration - gaugeNumbers.max) < Math.abs(predictedDuration - gaugeNumbers.min)) {
						gaugeNumbers.needle = gaugeNumbers.min;
					} else {
						gaugeNumbers.needle = gaugeNumbers.max;
					}
				} else {
					gaugeNumbers.needle = gaugeNumbers.max - predictedDuration + gaugeNumbers.min;
				}
	
				if ((gaugeNumbers.max - gaugeNumbers.min) / gaugeNumbers.minorTicks < 2) {
					gaugeNumbers.minorTicks = 2;
				} else if ((gaugeNumbers.max - gaugeNumbers.min) / gaugeNumbers.minorTicks < 4) {
					gaugeNumbers.minorTicks = 4;
				} else if ((gaugeNumbers.max - gaugeNumbers.min) / gaugeNumbers.minorTicks > 10) {
					gaugeNumbers.minorTicks = 8;
				}
	
				for (var i = gaugeNumbers.min; i <= gaugeNumbers.max; i += gaugeNumbers.minorTicks) {
					if (stuckFerment && i == gaugeNumbers.max) {
						i = i.toString() + '+';
					}
	
					gaugeNumbers.ticks.push(i);
				}
	
				gaugeNumbers.ticks.reverse();
	
				gaugeNumbers.highlights = [{ from: gaugeNumbers.min, to: desiredDuration - 2, color: '#5791d0' }, { from: desiredDuration - 2, to: desiredDuration + 2, color: '#70bd75' }, { from: desiredDuration + 2, to: gaugeNumbers.max, color: '#bc4841' }];
			}
	
			this.gauge = new _canvasGauges.RadialGauge({
				renderTo: 'gauge_' + this.fermenter.id,
				width: $('.ferment-gauge-container').width(),
				height: $('.ferment-gauge-container').outerHeight() * 1.5,
				title: 'Days',
				minValue: gaugeNumbers.min,
				maxValue: gaugeNumbers.max,
				ticksAngle: 180,
				startAngle: 90,
				majorTicks: gaugeNumbers.ticks,
				minorTicks: gaugeNumbers.minorTicks,
				strokeTicks: true,
				needleType: 'arrow',
				colorNeedle: 'rgba(37, 45, 51, 0.54)',
				colorNeedleEnd: 'rgba(37, 45, 51, 0.54)',
				needleWidth: 1.5,
				valueBox: false,
				borderOuterWidth: 0,
				borderMiddleWidth: 0,
				borderInnerWidth: 0,
				borderShadowWidth: 0,
				highlights: gaugeNumbers.highlights,
				glow: false,
				animationDelay: 0,
				animationDuration: 0,
				value: gaugeNumbers.needle
			});
	
			this.gauge.draw();
	
			$(window).on('resize', function () {
				try {
					_this.gauge.update({
						width: $('.ferment-gauge-container').width(),
						height: $('.ferment-gauge-container').outerHeight() * 1.5
					});
				} catch (exception) {}
			});
		},
	
	
		methods: (0, _extends3.default)({}, _fermenters2.default, {
			getLastSugar: function getLastSugar() {
				var lastSugar = '-';
	
				if (this.fermenter.currentFerment && (this.fermentNotEnoughData(this.fermenter.currentFerment.data) || this.fermentOutOfSync() || this.fermenter.currentFerment.data.blendComponents.data.length > 0)) {
					this.fermenter.currentFerment.data.dailyData.data.forEach(function (day) {
						if (day.baume) {
							lastSugar = day.baume;
						}
					});
				} else {
					lastSugar = this.gaugeData.baume_current == null ? '-' : this.gaugeData.baume_current;
				}
	
				return lastSugar == '-' ? lastSugar : _units2.default.baumeToBrix(lastSugar).toFixed(2);
			},
			getLastTemperature: function getLastTemperature() {
				var lastTemperature = '-',
				    lastDayWithBaume = void 0,
				    lastDayWithTemperature = void 0;
	
				if (this.fermenter.currentFerment && (this.fermentNotEnoughData(this.fermenter.currentFerment.data) || this.fermentOutOfSync() || this.fermenter.currentFerment.data.blendComponents.data.length > 0)) {
					this.fermenter.currentFerment.data.dailyData.data.forEach(function (day) {
						if (day.temp) {
							lastDayWithTemperature = day;
						}
	
						if (day.baume) {
							lastDayWithBaume = day;
						}
					});
				} else {
					lastTemperature = this.gaugeData.temp_current == null ? '-' : this.gaugeData.temp_current;
				}
	
				if (lastDayWithTemperature) {
					lastTemperature = lastDayWithTemperature.temp;
				}
	
				if (lastDayWithBaume && lastDayWithBaume.temp) {
					lastTemperature = lastDayWithBaume.temp;
				}
	
				return lastTemperature == '-' ? lastTemperature : _units2.default.celsiusToFahrenheit(lastTemperature).toFixed(1);
			},
			fermentOutOfSync: function fermentOutOfSync() {
				return this.fermenter.currentFerment && !this.fermentNotEnoughData(this.fermenter.currentFerment.data) && !this.fermenter.currentFerment.data.simulated;
			}
		})
	};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: ['index', 'day', 'measuringFreqInteger'],
	
		data: function data() {
			return {
				destinationFermenterId: null,
				continuing: false,
				confirmSelection: false
			};
		},
	
	
		vuex: {
			actions: {
				allFermenters: _actions.Fermenters.all,
				moveFerment: _actions.Ferments.move
			},
	
			getters: {
				fermenters: _getters.fermenters,
				fermenter: _getters.fermenter,
				ferment: _getters.ferment,
				site: _getters.site
			}
		},
	
		computed: {
			fermenterOptions: function fermenterOptions() {
				var _this = this;
	
				return this.fermenters.filter(function (fermenter) {
					return _this.fermenter.id !== fermenter.id && (!fermenter.currentFerment || fermenter.currentFerment.data.type === _this.ferment.type);
				}).map(function (fermenter) {
					return { name: fermenter.name, value: fermenter.id };
				});
			},
			haveNoDestinationFermenter: function haveNoDestinationFermenter() {
				return !this.destinationFermenter;
			},
			destinationFermenter: function destinationFermenter() {
				var _this2 = this;
	
				return this.fermenters.find(function (fermenter) {
					return fermenter.id == _this2.destinationFermenterId;
				});
			},
			destinationFermenterName: function destinationFermenterName() {
				if (this.destinationFermenter) {
					return this.destinationFermenter.name;
				}
	
				return null;
			},
			destinationFermenterIsEmpty: function destinationFermenterIsEmpty() {
				if (this.haveNoDestinationFermenter) {
					return true;
				}
	
				return this.destinationFermenter.currentFerment === undefined;
			},
			destinationFermentMissingData: function destinationFermentMissingData() {
				if (this.destinationFermenterIsEmpty) {
					return false;
				}
	
				var format = 'DD/MM/YYYY hh:mm A';
				var measuringFreq = 1 / this.measuringFreqInteger;
	
				var blendDate = (0, _moment2.default)(this.ferment.start_date, format).add(24 * measuringFreq * this.index, 'hours');
				var blendDateDiff = blendDate.diff((0, _moment2.default)(this.destinationFermenter.currentFerment.data.start_date, format), 'hours');
	
				var blendIndex = Math.floor(blendDateDiff / 24 / measuringFreq);
	
				return !(blendIndex in this.destinationFermenter.currentFerment.data.dailyData.data);
			}
		},
	
		ready: function ready() {
			var _this3 = this;
	
			$('#move_ferment').on('hidden.bs.modal', function () {
				_this3.continuing = false;
				_this3.confirmSelection = false;
				_this3.destinationFermenterId = null;
			});
		},
		created: function created() {
			this.allFermenters(this.site.id, ['currentFerment.dailyData']);
		},
	
	
		methods: {
			continue: function _continue() {
				var _this4 = this;
	
				if (!this.confirmSelection) {
					this.confirmSelection = true;
				} else {
					this.continuing = true;
	
					var payload = {
						destination_fermenter_id: this.destinationFermenterId,
						index: this.index,
						day: this.day
					};
	
					this.moveFerment(this.site.id, this.fermenter.id, this.ferment.id, payload).then(function (response) {
						$('#move_ferment').modal('hide');
	
						_this4.$router.go({
							name: 'ferments.index',
							params: {
								fermenterId: response.data.data.fermenter_id,
								fermentId: response.data.data.id
							}
						});
	
						_notify2.default.success('Successfully moved ferment.');
					}).catch(function (response) {
						if (response.status === 400) {
							_notify2.default.error(response.body.message);
						}
					});
				}
			},
			cancelSelection: function cancelSelection() {
				this.confirmSelection = false;
				this.destinationFermenterId = null;
			},
			goToDestinationFerment: function goToDestinationFerment() {
				$('#move_ferment').modal('hide');
	
				this.$router.go({
					name: 'ferments.index',
					params: {
						fermenterId: this.destinationFermenter.id,
						fermentId: this.destinationFermenter.currentFerment.data.id
					}
				});
			}
		}
	};

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    message: {
	      required: true
	    },
	    style: {
	      required: false,
	      default: ''
	    },
	    placement: {
	      required: false,
	      default: 'left'
	    },
	    class: {
	      required: false
	    }
	  },
	
	  computed: {
	    customStyle: function customStyle() {
	      return '\'margin-left: 7px; margin-top: 10px; ' + this.style + '\'';
	    }
	  }
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _props = __webpack_require__(30);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _events = __webpack_require__(29);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: _props2.default,
		events: _events2.default,
	
		data: function data() {
			return {
				hasError: false,
				errorMessage: null
			};
		}
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _props = __webpack_require__(30);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _events = __webpack_require__(29);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: _props2.default,
		events: _events2.default,
	
		data: function data() {
			return {
				hasError: false,
				errorMessage: null
			};
		},
		ready: function ready() {}
	};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _props = __webpack_require__(30);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _events = __webpack_require__(29);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: _props2.default,
		events: _events2.default,
	
		data: function data() {
			return {
				hasError: false,
				errorMessage: null
			};
		},
		ready: function ready() {
			var _this = this;
	
			var input = $('input[name=' + this.name + ']');
	
			if (this.spinner) {
				input.parent().find('.spinner-down > a').on('click', function (event) {
					event.preventDefault();
	
					input.val((parseFloat(input.val()) || 0) - 1);
	
					_this.vmodel = input.val();
				});
	
				input.parent().find('.spinner-up > a').on('click', function (event) {
					event.preventDefault();
	
					input.val((parseFloat(input.val()) || 0) + 1);
	
					_this.vmodel = input.val();
				});
			}
		}
	};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _props = __webpack_require__(30);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _events = __webpack_require__(29);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: _props2.default,
		events: _events2.default,
	
		data: function data() {
			return {
				hasError: false,
				errorMessage: null
			};
		}
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _config = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				authenticating: false
			};
		},
	
	
		vuex: {
			actions: {
				setTitle: _actions.App.title,
				selectSite: _actions.Sites.select,
				authenticateWithWinecloud: _actions.User.authenticateWithWinecloud
			}
		},
	
		ready: function ready() {
			var _this = this;
	
			this.setTitle('');
			this.selectSite({});
	
			if (this.$route.query.user && this.$route.query.pass) {
				var username = this.$route.query.user,
				    password = this.$route.query.pass;
	
				this.$router.replace('authorize');
	
				this.authenticating = true;
	
				this.authenticateWithWinecloud(username, password).then(function (response) {
					_this.authenticating = false;
	
					_this.gotoSiteSelection();
				}, function (response) {
					_this.authenticating = false;
	
					_this.backToWineCloud(response.body.message + ' We will now redirect you back to WineCloud.');
				});
			} else {
				this.backToWineCloud();
			}
		},
	
	
		methods: {
			gotoSiteSelection: function gotoSiteSelection() {
				this.$router.go({ name: 'site-selection.index' });
			},
			backToWineCloud: function backToWineCloud() {
				var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Sorry, but you are unauthorized to access this application. We will now redirect you back to WineCloud.';
	
				_alert2.default.error({ title: 'Unauthorized!', text: text }).then(function () {
					window.location = _config.config.WC_PATH;
				});
			}
		}
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _config = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Login",
	  data: function data() {
	    return {
	      input: {
	        username: "",
	        password: ""
	      },
	      authenticating: false
	    };
	  },
	
	
	  vuex: {
	    actions: {
	      setTitle: _actions.App.title,
	      selectSite: _actions.Sites.select,
	      authenticateLocally: _actions.User.authenticateLocally
	    }
	  },
	
	  ready: function ready() {
	    this.setTitle("Login");
	
	    this.$dispatch('loaded');
	  },
	
	
	  methods: {
	    gotoSiteSelection: function gotoSiteSelection() {
	      this.$router.go({ name: "site-selection.index" });
	    },
	    backToWineCloud: function backToWineCloud() {
	      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Sorry, but you are unauthorized to access this application. We will now redirect you back to WineCloud.";
	
	      _alert2.default.error({ title: "Unauthorized!", text: text }).then(function () {
	        window.location = _config.config.WC_PATH;
	      });
	    },
	    login: function login() {
	      var _this = this;
	
	      this.$dispatch('loading');
	
	      if (this.input.username != "" && this.input.password != "") {
	        this.authenticating = true;
	
	        this.authenticateLocally(this.input.username, this.input.password).then(function (response) {
	          _this.authenticating = false;
	          _this.gotoSiteSelection();
	        }, function (response) {
	          _this.$dispatch('loaded');
	          _this.authenticating = false;
	          var message = response.body.message;
	          _alert2.default.error({ title: "Unauthorized!", text: message });
	        });
	      } else {
	        this.$dispatch('loaded');
	        _alert2.default.error({
	          title: "Error!",
	          text: "A username and password must be present"
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _actions = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
		data: function data() {
			return {};
		},
	
	
		vuex: {
			actions: {
				setTitle: _actions.App.title,
				selectSite: _actions.Sites.select
			}
		},
	
		ready: function ready() {
			this.setTitle('');
			this.selectSite({});
	
			sessionStorage.removeItem('token');
			localStorage.removeItem('site');
	
			this.$store.dispatch(types.SET_AUTHORIZED, false);
	
			this.$router.go({ name: 'login' });
		}
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _config = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Register",
	  data: function data() {
	    return {
	      input: {
	        username: "",
	        password: ""
	      }
	    };
	  },
	
	
	  vuex: {
	    actions: {
	      setTitle: _actions.App.title,
	      selectSite: _actions.Sites.select,
	      authenticateLocally: _actions.User.authenticateLocally,
	      registerUser: _actions.User.register
	    }
	  },
	
	  ready: function ready() {
	    this.setTitle("Register");
	  },
	
	
	  methods: {
	    gotoSiteSelection: function gotoSiteSelection() {
	      this.$router.go({ name: "site-selection.index" });
	    },
	    isEmptyInput: function isEmptyInput(inputValue, message) {
	
	      var result = typeof inputValue === "undefined" || inputValue === null || inputValue === "";
	
	      if (result) {
	        this.fireValidationError(message);
	      }
	
	      return result;
	    },
	    fireValidationError: function fireValidationError(message) {
	      this.$dispatch('loaded');
	      _alert2.default.error({
	        title: "Error!",
	        text: message
	      });
	    },
	    register: function register() {
	      var _this = this;
	
	      this.$dispatch('loading');
	
	      if (this.isEmptyInput(this.input.name, "Please enter a name!") || this.isEmptyInput(this.input.email, "Please enter an email!") || this.isEmptyInput(this.input.username, "Please enter a username!") || this.isEmptyInput(this.input.password, "Please enter a password!") || this.isEmptyInput(this.input.confirmPassword, "Please confirm your password!") || this.isEmptyInput(this.input.siteName, "Please enter a Site name!")) {
	        return;
	      }
	
	      if (this.input.password !== this.input.confirmPassword) {
	        this.fireValidationError("The passwords provided do not match!");
	        return;
	      }
	
	      this.registerUser(this.input.name, this.input.email, this.input.username, this.input.password, this.input.siteName).then(function (response) {
	        _this.$dispatch('loaded');
	        _this.$router.go({ name: "login" });
	        _alert2.default.confirm({ title: "Please log in to continue", type: "success", confirmButtonColor: '#202e6d', showCancelButton: false, confirmButtonText: "Login" });
	      }, function (response) {
	        _this.$dispatch('loaded');
	        var message = response.body.message;
	        _alert2.default.error({ title: "Error!", text: message });
	      });
	    }
	  }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			getters: {
				site: _getters.site
			},
	
			actions: {
				setTitle: _actions.App.title
			}
		},
	
		route: {
			activate: function activate() {
				this.$dispatch('loading');
			},
			data: function data() {
				this.$dispatch('loaded');
			}
		},
	
		data: function data() {
			return {
				tank_group_id: null,
				search: ''
			};
		},
		ready: function ready() {
			this.setTitle('Contact');
		}
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _units = __webpack_require__(20);
	
	var _units2 = _interopRequireDefault(_units);
	
	var _tabbing = __webpack_require__(54);
	
	var _tabbing2 = _interopRequireDefault(_tabbing);
	
	var _rowHelpers = __webpack_require__(53);
	
	var _rowHelpers2 = _interopRequireDefault(_rowHelpers);
	
	var _dayHelpers = __webpack_require__(52);
	
	var _dayHelpers2 = _interopRequireDefault(_dayHelpers);
	
	var _agitatorDefinition = __webpack_require__(209);
	
	var _agitatorDefinition2 = _interopRequireDefault(_agitatorDefinition);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			AgitatorDefinition: _agitatorDefinition2.default
		},
	
		data: function data() {
			return {
				editing: {
					status: false,
					index: null,
					column: null
				},
				allowBaume: true,
				filteredFermenters: [],
				timeouts: {},
				watchers: {},
				preventUpdate: false,
				units: _units2.default
			};
		},
	
	
		vuex: {
			getters: {
				site: _getters.site,
				simulatorSetup: _getters.simulatorSetup
			},
	
			actions: {
				updateFerment: _actions.Ferments.update,
				getFerment: _actions.Ferments.get,
				runSimulation: _actions.Ferments.simulation
			}
		},
	
		props: ['fermenters', 'date', 'search', 'period', 'selectedTankGroup'],
	
		watch: {
			date: function date() {
				this.filterFermenters();
			},
			selectedTankGroup: function selectedTankGroup() {
				this.filterFermenters();
			},
			search: function search() {
				this.filterFermenters();
			},
			period: function period() {
				this.filterFermenters();
			}
		},
	
		created: function created() {
			this.filterFermenters();
		},
	
	
		methods: (0, _extends3.default)({}, _tabbing2.default, _rowHelpers2.default, _dayHelpers2.default, {
			handleTabToBlankRow: function handleTabToBlankRow(event, index, previous, next) {
				this.editing = {
					status: true,
					index: 0,
					column: 'baume'
				};
			},
			findNextRow: function findNextRow(row) {
				return $('.table-daily-data').find('tr:nth-child(2)');
			},
			getNextDay: function getNextDay() {
				return null;
			},
			filterFermenters: function filterFermenters() {
				var _this = this;
	
				this.filteredFermenters = this.fermenters.filter(function (fermenter) {
					var shouldBeIncluded = true;
	
					if (!fermenter.currentFerment) {
						shouldBeIncluded = false;
					} else {
						var ferment = fermenter.currentFerment.data;
						var inoculatedAtPM = _.endsWith(ferment.start_date, 'PM');
	
						var currentDay = (0, _moment2.default)(_this.date, 'DD/MM/YYYY').diff((0, _moment2.default)(ferment.start_date, 'DD/MM/YYYY hh:mm A').startOf('day'), 'days');
	
						if (inoculatedAtPM && ferment.measuring_freq == 0.5 && !_this.period) {
							currentDay -= 0.5;
						}
	
						if (currentDay < 0) {
							return false;
						}
	
						var index = _.findIndex(ferment.dailyData.data, function (day) {
							return day.day == currentDay;
						});
	
						if (index == -1) {
							index = ferment.dailyData.data.length;
						}
	
						if (_this.period && ferment.measuring_freq == 0.5 && !inoculatedAtPM) {
							index++;
	
							currentDay += 0.5;
						}
	
						var dayData = void 0;
	
						if (!ferment.dailyData.data[index]) {
							dayData = _this.newBlankDay();
	
							dayData.day = currentDay;
						} else {
							dayData = ferment.dailyData.data[index];
						}
	
						if (dayData && dayData.baume) {
							shouldBeIncluded = false;
						} else {
							fermenter.currentFerment.data = $.extend({}, fermenter.currentFerment.data, { 'currentDay': dayData });
						}
					}
	
					return shouldBeIncluded;
				});
	
				for (var fermenterId in this.watchers) {
					this.watchers[fermenterId]();
				}
	
				this.watchers = {};
	
				this.filteredFermenters.map(function (fermenter) {
					_this.watchers[fermenter.id] = _this.$watch(function () {
						return fermenter;
					}, function () {
						clearTimeout(_this.timeouts[fermenter.id]);
	
						if (_this.preventUpdate) {
							_this.preventUpdate = false;
	
							return;
						}
	
						_this.timeouts[fermenter.id] = setTimeout(function () {
							_this.updateFermenter(fermenter);
						}, 1500);
					}, { deep: true });
				});
			},
			updateFermenter: function updateFermenter(fermenter) {
				var _this2 = this;
	
				var data = $.extend(true, {}, fermenter.currentFerment.data);
	
				data.start_date = (0, _moment2.default)(data.start_date, 'DD/MM/YYYY hh:mm A').format('YYYY-MM-DD HH:mm:ss');
	
				data.dailyData.data.forEach(function (day) {
					day.temp = _units2.default.fahrenheitToCelsius(day.temp);
					day.baume = _units2.default.brixToBaume(day.baume);
				});
	
				if (data.juiceAnalysis) {
					data.juiceAnalysis.data.baume = _units2.default.brixToBaume(data.juiceAnalysis.data.baume);
				}
	
				var lastDay = void 0;
	
				if (data.dailyData.data.length > 0) {
					lastDay = data.dailyData.data[data.dailyData.data.length - 1];
				}
	
				var daysToAdd = lastDay ? data.currentDay.day - (lastDay.day + fermenter.currentFerment.data.measuring_freq) : data.currentDay.day,
				    newDay = void 0;
	
				for (var i = data.currentDay.day - daysToAdd; i < data.currentDay.day; i += fermenter.currentFerment.data.measuring_freq) {
					newDay = this.newBlankDay();
	
					newDay.day = i;
	
					data.dailyData.data.push(newDay);
				}
	
				var index = _.findIndex(data.dailyData.data, function (day) {
					return day.day == data.currentDay.day;
				});
	
				if (!data.dailyData.data[index]) {
					data.dailyData.data.push(data.currentDay);
				} else {
					data.dailyData.data[index] = data.currentDay;
				}
	
				this.updateFerment(this.site.id, fermenter.id, data).then(function (response) {
					_this2.getFerment(_this2.site.id, fermenter.id, fermenter.currentFerment.data.id, ['juiceAnalysis', 'dailyData.action', 'dailyData.analysis']).then(function (response) {
						_this2.preventUpdate = true;
	
						fermenter.currentFerment.data.dailyData = response.body.data.dailyData;
	
						_notify2.default.success('Ferment daily data has been updated.');
					});
				});
			},
			openActionModal: function openActionModal(index) {
				var _this3 = this;
	
				this.editing.index = index;
	
				_vue2.default.nextTick(function () {
					$('#actions_analysis').modal().on('hidden.bs.modal', function () {
						_this3.editing.index = null;
					});
				});
			}
		})
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getters = __webpack_require__(2);
	
	var _gauge = __webpack_require__(487);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _fermenters = __webpack_require__(56);
	
	var _fermenters2 = _interopRequireDefault(_fermenters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			FermentGauge: _gauge2.default
		},
	
		data: function data() {
			return {
				sluggishFermentationQuote: '\n\t\t\t\tThis ferment is predicted to run behind schedule, based on the desired duration entered.\n\t\t\t\tTo get it back on track, consider warming it up, aeration, or adding nutrients.\n\t\t\t',
				rapidFermentQuaote: '\n\t\t\t\tThis ferment is predicted to finish ahead of schedule, based on the desired duration entered.\n\t\t\t\tTo get it back on track, consider cooling it down.\n\t\t\t',
				poorSimulationQuote: '\n\t\t\t\t<p>The simulator is struggling to lock onto this ferment. There may be several reasons for this.</p>\n\t\t\t\t<ul>\n\t\t\t\t\t<li>Check for incorrectly entered data. You may be able to see bad data points on the graph.</li>\n\t\t\t\t\t<li>Ensure all actions performed have been entered (DAP, mixing events, dilution, etc).</li>\n\t\t\t\t\t<li>Ensure the temperature measurements are an accurate representation of the tank.</li>\n\t\t\t\t\t<li>The ferment may be suffering from a complex issue like micro nutrient deficiency or competition from other yeast or bacteria and requires specific winemaker attention.</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\tLastly, no model is perfect and the ferment may be outside the range of the current model\u2019s predictive capability.\n\t\t\t\t\t\tAs more data is gathered, the model will continue to improve.\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t',
				notEnoughtDataQuote: '\n\t\t\t\tThere is not enough data yet to run the simulation.\n\t\t\t\tThe simulator needs at least 4 measurements to run.\n\t\t\t\tIf you have this, you may be missing something else.\n\t\t\t\tOpen the ferments to see what\u2019s missing.\n\t\t\t',
				simulationOutOfSyncQuote: '\n\t\t\t\tThe ferment has been changed but a simulation has not yet been run.\n\t\t\t\tYou can open this ferment and click Run Simulation to update it manually, or leave it and it will update itself automatically in the background.\n\t\t\t',
				lowRangeOnSpecQuote: '\n\t\t\t\tThis ferment predicted to run behind schedule. Only the lower end of the confidence interval is within spec.\n\t\t\t\tConsider warming it up, aeration or adding nutrients.\n\t\t\t',
				highRangeOnSpecQuote: '\n\t\t\t\tThis ferment predicted to run ahead schedule.\n\t\t\t\tOnly the upper end of the confidence interval is within spec.\n\t\t\t\tConsider cooling it down.\n\t\t\t'
			};
		},
	
	
		vuex: {
			getters: {
				simulatorSetup: _getters.simulatorSetup
			}
		},
	
		props: ['fermenters', 'selectedTankGroup'],
	
		methods: (0, _extends3.default)({}, _fermenters2.default, {
			showAllFermenters: function showAllFermenters() {
				this.selectedTankGroup = 'all';
			},
			fermenterIsStuck: function fermenterIsStuck(fermenter) {
				return !this.fermentNotEnoughData(fermenter.currentFerment.data) && parseFloat(fermenter.currentFerment.data.gauge.data.predicted_duration) == 99;
			}
		})
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				Http: _http2.default
			};
		},
	
	
		props: ['computedTankGroups', 'selectedTankGroup', 'showEmpty', 'showOutOfSpec', 'eventLoading', 'date', 'search', 'period', 'defaultInclude', 'exportFermenters', 'site']
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _fermenters = __webpack_require__(500);
	
	var _fermenters2 = _interopRequireDefault(_fermenters);
	
	var _bulkEntry = __webpack_require__(499);
	
	var _bulkEntry2 = _interopRequireDefault(_bulkEntry);
	
	var _filters = __webpack_require__(501);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Fermenters: _fermenters2.default,
			BulkEntry: _bulkEntry2.default,
			Filters: _filters2.default
		},
	
		vuex: {
			getters: {
				tankGroups: _getters.tankGroups,
				fermenters: _getters.fermenters,
				site: _getters.site,
				loading: _getters.loading,
				eventLoading: _getters.eventLoading
			},
	
			actions: {
				allTankGroups: _actions.TankGroups.all,
				allFermenters: _actions.Fermenters.all,
				exportFermenters: _actions.Fermenters.exportDashboardData,
				favouriteFermenter: _actions.Fermenters.favourite,
				setTitle: _actions.App.title
			}
		},
	
		route: {
			canReuse: false,
	
			activate: function activate() {
				this.$dispatch('loading');
			},
			data: function data() {
				var _this = this;
	
				this.allFermenters(this.site.id, this.defaultInclude).then(function () {
					_this.$dispatch('loaded');
	
					_vue2.default.nextTick(_this.boot);
				});
			}
		},
	
		data: function data() {
			return {
				period: false,
				search: '',
				date: (0, _moment2.default)().format('DD/MM/YYYY'),
				selectedTankGroup: 'all',
				showEmpty: false,
				showOutOfSpec: false,
				defaultInclude: ['tankGroup', 'currentFerment.gauge', 'currentFerment.dailyData.action', 'currentFerment.dailyData.analysis', 'currentFerment.juiceAnalysis', 'currentFerment.blendComponents']
			};
		},
		ready: function ready() {
			this.setTitle('Dashboard');
		},
	
	
		computed: {
			computedFermenters: function computedFermenters() {
				var _this2 = this;
	
				return this.fermenters.filter(function (fermenter) {
					var shouldBeIncluded = true;
	
					if (_this2.showEmpty && !fermenter.currentFerment) {
						shouldBeIncluded = false;
					}
	
					if (_this2.showOutOfSpec && (fermenter.currentFerment && (fermenter.currentFerment.data.gauge.data.status < 10 || _this2.fermenterHasEnoughData(fermenter)) || !fermenter.currentFerment)) {
						shouldBeIncluded = false;
					}
	
					if (_this2.selectedTankGroup == 'favourites' && !fermenter.favourite) {
						shouldBeIncluded = false;
					}
	
					if (fermenter.tank_group_id != _this2.selectedTankGroup && $.isNumeric(_this2.selectedTankGroup)) {
						shouldBeIncluded = false;
					}
	
					if (_this2.$options.filters.filterBy(fermenter, _this2.search).length == 0) {
						shouldBeIncluded = false;
					}
	
					return shouldBeIncluded;
				});
			},
			computedTankGroups: function computedTankGroups() {
				return $.merge([{ name: 'Favourites', value: 'favourites' }, { name: 'All', value: 'all' }], this.tankGroups.map(function (tankGroup) {
					return { name: tankGroup.name, value: tankGroup.id };
				}));
			}
		},
	
		methods: {
			boot: function boot() {
				var _this3 = this;
	
				if (this.$route.params.tankGroupId) {
					this.tankGroups.forEach(function (tankGroup) {
						if (tankGroup.id == _this3.$route.params.tankGroupId) {
							_this3.selectedTankGroup = tankGroup.id;
						}
					});
				} else {
					this.selectedTankGroup = 'all';
				}
	
				$('.ferments').on('click', '.favourite', function (event) {
					var target = $(event.target).attr('id'),
					    fermenter = parseInt(target.substr(target.indexOf('_') + 1));
	
					_this3.favouriteFermenter(fermenter, _this3.site.id).then(function (response) {
						if (!response.body.data.favourite) {
							_notify2.default.success('Fermenter no longer favourited.');
						} else {
							_notify2.default.success('Fermenter favourited.');
						}
					});
				});
			},
			fermenterHasEnoughData: function fermenterHasEnoughData(fermenter) {
				return fermenter.currentFerment.data.dailyData.data.length <= 4 && parseFloat(fermenter.currentFerment.data.gauge.data.predicted_duration) == 99;
			}
		}
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _actions;
	
	var _getters = __webpack_require__(2);
	
	var _actions2 = __webpack_require__(3);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _validator = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: ['fermenter', 'justRepositioned'],
	
		data: function data() {
			return {
				validation: {
					rules: {
						tank_group_id: 'required',
						name: 'required|max:25',
						volume: 'required'
					},
					messages: {
						'required.tank_group_id': 'The tank group field is required.'
					}
				},
				saveTimeout: null
			};
		},
	
	
		vuex: {
			actions: (_actions = {
				updateFermenter: _actions2.Fermenters.update,
				editFermenter: _actions2.Fermenters.edit,
				clearFermenter: _actions2.Fermenters.clear,
				storeFermenter: _actions2.Fermenters.store,
				destroyFermenter: _actions2.Fermenters.destroy
			}, (0, _defineProperty3.default)(_actions, 'clearFermenter', _actions2.Fermenters.clear), (0, _defineProperty3.default)(_actions, 'allTankGroups', _actions2.TankGroups.all), _actions),
	
			getters: {
				tankGroups: _getters.tankGroups,
				site: _getters.site
			}
		},
	
		computed: {
			tankGroupOptions: function tankGroupOptions() {
				return this.tankGroups.map(function (tankGroup) {
					return { name: tankGroup.name, value: tankGroup.id };
				});
			}
		},
	
		watch: {
			fermenter: {
				handler: function handler(newFermenter, oldFermenter) {
					var _this = this;
	
					if (!newFermenter.tank_group_id || !newFermenter.name || !newFermenter.volume || newFermenter.id != oldFermenter.id || this.justRepositioned) {
						this.justRepositioned = false;
	
						return;
					}
	
					clearTimeout(this.saveTimeout);
	
					this.saveTimeout = setTimeout(function () {
						if (newFermenter.id) {
							_this.save();
						} else {
							_this.create();
						}
					}, 1250);
				},
	
				deep: true
			}
		},
	
		ready: function ready() {},
	
	
		methods: {
			validate: _validator.validate,
	
			save: function save() {
				var _this2 = this;
	
				this.validate(this.fermenter, this.validation.rules, this.validation.messages).passes(function () {
					_this2.updateFermenter(_this2.site.id, _this2.fermenter).then(function () {
						_this2.allTankGroups(_this2.site.id, ['fermenters']);
	
						_notify2.default.success('Fermenter updated.');
					});
				});
			},
			create: function create() {
				var _this3 = this;
	
				this.validate(this.fermenter, this.validation.rules, this.validation.messages).passes(function () {
					_this3.storeFermenter(_this3.site.id, _this3.fermenter).then(function () {
						_this3.allTankGroups(_this3.site.id, ['fermenters']);
	
						_notify2.default.success('New fermenter added.');
					});
				});
			},
			destroy: function destroy() {
				var _this4 = this;
	
				if (this.fermenter.ferments && this.fermenter.ferments.data.length) {
					_alert2.default.error({ text: 'Unable to delete fermenter with an active ferment or historic ferments.' });
	
					return;
				}
	
				var self = this;
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroyFermenter(self.fermenter.id, self.site.id);
					}
				}).then(function () {
					_this4.clearFermenter();
	
					_this4.allTankGroups(_this4.site.id, ['fermenters']);
	
					_alert2.default.success({ text: 'Fermenter has been deleted.' }).then(function () {}, function () {});
				});
			}
		}
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _fermentersForm = __webpack_require__(503);
	
	var _fermentersForm2 = _interopRequireDefault(_fermentersForm);
	
	var _tankGroupsForm = __webpack_require__(505);
	
	var _tankGroupsForm2 = _interopRequireDefault(_tankGroupsForm);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			FermenterForm: _fermentersForm2.default,
			TankGroupForm: _tankGroupsForm2.default
		},
	
		data: function data() {
			return {
				tankGroup: {},
				fermenter: {},
				showTankGroupForm: false,
				justRepositioned: false
			};
		},
	
	
		vuex: {
			actions: {
				allTankGroups: _actions.TankGroups.all,
				editFermenter: _actions.Fermenters.edit,
				clearFermenter: _actions.Fermenters.clear,
				editTankGroup: _actions.TankGroups.edit,
				clearTankGroup: _actions.TankGroups.clear,
				reposition: _actions.TankGroups.reposition,
				setTitle: _actions.App.title
			},
	
			getters: {
				tankGroups: _getters.tankGroups,
				site: _getters.site,
				activeTankGroup: _getters.tankGroup,
				activeFermenter: _getters.fermenter,
				loading: _getters.loading
			}
		},
	
		watch: {
			activeTankGroup: function activeTankGroup() {
				this.tankGroup = $.extend({}, this.activeTankGroup);
			},
			activeFermenter: function activeFermenter(newActiveFermenter) {
				this.fermenter = $.extend({}, this.activeFermenter);
			}
		},
	
		route: {
			activate: function activate() {
				this.$dispatch('loading');
			},
			data: function data() {
				var _this = this;
	
				this.clearFermenter();
	
				this.allTankGroups(this.site.id, ['fermenters.ferments']).then(function (response) {
					_this.$dispatch('loaded');
				});
			}
		},
	
		ready: function ready() {
			var _this2 = this;
	
			this.setTitle('Fermenter Setup');
	
			$('.sortable').nestedSortable({
				handle: 'div',
				items: 'li',
				isTree: true,
				maxLevels: 2,
				toleranceElement: '> div',
				protectRoot: true,
				relocate: function relocate(event) {
					var hierarchy = $('.sortable').nestedSortable('toHierarchy', { startDepthCount: 0 });
	
					hierarchy.forEach(function (parent) {
						delete parent['nestedSortable-item'];
	
						if (parent.children) {
							parent.children.forEach(function (child) {
								delete child['nestedSortable-item'];
							});
						}
					});
	
					_this2.justRepositioned = true;
	
					_this2.reposition(_this2.site.id, hierarchy, ['fermenters']).then(function (response) {
						_notify2.default.success('Fermenters have been sorted.', { timeout: 2000 });
	
						if (_this2.fermenter || _this2.tankGroup) {
							response.body.data.forEach(function (tankGroup) {
								if (_this2.fermenter) {
									tankGroup.fermenters.data.forEach(function (fermenter) {
										if (fermenter.id == _this2.fermenter.id) {
											_this2.fermenter.tank_group_id = tankGroup.id;
										}
									});
								}
	
								if (_this2.tankGroup) {
									if (tankGroup.id == _this2.tankGroup.id) {
										_this2.tankGroup.fermenters = tankGroup.fermenters;
									}
								}
							});
						}
					});
				}
			});
		},
	
	
		methods: {
			edit: function edit(type, object) {
				switch (type) {
					case 'tankGroup':
						this.showTankGroupForm = true;
						this.clearFermenter();
						this.editTankGroup(object);
						break;
					case 'fermenter':
						this.showTankGroupForm = false;
						this.editFermenter(object);
						this.clearTankGroup();
	
						_vue2.default.nextTick(function () {
							$("#tank_group_id").trigger('change');
						});
						break;
				}
			},
			createNewFermenter: function createNewFermenter() {
				this.clear();
	
				this.showTankGroupForm = false;
	
				this.$broadcast('resetValidation');
			},
			createNewTankGroup: function createNewTankGroup() {
				this.clear();
	
				this.showTankGroupForm = true;
	
				this.$broadcast('resetValidation');
			},
			clear: function clear() {
				this.clearTankGroup();
				this.clearFermenter();
			}
		}
	};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _validator = __webpack_require__(59);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: ['tankGroup', 'justRepositioned'],
	
		data: function data() {
			return {
				validation: {
					rules: {
						name: 'required'
					}
				},
				saveTimeout: null
			};
		},
	
	
		vuex: {
			actions: {
				storeTankGroup: _actions.TankGroups.store,
				updateTankGroup: _actions.TankGroups.update,
				destroyTankGroup: _actions.TankGroups.destroy,
				clearTankGroup: _actions.TankGroups.clear,
				allTankGroups: _actions.TankGroups.all
			},
			getters: {
				site: _getters.site,
				activeTankGroup: _getters.tankGroup
			}
		},
	
		watch: {
			tankGroup: {
				handler: function handler(newTankGroup, oldTankGroup) {
					var _this = this;
	
					if (!newTankGroup.name || newTankGroup.id != oldTankGroup.id || this.justRepositioned) {
						this.justRepositioned = false;
	
						return;
					}
	
					clearTimeout(this.saveTimeout);
	
					this.saveTimeout = setTimeout(function () {
						_this.saveOrCreate();
					}, 1250);
				},
	
				deep: true
			}
		},
	
		methods: {
			validate: _validator.validate,
	
			saveOrCreate: function saveOrCreate() {
				if (this.tankGroup.id) {
					this.save();
				} else {
					this.create();
				}
			},
			create: function create() {
				var _this2 = this;
	
				this.validate(this.tankGroup, this.validation.rules).passes(function () {
					_this2.storeTankGroup(_this2.site.id, _this2.tankGroup.name).then(function (response) {
						_notify2.default.success('New tank group added.');
					});
				});
			},
			save: function save() {
				var _this3 = this;
	
				this.validate(this.tankGroup, this.validation.rules).passes(function () {
					_this3.updateTankGroup(_this3.site.id, _this3.tankGroup).then(function (response) {
						_notify2.default.success('Tank group updated.');
					});
				});
			},
			destroy: function destroy() {
				var _this4 = this;
	
				if (this.tankGroup.fermenters && this.tankGroup.fermenters.data.length > 0) {
					_alert2.default.error({ text: 'This tank group has existing fermenters. Please move or delete the fermenters before you continue.' });
	
					return;
				}
	
				var self = this;
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroyTankGroup(self.site.id, self.tankGroup.id);
					}
				}).then(function () {
					_this4.clearTankGroup();
	
					_alert2.default.success({ text: 'Tank group has been deleted.' }).then(function () {}, function () {});
				});
			}
		}
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(22);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _graph = __webpack_require__(508);
	
	var _graph2 = _interopRequireDefault(_graph);
	
	var _dailyData = __webpack_require__(210);
	
	var _dailyData2 = _interopRequireDefault(_dailyData);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routes = __webpack_require__(31);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _units = __webpack_require__(20);
	
	var _units2 = _interopRequireDefault(_units);
	
	var _ferment2 = __webpack_require__(55);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			FermentGraph: _graph2.default,
			DailyData: _dailyData2.default
		},
	
		vuex: {
			getters: {
				site: _getters.site,
				loading: _getters.loading,
				fermenter: _getters.fermenter,
				varietals: _getters.varietals,
				regions: _getters.regions,
				yeastTypes: _getters.yeastTypes,
				profiles: _getters.profiles,
				ferment: _getters.ferment,
				simulatorRunning: _getters.simulatorRunning,
				graphBase64: _getters.graphBase64,
				simulator: _getters.simulatorSetup
			},
	
			actions: {
				getFermenter: _actions.Fermenters.get,
				resetFermenters: _actions.Fermenters.reset,
				allProfiles: _actions.Profiles.all,
				allVarietals: _actions.Settings.allVarietals,
				allRegions: _actions.Settings.allRegions,
				allYeastTypes: _actions.Settings.allYeastTypes,
				getFerment: _actions.Ferments.get,
				updateFerment: _actions.Ferments.update,
				storeFerment: _actions.Ferments.store,
				archiveFerment: _actions.Ferments.archive,
				destroyFerment: _actions.Ferments.destroy,
				setTitle: _actions.App.title
			}
		},
	
		events: {
			resetChanges: function resetChanges() {
				this.$store.dispatch(types.SET_ACTIVE_FERMENT, this.originalFerment);
	
				this.originalFerment = $.extend(true, {}, this.ferment);
			},
			clearSimulateTimeout: function clearSimulateTimeout() {
				clearTimeout(this.simulateTimeout);
	
				this.$broadcast('clearGraphCountdown');
			}
		},
	
		route: {
			canReuse: false,
	
			deactivate: function deactivate() {
				$(window).off('hidden.bs.modal');
				$(window).off('shown.bs.modal');
	
				$(document).off('keydown');
	
				clearTimeout(this.simulateTimeout);
	
				this.resetFermenters();
	
				_notify2.default.clear();
			},
			activate: function activate() {
				this.$dispatch('loading');
			},
			data: function data() {
				var _this = this;
	
				window.scrollTo(0, 0);
	
				this.allVarietals().then(function () {
	
					_this.loaded.push('varietals');
				});
	
				this.allRegions({ country_id: this.simulator && this.simulator.country_id }).then(function () {
					_this.regionOptions = _this.select2Transformer(_this.regions);
	
					_this.loaded.push('regions');
				});
	
				this.allYeastTypes().then(function () {
					_this.yeastTypeOptions = _this.select2Transformer(_this.yeastTypes);
	
					_this.loaded.push('yeast-types');
				});
	
				if (this.$route.params.fermentId == 0) {
					this.getFermenter(this.$route.params.fermenterId, this.site.id, ['tankGroup', 'currentFerment.blendComponents.fermenter', 'currentFerment.blendComponents.dailyData', 'currentFerment.juiceAnalysis', 'currentFerment.dailyData.action', 'currentFerment.dailyData.analysis']).then(function () {
						if (!_this.fermenter.currentFerment) {
							_this.isEmptyFermenter = true;
						}
	
						_this.$store.dispatch(types.SET_ACTIVE_FERMENT, _this.isEmptyFermenter ? _this.getFreshFerment() : _this.fermenter.currentFerment.data);
	
						_this.tankGroup = _this.fermenter.tankGroup.data;
	
						_this.updateMeasuringFrequency();
	
						_this.loaded.push('fermenter');
					}, function () {
						_this.$router.go({ name: 'dashboard' });
	
						_notify2.default.error('You do not have permission to see that ferment.');
					});
				} else {
					this.getFerment(this.site.id, this.$route.params.fermenterId, this.$route.params.fermentId, ['fermenter.tankGroup', 'blendComponents.fermenter', 'blendComponents.dailyData', 'previousFermenters', 'juiceAnalysis', 'dailyData.action', 'dailyData.analysis']).then(function () {
						_this.$store.dispatch(types.SET_ACTIVE_FERMENTER, _this.ferment.fermenter.data);
	
						_this.updateMeasuringFrequency();
	
						_this.loaded.push('ferment');
					}, function () {
						_this.$router.go({ name: 'dashboard' });
	
						_notify2.default.error('You do not have permission to see that ferment.');
					});
				}
			}
		},
	
		data: function data() {
			return {
				profile: '',
				updateTimeout: null,
				simulateTimeout: null,
				originalFerment: {},
				loaded: [],
				tankGroup: {},
				isEmptyFermenter: false,
				yeastTypeOptions: [],
				profileOptions: [],
				recentlyCreated: false,
				units: _units2.default,
				measuringFreqInteger: null,
				selectedBlendComponent: null
			};
		},
	
	
		computed: {
			blendComponentOptions: function blendComponentOptions() {
				if (this.isBlendedFerment) {
					return this.select2Transformer(_.map(this.ferment.blendComponents.data, function (ferment) {
						return { id: ferment.id, name: ferment.wine_name + ' ex ' + ferment.fermenter.data.name };
					}));
				}
			},
			winemakerOptions: function winemakerOptions() {
				if (this.simulator) {
					var winemakers = _.clone(this.simulator.winemakers);
	
					if (this.haveMultipleWinemakers) {
						winemakers.unshift({ id: 'various', name: 'Various' });
					}
	
					return this.select2Transformer(winemakers);
				}
			},
	
	
			selectedWinemakerOption: {
				get: function get() {
					if (this.haveMultipleWinemakers && this.ferment.winemaker_id == null) {
						return 'various';
					} else {
						return this.ferment.winemaker_id;
					}
				},
				set: function set(value) {
					if (this.haveMultipleWinemakers && value === 'various') {
						this.ferment.winemaker_id = null;
					} else {
						this.ferment.winemaker_id = value;
					}
				}
			},
	
			selectedVarietalOption: {
				get: function get() {
					if (this.haveMultipleVarietals && this.ferment.varietal_id == null) {
						return 'blend';
					} else {
						return this.ferment.varietal_id;
					}
				},
				set: function set(value) {
					if (this.haveMultipleVarietals && value === 'blend') {
						this.ferment.varietal_id = null;
					} else {
						this.ferment.varietal_id = value;
					}
				}
			},
	
			selectedRegionOption: {
				get: function get() {
					if (this.haveMultipleRegions && this.ferment.region_id == null) {
						return 'blend';
					} else {
						return this.ferment.region_id;
					}
				},
				set: function set(value) {
					if (this.haveMultipleRegions && value === 'blend') {
						this.ferment.region_id = null;
					} else {
						this.ferment.region_id = value;
					}
				}
			},
	
			varietalOptions: function varietalOptions() {
				var varietals = _.clone(this.varietals);
	
				if (this.haveMultipleVarietals) {
					varietals.unshift({ id: 'blend', name: 'Blend' });
				}
	
				return this.select2Transformer(varietals);
			},
			regionOptions: function regionOptions() {
				var regions = _.clone(this.regions);
	
				if (this.haveMultipleRegions) {
					regions.unshift({ id: 'blend', name: 'Blend' });
				}
	
				return this.select2Transformer(regions);
			},
			haveMultipleVarietals: function haveMultipleVarietals() {
				return this.ferment && this.ferment.blendComponents && _.uniqBy(this.ferment.blendComponents.data, 'varietal_id').length > 1;
			},
			haveMultipleRegions: function haveMultipleRegions() {
				return this.ferment && this.ferment.blendComponents && _.uniqBy(this.ferment.blendComponents.data, 'region_id').length > 1;
			},
			haveMultipleWinemakers: function haveMultipleWinemakers() {
				return this.ferment && this.ferment.blendComponents && _.uniqBy(this.ferment.blendComponents.data, 'winemaker_id').length > 1;
			},
			isBlendedFerment: function isBlendedFerment() {
				return this.ferment && this.ferment.blendComponents && this.ferment.blendComponents.data.length > 0;
			},
			havePreviousFermenters: function havePreviousFermenters() {
				return this.ferment && this.ferment.previousFermenters && this.ferment.previousFermenters.data.length > 0;
			}
		},
	
		watch: {
			selectedBlendComponent: function selectedBlendComponent() {
				var _this2 = this;
	
				if (this.selectedBlendComponent) {
					var _ferment = this.ferment.blendComponents.data.find(function (ferment) {
						return ferment.id == _this2.selectedBlendComponent;
					});
	
					this.$router.go({
						name: 'ferments.index',
						params: {
							fermenterId: _ferment.fermenter.data.id,
							fermentId: _ferment.id
						}
					});
				}
			},
			simulator: function simulator(val, oldVal) {
				var _this3 = this;
	
				if (val.country_id && !oldVal.country_id) {
					this.allRegions({ country_id: val.country_id }).then(function () {
						_this3.regionOptions = _this3.select2Transformer(_this3.regions);
	
						_this3.loaded.push('regions');
					});
				}
			},
			profile: function profile() {
				var _this4 = this;
	
				if (!this.isEmptyFermenter) {
					_alert2.default.custom({
						title: 'Profile change during ferment!',
						text: 'You are about to change your ferment profile during a ferment. This will change the desired duration and replace daily data from the next day onwards. Are you sure you want to do this?',
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#d33',
						cancelButtonColor: '#3085d6',
						confirmButtonText: 'Yes, change profile.'
					}).then(function () {
						_this4.handleProfileSwitch(_this4.profile);
					}, function () {});
				} else {
					this.handleProfileSwitch(this.profile);
				}
			},
			loaded: function loaded() {
				if (this.loaded.length == 4) {
					this.$dispatch('loaded');
	
					_vue2.default.nextTick(this.boot);
				}
			}
		},
	
		ready: function ready() {
			this.$on('forceUpdateData', this.save);
		},
	
	
		methods: {
			select2Transformer: function select2Transformer(arr) {
				var valueProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
				var nameProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
	
				if (!Array.isArray(arr)) {
					return [];
				}
	
				return arr.map(function (el) {
					return { name: el[nameProp], value: el[valueProp] };
				});
			},
			boot: function boot() {
				var _this5 = this;
	
				this.originalFerment = $.extend(true, {}, this.ferment);
	
				this.$broadcast('initialize');
	
				$('.ferment_nav').sticky({ topSpacing: 30 });
				$('.sticky-box').sticky({ topSpacing: 30 });
	
				$('.ferment-setup, .juice-analysis').on('show.bs.collapse', function (event) {
					_this5.toggleCollapse(event, false);
				});
	
				$('.ferment-setup, .juice-analysis').on('hide.bs.collapse', function (event) {
					_this5.toggleCollapse(event, true);
				});
	
				$(document).on('keydown', function (event) {
					if (event.which === 8 && !$(event.target).is('input, textarea, select')) {
						event.preventDefault();
					}
				});
	
				$('#ferment_graph_modal').on('show.bs.modal', function () {
					_this5.$broadcast('buildGraph', 'ferment-modal-graph');
				});
	
				if (this.fermenter.tankGroup) {
					this.setTitle(this.fermenter.tankGroup.data.name + ' - ' + this.fermenter.name);
				}
	
				this.volumeToggle();
	
				this.scrollToStoredState();
	
				this.$broadcast('reloadGraph');
	
				this.disableFields();
	
				this.updateYeastType();
	
				this.updateInitialUnits();
	
				var updateTimeoutSeconds = this.$route.name == 'ferments.index' ? 1250 : 2000;
	
				this.$watch('ferment', function (value, old) {
					_vue2.default.nextTick(function () {
						$('#type').prop('disabled', _this5.hasDailyData());
					});
	
					if (_this5.ferment.wine_name == '' || !_this5.ferment.wine_name || value.id != old.id || _this5.recentlyCreated) {
						_this5.recentlyCreated = false;
	
						return;
					}
	
					clearTimeout(_this5.updateTimeout);
	
					_this5.updateTimeout = setTimeout(function () {
						_this5.saveOrCreate();
					}, updateTimeoutSeconds);
				}, { deep: true });
	
				this.$watch('ferment.type', this.updateMeasuringFrequency);
	
				this.$watch('ferment.type', this.loadProfiles);
	
				this.$watch('ferment.style', this.updateYeastType);
	
				this.loadProfiles();
			},
			loadProfiles: function loadProfiles() {
				var _this6 = this;
	
				var wasDisabled = $('#profile').prop('disabled') || false;
	
				$('#profile').prop('disabled', true);
	
				this.allProfiles(this.site.id, { type: this.ferment.type ? 'red' : 'white' }).then(function () {
					_this6.profileOptions = _this6.profiles.map(function (profile) {
						return { name: profile.name, value: profile.id };
					});
	
					if (_this6.loaded.indexOf('profiles') == -1) {
						_this6.loaded.push('profiles');
					}
	
					$('#profile').prop('disabled', wasDisabled);
				});
			},
			updateInitialUnits: function updateInitialUnits() {
				this.ferment.dailyData.data.forEach(function (day) {
					day.temp = _units2.default.celsiusToFahrenheit(day.temp);
					day.baume = _units2.default.baumeToBrix(day.baume);
				});
	
				if (this.ferment.juiceAnalysis) {
					this.ferment.juiceAnalysis.data.baume = _units2.default.baumeToBrix(this.ferment.juiceAnalysis.data.baume);
				}
			},
			updateYeastType: function updateYeastType() {
				if (!this.ferment.style) {
					$('#yeast_type_id').val('').trigger('change').prop('disabled', true);
				} else {
					$('#yeast_type_id').prop('disabled', false);
				}
			},
			updateMeasuringFrequency: function updateMeasuringFrequency() {
				if (!this.ferment.measuring_freq) {
					this.ferment.measuring_freq = 1.0;
					this.measuringFreqInteger = 1;
				}
	
				if (this.ferment.type) {
	
					this.ferment.measuring_freq = (0, _ferment2.caluculateMeasuringFreq)(this.simulator.red_sampling_freq);
					this.measuringFreqInteger = this.simulator.red_sampling_freq;
				} else {
	
					this.ferment.measuring_freq = (0, _ferment2.caluculateMeasuringFreq)(this.simulator.white_sampling_freq);
					this.measuringFreqInteger = this.simulator.white_sampling_freq;
				}
	
				this.ferment.measuring_freq_integer = this.measuringFreqInteger;
			},
			calculateBaume: function calculateBaume() {
				var sugarOffset = 30;
	
				if (this.ferment.climate) {
					sugarOffset = 40;
				} else {
					sugarOffset = 25;
				}
	
				if (!this.ferment.juiceAnalysis || this.ferment.juiceAnalysis.data.baume == null || !parseFloat(this.ferment.volume) || this.ferment.total_water_added == null) {
					return 'n/a';
				}
	
				var dilution = parseFloat(this.ferment.volume) / (parseFloat(this.ferment.volume) + parseFloat(this.ferment.total_water_added) / 1000);
	
				return _units2.default.baumeToBrix((_units2.default.brixToBaume(this.ferment.juiceAnalysis.data.baume) - 0.0181) * dilution + (dilution - 1) * sugarOffset / 16.63 + 0.0181).toFixed(2) + ' ' + _units2.default.sugarUnit();
			},
			calculateYan: function calculateYan() {
				if (!this.ferment.juiceAnalysis || this.ferment.juiceAnalysis.data.yan == null || this.ferment.volume == null || this.ferment.total_water_added == null) {
					return 'n/a';
				}
	
				var dilution = parseFloat(this.ferment.volume) / (parseFloat(this.ferment.volume) + parseFloat(this.ferment.total_water_added) / 1000);
	
				return (parseFloat(this.ferment.juiceAnalysis.data.yan) * dilution).toFixed(2) + ' mg/L';
			},
			disableFields: function disableFields() {
				if (this.isBlendedFerment) {
					$('select[name=varietal_id]').prop('disabled', true);
					$('select[name=region_id]').prop('disabled', true);
				}
	
				if (this.ferment.archived && this.$route.name == 'ferments.index') {
					$('.form-horizontal input, textarea, select:not([name=blend_component_id])').prop('disabled', true);
	
					$('.input-group a').addClass('disabled');
				}
	
				if (this.$route.name == 'ferments.what-if') {
					$([{ name: 'wine_name', type: 'input' }, { name: 'blend_code', type: 'input' }, { name: 'batch_code', type: 'input' }, { name: 'varietal_id', type: 'select' }, { name: 'region_id', type: 'select' }, { name: 'start_date', type: 'input' }, { name: 'baume', type: 'input' }, { name: 'yan', type: 'input' }, { name: 'ph', type: 'input' }, { name: 'ta', type: 'input' }, { name: 'fs02', type: 'input' }, { name: 'ts02', type: 'input' }, { name: 'gf', type: 'input' }, { name: 'ntu', type: 'input' }, { name: 'profile', type: 'select' }].map(function (input) {
						return input.type + '[name=' + input.name + ']';
					}).join(', ')).prop('disabled', true);
	
					if (this.ferment.archived) {
						$(".juice-analysis input, .ferment-setup input, .ferment-setup select, textarea").prop('disabled', false);
					}
				}
	
				if (this.hasDailyData()) {
					$('#type').prop('disabled', true);
				}
			},
			handleProfileSwitch: function handleProfileSwitch(id) {
				var profile = _.find(this.profiles, function (profile) {
					return profile.id == id;
				});
	
				if (this.hasDailyData()) {
					if (profile.type != this.ferment.type) {
						_alert2.default.error('Unable to use profile as the profile type does not match the ferment type.');
	
						return;
					}
				}
	
				this.ferment.type = profile.type == 1 ? true : false;
				this.ferment.duration = profile.duration;
	
				if (this.hasDailyData()) {
					var dayDifference = (0, _moment2.default)().diff((0, _moment2.default)(this.ferment.start_date, 'DD/MM/YYYY hh:mm A'), 'days') + 1;
	
					if (this.ferment.measuring_freq == 0.5) {
						dayDifference *= 2;
					}
	
					if (profile.dailyData.data.length < dayDifference) {
						return;
					}
	
					for (var i = dayDifference; i < profile.dailyData.data.length; ++i) {
						if (this.ferment.dailyData.data[i]) {
							this.ferment.dailyData.data[i].action = profile.dailyData.data[i].action;
							this.ferment.dailyData.data[i].analysis = profile.dailyData.data[i].analysis;
							this.ferment.dailyData.data[i].temp = profile.dailyData.data[i].temp;
						} else {
							_vue2.default.set(this.ferment.dailyData.data, i, profile.dailyData.data[i]);
						}
					}
				} else {
					this.ferment.dailyData = $.extend({}, this.ferment.dailyData, profile.dailyData);
				}
			},
			hasDailyData: function hasDailyData() {
				if (this.ferment.dailyData.data.length == 1) {
					var blank = false;
	
					this.$broadcast('isBlankRow', this.ferment.dailyData.data[0], function () {
						blank = true;
					});
	
					return !blank;
				}
	
				return this.ferment.dailyData.data.length > 0;
			},
			gotoPreviousFermenter: function gotoPreviousFermenter() {
				this.storeScrolledState();
	
				_routes2.default.go({ name: 'ferments.index', params: { fermenterId: this.fermenter.previous, fermentId: 0 } });
			},
			gotoNextFermenter: function gotoNextFermenter() {
				this.storeScrolledState();
	
				_routes2.default.go({ name: 'ferments.index', params: { fermenterId: this.fermenter.next, fermentId: 0 } });
			},
			scrollToStoredState: function scrollToStoredState() {
				var scrolledState = JSON.parse(localStorage.getItem('scrolledState'));
	
				if (!scrolledState || scrolledState.top === undefined || scrolledState.left === undefined) return;
	
				window.scrollTo(scrolledState.left, scrolledState.top);
			},
			storeScrolledState: function storeScrolledState() {
				var doc = document.documentElement,
				    left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
				    top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
				    scrolledState = JSON.parse(localStorage.getItem('scrolledState'));
	
				if (!scrolledState) {
					scrolledState = {};
				}
	
				scrolledState.top = top;
				scrolledState.left = left;
	
				localStorage.setItem('scrolledState', (0, _stringify2.default)(scrolledState));
			},
			getFreshFerment: function getFreshFerment() {
				return {
					id: null,
					wine_name: '',
					type: false,
					measuring_freq: (0, _ferment2.caluculateMeasuringFreq)(this.simulator.white_sampling_freq),
					style: true,
					climate: false,
					duration: null,
					start_date: (0, _moment2.default)().format('DD/MM/YYYY hh:mm A'),
					juiceAnalysis: {
						data: {}
					},
					dailyData: {
						data: []
					}
				};
			},
			volumeToggle: function volumeToggle() {
				$('#type').change(function (event) {
					if ($(event.target).prop('checked')) {
						$('#volume').parent().find('.input-group-addon').html('T');
					} else {
						$('#volume').parent().find('.input-group-addon').html('kL');
					}
				}).trigger('change');
			},
			reloadGraph: function reloadGraph() {
				var _this7 = this;
	
				var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
				var seconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
				clearTimeout(this.simulateTimeout);
	
				this.$broadcast('reloadGraphCountdown', seconds);
	
				if (this.isBlendedFerment) {
					this.$broadcast('reloadGraph', force);
	
					return;
				}
	
				this.simulateTimeout = setTimeout(function () {
					_this7.$broadcast('reloadGraph', force);
				}, seconds * 1000);
			},
			clearFermenter: function clearFermenter() {
				var _this8 = this;
	
				var self = this;
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroyFerment(self.site.id, self.fermenter.id, self.ferment.id);
					}
				}).then(function () {
					_this8.$broadcast('destroyGraph');
					_this8.$broadcast('clearDailyData');
	
					_this8.$store.dispatch(types.SET_ACTIVE_FERMENT, _this8.getFreshFerment());
	
					_this8.$router.go({ name: 'ferments.index', params: { fermenterId: _this8.fermenter.id, fermentId: 0 } });
	
					_alert2.default.success({ text: 'Ferment has been deleted.' }).then(function () {}, function () {});
				}, function () {});
			},
			archive: function archive() {
				var _this9 = this;
	
				var self = this;
	
				_alert2.default.confirm({
					title: 'Archive Ferment',
					text: 'Are you sure you want to archive this ferment?',
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.archiveFerment(self.site.id, self.fermenter.id, self.ferment.id);
					}
				}).then(function () {
					_this9.$broadcast('clearGraph');
					_this9.$broadcast('clearDailyData');
	
					_this9.$store.dispatch(types.SET_ACTIVE_FERMENT, _this9.getFreshFerment());
	
					_this9.$router.go({ name: 'ferments.index', params: { fermenterId: _this9.fermenter.id, fermentId: 0 } });
	
					_alert2.default.success({ text: 'Ferment has been archived.' }).then(function () {}, function () {});
				}, function () {});
			},
			saveOrCreate: function saveOrCreate() {
				this.updateMeasuringFrequency();
	
				if (this.$route.name == 'ferments.what-if' || this.$route.name == 'ferments.what-now') {
					this.reloadGraph(false, 5);
	
					return;
				}
	
				if (this.ferment.archived) return;
	
				if (this.ferment.id == null) {
					this.create().then(this.reloadGraph);
				} else {
					this.save().then(this.reloadGraph);
				}
			},
			create: function create() {
				var _this10 = this;
	
				return this.storeFerment(this.site.id, this.fermenter.id, this.getSaveOrCreateData()).then(function (response) {
					_this10.recentlyCreated = true;
	
					_this10.getFerment(_this10.site.id, _this10.fermenter.id, response.body.data.id, ['fermenter.tankGroup', 'juiceAnalysis', 'dailyData.action', 'dailyData.analysis']).then(function (response) {
						_notify2.default.success('New ferment added.');
					});
				});
			},
			save: function save() {
				return this.updateFerment(this.site.id, this.fermenter.id, this.getSaveOrCreateData()).then(function (response) {
					_notify2.default.success('Ferment updated.');
				});
			},
			getSaveOrCreateData: function getSaveOrCreateData() {
				var data = $.extend(true, {}, this.ferment);
	
				data.start_date = (0, _moment2.default)(data.start_date, 'DD/MM/YYYY hh:mm A').format('YYYY-MM-DD HH:mm:ss');
	
				data.dailyData.data.forEach(function (day) {
					day.temp = _units2.default.fahrenheitToCelsius(day.temp);
					day.baume = _units2.default.brixToBaume(day.baume);
				});
	
				if (data.juiceAnalysis) {
					data.juiceAnalysis.data.baume = _units2.default.brixToBaume(data.juiceAnalysis.data.baume);
				}
	
				return data;
			},
			collapsed: function collapsed(group) {
				if (this.isEmptyFermenter) {
					return false;
				}
	
				var collapseState = JSON.parse(localStorage.getItem('collapseState'));
	
				if (!collapseState || !collapseState[this.fermenter.id] || !collapseState[this.fermenter.id][group]) {
					return false;
				}
	
				return collapseState[this.fermenter.id][group];
			},
			toggleCollapse: function toggleCollapse(event, collapsed) {
				var group = $(event.target).is('.ferment-setup') ? 'ferment-setup' : 'juice-analysis',
				    collapseState = JSON.parse(localStorage.getItem('collapseState'));
	
				if (!collapseState) {
					collapseState = {};
				}
	
				if (!collapseState[this.fermenter.id]) {
					collapseState[this.fermenter.id] = {};
				}
	
				collapseState[this.fermenter.id][group] = collapsed;
	
				localStorage.setItem('collapseState', (0, _stringify2.default)(collapseState));
			},
			download: function download(format) {
				var path = _http2.default.buildPath('ferments/' + this.ferment.id + '/export-' + format);
	
				this.$broadcast('generateBase64');
	
				if (!this.graphBase64) {
					_notify2.default.error('Unable to download report, please try again later.');
	
					return;
				}
	
				$('#download-ferment').find('input[name=graph]').val(this.graphBase64).parent().attr('action', path).submit();
			}
		}
	};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['exists']
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(293);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chart = __webpack_require__(313);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _units = __webpack_require__(20);
	
	var _units2 = _interopRequireDefault(_units);
	
	var _whatNow = __webpack_require__(510);
	
	var _whatNow2 = _interopRequireDefault(_whatNow);
	
	var _whatIf = __webpack_require__(509);
	
	var _whatIf2 = _interopRequireDefault(_whatIf);
	
	var _checklistItem = __webpack_require__(507);
	
	var _checklistItem2 = _interopRequireDefault(_checklistItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MIN_BAUME = 4;
	
	exports.default = {
		components: {
			WhatNow: _whatNow2.default,
			WhatIf: _whatIf2.default,
			ChecklistItem: _checklistItem2.default
		},
	
		vuex: {
			getters: {
				site: _getters.site,
				simulator: _getters.simulatorSetup,
				ferment: _getters.ferment,
				fermenter: _getters.fermenter,
				simulatorRunning: _getters.simulatorRunning
			},
	
			actions: {
				runSimulation: _actions.Ferments.simulation,
				runTemporarySimulation: _actions.Ferments.temporarySimulation
			}
		},
	
		data: function data() {
			return {
				chart: null,
				baselineSimulation: null,
				simulation: {},
				reloading: false,
				failedToSimulate: false,
				nothingToSimulate: false,
				unableToSimulate: false,
				simulationNotification: null,
				unableToSimulateMessage: '',
				moment: _moment2.default
			};
		},
	
	
		events: {
			generateBase64: function generateBase64() {
				if (!this.chart) return;
	
				this.$store.dispatch(types.SET_GRAPH_BASE64, this.chart.toBase64Image());
			},
			buildGraph: function buildGraph(target) {
				this.buildGraph(target);
			},
			reloadGraph: function reloadGraph() {
				var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				this.loadGraph(force, data);
			},
			clearGraphCountdown: function clearGraphCountdown() {
				if (this.simulationNotification) {
					_notify2.default.clear(this.simulationNotification);
				}
			},
			reloadGraphCountdown: function reloadGraphCountdown(seconds) {
				if (this.unableToSimulateWithData()) {
					this.nothingToSimulate = false;
					this.unableToSimulate = true;
	
					return;
				}
	
				if (this.isBlendedFerment) {
					return;
				}
	
				if (this.simulationNotification) {
					_notify2.default.clear(this.simulationNotification);
				}
	
				this.simulationNotification = _notify2.default.info('Simulation running in ' + seconds + ' seconds.', { timeout: seconds * 1000 });
			},
			clearGraph: function clearGraph() {
				if (this.chart) {
					this.chart.clear();
				}
	
				this.nothingToSimulate = true;
				this.unableToSimulate = false;
				this.failedToSimulate = false;
			},
			destroyGraph: function destroyGraph() {
				if (this.chart) {
					this.chart.destroy();
	
					this.chart = null;
				}
	
				this.nothingToSimulate = true;
				this.unableToSimulate = false;
				this.failedToSimulate = false;
			}
		},
	
		computed: {
			sugarLabel: function sugarLabel() {
				return this.simulator.sugar_units ? 'Baume' : 'Brix';
			},
			temperatureLabel: function temperatureLabel() {
				return this.simulator.temp_units ? 'Temperature (°C)' : 'Temperature (°F)';
			},
			fermentRateLabel: function fermentRateLabel() {
				return this.simulator.sugar_units ? 'Ferment Rate (Be/day)' : 'Ferment Rate (Bx/day)';
			},
			popoverContent: function popoverContent() {
				if (this.isBlendedFerment) {
					return '<small>This graph shows the sugar readings of the blend components (before blending) in light colours, and the sugar readings of the final blend in dark blue. You can show/hide individual series by clicking on them in the legend.</small>';
				}
	
				return '<small>The graph shows the predicted profile of the ferment from the simulator. Individual series can be shown/hidden by clicking on them in the legend.</small>';
			},
			checklist: function checklist() {
				function makeItem(obj, message) {
					return { exists: !!obj, message: message };
				}
	
				var ferment = this && this.ferment;
	
				return ferment ? [makeItem(ferment.wine_name, 'Wine Name'), makeItem(ferment.start_date, 'Wine Start Date'), makeItem(ferment.juiceAnalysis.data.yan, 'Juice Analysis: YAN'), makeItem(ferment.duration, 'Ferment Desired Duration'), makeItem(ferment.volume, 'Ferment Volume'), makeItem(ferment.dailyData.data[0] && ferment.dailyData.data[0].baume, 'Initial Baume'), makeItem(ferment.dailyData.data[0] && ferment.dailyData.data[0].temp, 'Initial Temperature')] : [];
			},
			checklistCompleted: function checklistCompleted() {
				var checklist = this.checklist;
	
				for (var prop in checklist) {
					if (checklist.hasOwnProperty(prop) && !checklist[prop].exists) {
						return false;
					}
				}
	
				return true;
			},
			isBlendedFerment: function isBlendedFerment() {
				return this.ferment && this.ferment.blendComponents && this.ferment.blendComponents.data.length > 0;
			}
		},
	
		methods: {
			getLastIndex: function getLastIndex() {
				var lastIndex = -1;
	
				for (var i = 0; i < this.ferment.dailyData.data.length; ++i) {
					if (this.ferment.dailyData.data[i].baume) {
						lastIndex = i;
					}
				}
	
				return lastIndex;
			},
			getLastTemperature: function getLastTemperature() {
				var lastIndex = this.getLastIndex();
	
				if (lastIndex < 0) {
					return 'n/a';
				}
	
				if (this.ferment.dailyData.data[lastIndex].temp) {
					return parseFloat(this.ferment.dailyData.data[lastIndex].temp).toFixed(1);
				} else if (this.simulation.model) {
					return _units2.default.celsiusToFahrenheit(parseFloat(this.simulation.model.model_temperature[lastIndex].value)).toFixed(1);
				}
	
				return 'n/a';
			},
			getTemperatureUnit: function getTemperatureUnit() {
				return _units2.default.temperatureUnit();
			},
			getLastSugar: function getLastSugar() {
				var lastIndex = this.getLastIndex();
	
				if (lastIndex < 0) {
					return 'n/a';
				}
	
				return _units2.default.baumeToBrix(parseFloat(this.ferment.dailyData.data[lastIndex].baume)).toFixed(2);
			},
			getSugarUnit: function getSugarUnit() {
				return _units2.default.sugarUnit();
			},
			getPredictedDuration: function getPredictedDuration() {
				return this.simulation.completion_model;
			},
			getPredictedEndDate: function getPredictedEndDate() {
				return (0, _moment2.default)(this.ferment.start_date, 'DD/MM/YYYY hh:mm A').add(this.simulation.completion_model, 'days').format('DD/MM/YYYY');
			},
			getPredictedPeakDate: function getPredictedPeakDate() {
				return (0, _moment2.default)(this.ferment.start_date, 'DD/MM/YYYY hh:mm A').add(this.simulation.peak_rate_day, 'days').format('DD/MM/YYYY');
			},
			getPredictedPeakRate: function getPredictedPeakRate() {
				if (this.simulation && this.simulation.peak_rate) {
					return _units2.default.baumeToBrix(this.simulation.peak_rate).toFixed(2);
				}
	
				return 0;
			},
			getBaumeCount: function getBaumeCount() {
				var baumeCount = 0;
	
				for (var i = 0; i < this.ferment.dailyData.data.length; ++i) {
					if (this.ferment.dailyData.data[i].baume) {
						baumeCount++;
					}
				}
	
				return baumeCount;
			},
			hasEnoughBaume: function hasEnoughBaume() {
				return this.getBaumeCount() >= MIN_BAUME;
			},
			unableToSimulateWithData: function unableToSimulateWithData() {
				if (!this.ferment.dailyData.data) {
					this.unableToSimulateMessage = 'Ferment daily data are missing.';
					return true;
				}
	
				if (!this.ferment.duration) {
					this.unableToSimulateMessage = 'Ferment desired duration is missing.';
					return true;
				}
	
				if (!this.ferment.volume) {
					this.unableToSimulateMessage = 'Ferment volume is missing.';
					return true;
				}
	
				if (!this.hasEnoughBaume()) {
					this.unableToSimulateMessage = 'At least 4 baume entries are needed for prediction.';
				} else {
					this.unableToSimulateMessage = '';
				}
	
				return false;
			},
			loadGraph: function loadGraph() {
				var _this = this;
	
				var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
				var ferment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				if (this.chart) {
					this.chart.destroy();
	
					this.chart = null;
				}
	
				this.$store.dispatch(types.SET_SIMULATOR_RUNNING, true);
				this.reloading = true;
				this.nothingToSimulate = false;
				this.unableToSimulate = false;
	
				if (!this.ferment.simulated) {
					force = true;
				}
	
				this.$dispatch('clearSimulateTimeout');
	
				_vue2.default.nextTick(function () {
					$('.loading-graph').css('height', Math.ceil($('.loading-graph').width() / 1.501408451) + 'px');
				});
	
				if (!this.ferment.id) {
					this.reloading = false;
					this.nothingToSimulate = true;
	
					this.$store.dispatch(types.SET_SIMULATOR_RUNNING, false);
	
					return;
				} else if (this.isBlendedFerment) {
					this.reloading = false;
					this.unableToSimulate = false;
					this.$store.dispatch(types.SET_SIMULATOR_RUNNING, false);
	
					_vue2.default.nextTick(function () {
						_this.buildGraph('ferment-graph');
					});
	
					return;
				} else if (this.unableToSimulateWithData()) {
					this.reloading = false;
					this.unableToSimulate = true;
	
					this.$store.dispatch(types.SET_SIMULATOR_RUNNING, false);
	
					return;
				} else if (this.ferment.id && this.$route.name == 'ferments.what-if') {
					return this.runTemporarySimulation(this.site.id, this.ferment.id, {
						fresh: 'yes',
						ferment: {
							duration: this.ferment.duration,
							climate: this.ferment.climate,
							style: this.ferment.style,
							volume: this.ferment.volume,
							initial_cell_mass: this.ferment.initial_cell_mass,
							total_water_added: this.ferment.total_water_added,
							dailyData: this.ferment.dailyData
						}
					}).then(this.fetchBaselineSimulation, this.handleFailedSimulationResponse);
				} else if (this.ferment.id && this.$route.name == 'ferments.what-now' && ferment.id) {
					return this.runTemporarySimulation(this.site.id, this.ferment.id, { fresh: 'yes', ferment: ferment }).then(this.fetchBaselineSimulation, this.handleFailedSimulationResponse);
				}
	
				return this.runSimulation(this.site.id, this.ferment.id, force).then(this.handleSimulationResponse, this.handleFailedSimulationResponse);
			},
			fetchBaselineSimulation: function fetchBaselineSimulation(response) {
				var _this2 = this;
	
				if (!this.baselineSimulation) {
					this.runSimulation(this.site.id, this.ferment.id, false).then(function (baselineResponse) {
						_this2.baselineSimulation = baselineResponse.body.data;
	
						_this2.handleSimulationResponse(response);
					}, this.handleFailedSimulationResponse);
				} else {
					this.handleSimulationResponse(response);
				}
			},
			handleFailedSimulationResponse: function handleFailedSimulationResponse(response) {
				this.simulation = {};
	
				this.reloading = false;
				this.nothingToSimulate = false;
				this.unableToSimulate = false;
				this.failedToSimulate = true;
	
				this.$store.dispatch(types.SET_SIMULATOR_RUNNING, false);
			},
			handleSimulationResponse: function handleSimulationResponse(response) {
				var _this3 = this;
	
				if (!response.body.data) {
					this.handleFailedSimulationResponse(response);
	
					return;
				}
	
				this.simulation = response.body.data;
	
				this.reloading = false;
				this.nothingToSimulate = false;
				this.unableToSimulate = false;
				this.failedToSimulate = false;
	
				this.$store.dispatch(types.SET_SIMULATOR_RUNNING, false);
	
				_vue2.default.nextTick(function () {
					_this3.buildGraph('ferment-graph');
				});
			},
			buildGraph: function buildGraph(target) {
				if (!document.getElementById(target) || this.reloading) return;
	
				var datasets = this.getDataSets(),
				    labels = this.getLabels(),
				    canvas = document.getElementById(target),
				    context = canvas.getContext('2d');
	
				this.chart = new _chart2.default(context, {
					type: 'line',
					data: {
						labels: labels,
						datasets: datasets
					},
					options: {
						animation: {
							duration: 0,
							onComplete: function onComplete() {
								var globalCompositeOperation = context.globalCompositeOperation;
	
								context.globalCompositeOperation = 'destination-over';
								context.fillStyle = '#ffffff';
								context.fillRect(0, 0, canvas.width, canvas.height);
	
								context.globalCompositeOperation = globalCompositeOperation;
							}
						},
						responsive: true,
						maintainAspectRatio: true,
						tooltips: {
							mode: 'label'
						},
						hover: {
							mode: 'dataset'
						},
						scales: {
							xAxes: [{
								display: true,
								ticks: {
									callback: function callback(value, index, values) {
										if (value == 0) {
											return value;
										}
	
										return value % 5 == 0 ? value : null;
									},
	
									maxRotation: 0
								},
								gridLines: {
									display: true
								},
								scaleLabel: {
									display: true,
									labelString: 'Ferment Duration (days)'
								}
							}],
							yAxes: [{
								id: 'y1',
								display: true,
								scaleLabel: {
									display: true,
									labelString: this.isBlendedFerment ? this.sugarLabel + ', ' + this.temperatureLabel : this.sugarLabel + ', Active Cell Mass (g/L), ' + this.temperatureLabel
								},
								gridLines: {
									display: true
								},
								ticks: {
									suggestedMin: -2
								}
							}, {
								id: 'y2',
								display: !this.isBlendedFerment,
								scaleLabel: {
									display: true,
									labelString: this.fermentRateLabel
								},
								ticks: {
									beginAtZero: true
								},
								position: 'right',
								gridLines: {
									display: false
								}
							}]
						}
					}
				});
			},
			getXAxisLengthFromBlendComponents: function getXAxisLengthFromBlendComponents() {
				return _.maxBy(this.ferment.dailyData.data, 'day').day;
			},
			getEarliestStartDate: function getEarliestStartDate() {
				return (0, _moment2.default)(this.ferment.start_date, 'DD/MM/YYYY h A');
			},
			getLabelsFromBlendComponents: function getLabelsFromBlendComponents() {
				var xAxisLength = this.getXAxisLengthFromBlendComponents();
	
				return this.ferment.dailyData.data.filter(function (point) {
					return point.day <= xAxisLength;
				}).map(function (point) {
					return point.day;
				});
			},
			getDataSetsFromBlendComponents: function getDataSetsFromBlendComponents() {
				var _this4 = this;
	
				var datasets = [];
				var xAxisLength = this.getXAxisLengthFromBlendComponents();
				var colors = ['rgb(90, 146, 237, 0.3)', 'rgb(221, 184, 70, 0.3)', 'rgb(234, 99, 21, 0.3)', 'rgb(100, 153, 16, 0.3)', 'rgb(13, 184, 196, 0.3)', 'rgb(121, 33, 198, 0.3)', 'rgb(193, 66, 52, 0.3)'];
	
				var randomRgb = function randomRgb() {
					var alpha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
					var o = Math.round,
					    r = Math.random,
					    s = 255;
					return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + alpha + ')';
				};
	
				var measuringFrequency = 1 / this.ferment.measuring_freq_integer;
	
				var filterFermentDailyData = function filterFermentDailyData(ferment) {
					var indexOffset = Math.floor((0, _moment2.default)(ferment.start_date, 'DD/MM/YYYY h A').diff(_this4.getEarliestStartDate(), 'hours') / 24 / measuringFrequency);
	
					var data = ferment.dailyData.data.filter(function (point, index) {
						if (index + indexOffset >= 0) {
							return true;
						}
	
						return false;
					}).map(function (point) {
						if (point.baume !== null && !point.locked) {
							return parseFloat(point.baume).toFixed(4);
						}
	
						return null;
					});
	
					if (indexOffset > 0) {
						data.unshift.apply(data, (0, _toConsumableArray3.default)(_.fill(Array(indexOffset), null)));
					}
	
					return data;
				};
	
				datasets.push({
					label: 'Temperature',
					data: this.ferment.dailyData.data.map(function (data) {
						return data.temp ? data.temp : null;
					}),
					fill: false,
					borderColor: 'rgba(234, 72, 72, 0.8)',
					backgroundColor: 'rgba(234, 72, 72, 0.8)',
					pointBorderColor: 'rgba(234, 72, 72, 0.8)',
					pointBackgroundColor: 'rgba(234, 72, 72, 0.8)',
					pointRadius: 0,
					pointHoverRadius: 0,
					yAxisID: 'y1',
					spanGaps: true,
					lineTension: 0.20
				}, {
					label: '' + this.ferment.wine_name,
					data: filterFermentDailyData(this.ferment),
					fill: false,
					borderColor: 'rgb(65, 124, 226, 0.8)',
					backgroundColor: 'rgb(65, 124, 226, 0.8)',
					pointBorderColor: 'rgb(65, 124, 226, 0.8)',
					pointBackgroundColor: 'rgb(65, 124, 226, 0.8)',
					pointBorderWidth: 3,
					showLine: false,
					pointStyle: 'circle',
					spanGaps: true,
					yAxisID: 'y1'
				});
	
				_.each(this.ferment.blendComponents.data, function (ferment, index) {
					var color = index in colors ? colors[index] : randomRgb(0.3);
	
					datasets.push({
						label: 'ex ' + ferment.fermenter.data.name,
						data: filterFermentDailyData(ferment).map(_units2.default.baumeToBrix),
						fill: false,
						borderColor: color,
						backgroundColor: color,
						pointBorderColor: color,
						pointBackgroundColor: color,
						pointBorderWidth: 3,
						showLine: false,
						pointStyle: 'circle',
						spanGaps: true,
						yAxisID: 'y1'
					});
				});
	
				return datasets;
			},
			getLabels: function getLabels() {
				if (this.isBlendedFerment) {
					return this.getLabelsFromBlendComponents();
				}
	
				var data = void 0,
				    xAxisLength = this.getXAxisLength();
	
				if (this.baselineSimulation && this.baselineSimulation.model.baume.slice(-1)[0].day < this.simulation.model.baume.slice(-1)[0].day) {
					data = this.baselineSimulation;
				} else {
					data = this.simulation;
				}
	
				return data.model.baume.filter(function (point) {
					return point.day <= xAxisLength;
				}).map(function (point) {
					return point.day;
				});
			},
			getDataSets: function getDataSets() {
				var datasets = [];
	
				if (this.isBlendedFerment) {
					return this.getDataSetsFromBlendComponents();
				}
	
				if ((this.$route.name == 'ferments.what-if' || this.$route.name == 'ferments.what-now') && this.baselineSimulation) {
					if (this.$route.name == 'ferments.what-if') {
						datasets.push({
							label: 'Baseline ' + this.sugarLabel + ' (Actual)',
							data: this.getDataFromSimulation('baume_actual', this.baselineSimulation).map(_units2.default.baumeToBrix),
							fill: false,
							borderColor: 'rgba(106, 133, 145, 0.3)',
							backgroundColor: 'rgba(106, 133, 145, 0.3)',
							pointBorderColor: 'rgba(106, 133, 145, 0.3)',
							pointBackgroundColor: 'rgba(106, 133, 145, 0.3)',
							pointBorderWidth: 5,
							showLine: false,
							pointStyle: 'rectRot',
							spanGaps: true,
							yAxisID: 'y1'
						}, {
							label: 'Ferment Rate',
							data: this.getDataFromSimulation('ferment_derivative').map(_units2.default.baumeToBrix),
							fill: false,
							borderColor: 'rgba(153, 120, 188, .8)',
							backgroundColor: 'rgba(153, 120, 188, .8)',
							pointBorderColor: 'rgba(153, 120, 188, .8)',
							pointBackgroundColor: 'rgba(153, 120, 188, .8)',
							pointRadius: 0,
							pointHoverRadius: 0,
							yAxisID: 'y2'
						});
					}
	
					datasets.push({
						label: 'Baseline ' + this.sugarLabel + ' (Predicted)',
						data: this.getDataFromSimulation('baume', this.baselineSimulation).map(_units2.default.baumeToBrix),
						fill: false,
						borderColor: 'rgba(63, 132, 121, 0.3)',
						backgroundColor: 'rgba(63, 132, 121, 0.3)',
						pointBorderColor: 'rgba(63, 132, 121, 0.3)',
						pointBackgroundColor: 'rgba(63, 132, 121, 0.3)',
						pointBorderWidth: 1,
						pointRadius: 0,
						pointHoverRadius: 0,
						yAxisID: 'y1'
					});
	
					datasets.push({
						label: 'Baseline ' + this.temperatureLabel,
						data: this.getDataFromSimulation('corrected_temperature', this.baselineSimulation).map(_units2.default.celsiusToFahrenheit),
						fill: false,
						borderColor: 'rgba(234, 72, 72, 0.3)',
						backgroundColor: 'rgba(234, 72, 72, 0.3)',
						pointBorderColor: 'rgba(234, 72, 72, 0.3)',
						pointBackgroundColor: 'rgba(234, 72, 72, 0.3)',
						pointBorderWidth: 1,
						pointRadius: 0,
						pointHoverRadius: 0,
						yAxisID: 'y2'
					});
				}
	
				datasets.push({
					label: this.sugarLabel + ' (Actual)',
					data: this.getDataFromSimulation('baume_actual').map(_units2.default.baumeToBrix),
					fill: false,
					borderColor: 'rgba(98, 141, 188, 0.9)',
					backgroundColor: 'rgba(98, 141, 188, 0.9)',
					pointBorderColor: 'rgba(98, 141, 188, 0.9)',
					pointBackgroundColor: 'rgba(98, 141, 188, 0.9)',
					pointBorderWidth: 7,
					showLine: false,
					pointStyle: 'rectRot',
					spanGaps: true,
					yAxisID: 'y1'
				}, {
					label: this.temperatureLabel,
					data: this.getDataFromSimulation('corrected_temperature').map(_units2.default.celsiusToFahrenheit),
					fill: false,
					borderColor: 'rgba(234, 72, 72, 0.8)',
					backgroundColor: 'rgba(234, 72, 72, 0.8)',
					pointBorderColor: 'rgba(234, 72, 72, 0.8)',
					pointBackgroundColor: 'rgba(234, 72, 72, 0.8)',
					pointRadius: 0,
					pointHoverRadius: 0,
					yAxisID: 'y1'
				});
	
				if (this.hasEnoughBaume()) {
					datasets.push({
						label: this.sugarLabel + ' (Predicted)',
						data: this.getDataFromSimulation('baume').map(_units2.default.baumeToBrix),
						fill: false,
						borderColor: 'rgba(63, 132, 121, 0.9)',
						backgroundColor: 'rgba(63, 132, 121, 0.9)',
						pointBorderColor: 'rgba(63, 132, 121, 0.9)',
						pointBackgroundColor: 'rgba(63, 132, 121, 0.9)',
						pointBorderWidth: 1,
						pointRadius: 0,
						pointHoverRadius: 0,
						yAxisID: 'y1'
					});
	
					if (this.$route.name == 'ferments.index') {
						datasets.push({
							label: this.sugarLabel + ' (High)',
							data: this.getDataFromSimulation('high_range').map(_units2.default.baumeToBrix),
							fill: false,
							borderColor: 'rgba(63, 132, 121, 0.4)',
							backgroundColor: 'rgba(63, 132, 121, 0.4)',
							pointBorderColor: 'rgba(63, 132, 121, 0.4)',
							pointBackgroundColor: 'rgba(63, 132, 121, 0.4)',
							pointBorderWidth: 1,
							pointRadius: 0,
							pointHoverRadius: 0,
							yAxisID: 'y1'
						}, {
							label: this.sugarLabel + ' (Low)',
							data: this.getDataFromSimulation('low_range').map(_units2.default.baumeToBrix),
							fill: false,
							borderColor: 'rgba(63, 132, 121, 0.4)',
							backgroundColor: 'rgba(63, 132, 121, 0.4)',
							pointBorderColor: 'rgba(63, 132, 121, 0.4)',
							pointBackgroundColor: 'rgba(63, 132, 121, 0.4)',
							pointBorderWidth: 1,
							pointRadius: 0,
							pointHoverRadius: 0,
							yAxisID: 'y1'
						});
					}
	
					datasets.push({
						label: 'Active Cells',
						data: this.getDataFromSimulation('active_cell_mass'),
						fill: false,
						borderColor: 'rgba(229, 201, 87, 0.8)',
						backgroundColor: 'rgba(229, 201, 87, 0.8)',
						pointBorderColor: 'rgba(229, 201, 87, 0.8)',
						pointBackgroundColor: 'rgba(229, 201, 87, 0.8)',
						pointBorderWidth: 1,
						pointRadius: 0,
						pointHoverRadius: 0,
						yAxisID: 'y1'
					}, {
						label: 'Ferment Rate',
						data: this.getDataFromSimulation('ferment_derivative').map(_units2.default.baumeToBrix),
						fill: false,
						borderColor: 'rgba(153, 120, 188, .8)',
						backgroundColor: 'rgba(153, 120, 188, .8)',
						pointBorderColor: 'rgba(153, 120, 188, .8)',
						pointBackgroundColor: 'rgba(153, 120, 188, .8)',
						pointRadius: 0,
						pointHoverRadius: 0,
						yAxisID: 'y2'
					});
				}
	
				return datasets;
			},
			getXAxisLength: function getXAxisLength() {
				var length = 0;
	
				if (this.baselineSimulation) {
					length = this.baselineSimulation.model.baume.slice(-1)[0].day;
				}
	
				if (!this.baselineSimulation || length > this.simulation.model.baume.slice(-1)[0].day) {
					length = this.simulation.model.baume.slice(-1)[0].day;
				}
	
				return length;
			},
			getDataFromSimulation: function getDataFromSimulation(type) {
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
				if (!data) {
					data = this.simulation;
				}
	
				var xAxisLength = this.getXAxisLength();
	
				return data.model[type].filter(function (point) {
					return point.day <= xAxisLength;
				}).map(function (point) {
					if (point.value !== null) {
						return parseFloat(point.value).toFixed(4);
					}
	
					return null;
				});
			}
		}
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(22);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getters = __webpack_require__(2);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			getters: {
				ferment: _getters.ferment,
				fermenter: _getters.fermenter,
				graphBase64: _getters.graphBase64,
				simulatorRunning: _getters.simulatorRunning
			}
		},
	
		data: function data() {
			return {};
		},
		ready: function ready() {},
	
	
		methods: {
			download: function download(format) {
				var path = _http2.default.buildPath('ferments/' + this.ferment.id + '/export-' + format);
	
				this.$dispatch('generateBase64');
	
				$('#download-ferment').find('input[name=graph]').val(this.graphBase64).next().val((0, _stringify2.default)({
					duration: this.ferment.duration,
					climate: this.ferment.climate,
					style: this.ferment.style,
					volume: this.ferment.volume,
					initial_cell_mass: this.ferment.initial_cell_mass,
					total_water_added: this.ferment.total_water_added,
					dailyData: this.ferment.dailyData
				})).parent().attr('action', path).submit();
			}
		}
	};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	exports.default = {
		vuex: {
			getters: {
				simulatorRunning: _getters.simulatorRunning,
				whatNow: _getters.whatNow,
				ferment: _getters.ferment,
				fermenter: _getters.fermenter,
				loading: _getters.loading
			},
	
			actions: {
				allWhatNow: _actions.Settings.allWhatNow
			}
		},
	
		data: function data() {
			return {
				updateTimeout: null,
				simulateTimeout: null,
				actions: {
					pump_over: false,
					reinoculate: null,
					dap: null,
					agitator: null,
					temperature: null
				}
			};
		},
	
	
		watch: {
			simulatorRunning: function simulatorRunning(running) {
				$('.slider.xdsoft').range2DSlider({ disabled: running });
			}
		},
	
		events: {
			initialize: function initialize() {
				this.boot();
			}
		},
	
		ready: function ready() {},
	
	
		methods: {
			boot: function boot() {
				var _this = this;
	
				this.allWhatNow().then(function () {
					_this.actions.temperature = _this.getLastTemperature();
					_this.actions.dap = _this.whatNow.dap_low;
					_this.actions.agitator = _this.whatNow.agitator_low;
					_this.actions.reinoculate = _this.whatNow.reinoculate_low;
	
					[{ id: 'what-now-temperature', ranges: [parseFloat(_this.whatNow.temperature_low), parseFloat(_this.whatNow.temperature_high)] }, { id: 'what-now-add-dap', ranges: [parseFloat(_this.whatNow.dap_low), parseFloat(_this.whatNow.dap_high)] }, { id: 'what-now-agitator', ranges: [parseFloat(_this.whatNow.agitator_low), parseFloat(_this.whatNow.agitator_high)] }, { id: 'what-now-reinoculate', ranges: [parseFloat(_this.whatNow.reinoculate_low), parseFloat(_this.whatNow.reinoculate_high)] }].forEach(function (slider) {
						$('#' + slider.id).range2DSlider({
							grid: true,
							height: 0,
							round: true,
							disabled: false,
							className: 'xdsoft_custom',
							showLegend: [1, 0],
							axis: [slider.ranges],
							tooltip: ['top'],
							alwShowTooltip: [true],
							allowAxisMove: ['x'],
							printLabel: function printLabel(val) {
								return parseFloat(val[0]).toFixed(0);
							},
							printValue: function printValue(val) {
								return parseFloat(val[0][0]).toFixed(0);
							}
						});
					});
	
					$('#what-now-temperature').range2DSlider({ value: [[_this.getLastTemperature(), 0]] });
	
					_this.$watch('actions', function (actions) {
						clearTimeout(_this.updateTimeout);
	
						if (_this.simulateTimeout) {
							_this.$dispatch('clearGraphCountdown');
	
							clearTimeout(_this.simulateTimeout);
						}
	
						_this.updateTimeout = setTimeout(function () {
							_this.$dispatch('reloadGraphCountdown', 5);
	
							_this.simulateTimeout = setTimeout(function () {
								_this.runSimulation();
							}, 5000);
						}, 1500);
					}, { deep: true });
				});
			},
			runSimulation: function runSimulation() {
				this.$dispatch('clearGraphCountdown');
	
				clearTimeout(this.simulateTimeout);
				clearTimeout(this.updateTimeout);
	
				var clone = $.extend(true, {}, this.ferment);
	
				clone.dailyData.data.push({
					day: parseFloat(clone.dailyData.data[clone.dailyData.data.length - 1].day) + 1,
					action: {
						data: {
							agitator: this.actions.agitator,
							dap: this.actions.dap,
							pump_over: this.actions.pump_over,
							reinoculate: this.actions.reinoculate
						}
					},
					analysis: {
						data: {}
					},
					temp: this.actions.temperature
				});
	
				this.$dispatch('reloadGraph', true, clone);
			},
			getLastTemperature: function getLastTemperature() {
				var lastIndex = this.ferment.dailyData.data.length - (this.ferment.dailyData.data.length == 1 ? 1 : 2),
				    lastTemperature = parseFloat(this.ferment.dailyData.data[lastIndex].temp);
	
				return lastTemperature || this.whatNow.temperature_low;
			}
		}
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(4);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
		components: {},
	
		vuex: {
			getters: {
				site: _getters.site,
				ferments: _getters.ferments,
				fermenters: _getters.fermenters,
				loading: _getters.loading,
				varietals: _getters.varietals,
				yeastTypes: _getters.yeastTypes,
				eventLoading: _getters.eventLoading
			},
	
			actions: {
				allFerments: _actions.Ferments.all,
				allFermenters: _actions.Fermenters.all,
				exportHistory: _actions.Fermenters.exportHistory,
				allVarietals: _actions.Settings.allVarietals,
				allYeastTypes: _actions.Settings.allYeastTypes
			}
		},
	
		route: {
			canReuse: false,
	
			data: function data() {
				var _this = this;
	
				this.$dispatch('loading');
	
				var that = this;
				this.allFerments(this.site.id, ['fermenter', 'gauge'], { archived: 1 }).then(function () {
					if (_this.ferments) {
						_this.ferments.forEach(function (ferment) {
							ferment.start_date = (0, _moment2.default)(ferment.start_date, 'DD/MM/YYYY hh:mm').format('DD/MM/YYYY');
							var year = (0, _moment2.default)(ferment.start_date, 'DD/MM/YYYY').year();
							var found = _this.vintageOptions.some(function (option) {
								return option.value === year;
							});
							if (!found) {
	
								_this.vintageOptions.push({
									name: year,
									value: year
								});
							}
							_this.filteredFerments = _this.ferments;
							_this.fermentsToExport = _this.filteredFerments.map(function (ferment) {
								return ferment.id;
							});
						});
					}
	
					_this.loaded.push('ferments');
				});
	
				this.allVarietals().then(function () {
					_this.varietalOptions = _this.varietals.map(function (varietal) {
						return { name: varietal.name, value: varietal.id };
					});
	
					_this.loaded.push('varietals');
				});
	
				this.allYeastTypes().then(function () {
					_this.yeastTypeOptions = _this.yeastTypes.map(function (yeastType) {
						return { name: yeastType.name, value: yeastType.id };
					});
	
					_this.loaded.push('yeast-types');
				});
	
				this.allFermenters(this.site.id).then(function () {
					_this.fermenterOptions = _this.fermenters.map(function (fermenter) {
						return { name: fermenter.name, value: fermenter.id };
					});
	
					_this.loaded.push('fermenters');
				});
			}
		},
	
		data: function data() {
			return {
				loaded: [],
				filters: {
					varietal_id: '',
					yeast_type_id: '',
					vintage: '',
					performance: '',
					fermenter_id: ''
				},
				varietalOptions: [],
				yeastTypeOptions: [],
				fermenterOptions: [],
				filteredFerments: [],
				vintageOptions: [],
				fermentsToExport: [],
				performanceOptions: [{
					name: 'Low Range On Spec',
					value: 10
				}, {
					name: 'High Range on Spec',
					value: 20
				}, {
					name: 'Sluggish',
					value: 30
				}, {
					name: 'Rapid',
					value: 40
				}],
				searchTerm: '',
				Http: _http2.default,
				moment: _moment2.default
			};
		},
	
	
		watch: {
			loaded: function loaded() {
				if (this.loaded.length == 4) {
					this.$dispatch('loaded');
	
					this.boot();
				}
			}
		},
	
		methods: {
			search: function search() {
				var _this2 = this;
	
				if (!this.ferments) return;
	
				$('#table-history-search').dataTable().fnDestroy();
	
				this.filteredFerments = this.ferments.filter(function (ferment) {
					if (_this2.filters.varietal_id && _this2.filters.varietal_id != ferment.varietal_id) return false;
	
					if (_this2.filters.yeast_type_id && _this2.filters.yeast_type_id != ferment.yeast_type_id) return false;
	
					if (_this2.filters.fermenter_id && _this2.filters.fermenter_id != ferment.fermenter_id) return false;
	
					if (_this2.filters.vintage && _this2.filters.vintage != (0, _moment2.default)(ferment.start_date, 'DD/MM/YYYY hh:mm').year()) return false;
	
					if (_this2.filters.performance && _this2.filters.performance != ferment.gauge.data.status) return false;
	
					if (_this2.$options.filters.filterBy(ferment, _this2.searchTerm).length == 0) return false;
	
					return true;
				});
	
				this.fermentsToExport = this.filteredFerments.map(function (ferment) {
					return ferment.id;
				});
	
				this.boot();
			},
			resetFilters: function resetFilters() {
				this.filters = {
					varietal_id: '',
					yeast_type_id: '',
					vintage: '',
					performance: '',
					fermenter_id: ''
				};
	
				this.searchTerm = '';
	
				this.search();
			},
			boot: function boot() {
				_vue2.default.nextTick(function () {
					$('#table-history-search').dataTable({
						'bPaginate': true,
						'bLengthChange': false,
						'bFilter': false,
						'bSort': true,
						'bInfo': true,
						'bAutoWidth': false,
						'responsive': true,
						'language': {
							'emptyTable': 'No archived ferments.'
						}
					});
				});
			}
		}
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var isAuthenticated = sessionStorage.getItem('token');
	
	exports.default = {
	  data: function data() {
	    return {
	      isAuthenticated: isAuthenticated
	    };
	  },
	  ready: function ready() {
	    $("#skin-select").affix({
	      offset: 60
	    });
	  },
	
	
	  vuex: {
	    getters: {
	      tankGroups: _getters.tankGroups,
	      authorized: _getters.authorized
	    }
	  }
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _profileForm = __webpack_require__(514);
	
	var _profileForm2 = _interopRequireDefault(_profileForm);
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			ProfileForm: _profileForm2.default
		},
	
		vuex: {
			actions: {
				all: _actions.Profiles.all,
				clear: _actions.Profiles.clear,
				edit: _actions.Profiles.edit,
				reposition: _actions.Profiles.reposition,
				setTitle: _actions.App.title
			},
			getters: {
				loading: _getters.loading,
				site: _getters.site,
				activeProfile: _getters.profile,
				profiles: _getters.profiles,
				simulatorSetup: _getters.simulatorSetup
			}
		},
	
		watch: {
			activeProfile: function activeProfile() {
				this.profile = $.extend({}, this.activeProfile);
			}
		},
	
		data: function data() {
			return {
				profile: {
					id: null,
					name: '',
					profile: 0,
					duration: 0,
					type: 1,
					dailyData: {
						data: []
					}
				}
			};
		},
	
	
		route: {
			activate: function activate() {
				this.$dispatch('loading');
			},
			data: function data() {
				var _this = this;
	
				this.all(this.site.id).then(function () {
					_this.$dispatch('loaded');
				});
			}
		},
	
		ready: function ready() {
			var _this2 = this;
	
			this.setTitle('Ferment Profiles');
	
			$('.sortable').nestedSortable({
				handle: 'div',
				items: 'li',
				isTree: true,
				maxLevels: 2,
				toleranceElement: '> div',
				protectRoot: true,
				relocate: function relocate(event) {
					var hierarchy = $('.sortable').nestedSortable('toHierarchy', { startDepthCount: 0 });
	
					hierarchy.forEach(function (parent) {
						delete parent['nestedSortable-item'];
					});
	
					_this2.reposition(_this2.site.id, hierarchy).then(function (response) {
						_notify2.default.success('Profiles have been sorted.', { timeout: 2000 });
					});
				}
			});
	
			$('#upload-temperature-profile').on('change', this.handleTemperatureProfileSelect);
		},
	
	
		methods: {
			createNewProfile: function createNewProfile() {
				this.clear();
	
				$('input[id=name]').focus();
			},
			handleTemperatureProfileSelect: function handleTemperatureProfileSelect(event) {
				var _this3 = this;
	
				var file = event.target.files[0],
				    reader = new FileReader();
	
				reader.readAsText(file);
	
				this.clear();
	
				reader.onload = function (event) {
					var dailyData = void 0;
	
					try {
						dailyData = $.csv.toObjects(event.target.result);
					} catch (e) {
						_this3.failedTemperatureProfileImport('Failed to import temperature profile. The selected file was not a valid exported temperature profile.');
	
						return;
					}
	
					if (dailyData.length > 1) {
						var dayDifference = parseFloat(dailyData[1].day) - parseFloat(dailyData[0].day);
	
						if (dayDifference == 0.5) {
							if (_this3.simulatorSetup.red_sampling_freq) {
								_this3.profile.type = true;
							} else if (_this3.simulatorSetup.white_sampling_freq) {
								_this3.profile.type = false;
							} else {
								_this3.failedTemperatureProfileImport();
	
								return;
							}
						} else if (dayDifference == 1) {
							if (!_this3.simulatorSetup.white_sampling_freq) {
								_this3.profile.type = false;
							} else if (!_this3.simulatorSetup.red_sampling_freq) {
								_this3.profile.type = true;
							} else {
								_this3.failedTemperatureProfileImport();
	
								return;
							}
						} else {
							_this3.failedTemperatureProfileImport('Failed to import temperature profile. The selected file was not a valid exported temperature profile.');
	
							return;
						}
					}
	
					_this3.profile.dailyData.data = [];
	
					for (var i = 0; i < dailyData.length; ++i) {
						_this3.profile.dailyData.data.push({
							id: null,
							day: dailyData[i].day,
							baume: null,
							temp: dailyData[i].temp,
							comments: dailyData[i].comments,
							action: {
								data: {
									acid: dailyData[i].acid,
									aeration: dailyData[i].aeration,
									agitator: dailyData[i].agitator,
									dap: dailyData[i].dap,
									pump_over: dailyData[i].pump_over,
									reinoculate: dailyData[i].reinoculate,
									juice: dailyData[i].juice
								}
							},
							analysis: {
								data: {
									cell_count: dailyData[i].cell_count,
									fs02: dailyData[i].fs02,
									gf: dailyData[i].gf,
									ntu: dailyData[i].ntu,
									ph: dailyData[i].ph,
									ta: dailyData[i].ta,
									ts02: dailyData[i].ts02
								}
							}
						});
					}
	
					_notify2.default.success('Temperature profile imported.');
				};
			},
			failedTemperatureProfileImport: function failedTemperatureProfileImport() {
				_alert2.default.error({ text: 'Failed to import temperature profile. Please check the sampling frequency of the exported profile.', title: 'Invalid File' });
			}
		}
	};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _dailyData = __webpack_require__(210);
	
	var _dailyData2 = _interopRequireDefault(_dailyData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			DailyData: _dailyData2.default
		},
	
		data: function data() {
			return {
				timeouts: {
					profile: null,
					dailyData: null
				},
				oldProfile: {}
			};
		},
	
	
		vuex: {
			actions: {
				all: _actions.Profiles.all,
				store: _actions.Profiles.store,
				update: _actions.Profiles.update,
				edit: _actions.Profiles.edit,
				destroy: _actions.Profiles.destroy,
				clear: _actions.Profiles.clear
			},
			getters: {
				site: _getters.site,
				simulator: _getters.simulatorSetup
			}
		},
	
		computed: {
			measuringFreqInteger: function measuringFreqInteger() {
				if (this.simulator) {
					return this.profile.type ? this.simulator.red_sampling_freq : this.simulator.white_sampling_freq;
				}
	
				return null;
			}
		},
	
		props: ['profile'],
	
		ready: function ready() {},
	
	
		watch: {
			profile: {
				handler: 'handleProfileChanges',
				deep: true
			}
		},
	
		methods: {
			handleProfileChanges: function handleProfileChanges(value, old) {
				var _this = this;
	
				if (this.profile.name == undefined || this.profile.name == '' || value.id != old.id) {
					return;
				}
	
				clearTimeout(this.timeouts.profile);
	
				this.timeouts.profile = setTimeout(function () {
					_this.saveOrCreate();
				}, 1250);
			},
			saveOrCreate: function saveOrCreate() {
				if (this.profile.id == null) {
					this.create();
				} else {
					this.save();
				}
			},
			create: function create() {
				return this.store(this.site.id, this.profile).then(function (response) {
					_notify2.default.success('New ferment profile added.');
				});
			},
			save: function save() {
				var _this2 = this;
	
				return this.update(this.site.id, this.profile).then(function (response) {
					_this2.all(_this2.site.id);
	
					_notify2.default.success('Ferment profile updated.');
				});
			},
			delete: function _delete() {
				var _this3 = this;
	
				var self = this;
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroy(self.site.id, self.profile.id);
					}
				}).then(function () {
					_this3.clear();
	
					_this3.all(_this3.site.id);
	
					_alert2.default.success({ text: 'Profile has been deleted.' }).then(function () {}, function () {});
				}, function () {});
			}
		}
	};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _whatNow = __webpack_require__(518);
	
	var _whatNow2 = _interopRequireDefault(_whatNow);
	
	var _varietals = __webpack_require__(517);
	
	var _varietals2 = _interopRequireDefault(_varietals);
	
	var _yeastTypes = __webpack_require__(519);
	
	var _yeastTypes2 = _interopRequireDefault(_yeastTypes);
	
	var _regions = __webpack_require__(516);
	
	var _regions2 = _interopRequireDefault(_regions);
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			WhatNow: _whatNow2.default,
			YeastTypes: _yeastTypes2.default,
			Varietals: _varietals2.default,
			Regions: _regions2.default
		},
	
		vuex: {
			actions: {
				setTitle: _actions.App.title
			},
			getters: {
				authorized: _getters.authorized
			}
		},
	
		ready: function ready() {
			this.setTitle('Admin Settings');
	
			if (this.authorized.access < 30) {
				this.$router.go({ name: 'dashboard' });
	
				_notify2.default.error('You do not have the required permissions.');
			} else {
				this.ready = true;
			}
		},
		data: function data() {
			return {
				ready: false,
				exportPath: _http2.default.buildPath('export-database')
			};
		},
	
	
		methods: {
			exportDb: function exportDb() {
				_http2.default.get('export-database').then(function (response) {}).catch(function (error) {
					console.warn(error);
				});
			}
		}
	};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			getters: {
				regions: _getters.regions,
				countries: _getters.countries
			},
			actions: {
				allRegions: _actions.Settings.allRegions,
				allCountries: _actions.Settings.allCountries,
				storeRegion: _actions.Settings.storeRegion,
				destroyRegion: _actions.Settings.destroyRegion,
				editRegion: _actions.Settings.editRegion
			}
		},
	
		data: function data() {
			return {
				name: null,
				country: 13,
				loading: false
			};
		},
		created: function created() {
			var _this = this;
	
			this.loading = true;
	
			this.allCountries().then(function (response) {
				_this.loading = false;
				_this.country = 13;
	
				_this.getRegions(_this.country);
			});
		},
	
	
		watch: {
			country: function country(val) {
				if (val) {
					this.getRegions(val);
				}
			}
		},
	
		methods: {
			getRegions: function getRegions(country) {
				var _this2 = this;
	
				this.loading = true;
	
				this.allRegions({ country_id: country }).then(function (response) {
					_this2.loading = false;
				});
			},
			save: function save() {
				var _this3 = this;
	
				this.storeRegion(this.name, this.country).then(function () {
					_notify2.default.success('New region added.');
					_this3.name = '';
				}, function () {
					_notify2.default.warning('Region could not be added.');
				});
			},
			remove: function remove(region) {
				var self = this;
	
				if (region.has_ferments) {
					_alert2.default.custom({
						title: 'Region in use!',
						text: 'This region is still in use in the database. Choose a new name for all instances to delete it from the list.',
						input: 'text',
						showCancelButton: true,
						confirmButtonText: 'OK',
						showLoaderOnConfirm: true,
						inputPlaceholder: 'Rename region',
						preConfirm: function preConfirm(name) {
							return self.editRegion(region.id, name).then(function (response) {}, function (response) {
								if (response.body.status_code == 422) {
									throw response.body.errors.name.pop();
								}
	
								throw 'Server has rejected the request.';
							});
						}
					}).then(function (name) {
						_alert2.default.success({ text: 'Region has been renamed.' });
					});
	
					return;
				}
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroyRegion(region.id);
					}
				}).then(function () {
					_alert2.default.success({ text: 'Region has been deleted.' }).then(function () {}, function () {});
				}, function () {});
			}
		}
	};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			getters: {
				varietals: _getters.varietals
			},
			actions: {
				allVarietals: _actions.Settings.allVarietals,
				storeVarietal: _actions.Settings.storeVarietal,
				destroyVarietal: _actions.Settings.destroyVarietal,
				editVarietal: _actions.Settings.editVarietal
			}
		},
	
		data: function data() {
			return {
				name: null,
				loading: false
			};
		},
		created: function created() {
			var _this = this;
	
			this.loading = true;
	
			this.allVarietals().then(function (response) {
				_this.loading = false;
			});
		},
		ready: function ready() {},
	
	
		methods: {
			save: function save() {
				var _this2 = this;
	
				this.storeVarietal(this.name).then(function () {
					_notify2.default.success('New varietal added.');
	
					_this2.name = '';
				}, function () {
					_notify2.default.warning('Varietal could not be added.');
				});
			},
			remove: function remove(varietal) {
				var self = this;
	
				if (varietal.has_ferments) {
					_alert2.default.custom({
						title: 'Varietal in use!',
						text: 'This varietal is still in use in the database. Choose a new name for all instances to delete it from the list.',
						input: 'text',
						showCancelButton: true,
						confirmButtonText: 'OK',
						showLoaderOnConfirm: true,
						inputPlaceholder: 'Rename varietal',
						preConfirm: function preConfirm(name) {
							return self.editVarietal(varietal.id, name).then(function (response) {}, function (response) {
								if (response.body.status_code == 422) {
									throw response.body.errors.name.pop();
								}
	
								throw 'Server has rejected the request.';
							});
						}
					}).then(function (name) {
						_alert2.default.success({ text: 'Varietal has been renamed.' });
					});
	
					return;
				}
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroyVarietal(varietal.id);
					}
				}).then(function () {
					_alert2.default.success({ text: 'Varietal has been deleted.' }).then(function () {}, function () {});
				}, function () {});
			}
		}
	};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			getters: {
				whatNow: _getters.whatNow
			},
			actions: {
				allWhatNow: _actions.Settings.allWhatNow,
				updateWhatNow: _actions.Settings.updateWhatNow
			}
		},
	
		data: function data() {
			return {
				dictionary: {
					temperature_high: 'Temperature High',
					temperature_low: 'Temperature Low',
					dap_high: 'DAP High',
					dap_low: 'DAP Low',
					reinoculate_high: 'Reinoculate High',
					reinoculate_low: 'Reinoculate Low',
					agitator_high: 'Agitator High',
					agitator_low: 'Agitator Low'
				},
				timeouts: {
					temperature_high: null,
					temperature_low: null,
					dap_high: null,
					dap_low: null,
					reinoculate_high: null,
					reinoculate_low: null,
					agitator_high: null,
					agitator_low: null
				}
			};
		},
		created: function created() {
			var _this = this;
	
			this.allWhatNow().then(function () {
				_this.$watch('whatNow.temperature_low', function (value) {
					return _this.save('temperature_low', value);
				});
				_this.$watch('whatNow.temperature_high', function (value) {
					return _this.save('temperature_high', value);
				});
				_this.$watch('whatNow.dap_low', function (value) {
					return _this.save('dap_low', value);
				});
				_this.$watch('whatNow.dap_high', function (value) {
					return _this.save('dap_high', value);
				});
				_this.$watch('whatNow.reinoculate_low', function (value) {
					return _this.save('reinoculate_low', value);
				});
				_this.$watch('whatNow.reinoculate_high', function (value) {
					return _this.save('reinoculate_high', value);
				});
				_this.$watch('whatNow.agitator_low', function (value) {
					return _this.save('agitator_low', value);
				});
				_this.$watch('whatNow.agitator_high', function (value) {
					return _this.save('agitator_high', value);
				});
			});
		},
		ready: function ready() {},
	
	
		methods: {
			save: function save(name, value) {
				var _this2 = this;
	
				if (this.timeouts[name]) {
					clearTimeout(this.timeouts[name]);
				}
	
				this.timeouts[name] = setTimeout(function () {
					_this2.updateWhatNow(name, value).then(function () {
						_notify2.default.success(_this2.dictionary[name] + ' has been updated.', { timeout: 2500 });
					});
				}, 1250);
			}
		}
	};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			getters: {
				yeastTypes: _getters.yeastTypes
			},
			actions: {
				allYeastTypes: _actions.Settings.allYeastTypes,
				storeYeastType: _actions.Settings.storeYeastType,
				destroyYeastType: _actions.Settings.destroyYeastType,
				editYeastType: _actions.Settings.editYeastType
			}
		},
	
		data: function data() {
			return {
				name: null,
				loading: false
			};
		},
		created: function created() {
			var _this = this;
	
			this.loading = true;
	
			this.allYeastTypes().then(function (response) {
				_this.loading = false;
			});
		},
		ready: function ready() {},
	
	
		methods: {
			save: function save() {
				var _this2 = this;
	
				this.storeYeastType(this.name).then(function () {
					_notify2.default.success('New yeast type added.');
	
					_this2.name = '';
				}, function () {
					_notify2.default.warning('Yeast type could not be added.');
				});
			},
			remove: function remove(yeastType) {
				var self = this;
	
				if (yeastType.has_ferments) {
					_alert2.default.custom({
						title: 'Yeast Type in use!',
						text: 'This yeast type is still in use in the database. Choose a new name for all instances to delete it from the list.',
						input: 'text',
						showCancelButton: true,
						confirmButtonText: 'OK',
						showLoaderOnConfirm: true,
						inputPlaceholder: 'Rename yeast type',
						preConfirm: function preConfirm(name) {
							return self.editYeastType(yeastType.id, name).then(function (response) {}, function (response) {
								if (response.body.status_code == 422) {
									throw response.body.errors.name.pop();
								}
	
								throw 'Server has rejected the request.';
							});
						}
					}).then(function (name) {
						_alert2.default.success({ text: 'Yeast type has been renamed.' });
					});
	
					return;
				}
	
				_alert2.default.delete({
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return self.destroyYeastType(yeastType.id);
					}
				}).then(function () {
					_alert2.default.success({ text: 'Yeast type has been deleted.' }).then(function () {}, function () {});
				}, function () {});
			}
		}
	};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _winemakers = __webpack_require__(521);
	
	var _winemakers2 = _interopRequireDefault(_winemakers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		vuex: {
			actions: {
				getSimulator: _actions.SimulatorSetup.get,
				updateSimulator: _actions.SimulatorSetup.update,
				setTitle: _actions.App.title,
				allCountries: _actions.Settings.allCountries
			},
	
			getters: {
				countries: _getters.countries,
				site: _getters.site,
				simulatorSetup: _getters.simulatorSetup,
				loading: _getters.loading
			}
		},
	
		computed: {
			secondarySugarUnits: {
				get: function get() {
					if (this.simulatorSetup.secondary_sugar_units == 'sg') {
						return true;
					} else {
						return false;
					}
				},
				set: function set(value) {
					if (value) {
						this.simulatorSetup.secondary_sugar_units = 'sg';
					} else {
						this.simulatorSetup.secondary_sugar_units = 'rs';
					}
				}
			}
		},
	
		route: {
			activate: function activate() {
				this.$dispatch('loading');
			},
			data: function data() {
				var _this = this;
	
				this.allCountries().then(function () {
					_this.getSimulator(_this.site.id).then(function () {
						_this.$dispatch('loaded');
					});
				});
			}
		},
	
		data: function data() {
			return {
				test: false,
				inputTimeout: null,
				dirty: false
			};
		},
		ready: function ready() {
			var _this2 = this;
	
			this.setTitle('Simulator Setup');
	
			['red', 'white'].forEach(function (type) {
				var freqType = type + '_sampling_freq';
	
				_this2.$watch('simulatorSetup.' + freqType, function (val, oldVal) {
					if (val) {
						val = parseInt(val, 10);
	
						if (val === 0 || !val) {
							_notify2.default.warning('Simpling Frequency cannot be 0 or empty');
	
							this.simulatorSetup[freqType] = oldVal;
						} else {
							this.autoSave();
						}
					}
				});
			});
	
			this.$watch('simulatorSetup.country_id', function (val) {
				if (val) {
					this.autoSave();
				}
			});
	
			$('.toggle').on('click', function (event) {
				return _this2.autoSave();
			});
	
			$('input').on('change keyup', function (event) {
				clearTimeout(_this2.inputTimeout);
	
				var key = event.which;
	
				if (key != 37 && key != 39 && key != 9) {
					_this2.setInputTimeout();
				}
			});
		},
	
	
		methods: {
			autoSave: function autoSave() {
				clearTimeout(this.inputTimeout);
				this.setInputTimeout();
			},
			setInputTimeout: function setInputTimeout() {
				var _this3 = this;
	
				this.inputTimeout = setTimeout(function () {
					_this3.save();
				}, 1500);
			},
			save: function save() {
				console.log(this.site.id);
				console.log(this.simulatorSetup.id);
				this.updateSimulator(this.site.id, this.simulatorSetup.id, this.simulatorSetup).then(function () {
					_notify2.default.success('Simulator has been updated.');
				});
			}
		},
	
		components: {
			Winemakers: _winemakers2.default
		}
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(9);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _notify = __webpack_require__(5);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _alert = __webpack_require__(6);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _logger = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['winemakers', 'loading', 'site'],
	
	  data: function data() {
	    return {
	      api: 'winemakers',
	      name: null
	    };
	  },
	
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      _http2.default.post(this.api, { name: this.name, site_id: this.site.id }).then(function (response) {
	        _notify2.default.success('New winemaker added.');
	        _this.winemakers.push(response.body.winemaker);
	        _this.name = null;
	      }, function (response) {
	        (0, _logger.toConsole)(response);
	        _notify2.default.warning('Winemaker could not be added.');
	      });
	    },
	    remove: function remove(winemaker, index) {
	      var _this2 = this;
	
	      var api = this.api;
	
	      _alert2.default.delete({
	        showLoaderOnConfirm: true,
	        preConfirm: function preConfirm() {
	          return _http2.default.destroy(api + '/' + winemaker.id);
	        }
	      }).then(function () {
	        _alert2.default.success({ text: 'Winemaker has been deleted.' }).then(function () {}, function () {});
	        _this2.winemakers.splice(index, 1);
	      }, function () {});
	    }
	  }
	};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _actions = __webpack_require__(3);
	
	var _getters = __webpack_require__(2);
	
	var _routes = __webpack_require__(31);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(21);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				selected: null
			};
		},
	
	
		vuex: {
			actions: {
				all: _actions.Sites.all,
				select: _actions.Sites.select,
				setTitle: _actions.App.title
			},
			getters: {
				sites: _getters.sites,
				loading: _getters.loading
			}
		},
	
		computed: {
			siteOptions: function siteOptions() {
				return this.sites.map(function (site) {
					return { value: site.id, name: site.name };
				});
			}
		},
	
		ready: function ready() {
			this.setTitle('Site Selection');
		},
	
	
		route: {
			data: function data() {
				var _this = this;
	
				this.$dispatch('loading');
	
				this.select({});
	
				this.all().then(function () {
					_this.$dispatch('loaded');
				});
			}
		},
	
		methods: {
			submit: function submit() {
				var site = {};
	
				if (!this.sites) {
					return;
				}
	
				for (var i = 0; i < this.sites.length; ++i) {
					if (this.sites[i].id == this.selected) {
						site = this.sites[i];
	
						break;
					}
				}
	
				if (site == {}) {
					return;
				}
	
				this.select(site);
	
				this.$router.go({ name: 'dashboard' });
			}
		}
	};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _navigation = __webpack_require__(512);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _getters = __webpack_require__(2);
	
	var _actions = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navigation: _navigation2.default
		},
	
		vuex: {
			getters: {
				loading: _getters.loading,
				site: _getters.site,
				title: _getters.title,
				authorized: _getters.authorized
			},
			actions: {
				getSimulator: _actions.SimulatorSetup.get,
				allTankGroups: _actions.TankGroups.all
			}
		},
	
		route: {
			data: function data(transition) {
				var _this = this;
	
				this.transition = transition;
	
				if (this.site.id) {
					this.getSimulator(this.site.id).then(function () {
						_this.loaded.push('simulator');
					});
	
					this.allTankGroups(this.site.id).then(function () {
						_this.loaded.push('tank-groups');
					});
				} else {
					transition.next();
				}
			}
		},
	
		watch: {
			loaded: function loaded() {
				if (this.loaded.length == 2) {
					this.transition.next();
				}
			}
		},
	
		data: function data() {
			return {
				loaded: [],
				transition: null,
				currentYear: new Date().getFullYear()
			};
		},
		ready: function ready() {
			var _this2 = this;
	
			$('body').popover({
				selector: '.popover-help',
				html: true,
				container: 'body',
				trigger: 'focus'
			});
	
			$('body').tooltip({
				selector: '[data-toggle="tooltip"]',
				html: true,
				container: 'body',
				trigger: 'hover'
			});
	
			$('body').css({ 'overflow': 'visible' });
	
			$("[data-widget='remove']").click(function () {
				var box = $(this).parents(".box").first();
	
				box.slideUp();
			});
	
			$("[data-widget='collapse']").click(function () {
				var box = $(this).parents(".box").first();
	
				var bf = box.find(".box-body, .box-footer");
	
				if (!box.hasClass("collapsed-box")) {
					box.addClass("collapsed-box");
					bf.slideUp();
				} else {
					box.removeClass("collapsed-box");
					bf.slideDown();
				}
			});
	
			$(".menu").slimscroll({
				height: "200px",
				alwaysVisible: true,
				size: "5px"
			}).css("width", "100%");
	
			$("[data-toggle='tooltip']").tooltip();
	
			$(".side-bar").accordionze({
				accordionze: true,
				speed: 300,
				closedSign: '<b class="fa fa-caret-down"></b>',
				openedSign: '<b class="fa fa-caret-up"></b>'
			});
	
			$('.tooltip-tip').tooltipster({
				position: 'top-left',
				animation: 'slide',
				theme: '.tooltipster-shadow',
				delay: 1,
				offsetY: '-50px',
				offsetX: '-60px',
				onlyOne: true
			});
	
			$("#skin-select #toggle").on('click', function (event) {
				if (_this2.$route.hideNavigation === true) {
					$('.wrap-fluid').css({ marginLeft: 0 });
				} else if ($(event.target).hasClass('active')) {
					$(event.target).removeClass('active');
	
					$('#skin-select').css({ "width": "200px" });
					$('.wrap-fluid').css({ "width": "auto", "margin-left": "200px" });
					$('#skin-select li').css({ "text-align": "left" });
					$('#skin-select li span, .devider-title h3, ul.topnav h4, .side-dash, .noft-blue, .noft-purple-number, .noft-blue-number').css({ "display": "inline-block", "float": "none" });
					$('.ul.topnav h4, .hide-min-toggle').css({ "display": "none" });
					$('.tooltip-tip2').addClass('tooltipster-disable');
					$('.tooltip-tip').addClass('tooltipster-disable');
					$('.datepicker-wrap').css({ "position": "absolute", "right": "300px" });
					$('.skin-part').css({ "visibility": "visible" });
					$('#menu-showhide').css({ "height": "auto", "margin": "-10px 0 0" });
					$('#skin-select li i').css({ "top": "8px 0" });
					$('ul.topnav ul').css({ "border-radius": "0", "padding": "15px 25px" });
					$('#menuwrapper').removeAttr('id');
				} else {
					$(event.target).addClass('active');
	
					$('#skin-select').css({ "width": "50px" });
					$('.wrap-fluid').css({ "width": "auto", "margin-left": "50px" });
					$('#skin-select li').css({ "text-align": "right" });
					$('#skin-select li span, .devider-title h3, ul.topnav h4, .side-dash, .noft-blue, .noft-purple-number, .noft-blue-number').css({ "display": "none" });
					$('.datepicker-wrap').css({ "position": "absolute", "right": "84px" });
					$('.skin-part').css({ "visibility": "visible" });
					$('.hide-min-toggle').css({ "display": "block" });
					$('#menu-showhide').css({ "height": "100vh", "margin": "40px 0 0" });
					$('#skin-select li i').css({ "top": "0", "left": "-11px", "padding": "8px 0" });
					$('ul.topnav ul').css({ "border-radius": "0", "padding": "5px 10px" });
					$('ul.topnav ul').removeAttr('style');
					$('#menuwrapper ul li ul').css({ "display": "inline-grid!important" });
					$('.accordion-nav').removeAttr('class').addClass('topnav');
					$(".side-bar").attr("id", "menuwrapper");
				}
	
				$(window).trigger('resize');
			});
	
			$("#skin-select #toggle").addClass('active').trigger('click');
	
			this.$watch('$route', function (route) {
				$("#skin-select #toggle").addClass('active').trigger('click');
			});
		}
	};

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 77,
		"./af.js": 77,
		"./ar": 84,
		"./ar-dz": 78,
		"./ar-dz.js": 78,
		"./ar-kw": 79,
		"./ar-kw.js": 79,
		"./ar-ly": 80,
		"./ar-ly.js": 80,
		"./ar-ma": 81,
		"./ar-ma.js": 81,
		"./ar-sa": 82,
		"./ar-sa.js": 82,
		"./ar-tn": 83,
		"./ar-tn.js": 83,
		"./ar.js": 84,
		"./az": 85,
		"./az.js": 85,
		"./be": 86,
		"./be.js": 86,
		"./bg": 87,
		"./bg.js": 87,
		"./bn": 88,
		"./bn.js": 88,
		"./bo": 89,
		"./bo.js": 89,
		"./br": 90,
		"./br.js": 90,
		"./bs": 91,
		"./bs.js": 91,
		"./ca": 92,
		"./ca.js": 92,
		"./cs": 93,
		"./cs.js": 93,
		"./cv": 94,
		"./cv.js": 94,
		"./cy": 95,
		"./cy.js": 95,
		"./da": 96,
		"./da.js": 96,
		"./de": 99,
		"./de-at": 97,
		"./de-at.js": 97,
		"./de-ch": 98,
		"./de-ch.js": 98,
		"./de.js": 99,
		"./dv": 100,
		"./dv.js": 100,
		"./el": 101,
		"./el.js": 101,
		"./en-au": 102,
		"./en-au.js": 102,
		"./en-ca": 103,
		"./en-ca.js": 103,
		"./en-gb": 104,
		"./en-gb.js": 104,
		"./en-ie": 105,
		"./en-ie.js": 105,
		"./en-nz": 106,
		"./en-nz.js": 106,
		"./eo": 107,
		"./eo.js": 107,
		"./es": 109,
		"./es-do": 108,
		"./es-do.js": 108,
		"./es.js": 109,
		"./et": 110,
		"./et.js": 110,
		"./eu": 111,
		"./eu.js": 111,
		"./fa": 112,
		"./fa.js": 112,
		"./fi": 113,
		"./fi.js": 113,
		"./fo": 114,
		"./fo.js": 114,
		"./fr": 117,
		"./fr-ca": 115,
		"./fr-ca.js": 115,
		"./fr-ch": 116,
		"./fr-ch.js": 116,
		"./fr.js": 117,
		"./fy": 118,
		"./fy.js": 118,
		"./gd": 119,
		"./gd.js": 119,
		"./gl": 120,
		"./gl.js": 120,
		"./gom-latn": 121,
		"./gom-latn.js": 121,
		"./he": 122,
		"./he.js": 122,
		"./hi": 123,
		"./hi.js": 123,
		"./hr": 124,
		"./hr.js": 124,
		"./hu": 125,
		"./hu.js": 125,
		"./hy-am": 126,
		"./hy-am.js": 126,
		"./id": 127,
		"./id.js": 127,
		"./is": 128,
		"./is.js": 128,
		"./it": 129,
		"./it.js": 129,
		"./ja": 130,
		"./ja.js": 130,
		"./jv": 131,
		"./jv.js": 131,
		"./ka": 132,
		"./ka.js": 132,
		"./kk": 133,
		"./kk.js": 133,
		"./km": 134,
		"./km.js": 134,
		"./kn": 135,
		"./kn.js": 135,
		"./ko": 136,
		"./ko.js": 136,
		"./ky": 137,
		"./ky.js": 137,
		"./lb": 138,
		"./lb.js": 138,
		"./lo": 139,
		"./lo.js": 139,
		"./lt": 140,
		"./lt.js": 140,
		"./lv": 141,
		"./lv.js": 141,
		"./me": 142,
		"./me.js": 142,
		"./mi": 143,
		"./mi.js": 143,
		"./mk": 144,
		"./mk.js": 144,
		"./ml": 145,
		"./ml.js": 145,
		"./mr": 146,
		"./mr.js": 146,
		"./ms": 148,
		"./ms-my": 147,
		"./ms-my.js": 147,
		"./ms.js": 148,
		"./my": 149,
		"./my.js": 149,
		"./nb": 150,
		"./nb.js": 150,
		"./ne": 151,
		"./ne.js": 151,
		"./nl": 153,
		"./nl-be": 152,
		"./nl-be.js": 152,
		"./nl.js": 153,
		"./nn": 154,
		"./nn.js": 154,
		"./pa-in": 155,
		"./pa-in.js": 155,
		"./pl": 156,
		"./pl.js": 156,
		"./pt": 158,
		"./pt-br": 157,
		"./pt-br.js": 157,
		"./pt.js": 158,
		"./ro": 159,
		"./ro.js": 159,
		"./ru": 160,
		"./ru.js": 160,
		"./sd": 161,
		"./sd.js": 161,
		"./se": 162,
		"./se.js": 162,
		"./si": 163,
		"./si.js": 163,
		"./sk": 164,
		"./sk.js": 164,
		"./sl": 165,
		"./sl.js": 165,
		"./sq": 166,
		"./sq.js": 166,
		"./sr": 168,
		"./sr-cyrl": 167,
		"./sr-cyrl.js": 167,
		"./sr.js": 168,
		"./ss": 169,
		"./ss.js": 169,
		"./sv": 170,
		"./sv.js": 170,
		"./sw": 171,
		"./sw.js": 171,
		"./ta": 172,
		"./ta.js": 172,
		"./te": 173,
		"./te.js": 173,
		"./tet": 174,
		"./tet.js": 174,
		"./th": 175,
		"./th.js": 175,
		"./tl-ph": 176,
		"./tl-ph.js": 176,
		"./tlh": 177,
		"./tlh.js": 177,
		"./tr": 178,
		"./tr.js": 178,
		"./tzl": 179,
		"./tzl.js": 179,
		"./tzm": 181,
		"./tzm-latn": 180,
		"./tzm-latn.js": 180,
		"./tzm.js": 181,
		"./uk": 182,
		"./uk.js": 182,
		"./ur": 183,
		"./ur.js": 183,
		"./uz": 185,
		"./uz-latn": 184,
		"./uz-latn.js": 184,
		"./uz.js": 185,
		"./vi": 186,
		"./vi.js": 186,
		"./x-pseudo": 187,
		"./x-pseudo.js": 187,
		"./yo": 188,
		"./yo.js": 188,
		"./zh-cn": 189,
		"./zh-cn.js": 189,
		"./zh-hk": 190,
		"./zh-hk.js": 190,
		"./zh-tw": 191,
		"./zh-tw.js": 191
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 426;


/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./de": 194,
		"./de.js": 194,
		"./el": 195,
		"./el.js": 195,
		"./en": 51,
		"./en.js": 51,
		"./es": 196,
		"./es.js": 196,
		"./fa": 197,
		"./fa.js": 197,
		"./fr": 198,
		"./fr.js": 198,
		"./it": 199,
		"./it.js": 199,
		"./ja": 200,
		"./ja.js": 200,
		"./nb_NO": 201,
		"./nb_NO.js": 201,
		"./pl": 202,
		"./pl.js": 202,
		"./pt": 203,
		"./pt.js": 203,
		"./ru": 204,
		"./ru.js": 204,
		"./tr": 205,
		"./tr.js": 205,
		"./vi": 206,
		"./vi.js": 206,
		"./zh": 207,
		"./zh.js": 207,
		"./zh_TW": 208,
		"./zh_TW.js": 208
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 441;


/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */
/***/ (function(module, exports) {

	module.exports = " <router-view></router-view> ";

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = " <quote :message=message></quote> ";

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = " <fieldset> <legend> Data Table <a class=\"fa fa-question-circle popover-help small\" v-if=!isBlendedFerment style=\"margin-left: 6px\" role=button tabindex=0 data-trigger=focus data-container=body data-placement=left data-html=true title=Help data-content=\"\n\t\t\t<small>\n\t\t\t\tTemperature and Baume data can be entered directly into the data table below.\n\t\t\t\tTo record actions performed on the ferment, lab analysis results and other comments,\n\t\t\t\tclick on the Action/Lab Analysis/Comments section in the desired row to bring up a box where all of this information can be entered against the selected time point.\n\t\t\t\tActions will be displayed in the table by the icons shown below.<br />\n\t\t\t\t<br />\n\t\t\t\t<div class='row'>\n\t\t\t\t\t<div class='col-xs-6'>\n\t\t\t\t\t\t<i class='fa fa-fw fa-sort-amount-asc'></i> - Pumpover<br />\n\t\t\t\t\t\t<i class='fa fa-fw fa-spinner'></i> - Aeration<br />\n\t\t\t\t\t\t<i class='fa fa-fw fa-refresh'></i> - Agitator<br />\n\t\t\t\t\t\t<i class='fa fa-fw fa-plus-square'></i> - DAP<br />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class='col-xs-6'>\n\t\t\t\t\t\t<i class='fontello-beer-1'></i> - Juice<br />\n\t\t\t\t\t\t<i class='fa fa-fw fa-tint'></i> - Water<br />\n\t\t\t\t\t\t<i class='fa fa-fw fa-flask'></i> - Acid<br />\n\t\t\t\t\t\t<i class='fa fa-fw fa-chain-broken'></i> - Overseed\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</small>\n\t\t\t\"> </a> <a class=\"fa fa-question-circle popover-help small\" v-else style=\"margin-left: 6px\" role=button tabindex=0 data-trigger=focus data-container=body data-placement=left data-html=true title=Help data-content=\"\n\t\t\t<small>\n\t\t\t\tThe data table shows the Temperature and Baume readings for the original blend component in this fermenter (before blending) for reference only (greyed out). New values for the blend can be entered in the open section of the data table. To see the data for the other blend components, select them from the 'Blend components' dropdown box above.\n\t\t\t</small>\n\t\t\t\"> </a> </legend> <table class=\"table table-profile table-daily-data\" cellspacing=0> <thead> <tr> <th class=col-day>Day</th> <th class=col-baume v-if=allowBaume>Sugar ({{{ units.sugarUnit() }}})</th> <th class=col-temp>Temp ({{{ units.temperatureUnit() }}})</th> <th class=col-secondary v-if=allowBaume>{{{ units.secondarySugarUnit() }}}</th> <th class=col-action>Action/Analysis</th> <th class=col-comments>Comments</th> </tr> <tr v-for=\"data in dailyData.data\" :class=\"{'highlight-current': isCurrentDay(data.day), 'highlight-after': isFutureDay(data.day), 'highlight-locked': data.locked}\"> <td> <span v-if=\"data.day.toString().indexOf('.') > -1 && data.day.toString().split('.')[1] == 0\"> {{dayToDate(data.day.toString().slice(0, data.day.toString().indexOf('.') == -1 ? 1 : data.day.toString().indexOf('.')))}} </span> <span v-else> {{dayToDate(data.day)}} <span v-if=\"measuringFreqInteger > 2\">- {{$index === 0 ? 1 : $index % measuringFreqInteger + 1}}</span> </span> </td> <td @click.stop=\"editCell($event, $index, 'baume', data)\" class=baume :class=\"{'info': editing.status && editing.index == $index && editing.column == 'baume'}\" v-if=allowBaume> <div v-if=\"editing.status && editing.index == $index && editing.column == 'baume'\"> <input type=text @keydown.tab=\"tabToNextCell($event, $index, 'temp', 'comments', data)\" v-model=data.baume class=form-control> </div> <div style=width:100% v-else> {{data.baume || data.baume === 0 ? parseFloat(data.baume).toFixed(2) : data.baume}} {{{data.baume || data.baume === 0 ? units.sugarUnit() : '' }}} </div> </td> <td @click.stop=\"editCell($event, $index, 'temp', data)\" class=temp :class=\"{'info': editing.status && editing.index == $index && editing.column == 'temp'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'temp'\"> <input type=text class=form-control @keydown.tab=\"tabToNextCell($event, $index, allowBaume ? 'secondary' : 'comments', allowBaume ? 'baume' : 'comments', data)\" v-model=data.temp> </div> <div v-else> {{data.temp ? parseFloat(data.temp).toFixed(2) : data.temp}} {{{data.temp ? units.temperatureUnit() : '' }}} </div> </td> <td @click.stop=\"editCell($event, $index, 'secondary', data)\" class=secondary :class=\"{'info': editing.status && editing.index == $index && editing.column == 'secondary'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'secondary'\"> <input type=text @keydown.tab=\"tabToNextCell($event, $index, 'comments', 'temp', data)\" v-model=dailyData.data[$index].analysis.data[simulatorSetup.secondary_sugar_units] class=form-control> </div> <div style=width:100% v-else> <span v-if=\"simulatorSetup.secondary_sugar_units == 'rs'\"> {{dailyData.data[$index].analysis.data.rs || dailyData.data[$index].analysis.data.rs === 0 ? parseFloat(dailyData.data[$index].analysis.data.rs).toFixed(2) : dailyData.data[$index].analysis.data.rs}} {{{dailyData.data[$index].analysis.data.rs || dailyData.data[$index].analysis.data.rs === 0 ? 'g/L' : '' }}} </span> <span v-else> {{dailyData.data[$index].analysis.data.sg || dailyData.data[$index].analysis.data.sg === 0 ? parseFloat(dailyData.data[$index].analysis.data.sg).toFixed(4) : dailyData.data[$index].analysis.data.sg}} </span> </div> </td> <td class=action-modal @click.stop=\"openActionModal($index, data)\"> <i v-if=\"data.action.data && data.action.data.pump_over\" class=\"fa fa-fw fa-sort-amount-asc\"></i> <i v-if=\"data.action.data && data.action.data.aeration\" class=\"fa fa-fw fa-spinner\"></i> <i v-if=\"data.action.data && data.action.data.agitator > 0\" class=\"fa fa-fw fa-refresh\"></i> <i v-if=\"data.action.data && data.action.data.dap\" class=\"fa fa-fw fa-plus-square\"></i> <i v-if=\"data.action.data && data.action.data.juice\" class=fontello-beer-1></i> <i v-if=\"data.action.data && data.action.data.water\" class=\"fa fa-fw fa-tint\"></i> <i v-if=\"data.action.data && data.action.data.acid\" class=\"fa fa-fw fa-flask\"></i> <i v-if=\"data.action.data && data.action.data.reinoculate\" class=\"fa fa-fw fa-chain-broken\"></i> <i v-if=!isEmptyAnalysis(data) class=\"fa fa-table\"></i> </td> <td @click.stop=\"editCell($event, $index, 'comments', data)\" class=comments :class=\"{'info': editing.status && editing.index == $index && editing.column == 'comments'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'comments'\"> <input type=text class=form-control @keydown.tab=\"tabToNextCell($event, $index, allowBaume ? 'baume' : 'temp', 'temp', data)\" v-model=data.comments> </div> <div v-else> {{data.comments}} </div> </td> </tr> </thead> </table> <a v-if=canRemoveBlankRow() @click.prevent=removeBlankRow class=\"btn btn-xs btn-danger pull-right\" style=\"margin-top: 10px; display: block\"> <i class=\"fa fa-times\"></i> Remove Blank Rows </a> <a v-if=missingDay @click.prevent=addMissingRow class=\"btn btn-xs btn-info pull-left\" style=\"margin-top: 10px; display: block\"> <i class=\"fa fa-plus\"></i> Add Missing Day </a> <div class=\"modal fade\" id=actions_analysis tabindex=-1 role=dialog aria-labelledby=actionsTitle aria-hidden=true v-if=\"editing.status && editing.index != null\"> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button> <h4 class=modal-title id=actionsTitle>Actions and Analysis</h4> </div> <div class=modal-body> <h2 class=no-margin-top>Actions</h2> <div class=modal-actions> <div class=row> <div class=col-xs-6> <input-toggle name=type :vmodel.sync=dailyData.data[editing.index].action.data.pump_over on=Performed off=None on-style=primary label=\"Pump Over\" icon=sort-amount-asc> </input-toggle> </div> <div class=col-xs-6> <input-toggle name=type :vmodel.sync=dailyData.data[editing.index].action.data.aeration on=Performed off=None on-style=primary label=Aeration icon=spinner> </input-toggle> </div> </div> <div class=row> <div class=col-sm-12> <div class=\"form-group form-control-toggle-top\"> <label for=agitator class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-refresh\"></i> Agitator Strength</label> <div class=col-xs-12> <div class=btn-group id=agitator-group data-toggle=buttons v-radio=dailyData.data[editing.index].action.data.agitator default-value=0> <label class=\"btn btn-default active\"> <input type=radio value=0> Off </label> <label class=\"btn btn-default\"> <input type=radio value=1> 1 </label> <label class=\"btn btn-default\"> <input type=radio value=2> 2 </label> <label class=\"btn btn-default\"> <input type=radio value=3> 3 </label> <agitator-definition></agitator-definition> </div> </div> </div> </div> </div> <div class=row> <div class=col-sm-6> <div class=form-group> <label for=add_dap class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-plus-square\"></i> Add DAP</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_dap class=\"form-control input-sm\" v-model=dailyData.data[editing.index].action.data.dap /> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_juice class=\"col-xs-12 control-label text-left\"><i class=fontello-beer-1></i> Add juice</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_juice class=\"form-control input-sm\" v-model=dailyData.data[editing.index].action.data.juice /> <span class=\"input-group-addon input-group-addon-narrow\">L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_water class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-tint\"></i> Add Water</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_water class=\"form-control input-sm\" v-model=dailyData.data[editing.index].action.data.water /> <span class=\"input-group-addon input-group-addon-narrow\">L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_acid class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-flask\"></i> Add Acid</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_acid class=\"form-control input-sm\" v-model=dailyData.data[editing.index].action.data.acid /> <span class=\"input-group-addon input-group-addon-narrow\">L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_acid class=\"col-xs-12 control-label text-left\"> <i class=\"fa fa-chain-broken\"></i> Overseed <a class=\"fa fa-question-circle popover-help\" style=\"margin-left: 7px\" tabindex=0 role=button data-placement=left data-html=true data-trigger=focus data-container=body title=Help data-content=\"\n\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\tIf propagating, you can use the following equation to convert your cell concentration:\n\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\t<code>Cell conc (cells/ml) x pitch rate (decimal) x 5x10^-5</code>\n\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\tFor example:\n\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\t\t\t\t\t<code>Equivalent dry yeast = 1x10^8 x 0.05 x 5x10^-5 = 250mg/L</code>\n\t\t\t\t\t\t\t\t\t\t\t</small>\"> </a> </label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_acid class=\"form-control input-sm\" v-model=dailyData.data[editing.index].action.data.reinoculate /> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6 v-if=\"ferment.id !== null && ferment.id !== undefined\"> <div class=form-group> <label class=col-xs-12>&nbsp;</label> <div class=col-xs-12> <button type=button :disabled=editingIndexBeforeExistingMoveEvent @click.prevent=openMoveModal class=\"m-t-md btn btn-sm btn-primary\"> Move Ferment... </button> </div> </div> </div> </div> </div> <h2>Lab Analysis</h2> <div class=modal-actions> <div class=row> <div class=col-sm-6> <div class=form-group> <label for=ana_cell_count class=\"col-xs-12 control-label text-left\">Cell Count</label> <div class=col-xs-12> <input type=text name=ana_cell_count class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.cell_count> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ph class=\"col-xs-12 control-label text-left\">pH</label> <div class=col-xs-12> <input type=text name=ana_ph class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.ph> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ta class=\"col-xs-12 control-label text-left\">TA</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_ta class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.ta> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_fs02 class=\"col-xs-12 control-label text-left\">FS0<sub>2</sub></label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_fs02 class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.fs02> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ts02 class=\"col-xs-12 control-label text-left\">TS0<sub>2</sub></label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_ts02 class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.ts02> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_gf class=\"col-xs-12 control-label text-left\">G/F</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_gf class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.gf> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ntu class=\"col-xs-12 control-label text-left\">NTU</label> <div class=col-xs-12> <input type=text name=ana_ntu class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.ntu> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_alcohol class=\"col-xs-12 control-label text-left\">Alcohol</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_alcohol class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.alcohol> <span class=\"input-group-addon input-group-addon-narrow\">%</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_malic_acid class=\"col-xs-12 control-label text-left\">Malic Acid</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_malic_acid class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.malic_acid> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group v-if=\"simulatorSetup.secondary_sugar_units == 'rs'\"> <label for=ana_malic_acid class=\"col-xs-12 control-label text-left\">SG</label> <div class=col-xs-12> <input type=text name=ana_sg class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.sg> </div> </div> <div class=form-group v-else> <label for=ana_malic_acid class=\"col-xs-12 control-label text-left\">RS</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_sg class=\"form-control input-sm\" v-model=dailyData.data[editing.index].analysis.data.rs> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> </div> </div> </div> <div class=modal-footer> <button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> </div> </div> </div> </div> <move-ferment v-if=isMovingFerment :index=editing.index :day=getDayFromIndex(editing.index) :measuring-freq-integer=measuringFreqInteger> </move-ferment> </fieldset> ";

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = " <div class=ferment-gauge-container :class=\"{'not-enough-data': this.fermenter.currentFerment && (fermentNotEnoughData(this.fermenter.currentFerment.data) || fermenter.currentFerment.data.blendComponents.data.length > 0)}\"> <canvas id=gauge_{{fermenter.id}} class=ferment-gauge width=100%></canvas> </div> <div class=progress-container-right> <div class=progress-label> {{ getLastSugar() }} {{{ units.sugarUnit() }}}<br/> {{ getLastTemperature() }} {{{ units.temperatureUnit() }}}<br/> </div> <div class=progress> <div v-if=!fermentIsBlended class=\"progress-bar progress-bar-primary progress-bar\" role=progressbar aria-valuenow=\"{{ gaugeData.progress || 0 }}\" aria-valuemin=0 aria-valuemax=100 :style=\"{'width': (gaugeData.progress || 0)+'%'}\"> <span>{{ gaugeData.progress ? gaugeData.progress+'%' : '' }}</span> </div> </div> </div> ";

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = " <a class=\"fa fa-question-circle popover-help\" v-bind:style=customStyle v-bind:class=class tabindex=0 role=button data-placement={{placement}} data-html=true data-trigger=focus data-container=body title=Help data-content={{{message}}}></a> ";

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = " <img src=/static/img/header.png style=\"margin:-36px 0px 37px -27px;width: 105%\" class=bnr /> <div class=row> <div class=col-md-12> <div class=authenticate> <h2 style=\"font-weight: initial;background: #202e6d; color: white;text-transform:initial\">Register</h2> <div class=wrap-fluid> <div class=row> <div class=col-lg-12> <div class=account-box> <div id=register> <div style=margin-bottom:20px> <div class=form-group> <label style=font-weight:initial>Name</label> <input type=text name=name v-model=input.name placeholder=Name class=form-control /> </div> <div class=form-group> <label style=font-weight:initial>Email</label> <input type=email name=email v-model=input.email placeholder=Email class=form-control /> </div> <div class=form-group> <label style=font-weight:initial>Username</label> <input type=text name=username v-model=input.username placeholder=Username class=form-control /> </div> <div class=form-group> <label style=font-weight:initial>Password</label> <input type=password name=password v-model=input.password placeholder=Password class=form-control /> </div> <div class=form-group> <label style=font-weight:initial>Confirm password</label> <input type=password name=confirmPassword v-model=input.confirmPassword placeholder=\"Confirm Password\" class=form-control /> </div> <div class=form-group> <label style=font-weight:initial>Site Name</label> <input type=text name=siteName v-model=input.siteName placeholder=\"Site Name\" class=form-control /> </div> </div> <div class=\"\"> <div class=\"\" style=\"text-align: right\"> <button type=button v-on:click=register() class=\"\" style=\"text-transform: uppercase; width: 100px; height: 40px; color: white; background: #202e6d; outline: none; border: none; margin-bottom: 10px\">Register</button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-sm-6> <div class=box> <div class=box-header> <h2 class=box-title>I need help with the <strong>simulator</strong></h2> </div> <div class=box-body> <p>Contact the simulator support team</p> <ul class=\"contact-list nolist\"> <li><i class=\"fa fa-fw fa-envelope\"></i> <a href=mailto:ferment.simulator@awri.com.au>ferment.simulator@awri.com.au</a></li> <li><i class=\"fa fa-fw fa-phone\"></i> <a href=tel:0883130891>08 8313 0891</a></li> </ul> </div> </div> </div> <div class=col-sm-6> <div class=box> <div class=box-header> <h2 class=box-title>I need help with a <strong>ferment</strong></h2> </div> <div class=box-body> <p>Contact the AWRI Helpdesk</p> <ul class=\"contact-list nolist\"> <li><i class=\"fa fa-fw fa-globe\"></i> <a href=http://www.awri.com.au/industry_support/helpdesk/ >Helpdesk Website</a></li> <li><i class=\"fa fa-fw fa-envelope\"></i> <a href=mailto:helpdesk@awri.com.au>helpdesk@awri.com.au</a></li> <li><i class=\"fa fa-fw fa-phone\"></i> <a href=tel:0883136600>08 8313 6600</a></li> </ul> </div> </div> </div> <div class=col-sm-12> <div class=\"alert alert-info\"> <span class=entypo-info-circled></span> Remember you can save and attach your ferment data as an Excel file. This may help us help you as quickly as possible </div> </div> <div class=col-sm-12> <div class=box> <div class=box-header> <h2 class=box-title>Other resources</h2> </div> <div class=box-body> <ul class=\"nav nav-list nav-list-half\"> <li><a href=http://www.awri.com.au/industry_support/winemaking_resources/calculators/ target=_blank><i class=\"fa fa-external-link\"></i> AWRI Winemaking Calculators</a></li> <li><a href=http://www.awri.com.au/information_services/fact-sheets/ target=_blank><i class=\"fa fa-external-link\"></i> AWRI Fact Sheets</a></li> <li><a href=http://www.awri.com.au/industry_support/winemaking_resources/wine_fermentation/ target=_blank><i class=\"fa fa-external-link\"></i> AWRI Fermentation Info</a></li> <li><a href=http://www.awri.com.au/commercial_services/analytical_services/ target=_blank><i class=\"fa fa-external-link\"></i> AWRI Lab Analysis</a></li> <li><a href=http://www.awri.com.au/information_services/library-services-to-levy-payers/ target=_blank><i class=\"fa fa-external-link\"></i> AWRI Library</a></li> </ul> </div> </div> </div> </div> ";

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = " <div class=box> <div class=box-header> <h2 class=box-title>Bulk Data Entry</h2> </div> <div class=box-body> <fieldset> <a class=\"fa fa-question-circle popover-help pull-right\" role=button tabindex=0 data-trigger=focus data-container=body data-placement=left data-html=true title=Help data-content=\"\n\t\t\t\t<small>\n\t\t\t\t\tTemperature and Baume data can be entered directly into the data table below. To record actions performed on the ferment, lab analysis results and other comments, click on the Action/Lab Analysis/Comments section in the desired row to bring up a box where all of this information can be entered against the selected time point. Actions will be displayed in the table by the icons shown below.<br />\n\t\t\t\t\t<br />\n\t\t\t\t\t<div class='row'>\n\t\t\t\t\t\t<div class='col-xs-6'>\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-sort-amount-asc'></i> - Pumpover<br />\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-spinner'></i> - Aeration<br />\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-refresh'></i> - Agitator<br />\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-plus-square'></i> - DAP<br />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class='col-xs-6'>\n\t\t\t\t\t\t\t<i class='fontello-beer-1'></i> - Juice<br />\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-tint'></i> - Water<br />\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-flask'></i> - Acid<br />\n\t\t\t\t\t\t\t<i class='fa fa-fw fa-chain-broken'></i> - Overseed\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</small>\n\t\t\t\t\"> </a> <table class=\"table table-profile table-daily-data\" cellspacing=0> <thead> <tr> <th class=col-fermenter>Fermenter</th> <th class=col-ferment>Ferment Name</th> <th class=col-day>Day</th> <th class=col-baume v-if=allowBaume>Sugar ({{{ units.sugarUnit() }}})</th> <th class=col-temp>Temp ({{{ units.temperatureUnit() }}})</th> <th class=col-secondary>{{{ units.secondarySugarUnit() }}}</th> <th class=col-action>Action/Analysis</th> <th class=col-comments>Comments</th> </tr> <tr v-for=\"fermenter in filteredFermenters\"> <td>{{ fermenter.tankGroup.data.name }} - {{ fermenter.name }}</td> <td>{{ fermenter.currentFerment.data.wine_name }}</td> <td>{{ fermenter.currentFerment.data.currentDay.day }}</td> <td @click.stop=\"editCell($event, $index, 'baume', fermenter.currentFerment.data.currentDay)\" class=baume :class=\"{'info': editing.status && editing.index == $index && editing.column == 'baume'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'baume'\"> <input type=text @keydown.tab=\"tabToNextCell($event, $index, 'temp', 'comments', fermenter.currentFerment.data.currentDay)\" v-model=fermenter.currentFerment.data.currentDay.baume class=form-control> </div> <div style=width:100% v-else> {{fermenter.currentFerment.data.currentDay.baume ? parseFloat(fermenter.currentFerment.data.currentDay.baume).toFixed(2) : fermenter.currentFerment.data.currentDay.baume}} {{{fermenter.currentFerment.data.currentDay.baume ? units.sugarUnit() : '' }}} </div> </td> <td @click.stop=\"editCell($event, $index, 'temp', fermenter.currentFerment.data.currentDay)\" class=temp :class=\"{'info': editing.status && editing.index == $index && editing.column == 'temp'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'temp'\"> <input type=text @keydown.tab=\"tabToNextCell($event, $index, 'secondary', 'baume', fermenter.currentFerment.data.currentDay)\" v-model=fermenter.currentFerment.data.currentDay.temp class=form-control> </div> <div style=width:100% v-else> {{fermenter.currentFerment.data.currentDay.temp ? parseFloat(fermenter.currentFerment.data.currentDay.temp).toFixed(2) : fermenter.currentFerment.data.currentDay.temp}} {{{fermenter.currentFerment.data.currentDay.temp ? units.temperatureUnit() : '' }}} </div> </td> <td @click.stop=\"editCell($event, $index, 'secondary', fermenter.currentFerment.data.currentDay)\" class=secondary :class=\"{'info': editing.status && editing.index == $index && editing.column == 'secondary'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'secondary'\"> <input type=text @keydown.tab=\"tabToNextCell($event, $index, 'comments', 'temp', fermenter.currentFerment.data.currentDay)\" v-model=fermenter.currentFerment.data.currentDay.analysis.data[simulatorSetup.secondary_sugar_units] class=form-control> </div> <div style=width:100% v-else> <span v-if=\"simulatorSetup.secondary_sugar_units == 'rs'\"> {{fermenter.currentFerment.data.currentDay.analysis.data.rs || fermenter.currentFerment.data.currentDay.analysis.data.rs === 0 ? parseFloat(fermenter.currentFerment.data.currentDay.analysis.data.rs).toFixed(2) : fermenter.currentFerment.data.currentDay.analysis.data.rs}} {{{fermenter.currentFerment.data.currentDay.analysis.data.rs || fermenter.currentFerment.data.currentDay.analysis.data.rs === 0 ? 'g/L' : '' }}} </span> <span v-else> {{fermenter.currentFerment.data.currentDay.analysis.data.sg || fermenter.currentFerment.data.currentDay.analysis.data.sg === 0 ? parseFloat(fermenter.currentFerment.data.currentDay.analysis.data.sg).toFixed(4) : fermenter.currentFerment.data.currentDay.analysis.data.sg}} </span> </div> </td> <td class=action-modal @click=openActionModal($index)> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.pump_over\" class=\"fa fa-fw fa-sort-amount-asc\"></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.aeration\" class=\"fa fa-fw fa-spinner\"></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.agitator > 0\" class=\"fa fa-fw fa-refresh\"></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.dap\" class=\"fa fa-fw fa-plus-square\"></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.juice\" class=fontello-beer-1></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.water\" class=\"fa fa-fw fa-tint\"></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.acid\" class=\"fa fa-fw fa-flask\"></i> <i v-if=\"fermenter.currentFerment.data.currentDay.action.data && fermenter.currentFerment.data.currentDay.action.data.reinoculate\" class=\"fa fa-fw fa-chain-broken\"></i> <i v-if=!isEmptyAnalysis(fermenter.currentFerment.data.currentDay) class=\"fa fa-table\"></i> </td> <td @click.stop=\"editCell($event, $index, 'comments', fermenter.currentFerment.data.currentDay)\" class=comments :class=\"{'info': editing.status && editing.index == $index && editing.column == 'comments'}\"> <div v-if=\"editing.status && editing.index == $index && editing.column == 'comments'\"> <input type=text class=form-control @keydown.tab=\"tabToNextCell($event, $index, 'baume', 'secondary', fermenter.currentFerment.data.currentDay)\" v-model=fermenter.currentFerment.data.currentDay.comments> </div> <div v-else> {{fermenter.currentFerment.data.currentDay.comments}} </div> </td> </tr> <tr v-if=\"filteredFermenters.length == 0\"> <td colspan=7 align=center> There are no fermenters for the current day. </td> </tr> </thead> </table> <div class=\"modal fade\" id=actions_analysis tabindex=-1 role=dialog aria-labelledby=actionsTitle aria-hidden=true v-if=\"editing.index != null\"> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button> <h4 class=modal-title id=actionsTitle>Actions and Analysis</h4> </div> <div class=modal-body> <h2 class=no-margin-top>Actions</h2> <div class=modal-actions> <div class=row> <div class=col-xs-6> <input-toggle name=type :vmodel.sync=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.pump_over on=Performed off=None on-style=primary label=\"Pump Over\" icon=sort-amount-asc> </input-toggle> </div> <div class=col-xs-6> <input-toggle name=type :vmodel.sync=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.aeration on=Performed off=None on-style=primary label=Aeration icon=spinner> </input-toggle> </div> </div> <div class=row> <div class=col-sm-12> <div class=\"form-group form-control-toggle-top\"> <label for=agitator class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-refresh\"></i> Agitator</label> <div class=col-xs-12> <div class=btn-group id=agitator-group data-toggle=buttons v-radio=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.agitator default-value=0> <label class=\"btn btn-default active\"> <input type=radio value=0> Off </label> <label class=\"btn btn-default\"> <input type=radio value=1> 1 </label> <label class=\"btn btn-default\"> <input type=radio value=2> 2 </label> <label class=\"btn btn-default\"> <input type=radio value=3> 3 </label> <agitator-definition></agitator-definition> </div> </div> </div> </div> </div> <div class=row> <div class=col-sm-6> <div class=form-group> <label for=add_dap class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-plus-square\"></i> Add DAP</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_dap class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.dap /> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_juice class=\"col-xs-12 control-label text-left\"><i class=fontello-beer-1></i> Add juice</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_juice class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.juice /> <span class=\"input-group-addon input-group-addon-narrow\">L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_water class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-tint\"></i> Add Water</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_water class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.water /> <span class=\"input-group-addon input-group-addon-narrow\">L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_acid class=\"col-xs-12 control-label text-left\"><i class=\"fa fa-flask\"></i> Add Acid</label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_acid class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.acid /> <span class=\"input-group-addon input-group-addon-narrow\">L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=add_acid class=\"col-xs-12 control-label text-left\"> <i class=\"fa fa-chain-broken\"></i> Overseed <a class=\"fa fa-question-circle popover-help\" style=\"margin-left: 7px\" tabindex=0 role=button data-placement=left data-html=true data-trigger=focus data-container=body title=Help data-content=\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tIf propagating, you can use the following equation to convert your cell concentration:\n\t\t\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<code>Cell conc (cells/ml) x pitch rate (decimal) x 5x10^-5</code>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tFor example:\n\t\t\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<code>Equivalent dry yeast = 1x10^8 x 0.05 x 5x10^-5 = 250mg/L</code>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</small>\"> </a> </label> <div class=col-xs-12> <div class=input-group> <input type=text name=add_acid class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.action.data.reinoculate /> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> </div> </div> <h2>Lab Analysis</h2> <div class=modal-actions> <div class=row> <div class=col-sm-6> <div class=form-group> <label for=ana_cell_count class=\"col-xs-12 control-label text-left\">Cell Count</label> <div class=col-xs-12> <input type=text name=ana_cell_count class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.cell_count> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ph class=\"col-xs-12 control-label text-left\">pH</label> <div class=col-xs-12> <input type=text name=ana_ph class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.ph> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ta class=\"col-xs-12 control-label text-left\">TA</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_ta class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.ta> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_fs02 class=\"col-xs-12 control-label text-left\">FS0<sub>2</sub></label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_fs02 class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.fs02> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ts02 class=\"col-xs-12 control-label text-left\">TS0<sub>2</sub></label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_ts02 class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.ts02> <span class=\"input-group-addon input-group-addon-narrow\">mg/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_gf class=\"col-xs-12 control-label text-left\">G/F</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_gf class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.gf> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_ntu class=\"col-xs-12 control-label text-left\">NTU</label> <div class=col-xs-12> <input type=text name=ana_ntu class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.ntu> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_alcohol class=\"col-xs-12 control-label text-left\">Alcohol</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_alcohol class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.alcohol> <span class=\"input-group-addon input-group-addon-narrow\">%</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=ana_malic_acid class=\"col-xs-12 control-label text-left\">Malic Acid</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_malic_acid class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.malic_acid> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> <div class=col-sm-6> <div class=form-group v-if=\"simulatorSetup.secondary_sugar_units == 'rs'\"> <label for=ana_malic_acid class=\"col-xs-12 control-label text-left\">SG</label> <div class=col-xs-12> <input type=text name=ana_sg class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.sg> </div> </div> <div class=form-group v-else> <label for=ana_malic_acid class=\"col-xs-12 control-label text-left\">RS</label> <div class=col-xs-12> <div class=input-group> <input type=text name=ana_sg class=\"form-control input-sm\" v-model=filteredFermenters[editing.index].currentFerment.data.currentDay.analysis.data.rs> <span class=\"input-group-addon input-group-addon-narrow\">g/L</span> </div> </div> </div> </div> </div> </div> </div> <div class=modal-footer> <button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> </div> </div> </div> </div> </fieldset> </div> </div> ";

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-lg-12> <div class=box> <div class=\"box-body clearfix\"> <form class=\"form-inline col-sm-12 col-lg-9\" role=form> <div class=form-group> <input-select :options=computedTankGroups name=tank_group_id :vmodel.sync=selectedTankGroup label=\"Tank Group:\" value=favourites :inline=true> </input-select> </div> <div class=form-group> <label for=search>Search:</label> <input name=search v-model=search class=form-control> </div> <div class=form-group v-show=\"$route.name == 'dashboard'\"> <div class=checkbox> <label> <input type=checkbox v-model=showEmpty> Hide empty fermenters </label> </div> </div> <div class=form-group v-show=\"$route.name == 'dashboard'\"> <div class=checkbox> <label> <input type=checkbox v-model=showOutOfSpec> Show out-of-spec only </label> </div> </div> <div class=form-group v-show=\"$route.name == 'dashboard.bulk-entry'\"> <input-date label=Date: name=start_date :vmodel.sync=date :inline=true date-format=DD/MM/YYYY></input-date> </div> <div class=form-group v-show=\"$route.name == 'dashboard.bulk-entry'\"> <input-toggle name=period :vmodel.sync=period on=PM off=AM off-style=primary> </input-toggle> </div> </form> <div class=\"col-sm-12 col-lg-3\"> <div class=\"form-group text-right\"> <a v-if=\"$route.name != 'dashboard.bulk-entry'\" class=\"btn btn-xs btn-success\" :href=\"Http.buildPath(`fermenters-download/${site.id}`)\" v-bind:class=\"{ 'disabled': eventLoading }\"> Export </a> <a v-if=\"$route.name != 'dashboard.bulk-entry'\" class=\"btn btn-xs btn-success\" @click.prevent=\"$router.go({ name: 'dashboard.bulk-entry' })\" href=#>Bulk Data Entry</a> <a v-else class=\"btn btn-xs btn-success\" @click.prevent=\"$router.go({ name: 'dashboard' })\" href=#>Back To Dashboard</a> <a style=\"margin-left: 15px\" class=\"fa fa-lg fa-question-circle popover-help\" href=# data-toggle=modal data-target=#dashboard_help_modal></a> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=!loading> <filters :event-loading=eventLoading :site=site :default-include=defaultInclude :export-fermenters=exportFermenters :show-empty.sync=showEmpty :show-out-of-spec.sync=showOutOfSpec :computed-tank-groups=computedTankGroups :selected-tank-group.sync=selectedTankGroup :search.sync=search :date.sync=date :period.sync=period> </filters> <fermenters v-if=\"$route.name == 'dashboard' || $route.name == 'dashboard.tank-group'\" :fermenters=computedFermenters :selected-tank-group.sync=selectedTankGroup></fermenters> <bulk-entry v-else :fermenters=computedFermenters :date=date :selected-tank-group=selectedTankGroup :search=search :period=period></bulk-entry> <div class=\"modal fade\" id=dashboard_help_modal tabindex=-1 role=dialog aria-hidden=true> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button> <h4 class=modal-title id=actionsTitle>Help</h4> </div> <div class=modal-body> <p> The dashboard gives you an overview of ferment status. Clicking on the fermenter name opens that ferment. </p> <p> You can search and filter through fermenters and tank groups using the options in the top bar. </p> <p> Clicking the <i class=\"fa fa-star-o\" style=\"font-weight: bold\"></i> in the top right corner of the ferment widget saves the ferment to the favourites group for faster access. </p> <img src=/static/img/dashboard-help.png> </div> <div class=modal-footer> <button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> </div> </div> </div> </div> </div> ";

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports = " <div class=box> <div class=box-header> <h2 class=box-title>Fermenter Setup</h2> </div> <div class=box-body> <div class=margin-20></div> <form class=form-horizontal> <fieldset> <input-select :select2=true :options=tankGroupOptions name=tank_group_id :vmodel.sync=fermenter.tank_group_id label=\"Tank Group\"> </input-select> <input-text name=name label=\"Tank Name\" :vmodel.sync=fermenter.name></input-text> <input-text :textarea=true name=description label=\"Tank Description\" :vmodel.sync=fermenter.description></input-text> <input-text type=text name=volume label=\"Tank Volume\" :vmodel.sync=fermenter.volume :spinner=true postfix=kL></input-text> </fieldset> <fieldset> <legend>Properties (Optional)</legend> <input-select :options=\"[{ name: 'None', value: 1 }, { name: 'Full', value: 2 }, { name: 'Jacket Only', value: 3 }]\" name=insulation :vmodel.sync=fermenter.insulation label=Insulation> </input-select> <div class=margin-20></div> <input-text type=text name=diameter label=Diameter :vmodel.sync=fermenter.diameter :spinner=true postfix=m></input-text> <input-text type=text name=height label=Height :vmodel.sync=fermenter.height :spinner=true postfix=m></input-text> <input-text type=text name=hd_ratio label=\"H/D Ratio\" :vmodel.sync=fermenter.hd_ratio :spinner=true postfix=m/m></input-text> </fieldset> </form> <div v-if=fermenter.id> <a @click=destroy() class=\"btn btn-danger\"><i class=\"fa fa-close\"></i> Delete Fermenter</a> </div> </div> </div> ";

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports = " <div class=row v-show=!loading> <div class=col-lg-6> <tank-group-form v-if=showTankGroupForm :tank-group.sync=tankGroup :just-repositioned.sync=justRepositioned></tank-group-form> <fermenter-form v-else :fermenter.sync=fermenter :just-repositioned.sync=justRepositioned></fermenter-form> </div> <div class=col-lg-6> <div class=box> <div class=box-header> <h2 class=box-title>Fermenter List</h2> </div> <div class=box-body> <a @click=createNewFermenter class=\"btn btn-sm btn-success\"><i class=\"fa fa-plus\"></i> Create New Fermenter</a> <a @click=createNewTankGroup class=\"btn btn-sm btn-success\"><i class=\"fa fa-plus\"></i> Create New Tank Group</a> <hr/> <div class=\"alert alert-info\"> <i class=\"fa fa-info-circle\"></i> Drag and drop your fermenters list into your preferred correct order. </div> <ol class=sortable> <li v-for=\"tankGroup in tankGroups\" :id=\"`tank_${tankGroup.id}`\" class=tank_group @click.stop=\"edit('tankGroup', tankGroup)\" :class=\"{'active': tankGroup.id == activeTankGroup.id}\"> <div>{{ tankGroup.name }}</div> <ol v-if=tankGroup.fermenters> <li v-for=\"fermenter in tankGroup.fermenters.data\" @click.stop=\"edit('fermenter', fermenter)\" :class=\"{'active': fermenter.id == activeFermenter.id}\" :id=\"`fermenter_${fermenter.id}`\"> <div>{{ fermenter.name }}</div> </li> </ol> </li> </ol> </div> </div> </div> </div> ";

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports = " <div class=box> <div class=box-header> <h2 class=box-title v-if=tankGroup.id>Edit Tank Group</h2> <h2 class=box-title v-else>Create New Tank Group</h2> </div> <div class=box-body> <div class=margin-20></div> <form class=form-horizontal @submit=saveOrCreate()> <fieldset> <input-text name=name label=\"Group Name\" :vmodel.sync=tankGroup.name></input-text> </fieldset> </form> <div v-if=tankGroup.id> <a @click=destroy() class=\"btn btn-danger\"><i class=\"fa fa-close\"></i> Delete Tank Group</a> </div> </div> </div> ";

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	module.exports = " <div class=ferment-container style=\"position: relative; padding-left: 20px; padding-right: 20px\" v-show=!loading> <div class=ferment_nav v-if=\"!ferment.archived && $route.name == 'ferments.index'\"> <a v-if=fermenter.previous href=# @click.prevent=gotoPreviousFermenter class=left><i class=\"fa fa-chevron-left\"></i></a> <a v-if=fermenter.next href=# @click.prevent=gotoNextFermenter class=right><i class=\"fa fa-chevron-right\"></i></a> </div> <div class=row> <div class=col-lg-6 v-if=\"$route.name != 'ferments.what-now'\"> <div class=box> <div class=box-header> <h2 class=box-title>Ferment Data - {{fermenter.name}}</h2> <div class=\"btn-group pull-right top-download-button\" v-if=\"ferment.id && this.$route.name == 'ferments.index'\"> <button :disabled=simulatorRunning type=button class=\"btn btn-xs btn-success dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false> <i class=\"fa fa-download\"></i> Download Report <span class=caret></span> </button> <ul class=dropdown-menu> <li> <a href=# @click.prevent=\"download('excel')\"> <i class=\"fa fa-file-excel-o\"></i> Download Excel File </a> </li> <li> <a href=# @click.prevent=\"download('pdf')\"> <i class=\"fa fa-file-pdf-o\"></i> Download PDF File </a> </li> <li> <a href=# @click.prevent=\"download('jpg')\"> <i class=\"fa fa-file-image-o\"></i> Download JPG File </a> </li> </ul> </div> </div> <div class=box-body> <form class=form-horizontal> <fieldset> <div class=form-group> <label for=wine_name class=\"col-sm-4 col-md-3 control-label\"> {{ simulator.custom_wine_name ? simulator.custom_wine_name : 'Wine Name' }}* </label> <div class=\"col-sm-8 col-md-9\"> <input type=text name=wine_name v-model=ferment.wine_name class=form-control> </div> </div> <div class=form-group v-show=simulator.blend_code> <label for=blend_code class=\"col-sm-4 col-md-3 control-label\"> {{ simulator.custom_blend_code ? simulator.custom_blend_code : 'Blend Code' }} </label> <div class=\"col-sm-8 col-md-9\"> <input type=text name=blend_code v-model=ferment.blend_code class=form-control> </div> </div> <div class=form-group v-show=simulator.blend_code> <label for=batch_code class=\"col-sm-4 col-md-3 control-label\"> {{ simulator.custom_batch_code ? simulator.custom_batch_code : 'Batch Code' }} </label> <div class=\"col-sm-8 col-md-9\"> <input type=text name=batch_code v-model=ferment.batch_code class=form-control> </div> </div> <input-select :select2=true :options=varietalOptions :disabled=haveMultipleVarietals name=varietal_id :vmodel.sync=selectedVarietalOption label=Varietal v-if=!loading> </input-select> <input-select :select2=true :options=regionOptions name=region_id :vmodel.sync=selectedRegionOption label=Region v-if=!loading> </input-select> <input-select :select2=true :options=winemakerOptions name=winemaker_id :vmodel.sync=selectedWinemakerOption label=Winemaker v-if=!loading> </input-select> <input-date name=start_date :vmodel.sync=ferment.start_date label=\"Date Start*\"></input-date> <input-select :select2=true :options=blendComponentOptions name=blend_component_id label=\"Blend Components\" :vmodel.sync=selectedBlendComponent v-if=\"!loading && isBlendedFerment\"> </input-select> <div class=form-group v-if=havePreviousFermenters> <label class=\"col-sm-4 col-md-3 control-label\">Previous Fermenters</label> <div class=\"col-sm-8 col-md-9\"> <ul class=previous-fermenter-list> <li v-for=\"previousFermenter in ferment.previousFermenters.data\">{{ previousFermenter.name }}</li> </ul> </div> </div> <div class=margin-20></div> </fieldset> <fieldset v-if=!isBlendedFerment> <legend class=legend-collapse> Juice Analysis <a data-toggle=collapse data-target=.juice-analysis class=fieldset-collapse></a> </legend> <div class=\"juice-analysis collapse\" :class=\"{'in': ! collapsed('juice-analysis')}\"> <input-text :vmodel.sync=ferment.juiceAnalysis.data.baume :spinner=true :postfix=units.sugarUnit() name=baume label=Sugar> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.yan :spinner=true postfix=mg/L name=yan label=YAN*> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.ph :spinner=true name=ph label=pH> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.ta :spinner=true postfix=g/L name=ta label=TA> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.fs02 :spinner=true postfix=mg/L name=fs02 label=\"FS0<sub>2</sub>\"> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.ts02 :spinner=true postfix=mg/L name=ts02 label=\"TS0<sub>2</sub>\"> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.gf :spinner=true postfix=g/L name=gf label=G/F> </input-text> <input-text :vmodel.sync=ferment.juiceAnalysis.data.ntu :spinner=true name=ntu label=NTU> </input-text> </div> </fieldset> <fieldset v-if=!isBlendedFerment> <legend class=legend-collapse> Ferment Setup <a data-toggle=collapse data-target=.ferment-setup class=fieldset-collapse></a> </legend> <div class=\"ferment-setup collapse\" :class=\"{'in': ! collapsed('ferment-setup')}\"> <div class=row> <div class=col-md-6> <div class=form-group> <input-toggle name=type :vmodel.sync=ferment.type on=Red off=White label=\"Ferment Type\"> </input-toggle> </div> </div> </div> <div class=row> <div class=col-md-12> <input-select :select2=true :options=profileOptions name=profile :vmodel.sync=profile label=\"Ferment Profile\" v-if=!loading> </input-select> </div> <div class=col-md-12> <input-text :vmodel.sync=ferment.duration :spinner=true postfix=Days name=duration label=\"Desired Duration*\"> </input-text> </div> </div> <div class=row> <div class=\"col-md-4 col-md-offset-1\"> <div class=form-group> <input-toggle name=type :vmodel.sync=ferment.climate on=Warm off=Cool off-style=primary label=Climate> </input-toggle> </div> </div> <div class=col-md-5> <input-toggle name=type :vmodel.sync=ferment.style on=Inoculate on-style=default off=Wild off-style=info label=\"Ferment Style\"> </input-toggle> </div> </div> <div class=row> <div class=\"col-md-6 col-md-offset-6\"> <input-select :select2=true :options=yeastTypeOptions name=yeast_type_id :vmodel.sync=ferment.yeast_type_id label=\"Yeast Types\" v-if=!loading> </input-select> </div> </div> <div class=margin-20></div> <input-text :vmodel.sync=ferment.volume :spinner=true postfix=T name=volume label=\"Ferment Volume*\"> </input-text> <input-text :vmodel.sync=ferment.total_water_added :spinner=true postfix=L name=water_added label=\"Total Water Added\"> </input-text> <div class=row> <div class=\"col-sm-offet-4 col-sm-4 col-md-offset-3 col-md-4\"> Calculated Sugar: {{{ calculateBaume() }}} </div> <div class=\"col-sm-4 col-md-5\"> Calculated YAN: {{{ calculateYan() }}} <a class=\"pull-right fa fa-question-circle popover-help\" style=margin-top:5px tabindex=0 role=button data-placement=left data-html=true data-trigger=focus data-container=body title=Help data-content=\"\n\t\t\t\t\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\t\t\t\t\tThe initial Be and YAN from the juice analysis are recalculated to account for dilution associated with any additions, etc. at the beginning of ferment. To ensure accurate ferment conditions, be sure to include all initial water additions above, and then throughout the ferment in the data table.\n\t\t\t\t\t\t\t\t\t\t\t</small>\"> </a> </div> </div> <div class=margin-20></div> <div class=form-group> <div class=\"col-sm-4 col-md-3\"> <a class=\"pull-right fa fa-question-circle popover-help\" style=\"margin-left: 10px; margin-top: 10px\" tabindex=0 role=button data-placement=left data-html=true data-trigger=focus data-container=body title=Help data-content=\"\n\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\tIf propagating, you can leave this blank and the simulator will figure it out, or you can use the following equation to convert your cell concentration:\n\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\t<code>Cell conc (cells/ml) x pitch rate (decimal) x 5x10^-5</code>\n\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t<small style='margin-bottom: 10px; display: block'>\n\t\t\t\t\t\t\t\t\t\t\t\tFor example:\n\t\t\t\t\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\t\t\t\t\t<code>Equivalent dry yeast = 1x10^8 x 0.05 x 5x10^-5 = 250mg/L</code>\n\t\t\t\t\t\t\t\t\t\t\t</small>\"> </a> <label for=initial_cell_mass class=\"control-label pull-right\"> Initial Cell Mass </label> </div> <div class=\"col-sm-8 col-md-9\"> <input-text :vmodel.sync=ferment.initial_cell_mass :spinner=true postfix=mg/L name=initial_cell_mass> </input-text> </div> </div> <div class=margin-20></div> <div class=form-group> <label for=comments class=\"col-sm-4 col-md-3 control-label\">Comments</label> <div class=\"col-sm-8 col-md-9\"> <textarea name=comments v-model=ferment.comments class=form-control rows=8></textarea> </div> </div> </div> </fieldset> </form> <daily-data v-if=measuringFreqInteger :ferment=ferment :daily-data.sync=ferment.dailyData :measuring-freq=ferment.measuring_freq :measuring-freq-integer=measuringFreqInteger :archived=ferment.archived :days-as-dates=true :start-date=ferment.start_date :editing-disabled=\"ferment.archived && $route.name == 'ferments.index'\"> </daily-data> <hr/> <div class=margin-20></div> <ul class=\"nav nav-pills nav-justified\" v-if=\"ferment.id && this.$route.name == 'ferments.index'\"> <li> <div class=\"btn-group btn-block\"> <button :disabled=simulatorRunning type=button class=\"btn btn-block btn-sm btn-success dropdown-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false> <i class=\"fa fa-download\"></i> Download Report <span class=caret></span> </button> <ul class=dropdown-menu> <li> <a href=# @click.prevent=\"download('excel')\"> <i class=\"fa fa-file-excel-o\"></i> Download Excel File </a> </li> <li> <a href=# @click.prevent=\"download('pdf')\"> <i class=\"fa fa-file-pdf-o\"></i> Download PDF File </a> </li> <li> <a href=# @click.prevent=\"download('jpg')\"> <i class=\"fa fa-file-image-o\"></i> Download JPG File </a> </li> </ul> </div> </li> <li v-if=ferment.archived> <a href=# @click.prevent=\"download('csv')\" class=\"btn btn-sm btn-sm btn-info\"> <i class=\"fa fa-external-link-square\"></i> Extract Temperature Profile </a> </li> <li v-if=!ferment.archived> <a @click=clearFermenter() class=\"btn btn-sm btn-sm btn-info\"> <i class=\"fa fa-minus\"></i> Clear Fermenter </a> </li> <li v-if=!ferment.archived> <a @click.prevent=archive() class=\"btn btn-sm btn-sm btn-info\"> <i class=\"fa fa-archive\"></i> Archive Ferment </a> </li> </ul> </div> </div> </div> <div class=col-lg-6> <div class=box :class=\"{'sticky-box': $route.name != 'ferments.what-now'}\"> <div class=box-header> <h2 class=box-title> Ferment Graph </h2> <a href=# id=graph-full data-toggle=modal data-target=#ferment_graph_modal> <span class=text>Expand</span> <i class=\"fa fa-expand\"></i> </a> </div> <div class=box-body> <ferment-graph v-if=!loading></ferment-graph> </div> </div> </div> <div class=\"modal modal-fullscreen fade\" id=ferment_graph_modal tabindex=-1 role=dialog aria-labelledby=actionsTitle aria-hidden=true> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button> <h4 class=modal-title id=actionsTitle>Ferment Graph</h4> </div> <div class=modal-body> <canvas class=page-graph id=ferment-modal-graph></canvas> </div> <div class=modal-footer> <button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button> </div> </div> </div> </div> <form method=post id=download-ferment> <input type=hidden name=graph> </form> </div> </div> ";

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=!exists class=checklist> <div class=checklist-danger> <input type=checkbox name=checkbox disabled=disabled /> <label><slot></slot></label> </div> </div> ";

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = " <div> <div v-if=\"!reloading && !nothingToSimulate && !isBlendedFerment\"> <p v-if=hasEnoughBaume()> <span v-if=\"simulation.status == 1\" class=\"label label-lg label-success\"> <i class=\"fa fa-check\"></i> Good </span> <span v-if=\"simulation.status == 10\" class=\"label label-lg label-info\"> <i class=\"fa fa-exclamation-triangle\"></i> Low Range On Spec </span> <span v-if=\"simulation.status == 20\" class=\"label label-lg label-danger\"> <i class=\"fa fa-exclamation-triangle\"></i> High Range On Spec </span> <span v-if=\"simulation.status == 30\" class=\"label label-lg label-info\"> <i class=\"fa fa-exclamation-triangle\"></i> Sluggish Fermentation </span> <span v-if=\"simulation.status == 40\" class=\"label label-lg label-danger\"> <i class=\"fa fa-exclamation-triangle\"></i> Rapid Fermentation </span> <span v-if=\"simulation.prediction_score > 25\" class=\"label label-lg label-warning\" style=\"margin-left: 6px\"> <i class=\"fa fa-exclamation-triangle\"></i> Poor Simulation </span> </p> <p v-else> <span class=\"label label-lg label-warning\"> <i class=\"fa fa-exclamation-triangle\"></i> Not Enough Data </span> </p> <p v-if=!hasEnoughBaume() class=text-center>Need more Baume measurements (at least 4) to make a prediction.</p> </div> <p> <a class=\"pull-right fa fa-question-circle popover-help\" tabindex=0 role=button data-container=body data-placement=left data-html=true data-trigger=focus title=Help :data-content=popoverContent> </a> </p> <div v-if=reloading class=loading-graph> <div class=status-loading></div> </div> <canvas v-if=\"!reloading && !nothingToSimulate && !unableToSimulate && !failedToSimulate\" class=page-graph id=ferment-graph height=200></canvas> <div v-if=!reloading> <div v-if=nothingToSimulate> <h4>Nothing to simulate. Please add ferment data.</h4> </div> <div v-if=unableToSimulate> <h4>Unable to simulate. Not enough ferment data.</h4> </div> <div v-if=failedToSimulate> <h4>The simulation has failed.</h4> </div> </div> <div v-if=\"!checklistCompleted && !isBlendedFerment\"> <h4>Simulation Checklist</h4> <div class=checklist> <checklist-item v-for=\"list in checklist\" :exists=list.exists track-by=message> {{list.message}}  </checklist-item></div> </div> <div class=margin-20></div> <div v-if=\"!reloading && !nothingToSimulate && !unableToSimulate && !failedToSimulate && !isBlendedFerment\"> <div class=margin-20></div> <div class=row> <div class=col-xs-4> Sugars: {{ getLastSugar() }} {{{ getSugarUnit() }}} </div> <div class=col-xs-4> Temperature: {{ getLastTemperature() }} {{{ getTemperatureUnit() }}} </div> <div v-if=getPredictedPeakRate() class=col-xs-4> Predicted Peak Rate: {{ getPredictedPeakRate() }} </div> </div> <div class=row> <div class=col-xs-4> Predicted Duration: {{ getPredictedDuration() }} days </div> <div class=col-xs-4> Predicted End Date: {{ getPredictedEndDate() }} </div> <div class=col-xs-4> Predicted Peak Date: {{ getPredictedPeakDate() }} </div> </div> <div class=margin-20></div> </div> <div class=row v-if=\"$route.name == 'ferments.index' && !nothingToSimulate && !isBlendedFerment\"> <div class=col-sm-4> <button class=\"btn btn-primary btn-lg btn-block\" :disabled=simulatorRunning @click.prevent=\"$emit('reloadGraph', true)\">Run Simulation</button> </div> <div class=col-sm-4> <a v-link=\"{name: 'ferments.what-now', params: { fermenterId: fermenter.id, fermentId: ferment.id }}\" class=\"btn btn-lg btn-block btn-primary\">What Now?</a> </div> <div class=col-sm-4> <a v-link=\"{name: 'ferments.what-if', params: { fermenterId: fermenter.id, fermentId: ferment.id }}\" class=\"btn btn-lg btn-block btn-primary\">What If?</a> </div> </div> <div v-if=\"$route.name == 'ferments.what-if' && !nothingToSimulate\"> <what-if></what-if> </div> <div v-if=\"$route.name == 'ferments.what-now' && !nothingToSimulate\"> <what-now></what-now> </div> </div> ";

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports = " <div class=row v-if=\"$route.name == 'ferments.what-if'\"> <div class=col-md-4> <a v-link=\"{name: 'ferments.index', params: { fermenterId: fermenter.id, fermentId: ferment.id }}\" class=\"btn btn-primary\"><i class=\"fa fa-arrow-left\"></i> Return To Ferment</a> </div> <div class=col-md-8> <div class=pull-right> <button class=\"btn btn-primary btn-sm\" :disabled=simulatorRunning @click.prevent=\"$dispatch('reloadGraph', true)\">Run Simulation</button> <div class=btn-group> <button type=button class=\"btn btn-block btn-sm btn-info dropdown-toggle\" :disabled=simulatorRunning data-toggle=dropdown aria-haspopup=true aria-expanded=false> <i class=\"fa fa-download\"></i> Download <span class=caret></span> </button> <ul class=dropdown-menu> <li> <a href=# @click.prevent=\"download('excel')\"> <i class=\"fa fa-file-excel-o\"></i> Download Excel File </a> </li> <li> <a href=# @click.prevent=\"download('pdf')\"> <i class=\"fa fa-file-pdf-o\"></i> Download PDF File </a> </li> <li> <a href=# @click.prevent=\"download('jpg')\"> <i class=\"fa fa-file-image-o\"></i> Download JPG File </a> </li> </ul> </div> <button @click.prevent=\"$dispatch('resetChanges')\" class=\"btn btn-danger\" :disabled=simulatorRunning><i class=\"fa fa-repeat\"></i> Reset</button> </div> </div> <form method=post id=download-ferment> <input type=hidden name=graph> <input type=hidden name=ferment> </form> </div> ";

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports = " <div> <div class=\"row row-slider\"> <div class=col-sm-4> <p class=\"control-label text-right\">Temperature</p> </div> <div class=col-sm-6> <input class=slider id=what-now-temperature v-model=actions.temperature> </div> <div class=col-sm-2> &deg;C </div> </div> <div class=\"row row-slider\"> <div class=col-sm-4> <p class=\"control-label text-right\">Add DAP</p> </div> <div class=col-sm-6> <input class=slider id=what-now-add-dap v-model=actions.dap> </div> <div class=col-sm-2> mg/L </div> </div> <div class=\"row row-slider\"> <div class=col-sm-4> <p class=\"control-label text-right\">Agitator</p> </div> <div class=col-sm-6> <input class=slider id=what-now-agitator v-model=actions.agitator> </div> <div class=col-sm-2> </div> </div> <div class=\"row row-slider\"> <div class=col-sm-4> <p class=\"control-label text-right\">Overseed</p> </div> <div class=col-sm-6> <input class=slider id=what-now-reinoculate v-model=actions.reinoculate> </div> <div class=col-sm-2> mg/L </div> </div> <div class=\"row row-slider\"> <div class=col-sm-4> <p class=\"control-label text-right\" style=padding-top:6px>Pumpover</p> </div> <div class=col-sm-8> <input-toggle name=what_now_pumpover on=Performed off=None on-style=success :vmodel.sync=actions.pump_over></input-toggle> </div> </div> <div class=row> <div class=col-md-6> <a v-link=\"{name: 'ferments.index', params: { fermenterId: fermenter.id, fermentId: ferment.id }}\" class=\"btn btn-primary\"><i class=\"fa fa-arrow-left\"></i> Return To Ferment</a> </div> <div class=\"col-md-6 text-right\"> <button class=\"btn btn-primary\" :disabled=simulatorRunning @click.prevent=runSimulation>Run Simulation</button> </div> </div> </div> ";

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-sm-12 v-show=!loading> <div class=box> <div class=box-body> <form class=\"form-horizontal form-history\" @submit.prevent=search> <div class=form-group> <label for=inputSearch class=\"col-sm-2 col-lg-2 search-label control-label\">Search</label> <div class=\"col-sm-10 col-lg-8 search-field\"> <input type=text class=form-control v-model=searchTerm id=inputSearch placeholder=Keywords autocomplete=off /> </div> </div> <div class=row> <div class=\"col-sm-6 col-lg-4\"> <div class=form-group> <label class=\"col-sm-4 col-lg-4 control-label\">Vintage</label> <div class=\"col-sm-8 col-lg-8\"> <select class=form-control v-model=filters.vintage> <option value=\"\" selected=selected>All</option> <option v-for=\"vintage in vintageOptions\" value={{vintage.value}}>{{vintage.name}}</option> </select> </div> </div> </div> <div class=\"col-sm-6 col-lg-4\"> <div class=form-group> <label class=\"col-sm-4 col-lg-4 control-label\">Varietal</label> <div class=\"col-sm-8 col-lg-8\"> <select class=form-control v-model=filters.varietal_id> <option value=\"\" selected=selected>All</option> <option v-for=\"varietal in varietalOptions\" value={{varietal.value}}>{{varietal.name}}</option> </select> </div> </div> </div> <div class=\"col-sm-6 col-lg-4\"> <div class=form-group> <label class=\"col-sm-4 col-lg-4 control-label\">Yeast Type</label> <div class=\"col-sm-8 col-lg-8\"> <select class=form-control v-model=filters.yeast_type_id> <option value=\"\" selected=selected>All</option> <option v-for=\"yeastType in yeastTypeOptions\" value={{yeastType.value}}>{{yeastType.name}}</option> </select> </div> </div> </div> <div class=\"col-sm-6 col-lg-4\"> <div class=form-group> <label class=\"col-sm-4 col-lg-4 control-label\">Fermenter</label> <div class=\"col-sm-8 col-lg-8\"> <select class=form-control v-model=filters.fermenter_id> <option value=\"\" selected=selected>All</option> <option v-for=\"fermenter in fermenterOptions\" value={{fermenter.value}}>{{fermenter.name}}</option> </select> </div> </div> </div> <div class=\"col-sm-6 col-lg-4\"> <div class=form-group> <label class=\"col-sm-4 col-lg-4 control-label\">Performance</label> <div class=\"col-sm-8 col-lg-8\"> <select class=form-control v-model=filters.performance> <option value=\"\" selected=selected>All</option> <option v-for=\"performance in performanceOptions\" value={{performance.value}}>{{performance.name}}</option> </select> </div> </div> </div> <div class=\"col-sm-12 col-lg-4\"> <div class=\"col-lg-6 search-btn-container\"> <button type=reset class=\"btn btn-block btn-info\" @click.prevent=resetFilters>Clear Filters</button> </div> <div class=\"col-lg-6 search-btn-container\"> <button type=submit class=\"btn btn-block btn-success\" @click.prevent=search>Search</button> </div> </div> </div> </form> <hr/> <table id=table-history-search class=\"table table-bordered table-hover\"> <thead> <tr> <th data-priority=2>Fermenter</th> <th>Start Date</th> <th data-priority=3>Name</th> <th>Blend Code</th> <th>Batch Code</th> <th>Varietal</th> <th>Duration</th> <th>Performance</th> <th data-priority=1>View</th> </tr> </thead> <tfoot> <tr> <th>Fermenter</th> <th>Start Date</th> <th>Name</th> <th>Blend Code</th> <th>Batch Code</th> <th>Varietal</th> <th>Duration</th> <th>Performance</th> <th>View</th> </tr> </tfoot> <tbody> <tr v-for=\"ferment in filteredFerments\"> <td>{{ferment.fermenter.data.name}}</td> <td :data-sort=\"moment(ferment.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')\">{{ferment.start_date}}</td> <td>{{ferment.wine_name}}</td> <td>{{ferment.blend_code}}</td> <td>{{ferment.batch_code}}</td> <td>{{ferment.varietal}}</td> <td>{{ferment.duration}}</td> <td> {{ferment.gauge.data.status == 10 ? 'Low Range On Spec' : ''}} {{ferment.gauge.data.status == 20 ? 'High Range On Spec' : ''}} {{ferment.gauge.data.status == 30 ? 'Sluggish' : ''}} {{ferment.gauge.data.status == 40 ? 'Rapid' : ''}} </td> <td><a v-link=\"{name: 'ferments.index', params: { fermenterId: ferment.fermenter.data.id, fermentId:ferment.id }}\" class=\"btn btn-sm btn-block btn-primary\">View <i class=\"fa fa-arrow-right\"></i></a></td> </tr> </tbody> </table> <hr/> <a :href=\"Http.buildPath(`ferments/export-history?ferments=${this.fermentsToExport.join(',')}`)\" class=\"btn btn-sm btn-success\" :class=\"{'disabled': filteredFerments.length == 0 || eventLoading}\"> <i class=\"fa fa-table\"></i> Export To Excel </a> </div> </div> </div> ";

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = " <div class=row v-show=!loading> <div class=col-lg-6> <profile-form :profile.sync=profile></profile-form> </div> <div class=col-lg-6> <div class=box> <div class=box-header> <h2 class=box-title>Profiles</h2> </div> <div class=box-body> <div class=\"alert alert-info\"> <i class=\"fa fa-info-circle\"></i> Drag and drop your profiles list into your preferred order. </div> <ol class=sortable> <li v-for=\"profile in profiles\" :id=\"`profile_${profile.id}`\" @click.stop=edit(profile) :class=\"{'active': profile.id == activeProfile.id}\"> <div>{{ profile.name }}</div> </li> </ol> <hr/> <a @click=createNewProfile class=\"btn btn-sm btn-success\"><i class=\"fa fa-plus\"></i> Create New Profile</a> <label for=upload-temperature-profile class=\"btn btn-sm btn-success\"><i class=\"fa fa-file-archive-o\"></i> Import Temperature Profile</label> <input type=file name=temperature_profile id=upload-temperature-profile accept=.csv> </div> </div> </div> </div> ";

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = " <div class=box> <div class=box-header> <h2 class=box-title v-if=profile.id>Editing Ferment Profile</h2> <h2 class=box-title v-else>New Ferment Profile</h2> </div> <div class=box-body> <p> Ferment profiles provide a rough temperature map for the simulator to follow. You don't have to use them, but outlining a temperature pathway will improve the prediction. Remember, the simulator will assume that the ferment will remain at the last temperature seen unless you tell it otherwise. </p> <form class=form-horizontal> <fieldset> <input-text name=name :vmodel.sync=profile.name label=\"Profile Name\"></input-text> <input-text name=duration :vmodel.sync=profile.duration label=\"Desired Duration\" :spinner=true postfix=Days></input-text> <div class=col-md-6> <input-toggle name=type :vmodel.sync=profile.type on=Red off=White label=\"Profile Type\"> </input-toggle> </div> </fieldset> <daily-data v-if=measuringFreqInteger :daily-data.sync=profile.dailyData :measuring-freq-integer=measuringFreqInteger :ferment-type=profile.type> </daily-data> <div class=\"alert alert-warning\" v-if=\"profile.dailyData && ! profile.name\" style=\"margin: 20px 0 0\"> <i class=\"fa fa-exclamation-triangle\"></i> Please note that all daily data will remain unsaved until you give this profile a name. </div> </form> <div class=margin-20></div> <a v-if=profile.id @click=delete class=\"btn btn-danger\"><i class=\"fa fa-close\"></i> Delete Profile</a> </div> </div> ";

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = " <div class=row v-if=ready> <div v-if=authorized.database_exportable class=col-xs-12 style=\"margin-bottom: 15px\"> <a href={{exportPath}} class=\"btn btn-primary pull-right\">Export Database</a> </div> <div class=clearfix></div> <yeast-types></yeast-types> <varietals></varietals> <regions></regions> <div class=clearfix></div> <what-now></what-now> </div> ";

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-sm-6> <div class=box> <div class=box-header> <h2 class=box-title>Varietals</h2> </div> <div class=box-body> <div class=form-group> <ul class=list-remove> <li v-for=\"varietal in varietals\">{{varietal.name}}<a @click.prevent=remove(varietal) class=\"varietal-delete btn btn-sm\"><i class=\"fa fa-close\"></i> Delete</a></li> <li v-if=\"!varietals.length && !loading\">No varietals.</li> <li v-if=\"!varietals.length && loading\">Loading varietals...</li> </ul> </div> <form @submit.prevent=save> <div class=input-group> <input type=text v-model=name class=form-control> <span class=input-group-btn> <button class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add Varietal</button> </span> </div> </form> </div> </div> </div> ";

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col-sm-12 what-now-settings\"> <div class=box> <div class=box-header> <h2 class=box-title>What Now Ranges</h2> </div> <div class=box-body> <fieldset class=form-horizontal> <div class=row> <div class=col-md-6> <legend>Temperature (&deg;C)</legend> <div class=row> <div class=col-sm-6> <input-text name=temperature_low :vmodel.sync=whatNow.temperature_low :spinner=true postfix=&deg;C label=Low></input-text> </div> <div class=col-sm-6> <input-text name=temperature_high :vmodel.sync=whatNow.temperature_high :spinner=true postfix=&deg;C label=High></input-text> </div> </div> </div> <div class=col-md-6> <legend>Add DAP (mg/L)</legend> <div class=row> <div class=col-sm-6> <input-text name=dap_low :vmodel.sync=whatNow.dap_low :spinner=true label=Low postfix=mg/L></input-text> </div> <div class=col-sm-6> <input-text name=dap_high :vmodel.sync=whatNow.dap_high :spinner=true label=High postfix=mg/L></input-text> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <legend>Agitator</legend> <div class=row> <div class=col-sm-6> <input-text name=agitator_low :vmodel.sync=whatNow.agitator_low :spinner=true label=Low></input-text> </div> <div class=col-sm-6> <input-text name=agitator_high :vmodel.sync=whatNow.agitator_high :spinner=true label=High></input-text> </div> </div> </div> <div class=col-md-6> <legend>Overseed (mg/L)</legend> <div class=row> <div class=col-sm-6> <input-text name=reinoculate_low :vmodel.sync=whatNow.reinoculate_low :spinner=true label=Low postfix=mg/L></input-text> </div> <div class=col-sm-6> <input-text name=reinoculate_high :vmodel.sync=whatNow.reinoculate_high :spinner=true label=High postfix=mg/L></input-text> </div> </div> </div> </div> </fieldset> </div> </div> </div> ";

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-sm-6> <div class=box> <div class=box-header> <h2 class=box-title>Yeast Types</h2> </div> <div class=box-body> <div class=form-group> <ul class=list-remove> <li v-for=\"yeastType in yeastTypes\">{{yeastType.name}} <a @click.prevent=remove(yeastType) class=\"yeast-delete btn btn-sm\"><i class=\"fa fa-close\"></i> Delete</a></li> <li v-if=\"!yeastTypes.length && !loading\">No yeast types.</li> <li v-if=\"!yeastTypes.length && loading\">Loading yeast types...</li> </ul> </div> <form @submit.prevent=save> <div class=input-group> <input type=text v-model=name class=form-control> <span class=input-group-btn> <button class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add Yeast Type</button> </span> </div> </form> </div> </div> </div> ";

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=winemakers class=col-sm-6> <div class=box> <div class=box-header> <h2 class=box-title>Winemakers</h2> </div> <div class=box-body> <div class=form-group> <ul class=list-remove> <li v-for=\"winemaker in winemakers\">{{winemaker.name}}<a @click.prevent=\"remove(winemaker, $index)\" class=\"region-delete btn btn-sm\"><i class=\"fa fa-close\"></i> Delete</a></li> <li v-if=\"!winemakers.length && !loading\">No winemakers.</li> <li v-if=\"!winemakers.length && loading\">Loading winemakers...</li> </ul> </div> <form @submit.prevent=save> <div class=input-group> <input type=text v-model=name class=form-control> <span class=input-group-btn> <button class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add Winemaker</button> </span> </div> </form> </div> </div> </div>";

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = " <div class=row v-show=!loading> <div class=\"col-md-4 col-md-offset-4\"> <div class=select-site> <h2>Please Select A Site</h2> <div class=wrap-fluid> <div class=row> <div class=col-lg-12> <div class=account-box> <form role=form @submit.prevent=submit> <input-select :select2=true :options=siteOptions name=site class=\"\" :vmodel.sync=selected> </input-select> <hr/> <button class=\"btn btn-sm btn-primary\">Continue <i class=\"fa fa-chevron-right\"></i></button> </form> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	module.exports = " <div class=status-loading v-show=loading>&nbsp;</div> <div class=\"container-fluid paper-wrap bevel tlbr\"> <div id=paper-top> <div class=row> <div class=\"col-sm-3 no-pad\"> <a class=\"navbar-brand logo-text\" href=#> <img src=/static/img/header-logo.png alt=\"The Australian Wine Research Institute\"/> </a> </div> <div class=\"col-sm-9 no-pad\"> <h1 class=page-title> {{ title || '' }} <span v-if=\"site.id && title\"> | {{ site.name }} </span> <span v-if=\"site.id && !title\"> {{ site.name }} </span> </h1> </div> </div> </div> <div class=wrap-sidebar-content> <navigation></navigation> <div class=wrap-fluid id=paper-bg> <router-view></router-view> </div> </div> <div id=footer> <a href=http://www.awri.com.au/ target=_blank class=\"copyright pull-left hidden-xs\" style=\"padding-left: 25px\">AWRI Home</a> <a href=http://www.awri.com.au/disclaimer/ target=_blank class=\"copyright pull-left\">Disclaimer</a> <a href=http://www.awri.com.au/privacy-policy/ target=_blank class=\"copyright pull-left\">Privacy Policy</a> <a href=http://www.awri.com.au/industry_support/winemaking_resources/wine_fermentation/awri-ferment-simulator/ target=_blank class=\"copyright pull-left\">Help and FAQs</a> <a v-if=\"authorized.access == 30\" href=https://thewinecloud.com.au/Secure/Administrator/DashBoard.aspx target=_blank class=\"copyright pull-left visible-md-block visible-lg-block\">WineCloud Home</a> <a v-else href=https://thewinecloud.com.au/Secure/Client/DashBoard.aspx target=_blank class=\"copyright pull-left visible-md-block visible-lg-block\">WineCloud Home</a> <a href=http://www.awri.com.au/industry_support/helpdesk/ target=_blank class=\"copyright pull-left visible-md-block visible-lg-block\">AWRI Helpdesk</a> <div class=copyright>Copyright &copy; {{currentYear}} The Australian Wine Research Institute</div> </div> </div> ";

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = " <div class=form-group :class=\"{'has-error': hasError}\" _v-07f5ca6f=\"\"> <label v-if=label :for=name class=\"col-sm-4 col-md-6 control-label control-label-toggle\" _v-07f5ca6f=\"\"><i v-if=icon class=\"fa fa-{{icon}}\" _v-07f5ca6f=\"\"></i> {{label}}</label> <div :class=\"{'col-sm-8 col-md-6': label}\" _v-07f5ca6f=\"\"> <div class=checkbox _v-07f5ca6f=\"\"> <input type=checkbox :id=name v-toggle=vmodel :on=on :off=off :on-style=onStyle :off-style=offStyle _v-07f5ca6f=\"\"> </div> <span v-if=hasError class=help-block _v-07f5ca6f=\"\"><i class=\"fa fa-exclamation-triangle\" _v-07f5ca6f=\"\"></i> {{ errorMessage }}</span> </div> </div> ";

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"modal fade\" id=move_ferment role=dialog aria-labelledby=actionsTitle aria-hidden=true _v-14ee6110=\"\"> <div class=modal-dialog _v-14ee6110=\"\"> <div class=modal-content _v-14ee6110=\"\"> <div class=modal-header _v-14ee6110=\"\"> <button type=button class=close data-dismiss=modal _v-14ee6110=\"\"><span aria-hidden=true _v-14ee6110=\"\">×</span><span class=sr-only _v-14ee6110=\"\">Close</span></button> <h4 class=modal-title id=actionsTitle _v-14ee6110=\"\">Move Ferment</h4> </div> <div class=modal-body _v-14ee6110=\"\"> <div class=row v-if=!confirmSelection _v-14ee6110=\"\"> <div class=col-xs-12 _v-14ee6110=\"\"> <input-select :select2=true :inline=true :options=fermenterOptions name=destination_fermenter_id :vmodel.sync=destinationFermenterId label=\"Please select a destination tank\" _v-14ee6110=\"\"> </input-select> </div> </div> <div class=row v-else=\"\" _v-14ee6110=\"\"> <div class=col-xs-12 v-if=destinationFermenterIsEmpty _v-14ee6110=\"\"> This will move this ferment to <strong _v-14ee6110=\"\">{{ destinationFermenterName }}</strong>. Do you want to continue? </div> <div class=col-xs-12 v-else=\"\" _v-14ee6110=\"\"> <strong _v-14ee6110=\"\">{{ destinationFermenterName }}</strong> already has a ferment running. This operation will blend them together. If you expected <strong _v-14ee6110=\"\">{{ destinationFermenterName }}</strong> to be empty, please go and archive that ferment first. Do you want to continue? <div class=\"alert alert-warning\" v-if=destinationFermentMissingData _v-14ee6110=\"\"> The destination ferment might be missing data. Make sure all data is entered on the blend components before blending. You won't be able to edit the individual component records once a blend is created. </div> </div> </div> </div> <div class=modal-footer _v-14ee6110=\"\"> <button v-if=!confirmSelection type=button class=\"btn btn-default\" data-dismiss=modal _v-14ee6110=\"\">Close</button> <button v-else=\"\" @click=cancelSelection type=button class=\"btn btn-default\" _v-14ee6110=\"\">Cancel</button> <button v-if=\"!destinationFermenterIsEmpty &amp;&amp; confirmSelection\" type=button class=\"btn btn-success\" @click=goToDestinationFerment _v-14ee6110=\"\">Go to {{ destinationFermenterName }}</button> <button @click=continue type=button class=\"btn btn-primary\" :disabled=\"haveNoDestinationFermenter || continuing\" _v-14ee6110=\"\">Continue</button> </div> </div> </div> </div> ";

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	module.exports = " <div class=form-group :class=\"{'has-error': hasError}\" v-if=!inline _v-1eee0689=\"\"> <label v-if=label :for=name class=\"col-sm-4 col-md-3 control-label\" _v-1eee0689=\"\">{{ label }}</label> <div class=\"col-sm-8 col-md-9\" _v-1eee0689=\"\"> <div class=input-group _v-1eee0689=\"\"> <span v-if=prependIcon class=input-group-addon _v-1eee0689=\"\"><i class=\"fa fa-fw fa-{{ prependIcon }}\" _v-1eee0689=\"\"></i></span> <input :type=type :name=name :id=name :date-format=dateFormat class=\"form-control dateselect\" :placeholder=placeholder v-model=vmodel v-datepicker=vmodel :start-date=vmodel readonly=readonly _v-1eee0689=\"\"> </div> <span v-if=hasError class=help-block _v-1eee0689=\"\"><i class=\"fa fa-exclamation-triangle\" _v-1eee0689=\"\"></i> {{ errorMessage }}</span> </div> </div> <div v-else=\"\" _v-1eee0689=\"\"> <label v-if=label :for=name class=control-label _v-1eee0689=\"\">{{ label }}</label> <input :type=type :name=name :id=name :date-format=dateFormat class=\"form-control dateselect\" :placeholder=placeholder v-model=vmodel v-datepicker=vmodel :start-date=vmodel readonly=readonly _v-1eee0689=\"\"> </div> ";

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	module.exports = " <div class=row v-show=!loading _v-319cc023=\"\"> <div class=col-lg-12 _v-319cc023=\"\"> <div class=box _v-319cc023=\"\"> <div class=box-header _v-319cc023=\"\"> <h2 class=box-title _v-319cc023=\"\">Ferment Simulator Setup</h2> </div> <div class=box-body _v-319cc023=\"\"> <form class=\"form-horizontal form-col-tight\" _v-319cc023=\"\"> <fieldset _v-319cc023=\"\"> <legend _v-319cc023=\"\">Data Entry</legend> <div class=\"row row-clear-md-6-lg-4\" _v-319cc023=\"\"> <div class=\"col-md-8 col-lg-8\" _v-319cc023=\"\"> <input-text type=text name=dap_grade :vmodel.sync=simulatorSetup.dap_grade :spinner=true postfix=\"% N\" label=\"DAP Grade\" _v-319cc023=\"\"></input-text> <input-text type=text name=default_yan :vmodel.sync=simulatorSetup.default_yan :spinner=true label=\"Default YAN (if unknown)\" postfix=mg/L _v-319cc023=\"\"></input-text> </div> </div> <div class=row _v-319cc023=\"\"> <div class=\"col-md-6 col-lg-6\" _v-319cc023=\"\"> <div class=form-group _v-319cc023=\"\"> <label for=data_temperature_units class=\"col-xs-4 col-md-4 control-label control-label-toggle\" _v-319cc023=\"\">Temperature Units</label> <div class=\"col-xs-8 col-md-8\" _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.temp_units :value=simulatorSetup.temp_units data-on=°Celsius data-off=°Fahrenheit data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=data_sugar_units class=\"col-xs-4 col-md-4 control-label control-label-toggle\" _v-319cc023=\"\">Sugar Units</label> <div class=\"col-xs-8 col-md-8\" _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.sugar_units :value=simulatorSetup.sugar_units data-on=°Baume data-off=°Brix data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=data_secondary_sugar_units class=\"col-xs-4 col-md-4 control-label control-label-toggle\" _v-319cc023=\"\">Secondary Sugar Units</label> <div class=\"col-xs-8 col-md-8\" _v-319cc023=\"\"> <input type=checkbox v-toggle=secondarySugarUnits :value=secondarySugarUnits data-on=SG data-off=\"RS (g/L)\" data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=data_red_sampling_frequency class=\"col-xs-4 col-md-4 control-label control-label-toggle\" _v-319cc023=\"\">Red Sampling Frequency</label> <div class=\"col-xs-8 col-md-8\" _v-319cc023=\"\"> <input-text type=text name=data_red_sampling_frequency :vmodel.sync=simulatorSetup.red_sampling_freq :spinner=true postfix=\"per day\" _v-319cc023=\"\"></input-text> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=data_white_sampling_frequency class=\"col-xs-4 col-md-4 control-label control-label-toggle\" _v-319cc023=\"\">White Sampling Frequency</label> <div class=\"col-xs-8 col-md-8\" _v-319cc023=\"\"> <input-text type=text name=data_white_sampling_frequency :vmodel.sync=simulatorSetup.white_sampling_freq :spinner=true postfix=\"per day\" _v-319cc023=\"\"></input-text> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=data_date_day_display class=\"col-xs-4 col-md-4 control-label control-label-toggle\" _v-319cc023=\"\">Date / Day Display</label> <div class=\"col-xs-8 col-md-8\" _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.date_day_display :value=simulatorSetup.date_day_display data-on=Date data-off=Day data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> </div> </div> </fieldset> <fieldset _v-319cc023=\"\"> <legend _v-319cc023=\"\">Wine Description</legend> <div class=form-group _v-319cc023=\"\"> <label for=wine_name class=\"col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle\" _v-319cc023=\"\">Wine Name</label> <div class=\"col-xs-12 col-md-4 col-lg-3\" _v-319cc023=\"\"> <input type=text class=\"form-control form-control-toggle-top\" placeholder=Rename v-model=simulatorSetup.custom_wine_name _v-319cc023=\"\"> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=wine_blend_code class=\"col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle\" _v-319cc023=\"\">Blend Code</label> <div class=\"col-xs-6 col-md-2 col-lg-1\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.blend_code :value=simulatorSetup.blend_code data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> <div class=\"col-xs-12 col-sm-offset-6 col-sm-6 col-md-offset-1 col-md-4 col-lg-3 col-lg-offset-1\" _v-319cc023=\"\"> <input type=text class=\"form-control form-control-toggle-top\" placeholder=Rename v-model=simulatorSetup.custom_blend_code _v-319cc023=\"\"> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=wine_batch_code class=\"col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle\" _v-319cc023=\"\">Batch Code</label> <div class=\"col-xs-6 col-md-2 col-lg-1\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.batch_code :value=simulatorSetup.batch_code data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> <div class=\"col-xs-12 col-sm-offset-6 col-sm-6 col-md-offset-1 col-md-4 col-lg-3 col-lg-offset-1\" _v-319cc023=\"\"> <input type=text class=\"form-control form-control-toggle-top\" placeholder=Rename v-model=simulatorSetup.custom_batch_code _v-319cc023=\"\"> </div> </div> <div class=form-group _v-319cc023=\"\"> <label for=country class=\"col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle\" _v-319cc023=\"\">Country</label> <div class=\"col-xs-12 col-md-4 col-lg-3 fix-top\" _v-319cc023=\"\"> <input-select :select2=true :options=countries name=country_id :vmodel.sync=simulatorSetup.country_id _v-319cc023=\"\"></input-select> </div> </div> </fieldset> <fieldset _v-319cc023=\"\"> <legend _v-319cc023=\"\">Dashboard Customization</legend> <div class=\"row row-clear-md-6-lg-4\" _v-319cc023=\"\"> <div class=\"col-md-6 col-lg-4\" _v-319cc023=\"\"> <div class=form-group _v-319cc023=\"\"> <label for=dashboard_tank_name class=\"col-xs-6 col-md-6 control-label control-label-toggle\" _v-319cc023=\"\">Tank Name</label> <div class=\"col-xs-6 col-md-6\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.dashboard_tank_name :value=simulatorSetup.dashboard_tank_name data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> </div> </div> <div class=\"col-md-6 col-lg-4\" _v-319cc023=\"\"> <div class=form-group _v-319cc023=\"\"> <label for=dashboard_wine_name class=\"col-xs-6 col-md-6 control-label control-label-toggle\" _v-319cc023=\"\">Wine Name</label> <div class=\"col-xs-6 col-md-6\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.dashboard_wine_name :value=simulatorSetup.dashboard_wine_name data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> </div> </div> <div class=\"col-md-6 col-lg-4\" _v-319cc023=\"\"> <div class=form-group _v-319cc023=\"\"> <label for=dashboard_batch_code class=\"col-xs-6 col-md-6 control-label control-label-toggle\" _v-319cc023=\"\">Batch Code</label> <div class=\"col-xs-6 col-md-6\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.dashboard_batch_code :value=simulatorSetup.dashboard_batch_code data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> </div> </div> <div class=\"col-md-6 col-lg-4\" _v-319cc023=\"\"> <div class=form-group _v-319cc023=\"\"> <label for=dashboard_blend_code class=\"col-xs-6 col-md-6 control-label control-label-toggle\" _v-319cc023=\"\">Blend Code</label> <div class=\"col-xs-6 col-md-6\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.dashboard_blend_code :value=simulatorSetup.dashboard_blend_code data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> </div> </div> <div class=\"col-md-6 col-lg-4\" _v-319cc023=\"\"> <div class=form-group _v-319cc023=\"\"> <label for=dashboard_varietal class=\"col-xs-6 col-md-6 control-label control-label-toggle\" _v-319cc023=\"\">Varietal</label> <div class=\"col-xs-6 col-md-6\" _v-319cc023=\"\"> <div class=checkbox _v-319cc023=\"\"> <input type=checkbox v-toggle=simulatorSetup.dashboard_varietal :value=simulatorSetup.dashboard_varietal data-on=Show data-off=Hide data-onstyle=info data-offstyle=default _v-319cc023=\"\"> </div> </div> </div> </div> </div> </fieldset> </form> </div> </div> </div> <winemakers :site=site :winemakers=simulatorSetup.winemakers :loading=loading _v-319cc023=\"\"></winemakers> </div> ";

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	module.exports = " <img src=/static/img/header.png style=\"margin:-36px 0px 37px -27px;width: 105%\" class=bnr _v-3539f533=\"\"> <div class=row _v-3539f533=\"\"> <div class=col-md-4 _v-3539f533=\"\"> <div class=authenticate _v-3539f533=\"\"> <h2 style=\"font-weight: initial;background: #202e6d; color: white;text-transform:initial\" _v-3539f533=\"\">Log in</h2> <div class=wrap-fluid style=\"margin-left: 0px !important\" _v-3539f533=\"\"> <div class=row _v-3539f533=\"\"> <div class=col-lg-12 _v-3539f533=\"\"> <div class=account-box _v-3539f533=\"\"> <div id=login _v-3539f533=\"\"> <div style=margin-bottom:20px _v-3539f533=\"\"> <div class=form-group _v-3539f533=\"\"> <label style=font-weight:initial _v-3539f533=\"\">Username</label> <input type=text name=username v-model=input.username placeholder=Username class=form-control _v-3539f533=\"\"> </div> <div class=form-group _v-3539f533=\"\"> <label style=font-weight:initial _v-3539f533=\"\">Password</label> <input type=password name=password v-model=input.password placeholder=Password class=form-control _v-3539f533=\"\"> </div> </div> <div class=\"\" _v-3539f533=\"\"> <div class=\"\" style=text-align:right _v-3539f533=\"\"> <button type=button v-on:click=login() class=\"\" style=\"text-transform: uppercase; width: 100px; height: 40px; color: white; background: #202e6d; outline: none; border: none; margin-bottom: 10px\" _v-3539f533=\"\">Log in</button> <br _v-3539f533=\"\"> <a href=/register _v-3539f533=\"\"> <button type=button v-on:click=\"\" class=\"\" style=\"text-transform:none;width: 100px;height:40px;color:#202e6d;background:white;outline:none;border:solid 1px #202e6d\" _v-3539f533=\"\">Register</button> </a> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=col-md-8 _v-3539f533=\"\"> <div class=\"authenticate display-card\" _v-3539f533=\"\"> <div class=text-half style=padding:30px;display:inline-block;width:49% _v-3539f533=\"\"> <h2 style=color:black;border:none;padding:0px _v-3539f533=\"\">Predict your ferments with powerful data analysis</h2> <p _v-3539f533=\"\"> Powerful algorithms match the ferment curve from your data as it is collected, enabling forward prediction of how your ferment will end. </p> <p _v-3539f533=\"\"> Access the ferment simulator from anywhere, at any time. </p> </div> <div class=img-half style=display:inline-block;width:49% _v-3539f533=\"\"> <img src=/static/img/fermentsimgraphic.png style=max-width:100% _v-3539f533=\"\"> </div> </div> </div> </div> ";

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	module.exports = " <div class=col-sm-6 _v-3e5e4c80=\"\"> <div class=box _v-3e5e4c80=\"\"> <div class=box-header _v-3e5e4c80=\"\"> <h2 class=box-title _v-3e5e4c80=\"\">Regions</h2> </div> <div class=box-body _v-3e5e4c80=\"\"> <div class=form-group _v-3e5e4c80=\"\"> <ul class=list-remove _v-3e5e4c80=\"\"> <li v-for=\"region in regions\" _v-3e5e4c80=\"\">{{region.name}}<a @click.prevent=remove(region) class=\"region-delete btn btn-sm\" _v-3e5e4c80=\"\"><i class=\"fa fa-close\" _v-3e5e4c80=\"\"></i> Delete</a></li> <li v-if=\"!regions.length &amp;&amp; !loading\" _v-3e5e4c80=\"\">No regions.</li> <li v-if=\"!regions.length &amp;&amp; loading\" _v-3e5e4c80=\"\">Loading regions...</li> </ul> </div> <form @submit.prevent=save _v-3e5e4c80=\"\"> <div class=fix-select2 _v-3e5e4c80=\"\"> <input-select :select2=true :options=countries name=country_id :vmodel.sync=country _v-3e5e4c80=\"\"></input-select> </div> <div class=input-group _v-3e5e4c80=\"\"> <input type=text v-model=name class=form-control _v-3e5e4c80=\"\"> <span class=input-group-btn _v-3e5e4c80=\"\"> <button class=\"btn btn-default\" _v-3e5e4c80=\"\"><i class=\"fa fa-plus\" _v-3e5e4c80=\"\"></i> Add Region</button> </span> </div> </form> </div> </div> </div>";

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = " <div id=skin-select v-show=\"\n    $route.hideNavigation === undefined || $route.hideNavigation == false\n  \" _v-4b2f2f92=\"\"> <a id=toggle _v-4b2f2f92=\"\"> <span class=\"fa icon-menu\" _v-4b2f2f92=\"\"></span> </a> <div class=skin-part _v-4b2f2f92=\"\"> <div id=tree-wrap _v-4b2f2f92=\"\"> <div id=menuwrapper class=side-bar _v-4b2f2f92=\"\"> <ul id=menu-showhide class=topnav _v-4b2f2f92=\"\"> <li v-if=\"authorized.access == null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip href=https://www.awri.com.au/industry_support/winemaking_resources/wine_fermentation/awri-ferment-simulator _v-4b2f2f92=\"\"> <div class=img-container style=min-width:20px;display:inline-block;text-align:center;margin-right:10px _v-4b2f2f92=\"\"> <img src=/static/img/i.png style=\"height: 17px\" _v-4b2f2f92=\"\"> </div> <span _v-4b2f2f92=\"\">Overview</span> </a> </li> <li v-if=\"authorized.access == null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip href=https://www.awri.com.au/industry_support/winemaking_resources _v-4b2f2f92=\"\"> <div class=img-container style=min-width:20px;display:inline-block;text-align:center;margin-right:10px _v-4b2f2f92=\"\"> <img src=/static/img/wine.png style=\"height: 17px\" _v-4b2f2f92=\"\"> </div> <span _v-4b2f2f92=\"\">Winemaking</span> </a> </li> <li v-if=\"authorized.access == null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip href=https://www.awri.com.au/industry_support _v-4b2f2f92=\"\"> <div class=img-container style=min-width:20px;display:inline-block;text-align:center;margin-right:10px _v-4b2f2f92=\"\"> <img src=/static/img/grape.png style=\"height: 17px\" _v-4b2f2f92=\"\"> </div> <span _v-4b2f2f92=\"\">Services to industry</span> </a> </li> <li v-if=\"authorized.access == null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip href=https://www.awri.com.au _v-4b2f2f92=\"\"> <div class=img-container style=min-width:20px;display:inline-block;text-align:center;margin-right:10px _v-4b2f2f92=\"\"> <img src=/static/img/awri.png style=\"height: 17px\" _v-4b2f2f92=\"\"> </div> <span _v-4b2f2f92=\"\">AWRI Home</span> </a> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'dashboard' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-dashboard\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Dashboard</span> </a> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip href=# _v-4b2f2f92=\"\"> <i class=\"fa fa-database\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Tank Groups</span> </a> <ul _v-4b2f2f92=\"\"> <li v-for=\"tankGroup in tankGroups\" :key=tankGroup.id _v-4b2f2f92=\"\"> <a v-link=\"{\n                    name: 'dashboard.tank-group',\n                    params: { tankGroupId: tankGroup.id },\n                  }\" _v-4b2f2f92=\"\">{{ tankGroup.name }}</a> </li> </ul> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'history.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-clock-o\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">History</span> </a> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'fermenters.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-plus\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Fermenter Setup</span> </a> </li> <li v-if=\"authorized.access > 10\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'profiles.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-server\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Ferment Profiles</span> </a> </li> <li v-if=\"authorized.access > 10\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'simulators.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-line-chart\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Simulator Setup</span> </a> </li> <li v-if=\"authorized.access == 30\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'settings.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-cog\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Admin Settings</span> </a> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'site-selection.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-retweet\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Change Site</span> </a> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'contact.index' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-envelope\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Contact</span> </a> </li> <li v-if=\"authorized.access != null\" _v-4b2f2f92=\"\"> <a class=tooltip-tip v-link=\"{ name: 'logout' }\" _v-4b2f2f92=\"\"> <i class=\"fa fa-sign-out\" _v-4b2f2f92=\"\"></i> <span _v-4b2f2f92=\"\">Logout</span> </a> </li> </ul> </div> </div> </div> </div> ";

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = " <div _v-4fdd9fd2=\"\"> <div class=form-group :class=\"{'has-error': hasError}\" v-if=!inline _v-4fdd9fd2=\"\"> <label v-if=label :for=name class=\"col-sm-4 col-md-3 control-label\" _v-4fdd9fd2=\"\">{{ label }}</label> <div class=\"{{ class }}\" _v-4fdd9fd2=\"\"> <select v-if=select2 :name=name :id=name class=form-control :tags=tags :options=options v-model=vmodel v-select=vmodel _v-4fdd9fd2=\"\"> <option v-for=\"option in options\" track-by=$index :value=option.value _v-4fdd9fd2=\"\">{{ option.name }}</option> </select> <select v-else=\"\" :name=name :id=name class=form-control v-model=vmodel _v-4fdd9fd2=\"\"> <option v-for=\"option in options\" track-by=$index :value=option.value _v-4fdd9fd2=\"\">{{ option.name }}</option> </select> <span v-if=hasError class=help-block _v-4fdd9fd2=\"\"><i class=\"fa fa-exclamation-triangle\" _v-4fdd9fd2=\"\"></i> {{ errorMessage }}</span> </div> </div> <div v-else=\"\" _v-4fdd9fd2=\"\"> <label v-if=label :for=name _v-4fdd9fd2=\"\">{{ label }}</label> <select v-if=select2 :name=name :id=name class=form-control :tags=tags :options=options v-model=vmodel v-select=vmodel _v-4fdd9fd2=\"\"> <option v-for=\"option in options\" track-by=$index :value=option.value _v-4fdd9fd2=\"\">{{ option.name }}</option> </select> <select v-else=\"\" :name=name :id=name class=form-control v-model=vmodel _v-4fdd9fd2=\"\"> <option v-for=\"option in options\" track-by=$index :value=option.value _v-4fdd9fd2=\"\">{{ option.name }}</option> </select> </div> </div> ";

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	module.exports = " <div :class=\"{'has-error': hasError, 'form-group': label}\" _v-78408488=\"\"> <label v-if=label :for=name class=\"col-sm-4 col-md-3 control-label\" _v-78408488=\"\">{{{ label }}}</label> <div :class=\"{'col-sm-8 col-md-9': label}\" _v-78408488=\"\"> <div class=input-group v-if=!textarea _v-78408488=\"\"> <span v-if=spinner class=\"input-group-btn spinner-down\" _v-78408488=\"\"> <a class=\"btn btn-default\" _v-78408488=\"\">-</a> </span> <span v-if=prependIcon class=input-group-addon _v-78408488=\"\"><i class=\"fa fa-fw fa-{{ prependIcon }}\" _v-78408488=\"\"></i></span> <input :type=type :id=name :name=name class=form-control :placeholder=placeholder v-model=vmodel _v-78408488=\"\"> <span v-if=postfix class=input-group-addon _v-78408488=\"\">{{{ postfix }}}</span> <span v-if=spinner class=\"input-group-btn spinner-up\" _v-78408488=\"\"> <a class=\"btn btn-default\" _v-78408488=\"\">+</a> </span> </div> <div v-else=\"\" _v-78408488=\"\"> <textarea :id=name class=form-control :rows=rows :placeholder=placeholder v-model=vmodel _v-78408488=\"\"></textarea> </div> <span v-if=hasError class=help-block _v-78408488=\"\"><i class=\"fa fa-exclamation-triangle\" _v-78408488=\"\"></i> {{ errorMessage }}</span> </div> </div> ";

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	module.exports = " <div _v-7ee4a4b3=\"\"> <div class=\"col-md-4 col-md-offset-4\" _v-7ee4a4b3=\"\"> <div class=authenticate _v-7ee4a4b3=\"\"> <h2 _v-7ee4a4b3=\"\">Please Wait</h2> <div class=wrap-fluid _v-7ee4a4b3=\"\"> <div class=row _v-7ee4a4b3=\"\"> <div class=col-lg-12 _v-7ee4a4b3=\"\"> <div class=account-box _v-7ee4a4b3=\"\"> <i class=\"fa fa-fw fa-spin fa-cog\" _v-7ee4a4b3=\"\"></i> Authenticating you with the AWRI Wine Simulator... </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports = " <div _v-81d48ca0=\"\"></div> ";

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	module.exports = " <div _v-99b82fca=\"\"> <div v-show=\"fermenters.length == 0\" style=\"padding: 40px 0; text-align: center\" _v-99b82fca=\"\"> <h3 v-if=\"selectedTankGroup == 'favourites'\" _v-99b82fca=\"\">There are currently no fermenters favourited.</h3> <h3 v-else=\"\" _v-99b82fca=\"\">There are currently no fermenters in this tank group.</h3> <h3 _v-99b82fca=\"\"><a href=# @click.prevent=showAllFermenters() _v-99b82fca=\"\">Show all fermenters <i class=\"fa fa-angle-right\" _v-99b82fca=\"\"></i></a></h3> </div> <div class=\"row row-clear-sm-6-md-4-lg-3 ferments\" _v-99b82fca=\"\"> <div v-for=\"fermenter in fermenters\" class=\"ferment-grid col-sm-6 col-md-4 col-lg-3\" _v-99b82fca=\"\"> <div class=\"box box-ferment\" v-bind:class=\"{'box-ferment-empty' : !fermenter.currentFerment}\" _v-99b82fca=\"\"> <div class=box-header _v-99b82fca=\"\"> <div class=\"pull-right box-tools\" _v-99b82fca=\"\"> <input id=favourite_{{fermenter.id}} type=checkbox class=favourite v-model=fermenter.favourite _v-99b82fca=\"\"> <label for=favourite_{{fermenter.id}} _v-99b82fca=\"\"></label> </div> <h3 class=box-title _v-99b82fca=\"\"> <a v-link=\"{name: 'ferments.index', params: { fermenterId: fermenter.id, fermentId: fermenter.currentFerment ? fermenter.currentFerment.data.id : 0 }}\" _v-99b82fca=\"\"> <i class=\"bg-green fontello-waves\" _v-99b82fca=\"\"></i> <span class=text-green v-if=simulatorSetup.dashboard_tank_name _v-99b82fca=\"\">{{fermenter.name}}</span> </a> </h3> </div> <div class=box-body _v-99b82fca=\"\"> <div v-if=fermenter.currentFerment class=row _v-99b82fca=\"\"> <div class=col-md-12 _v-99b82fca=\"\"> <h3 v-if=\"fermenter.currentFerment &amp;&amp; simulatorSetup.dashboard_wine_name\" _v-99b82fca=\"\">{{fermenter.currentFerment.data.wine_name}}</h3> </div> <div class=col-md-12 _v-99b82fca=\"\"> <div class=text-small v-if=\"fermenter.currentFerment.data.varietal &amp;&amp; simulatorSetup.dashboard_varietal\" _v-99b82fca=\"\"><small _v-99b82fca=\"\">{{fermenter.currentFerment.data.varietal}}</small></div> <div v-if=\"fermenter.currentFerment.data.blend_code &amp;&amp; simulatorSetup.dashboard_blend_code\" _v-99b82fca=\"\"><small _v-99b82fca=\"\">{{fermenter.currentFerment.data.blend_code}}</small></div> <div v-if=\"fermenter.currentFerment.data.batch_code &amp;&amp; simulatorSetup.dashboard_batch_code\" _v-99b82fca=\"\"><small _v-99b82fca=\"\">{{fermenter.currentFerment.data.batch_code}}</small></div> </div> </div> <h3 v-if=!fermenter.currentFerment class=text-center _v-99b82fca=\"\">Empty</h3> <ferment-gauge :fermenter=fermenter _v-99b82fca=\"\"></ferment-gauge> </div> <div class=\"alerts gauge-alerts\" v-if=fermenter.currentFerment _v-99b82fca=\"\"> <div v-if=\"fermenter.currentFerment.data.blendComponents.data.length > 0\" class=\"alert alert-default\" _v-99b82fca=\"\"> Blend – No simulation available </div> <template v-else=\"\"> <div if=\"fermenter.currentFerment.data.simulated &amp;&amp; !fermentNotEnoughData(fermenter.currentFerment.data)\" _v-99b82fca=\"\"> <div v-if=\"fermenter.currentFerment.data.gauge.data.status == 10\" class=\"alert alert-info\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Low Range On Spec <quote :message=lowRangeOnSpecQuote :class=\"'white'\" _v-99b82fca=\"\"></quote> </div> <div v-if=\"fermenter.currentFerment.data.gauge.data.status == 20\" class=\"alert alert-danger\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> High Range On Spec <quote :message=highRangeOnSpecQuote :class=\"'white'\" _v-99b82fca=\"\"></quote> </div> <div v-if=\"fermenter.currentFerment.data.gauge.data.status == 30\" class=\"alert alert-info\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Sluggish Fermentation <quote :message=sluggishFermentationQuote :class=\"'white'\" _v-99b82fca=\"\"></quote> </div> <div v-if=\"fermenter.currentFerment.data.gauge.data.status == 40\" class=\"alert alert-danger\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Rapid Fermentation <quote :message=rapidFermentQuaote :class=\"'white'\" _v-99b82fca=\"\"></quote> </div> </div> <div v-if=\"!fermentNotEnoughData(fermenter.currentFerment.data) &amp;&amp; !fermenter.currentFerment.data.simulated\" class=\"alert alert-warning\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Simulation Out of Sync <quote :message=simulationOutOfSyncQuote _v-99b82fca=\"\"></quote> </div> <div v-if=fermentNotEnoughData(fermenter.currentFerment.data) class=\"alert alert-warning\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Not Enough Data <quote :message=notEnoughtDataQuote _v-99b82fca=\"\"></quote> </div> <div v-if=fermenterIsStuck(fermenter) class=\"alert alert-warning\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Ferment Stuck </div> <div v-if=\"fermenter.currentFerment.data.gauge.data.prediction_score > 25 &amp;&amp; fermenter.currentFerment.data.simulated\" class=\"alert alert-warning\" role=alert _v-99b82fca=\"\"> <i class=\"fa fa-exclamation-triangle\" _v-99b82fca=\"\"></i> Poor Simulation <quote :message=poorSimulationQuote _v-99b82fca=\"\"></quote> </div> </template> </div> </div> </div> </div> </div> ";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(249)
	__vue_template__ = __webpack_require__(446)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(401)
	__vue_script__ = __webpack_require__(252)
	__vue_template__ = __webpack_require__(449)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(410)
	__vue_script__ = __webpack_require__(253)
	__vue_template__ = __webpack_require__(475)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(254)
	__vue_template__ = __webpack_require__(450)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(411)
	__vue_script__ = __webpack_require__(255)
	__vue_template__ = __webpack_require__(476)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(416)
	__vue_script__ = __webpack_require__(256)
	__vue_template__ = __webpack_require__(481)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(417)
	__vue_script__ = __webpack_require__(257)
	__vue_template__ = __webpack_require__(482)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(409)
	__vue_script__ = __webpack_require__(258)
	__vue_template__ = __webpack_require__(474)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(418)
	__vue_script__ = __webpack_require__(259)
	__vue_template__ = __webpack_require__(483)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(413)
	__vue_script__ = __webpack_require__(260)
	__vue_template__ = __webpack_require__(478)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(419)
	__vue_script__ = __webpack_require__(261)
	__vue_template__ = __webpack_require__(484)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(402)
	__vue_script__ = __webpack_require__(262)
	__vue_template__ = __webpack_require__(451)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(263)
	__vue_template__ = __webpack_require__(452)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(264)
	__vue_template__ = __webpack_require__(453)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(420)
	__vue_script__ = __webpack_require__(265)
	__vue_template__ = __webpack_require__(485)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(266)
	__vue_template__ = __webpack_require__(454)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(403)
	__vue_script__ = __webpack_require__(267)
	__vue_template__ = __webpack_require__(455)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(268)
	__vue_template__ = __webpack_require__(456)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(269)
	__vue_template__ = __webpack_require__(457)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(270)
	__vue_template__ = __webpack_require__(458)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(404)
	__vue_script__ = __webpack_require__(271)
	__vue_template__ = __webpack_require__(459)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(405)
	__vue_script__ = __webpack_require__(272)
	__vue_template__ = __webpack_require__(460)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(406)
	__vue_script__ = __webpack_require__(273)
	__vue_template__ = __webpack_require__(461)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(274)
	__vue_template__ = __webpack_require__(462)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(275)
	__vue_template__ = __webpack_require__(463)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(276)
	__vue_template__ = __webpack_require__(464)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(415)
	__vue_script__ = __webpack_require__(277)
	__vue_template__ = __webpack_require__(480)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(407)
	__vue_script__ = __webpack_require__(278)
	__vue_template__ = __webpack_require__(465)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(279)
	__vue_template__ = __webpack_require__(466)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(280)
	__vue_template__ = __webpack_require__(467)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(414)
	__vue_script__ = __webpack_require__(281)
	__vue_template__ = __webpack_require__(479)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(282)
	__vue_template__ = __webpack_require__(468)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(283)
	__vue_template__ = __webpack_require__(469)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(284)
	__vue_template__ = __webpack_require__(470)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(412)
	__vue_script__ = __webpack_require__(285)
	__vue_template__ = __webpack_require__(477)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(286)
	__vue_template__ = __webpack_require__(471)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(287)
	__vue_template__ = __webpack_require__(472)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(408)
	__vue_script__ = __webpack_require__(288)
	__vue_template__ = __webpack_require__(473)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.2c194e5089b285653777.js